// Country-dataset locale translations beyond the common global catalog.
export const additionalLocaleTranslations = {
  "fas": {
    "checkout": {
      "liveInstruction": "روش زنده را انتخاب کنید؛ در صفحهٔ بعد شمارهٔ حسابی را که از آن پول ارسال خواهید کرد وارد و تأیید کنید. یک جلسهٔ زندهٔ ۱۰ دقیقه‌ای شروع می‌شود؛ ارسال پول در طول آن پرداخت را به‌طور خودکار تأیید می‌کند.",
      "trxInstruction": "از یک مغازه Cash In کنید یا از شخص دیگری بخواهید که Send Money کند. سپس با استفاده از Transaction ID (TrxID) به‌طور خودکار تأیید کنید.",
      "enterNumberInstruction": "شمارهٔ خود را وارد کرده و بر روی دکمهٔ '{action}' کلیک کنید.",
      "offlineTitle": "دستگاه فروشنده آفلاین است",
      "offlineDescription": "تأیید خودکار موقتاً در دسترس نیست.",
      "copyPersonal": "شمارهٔ Personal Account بالا را کپی کنید.",
      "sendMoneyOffline": "به شمارهٔ بالا Send Money یا Cash In کنید، یا از شخص دیگری بخواهید پول ارسال کند.",
      "trxOffline": "Transaction ID (TrxID) را دریافت کرده و آن را در پایین وارد کنید. وقتی فروشنده آنلاین شود، از طریق ایمیل اطلاع‌رسانی خواهید شد، یا می‌توانید مستقیماً با فروشنده تماس بگیرید.",
      "cashinNagad": "Cash In در Nagad مجاز نیست، لطفاً از حساب Nagad دیگری Send Money کنید.",
      "cashinOther": "قبل از Cash In از فروشنده بپرسید آیا TrxID را می‌دهد یا نه؛ اگر نمی‌دهد، ادامه ندهید. به‌طور جایگزین، از شخص دیگری بخواهید Send Money کند.",
      "waitTrx": "پس از پرداخت، ۱۰–۱۵ ثانیه منتظر بمانید و TrxID را در پایین وارد کنید. می‌توانید این صفحه را ترک کرده و در هر زمان ظرف ۲۴ ساعت برای تأیید خودکار با TrxID خود به این صفحه بازگردید.",
      "goApp": "به برنامهٔ {provider} بروید یا شمارهٔ {dialCode} را شماره‌گیری کرده و 'Send Money' را انتخاب کنید.",
      "confirmAuto": "شمارهٔ کپی‌شده و مبلغ را وارد کرده، سپس با PIN خود تأیید کنید تا به‌طور خودکار تأیید شود.",
      "dontClose": "لطفاً این صفحه را نبندید",
      "autoVerify": "پرداخت شما به‌طور خودکار در حال تأیید شدن است",
      "successOffline": "متشکریم، {name}. تراکنش شما ثبت شد. فروشنده در حال حاضر آفلاین است. پس از اینکه فروشنده آنلاین شد و پرداخت شما را تأیید کرد، از طریق ایمیل به شما اطلاع داده خواهد شد.",
      "successOnline": "متشکریم، {name}. پرداخت شما به مبلغ {amount} از طریق {provider} دریافت شد و در حال تأیید است."
    },
    "features": {
      "no-code-website": [
        "بدون کدنویسی سایت‌های تجارت الکترونیک، آموزشی، وبلاگ یا خبری ایجاد و منتشر کنید.",
        "مثال: از داشبورد فروشندهٔ دوره می‌توانید یک صفحهٔ فرود و پست محصول منتشر کنید."
      ],
      "custom-domain": [
        "دامنهٔ خود را وصل کنید و با مسیر‌دهی سریع‌تر هویت دیجیتال حرفه‌ای بسازید.",
        "مثال: فروشگاه شما روی www.acme.com اجرا می‌شود به‌جای زیردامنهٔ یک پلتفرم."
      ],
      "capi": [
        "رویدادهای تبدیل را از سمت سرور ارسال کنید تا اندازه‌گیری کمپین قابل‌اعتماد باشد.",
        "مثال: یک رویداد خرید از سرور به پلتفرم تبلیغات ارسال می‌شود."
      ],
      "personal-mfs": [
        "تأیید پرداخت‌های Personal MFS پشتیبانی‌شده را خودکار کنید.",
        "مثال: یک پرداخت Personal MFS با سفارش وب‌سایت مطابقت داده می‌شود."
      ],
      "local-gateway": [
        "روش‌های پرداخت محلی را برای مشتریان منطقه‌ای متصل کنید.",
        "مثال: خریدار محلی تسویه‌حساب را از طریق درگاه منطقه‌ای تکمیل می‌کند."
      ],
      "international-gateway": [
        "روش‌های پرداخت بین‌المللی را برای مشتریان سراسر جهان متصل کنید.",
        "مثال: خریدار خارجی تسویه را با یک روش جهانی تکمیل می‌کند."
      ],
      "notifications": [
        "به مشتریان و فروشندگان به‌روزرسانی‌های پرداخت و سفارش را ارسال کنید.",
        "مثال: موفقیت پرداخت منجر به هشدار برای فروشنده و به‌روزرسانی برای مشتری می‌شود."
      ],
      "courier": [
        "سفارش‌های تأییدشده را به‌طور خودکار به گردش‌کار پیک پشتیبانی‌شده ارسال کنید.",
        "مثال: یک سفارش COD تأییدشده برای تحویل به پیک آماده می‌شود."
      ],
      "business-email": [
        "ایمیل حرفه‌ای روی دامنهٔ برندشدهٔ خود ارسال و دریافت کنید.",
        "مثال: sales@acme.com پرسش‌ها را دریافت می‌کند و support@acme.com پاسخ می‌دهد."
      ]
    }
  },
  "fij": {
    "checkout": {
      "liveInstruction": "Digitaka na iwalewale ni live; ena matata na page ka volai iko na nomu naba ni akaunti sa na vakayagataki kina me vakacuru kina na ilavo, ka tauri. Ena tekivu e dua na veisiga ni session ni 10 na miniti; ni vakacurumi kina na ilavo ena gauna oqo ena auto-verify kina na bileti.",
      "trxInstruction": "Caka Cash In mai na dua na sitoa se taroga e dua me Send Money. Oti qai auto-verify ena Transaction ID (TrxID).",
      "enterNumberInstruction": "Volai nomu naba ka kiliki na butoni '{action}'.",
      "offlineTitle": "Na iyaya ni bisinisi e Offline",
      "offlineDescription": "Sega ni tu mai na gauna oqo na kena auto-verification.",
      "copyPersonal": "Kopi na Personal Account naba e cake.",
      "sendMoneyOffline": "Send Money se Cash In ki na naba e cake, se taroga e dua me ratou vosa mo Send Money.",
      "trxOffline": "Kauta mai na Transaction ID (TrxID) ka volai ki lalo. Ni sa yaco mai na bisinisi me online, ena tukuna vei iko ena imeli, se rawa ni o veitaratara vakatotolo kina.",
      "cashinNagad": "Sega ni rawa na Cash In ena Nagad, vakau mai na ilavo mai ena dua tale na akaunti Nagad ka Send Money vei ira.",
      "cashinOther": "Qai taroga na dauvolivoli ni sitoa kevaka ena solia na TrxID; kevaka sega, kua ni tomana. Ena kena veibasai, taroga e dua me Send Money.",
      "waitTrx": "Ni oti na ilavo, tarai 10–15 na секond ka volai mai na TrxID ki lalo. E rawa ni o lai lako tani mai ena page oqo ka lesi me tiko tale ena loma ni 24 qai na vakayacori na auto-verify mai na nomu TrxID.",
      "goApp": "Lako yani ki na {provider} app se kuru {dialCode} ka digitaka 'Send Money'.",
      "confirmAuto": "Volai na naba sa kopi ka na isau, qai vakarautaka ena PIN me auto-verify.",
      "dontClose": "Kerekere, kua ni vakacegui oqo na page",
      "autoVerify": "Sa vakatovolei tiko na nomu saumi me vakadodonutaka talega",
      "successOffline": "Vinaka, {name}. Sa kena rai na nomu transakisoni. Sa offline tiko na bisinisi ena gauna oqo. Ena tukuna vei iko ena imeli ni sa lesu yani na bisinisi ka vakadeitaki na nomu saumi.",
      "successOnline": "Vinaka, {name}. Sa rawata na nomu saumi e {amount} ena {provider} ka sa tiko ena kena vakadeitaki."
    },
    "features": {
      "no-code-website": [
        "Bulia ka publish na website ni e-commerce, education, blog, se news sega ni gadrevi kina na coding.",
        "iTukutuku: publish e dua na landing page kei na product post mai na dashboard ni seller ni course."
      ],
      "custom-domain": [
        "Vakayagataka nomu domain ka bulia e dua na digital identity vakataki professional kei na routing vata kei na cecere.",
        "iTukutuku: na nomu sitoa e vakayagataki ena www.acme.com se sega ni vei subdomain ni platform."
      ],
      "capi": [
        "Tukuna na conversion events mai na server me rawarawa na campaign measurement.",
        "iTukutuku: e dua na purchase event sa vakacurumi mai na server ki na ad platform."
      ],
      "personal-mfs": [
        "Veivakavoui na verification ni Personal MFS payments ka ra sa vakarautaki.",
        "iTukutuku: e dua na Personal MFS payment ena vakamatalai kei na oda mai na website."
      ],
      "local-gateway": [
        "Tukuna na local payment methods vei ira na customers ena region.",
        "iTukutuku: e dua na local buyer ena taukena na checkout ena dua na regional gateway."
      ],
      "international-gateway": [
        "Tukuna na international payment methods vei ira na customers e vuravura taucoko.",
        "iTukutuku: e dua na overseas buyer ena taukena na checkout ena global method."
      ],
      "notifications": [
        "Tukuna na updates ni payment kei na order vei ira na customers kei na merchants.",
        "iTukutuku: na success ni payment e vakavuna e dua na alert vei na merchant kei na update vei na customer."
      ],
      "courier": [
        "Tukuna na orders ka sa kena confirmation ki na workflow ni courier e vakarautaki tiko vakautomate.",
        "iTukutuku: e dua na confirmed COD order e tarewa me solia vei na courier."
      ],
      "business-email": [
        "Tukuna ka vakauta vakabisinisi na email ena nomu branded domain.",
        "iTukutuku: sales@acme.com e qarava na taro ka support@acme.com e sauma."
      ]
    }
  },
  "fil": {
    "checkout": {
      "liveInstruction": "Piliin ang live method; sa susunod na pahina, ilagay at kumpirmahin ang account number na gagamitin mong magpapadala ng pera. Magsisimula ang 10-minutong live session; ang pagpapadala ng pera habang nandiyan ay mag-a-auto-verify ng bayad.",
      "trxInstruction": "Mag-Cash In mula sa tindahan o humiling sa ibang tao na Send Money. Pagkatapos ay i-auto-verify gamit ang Transaction ID (TrxID).",
      "enterNumberInstruction": "Ilagay ang iyong numero at i-click ang button na '{action}'.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Pansamantalang unavailable ang auto-verification.",
      "copyPersonal": "Kopyahin ang Personal Account number sa itaas.",
      "sendMoneyOffline": "Mag-Send Money o Mag-Cash In sa numerong nasa itaas, o humiling sa ibang tao na magpadala ng pera.",
      "trxOffline": "Kunin ang Transaction ID (TrxID) at ilagay ito sa ibaba. Kapag naging online ang merchant, makakatanggap ka ng abiso sa email, o maaari mong direktang kontakin ang merchant.",
      "cashinNagad": "Hindi pinapayagan ang Cash In sa Nagad, kaya mangyaring Send Money mula sa ibang Nagad account.",
      "cashinOther": "Bago mag-Cash In, itanong sa tindero kung ibibigay nila ang TrxID; kung hindi, huwag magpatuloy. Bilang alternatibo, humiling sa ibang tao na Send Money.",
      "waitTrx": "Pagkatapos ng bayad, maghintay ng 10–15 segundo at ilagay ang TrxID sa ibaba. Maaari mong iwanan ang pahinang ito at bumalik sa payment page anumang oras sa loob ng 24 na oras para auto-verify gamit ang iyong TrxID.",
      "goApp": "Pumunta sa {provider} app o i-dial ang {dialCode} at piliin ang 'Send Money'.",
      "confirmAuto": "Ilagay ang kinopyang numero at halaga, pagkatapos kumpirmahin gamit ang iyong PIN para mag-auto-verify.",
      "dontClose": "Mangyaring huwag isara ang pahinang ito",
      "autoVerify": "Awtomatikong tine-verify ang iyong bayad",
      "successOffline": "Salamat, {name}. Naitala na ang iyong transaksyon. Kasalukuyang offline ang merchant. Makakatanggap ka ng email kapag naging online ang merchant at na-verify ang iyong bayad.",
      "successOnline": "Salamat, {name}. Natanggap ang iyong bayad na {amount} sa pamamagitan ng {provider} at kasalukuyang tine-verify."
    },
    "features": {
      "no-code-website": [
        "Gumawa at mag-publish ng e-commerce, education, blog, o news sites nang walang coding.",
        "Halimbawa: mag-publish ng landing page at product post mula sa course seller dashboard."
      ],
      "custom-domain": [
        "Ikonekta ang sarili mong domain at bumuo ng propesyonal na digital identity na may mas mabilis na routing.",
        "Halimbawa: ang tindahan mo ay tumatakbo sa www.acme.com sa halip na platform subdomain."
      ],
      "capi": [
        "Magpadala ng conversion events server-side para sa maaasahang campaign measurement.",
        "Halimbawa: isang purchase event ang ipinapadala mula sa server papuntang ad platform."
      ],
      "personal-mfs": [
        "I-automate ang suportadong personal MFS payment verification.",
        "Halimbawa: isang personal MFS payment ay itinatapat sa order sa website."
      ],
      "local-gateway": [
        "Ikonekta ang lokal na payment methods para sa mga rehiyonal na customer.",
        "Halimbawa: isang lokal na buyer ang nagko-kompleto ng checkout sa pamamagitan ng regional gateway."
      ],
      "international-gateway": [
        "Ikonekta ang international payment methods para sa mga customer sa buong mundo.",
        "Halimbawa: isang overseas buyer ang nagko-kompleto ng checkout gamit ang global method."
      ],
      "notifications": [
        "Magpadala ng payment at order updates sa mga customer at merchant.",
        "Halimbawa: ang success ng payment ay nagti-trigger ng alert para sa merchant at update para sa customer."
      ],
      "courier": [
        "Ipadala nang awtomatiko ang mga confirmed orders sa suportadong courier workflow.",
        "Halimbawa: isang confirmed COD order ang inihahanda para sa courier handoff."
      ],
      "business-email": [
        "Magpadala at tumanggap ng propesyonal na email sa sarili mong branded domain.",
        "Halimbawa: sales@acme.com ang tumatanggap ng inquiries at support@acme.com ang sumasagot."
      ]
    }
  },
  "fin": {
    "checkout": {
      "liveInstruction": "Valitse live-menetelmä, anna ja vahvista tilinumero, jolta lähetät rahaa, seuraavalla sivulla. Käynnistyy 10 minuutin live-istunto; rahan lähettäminen sen aikana vahvistaa maksun automaattisesti.",
      "trxInstruction": "Tee Cash In kaupasta tai pyydä joku muu Send Money. Vahvista sitten automaattisesti Transaction ID:llä (TrxID).",
      "enterNumberInstruction": "Syötä numerosi ja klikkaa '{action}'-painiketta.",
      "offlineTitle": "Kauppiaan laite offline-tilassa",
      "offlineDescription": "Automaattinen vahvistus ei ole tilapäisesti käytettävissä.",
      "copyPersonal": "Kopioi yllä oleva Personal Account -numero.",
      "sendMoneyOffline": "Send Money tai Cash In yllä olevaan numeroon, tai pyydä joku muu lähettämään rahaa.",
      "trxOffline": "Hanki Transaction ID (TrxID) ja syötä se alle. Kun kauppias on taas online, saat ilmoituksen sähköpostitse, tai voit ottaa kauppiaaseen suoraan yhteyttä.",
      "cashinNagad": "Cash In ei ole sallittu Nagadissa, joten lähetäthän Send Money toisesta Nagad-tilistä.",
      "cashinOther": "Ennen Cash In -toimenpidettä kysy kauppiaalta, antavatko he TrxID:n; jos eivät, älä jatka. Vaihtoehtoisesti pyydä joku muu Send Money.",
      "waitTrx": "Maksun jälkeen odota 10–15 sekuntia ja syötä TrxID alle. Voit poistua tältä sivulta ja palata maksusivulle milloin tahansa 24 tunnin sisällä auto-verifioidaksesi TrxID:lläsi.",
      "goApp": "Mene {provider}-sovellukseen tai valitse {dialCode} ja valitse 'Send Money'.",
      "confirmAuto": "Syötä kopioitu numero ja summa, vahvista PIN-koodillasi auto-verifiointia varten.",
      "dontClose": "Älä sulje tätä sivua, ole hyvä",
      "autoVerify": "Maksuasi ollaan tarkistamassa automaattisesti",
      "successOffline": "Kiitos, {name}. Tapahtumasi on kirjattu. Kauppias on tällä hetkellä offline-tilassa. Saat sähköpostin, kun kauppias tulee online-tilaan ja vahvistaa maksusi.",
      "successOnline": "Kiitos, {name}. {amount} maksusi {provider}-palvelun kautta on vastaanotettu ja sitä tarkistetaan."
    },
    "features": {
      "no-code-website": [
        "Luo ja julkaise verkkokauppa-, koulutus-, blogi- tai uutissivustoja ilman koodausta.",
        "Esimerkki: julkaise laskeutumissivu ja tuotteen julkaisu kurssin myyjän hallintapaneelista."
      ],
      "custom-domain": [
        "Yhdistä oma domain ja luo ammattimainen digitaalinen identiteetti nopeammalla reitityksellä.",
        "Esimerkki: kauppasi toimii osoitteessa www.acme.com sen sijaan, että käyttäisit alustapäätettä."
      ],
      "capi": [
        "Lähetä konversiotapahtumia palvelinpuolelta luotettavaa kampanjan mittausta varten.",
        "Esimerkki: ostotapahtuma lähetetään palvelimelta mainosalustalle."
      ],
      "personal-mfs": [
        "Automatisoi tuetun Personal MFS -maksun vahvistus.",
        "Esimerkki: henkilökohtainen MFS-maksu yhdistetään verkkosivun tilaukseen."
      ],
      "local-gateway": [
        "Yhdistä paikallisia maksutapoja alueellisille asiakkaille.",
        "Esimerkki: paikallinen ostaja suorittaa ostoksen alueellisen maksunvälittäjän kautta."
      ],
      "international-gateway": [
        "Yhdistä kansainvälisiä maksutapoja asiakkaillesi maailmanlaajuisesti.",
        "Esimerkki: ulkomainen ostaja suorittaa maksun globaalilla menetelmällä."
      ],
      "notifications": [
        "Lähetä maksuihin ja tilauksiin liittyviä päivityksiä asiakkaille ja kauppiaille.",
        "Esimerkki: maksun onnistuminen laukaisee ilmoituksen kauppiaalle ja päivityksen asiakkaalle."
      ],
      "courier": [
        "Lähetä vahvistetut tilaukset automaattisesti tuettuun kuriirityönkulkuun.",
        "Esimerkki: vahvistettu COD-tilaus valmistellaan kuriirin luovutusta varten."
      ],
      "business-email": [
        "Lähetä ja vastaanota ammatillista sähköpostia omalla brändätyllä domainillasi.",
        "Esimerkki: sales@acme.com vastaanottaa tiedusteluja ja support@acme.com vastaa niihin."
      ]
    }
  },
  "gil": {
    "checkout": {
      "liveInstruction": "Koa ao live are e kakaraua; tia na kamatean ara n ae akau account number ma e na moan reirei bwa e tangiria nako reirei. E a tauta 10-minute live session; nako a tangiria ao e na reirei e tangiria auto-verify na payment.",
      "trxInstruction": "Mani Cash In mai ae te kabane ao n tare i nanon te manu are a Send Money. Kain auto-verify bwa Transaction ID (TrxID).",
      "enterNumberInstruction": "Tanon ao tabaki n ranea ao ka tia buton '{action}'.",
      "offlineTitle": "Device ni merchant e Offline",
      "offlineDescription": "Auto-verification e not available tetai ake.",
      "copyPersonal": "Copy na Personal Account number niu ae.",
      "sendMoneyOffline": "Send Money or Cash In niu ae number, ao n tare i nanon te manu are a send money.",
      "trxOffline": "Kakaua bwa Transaction ID (TrxID) ao tabaki naba niu ae. Aeo nako merchant e bon online, e na kabane taetae ni email, ao ira bane tia ni banda tekirei ma merchant direct.",
      "cashinNagad": "Cash In nije na allowed ni Nagad, kaitia kabane Send Money mai niion Nagad account.",
      "cashinOther": "Tuana Cash In, tarakeba ni etea n te kabane ni shopkeeper ao e na mareoraoi TrxID; ke e na akamata, bwa kakaura e na on, tia nua nanon. Alternatively, tare i nanon te manu are a Send Money.",
      "waitTrx": "Bwai ni mauri, tarai 10–15 sec ao tabaki TrxID niu ae. Ratake mai ni tabon page ao bon aba mai ni page e na 24 ora ke a bon return bwa auto-verify na TrxID.",
      "goApp": "Koa naar {provider} app ae ka dial {dialCode} ao tia 'Send Money'.",
      "confirmAuto": "Tanon na number ma kora ao amount, ao konfirm mai ni PIN me auto-verify.",
      "dontClose": "Aoia, kua ni karakei n page",
      "autoVerify": "Iroro ni payment e a auto-verify rau",
      "successOffline": "Ko rabwa, {name}. Ao a taetae ni transakison. Merchant e bon offline iaki. Aeo nako merchant e bo online ao na verify ni payment, e na kabane email.",
      "successOnline": "Ko rabwa, {name}. Ao a rawata na payment ni {amount} ma {provider} ao e a reirei me verify."
    },
    "features": {
      "no-code-website": [
        "Kiraki ao publish e-commerce, education, blog, ao news website n tare aba ni coding.",
        "Example: publish e landing page ao product post mai na dashboard ni course seller."
      ],
      "custom-domain": [
        "Bakia ni domain are ao build e professional digital identity ao faster routing.",
        "Example: ao store e run ni www.acme.com bad instead of platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side bwe reliable campaign measurement.",
        "Example: purchase event e a send mai server ao n te ad platform."
      ],
      "personal-mfs": [
        "Karaoa bwa e na otometik kamatoaan te kabwamakoro ibukin te Personal MFS ae boutokaaki.",
        "Example: Personal MFS payment e match ae website order."
      ],
      "local-gateway": [
        "Connect local payment methods ni regional customers.",
        "Example: local buyer e complete checkout via regional gateway."
      ],
      "international-gateway": [
        "Connect international payment methods ni customers worldwide.",
        "Example: overseas buyer e complete checkout with a global method."
      ],
      "notifications": [
        "Send payment ao order updates ni customers ao merchants.",
        "Example: payment success e trigger merchant alert ao customer update."
      ],
      "courier": [
        "Send confirmed orders into supported courier workflow automatically.",
        "Example: confirmed COD order e prepare for courier handoff."
      ],
      "business-email": [
        "N te kanganga ao bon riki ni mauri e aomaia ake: kamwara ni karokoa ao karakiu i buoka n te domain bwa mauri n tainano.",
        "sales@acme.com karokoa inquiries ao support@acme.com karakiu reply."
      ]
    }
  },
  "gle": {
    "checkout": {
      "liveInstruction": "Roghna an modh beo, cuir isteach agus dearbhaigh an uimhir chuntais ónar sheolfá airgead ar an gcéad leathanach eile. Tosóidh seisiún beo 10 nóiméad; trí airgead a sheoladh le linn dó sin, déanfar an íocaíocht a fhíorú go huathoibríoch.",
      "trxInstruction": "Déan Cash In ó siopa nó iarr ar dhuine eile Send Money. Ansin déan auto-verify ag úsáid an Transaction ID (TrxID).",
      "enterNumberInstruction": "Cuir isteach d’uimhir agus cliceáil an cnaipe '{action}'.",
      "offlineTitle": "Gléas an mhiondíoltóra as líne",
      "offlineDescription": "Níl fíorú uathoibrithe ar fáil go sealadach.",
      "copyPersonal": "Cóipeáil an uimhir Personal Account thuas.",
      "sendMoneyOffline": "Send Money nó Cash In chuig an uimhir thuas, nó iarr ar dhuine eile airgead a sheoladh.",
      "trxOffline": "Bailigh an Transaction ID (TrxID) agus cuir isteach thíos é. Nuair a thiocfaidh an miondíoltóir ar líne, cuirfear fógra chugat trí ríomhphost, nó is féidir leat teagmháil a dhéanamh leis an miondíoltóir go díreach.",
      "cashinNagad": "Níl cead Cash In i Nagad, mar sin déan Send Money le do thoil ó chuntas Nagad eile.",
      "cashinOther": "Sula ndéanann tú Cash In, fiafraigh den siopadóir an dtugann siad TrxID; mura dtugann siad, ná lean ort. Mar mhalairt, iarr ar dhuine eile Send Money.",
      "waitTrx": "Tar éis an íocaíochta, fan 10–15 soicind agus cuir isteach an TrxID thíos. Is féidir leat an leathanach seo a fhágáil agus filleadh ar an leathanach íocaíochta am ar bith laistigh de 24 uair chun fíorú uathoibrithe a dhéanamh ag úsáid do TrxID.",
      "goApp": "Téigh chuig an aip {provider} nó dial {dialCode} agus roghnaigh 'Send Money'.",
      "confirmAuto": "Cuir isteach an uimhir chóipeáilte agus an suim, ansin dearbhaigh le do PIN chun fíorú uathoibríoch a dhéanamh.",
      "dontClose": "Ná dún an leathanach seo le do thoil",
      "autoVerify": "Tá d’íocaíocht á fíorú go huathoibríoch",
      "successOffline": "Go raibh maith agat, {name}. Taifeadadh do idirbheart. Tá an miondíoltóir as líne faoi láthair. Cuirfear fógra chugat trí ríomhphost nuair a thiocfaidh an miondíoltóir ar líne agus a fhíoróidh sé d’íocaíocht.",
      "successOnline": "Go raibh maith agat, {name}. Tá d’íocaíocht {amount} trí {provider} faighte agus tá sí á fíorú."
    },
    "features": {
      "no-code-website": [
        "Cruthaigh agus foilsiú suíomhanna r-thráchtála, oideachais, blagála, nó nuachta gan códú.",
        "Sampla: foilseacháin leathanach teacht agus post táirge ón dashboard díoltóra cúrsa."
      ],
      "custom-domain": [
        "Ceangail d’ainm fearainn féin agus tóg aitheantas digiteach ghairmiúil le routáil níos tapúla.",
        "Sampla: rithfidh do stór ar www.acme.com seachas fo-ainm fearainn an ardáin."
      ],
      "capi": [
        "Seol imeachtaí tiontaithe ar thaobh an fhreastalaí le haghaidh tomhais feachtas iontaofa.",
        "Sampla: seoltar imeacht ceannach ón bhfreastalaí chuig an ardán fógraíochta."
      ],
      "personal-mfs": [
        "Uathoibriú deimhnithe íocaíochta Personal MFS tacaithe.",
        "Sampla: meaitseálaítear íocaíocht Personal MFS le hordú an tsuímh."
      ],
      "local-gateway": [
        "Ceangail modhanna íocaíochta áitiúla do chustaiméirí réigiúnacha.",
        "Sampla: comhlánaíonn ceannaitheoir áitiúil an seiceáil amach tríd an geata réigiúnach."
      ],
      "international-gateway": [
        "Ceangail modhanna íocaíochta idirnáisiúnta do chustaiméirí ar fud an domhain.",
        "Sampla: comhlánaíonn ceannaitheoir thar lear an seiceáil amach le modh domhanda."
      ],
      "notifications": [
        "Seol nuashonruithe íocaíochta agus ordaithe chuig custaiméirí agus miondíoltóirí.",
        "Sampla: spreagann rath íocaíochta foláireamh don mhiondíoltóir agus nuashonrú don chustaiméir."
      ],
      "courier": [
        "Seol orduithe dearbhaithe isteach i sreabhadh oibre curier tacaíochta go huathoibríoch.",
        "Sampla: ullmhaítear ordú COD dearbhaithe le haghaidh seachadta chuig an gcurier."
      ],
      "business-email": [
        "Seol agus faigh ríomhphost gairmiúil ar do ainm fearainn brandaithe féin.",
        "Sampla: faigheann sales@acme.com fiosrúcháin agus freagraíonn support@acme.com."
      ]
    }
  },
  "glv": {
    "checkout": {
      "liveInstruction": "Ree yn modh live shoh, ny meeag as creck eddyr, agh ayns yn doh-chlosh, kion tuittym? Curragh yn nuyll yannoo as co-raggey shoh; freayll ta'n sessioun live 10-mionnid; ta'n 'sending money' ayns shoh cooneyg er y cheet çheetyn as cooneyg er shoh agh auto-verify y choyr.",
      "trxInstruction": "Jeer Cash In veih ny storagh ny foddee coontag yindyssagh 'Send Money'. Ny lee er y 'auto-verify' myr shen er y Transaction ID (TrxID).",
      "enterNumberInstruction": "Cur magh dy numyr as claggey yn bouton '{action}'.",
      "offlineTitle": "Ta'n cooish-laggey 'Merchant Device' ayns 'Offline'",
      "offlineDescription": "Vea shen, cha nel y verifee auto-chooidagh raayllagh ayn.",
      "copyPersonal": "Coppee yn 'Personal Account' numyr shoh eaisht.",
      "sendMoneyOffline": "Send Money ny Cash In dy'n numyr shoh, ny tarroo coontag dy cheet er lhiam.",
      "trxOffline": "Gaiagh yn Transaction ID (TrxID) as cur e neuchroo. Myr t'ou mannagh yn merchant lesh 'online', mish ta coyr er dty chooid raad, ny nel shiu dy chooish yindyssagh uss an merchant.",
      "cashinNagad": "Ta Cash In ny 'Nagad' cha nel er co-chliaghtey; shoobys, dy vee er shiu moyl 'Send Money' from ny Nagad account elleh.",
      "cashinOther": "Roish dy veih Cash In, soilsh ny siopagh cre'n ve 'TrxID' eh; myr veagh cha nel, cha nel oo aastey. Eisht, tarroo cooish beg 'Send Money'.",
      "waitTrx": "Aeg er 'payment', coyrt 10–15 secondyn as cur yn TrxID reesht. Ta shiu goll er traoo yn cheer as goll agh back dy'n cheer ayns 24 o'yeragh dy auto-verify liorish dy TrxID.",
      "goApp": "Gow 'app' {provider} ny dial ' {dialCode} ' as roish 'Send Money'.",
      "confirmAuto": "Cur magh yn numyr coppee as yn chash, as creck er dty PIN dy auto-verify.",
      "dontClose": "Cur shiu fys y cheet shen cha nel eh carrey, my saillagh",
      "autoVerify": "Shegin dty paymmynt shoh er ve auto-verified",
      "successOffline": "Gura mie eu, {name}. Ta dty transaactiooin ruggit. Ta'n merchant nyn 'offline' er shoh. Ta'n email eill beg feer v'eh myr marish, myr t'ou 'online' as verifee dty paymmynt.",
      "successOnline": "Gura mie eu, {name}. Ta dty paymmynt ' {amount} ' liorish {provider} hom as bioag er son verifee."
    },
    "features": {
      "no-code-website": [
        "Cree as publish site syn e-commerce, ooyl-yannoo, blog ny news liorish forcuid ny code.",
        "Sample: publish aeg cree landing page as product post liorish course seller dashboard."
      ],
      "custom-domain": [
        "Kirree yn domayne shiu as shooyl cre'n digital taid 'professional' liorish faster routing.",
        "Sample: dty shop jean er www.acme.com ny s'cosoyr as platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side myr t'eh taid 'reliable campaign measurement'.",
        "Sample: purchase event t'eh cur er server as send liorish ad platform."
      ],
      "personal-mfs": [
        "Automate verifee dy payments 'Personal MFS' t'eh shassagh.",
        "Sample: Personal MFS payment beagh taail liorish website order."
      ],
      "local-gateway": [
        "Cur y local payment methods er y customers regionel.",
        "Sample: local buyer goaagh y checkout liorish regional gateway."
      ],
      "international-gateway": [
        "Cur international payment methods er y customers er y ayraght shoh.",
        "Sample: overseas buyer t'eh goaagh y checkout liorish global method."
      ],
      "notifications": [
        "Send payment as order updates dy customers as merchants.",
        "Sample: payment success s'crea alert dy merchant as update dy customer."
      ],
      "courier": [
        "Send confirmed orders lonnee er y courier workflow t'eh by automaat.",
        "Sample: confirmed COD order ooil hill liorish courier handoff."
      ],
      "business-email": [
        "Send as receive email professional er dty domayne brandagh.",
        "Sample: sales@acme.com jannoo inquiries as support@acme.com freayll."
      ]
    }
  },
  "grn": {
    "checkout": {
      "liveInstruction": "Eike live método reheve, ejapo ha emyesẽ pe cuenta nomemboa oipurũ vaʼerã rehegua ndoikói tape. Ojapóta 10 minuto reheve sesión live; oikove rire pe tiempo-pe, pe envío de plata oikotevẽta auto-verify pe paguetépe.",
      "trxInstruction": "Ehaʼarõ Cash In peteĩ almacén-pe térã eporandu pe otro tapicha oporanduha ojapo Send Money. Upéi e-auto-verify ojapóta Transaction ID (TrxID)-pe.",
      "enterNumberInstruction": "Eike pe número ha eclick '{action}' botón-pe.",
      "offlineTitle": "Aparato del comerciante offline",
      "offlineDescription": "Auto-verificación ndahaʼéi disponible tembiapo ryepýpe.",
      "copyPersonal": "Kopiate pe Personal Account número oñeʼẽvaʼerã.",
      "sendMoneyOffline": "Send Money térã Cash In pe número-pe, térã porandu peteĩ otro tapicha omoenvia plata.",
      "trxOffline": "Mbaʼetaʼỹ Transaction ID (TrxID) ha eike pepy. Oñeñandu vaʼerã comerciante ojapo online, remboʼepyrũta correo reheve, térã ikatu reñemombaʼe directo comerciante rehe.",
      "cashinNagad": "Cash In ndorekói Nagad-pe, upévare eporandu Send Money peteĩ otro Nagad cuenta-pe.",
      "cashinOther": "Antes Cash In, porandu pe comerciante si omboʼe TrxID; noñeʼẽi haʼe, ani reñemoirũ. Alternativamente, porandu otro tapicha oikuaau Send Money.",
      "waitTrx": "Peguereko rire pe pago, esperá 10–15 segundos ha eike pe TrxID pepy. Ikatu reho vaʼerã pe página ha úpeicha apyka 24 horas-pe oime hag̃ua auto-verify ojapóva pe TrxID reheve.",
      "goApp": "Irã {provider} app-pe térã marcar {dialCode} ha escoger 'Send Money'.",
      "confirmAuto": "Eike pe número kopiaha ha pe monto, upéi confirmá pe PIN reheve auto-verify haguére.",
      "dontClose": "Nderehechauka pórã pe página koʼẽnga, por favor",
      "autoVerify": "Pe pago rembiapo oñehaʼã oñemboguejy automáticamente",
      "successOffline": "Aguyje, {name}. Pe transacción remboʼe. Koʼágã comerciante oĩ offline. Reherru porãta correo reheve og̃uahẽ rire comerciante ojapo online ha omoĩ pe pago reheve verificación.",
      "successOnline": "Aguyje, {name}. Pe pago {amount} rehegua por {provider} oĩ ohasa ha oñehaʼã reñemombaʼe."
    },
    "features": {
      "no-code-website": [
        "Eike ha publicá e-commerce, educación, blog térã noticias sitios sin necesidad de coding.",
        "Ejemplo: publicá página de aterrizaje ha publicación de producto desde dashboard del vendedor del curso."
      ],
      "custom-domain": [
        "Conectá tu propio dominio y construí una identidad digital profesional con enrutamiento más rápido.",
        "Ejemplo: tu tienda corre en www.acme.com en vez de un subdominio de la plataforma."
      ],
      "capi": [
        "Enviá eventos de conversión server-side para medición de campañas confiable.",
        "Ejemplo: un evento de compra se envía del servidor a la plataforma de anuncios."
      ],
      "personal-mfs": [
        "Automatizá la verificación de pagos Personal MFS soportados.",
        "Ejemplo: un pago Personal MFS se empareja con el pedido del sitio web."
      ],
      "local-gateway": [
        "Conectá métodos de pago locales para clientes regionales.",
        "Ejemplo: un comprador local completa el checkout por medio de una pasarela regional."
      ],
      "international-gateway": [
        "Conectá métodos de pago internacionales para clientes en todo el mundo.",
        "Ejemplo: un comprador del exterior completa el checkout con un método global."
      ],
      "notifications": [
        "Enviá actualizaciones de pago y pedidos a clientes y comerciantes.",
        "Ejemplo: el éxito del pago dispara una alerta al comerciante y una actualización al cliente."
      ],
      "courier": [
        "Enviá pedidos confirmados al flujo de trabajo de mensajería soportado automáticamente.",
        "Ejemplo: un pedido COD confirmado se prepara para la entrega al mensajero."
      ],
      "business-email": [
        "Enviá y recibí correo profesional en tu propio dominio de marca.",
        "Ejemplo: sales@acme.com recibe consultas y support@acme.com responde."
      ]
    }
  },
  "gsw": {
    "checkout": {
      "liveInstruction": "Wähl d'Live-Methode, gib uf dr nöchschte Syte d'Kontonummer a wo du voirhersch göndisch und bestätig sie. E 10-Minute Live-Session fängt aa; wenn du während däre schickisch, wird d'Zahlig automatisch verifiziert.",
      "trxInstruction": "Mach e Cash In i mim Lade oder frag öpper anders z' Send Money. Denn auto-verifizier mit dr Transaction ID (TrxID).",
      "enterNumberInstruction": "Gib dini Nummer i und klick uf dr '{action}'-Button.",
      "offlineTitle": "Händler-Gerät offline",
      "offlineDescription": "D'automatisch Verifizierung isch vorübergehend nit verfügbar.",
      "copyPersonal": "Kopier d'Personal Account Nummer obez.",
      "sendMoneyOffline": "Send Money oder Cash In uf d'obig Nummer, oder fräg öpper anders, ob er schicke cha.",
      "trxOffline": "Hol der Transaction ID (TrxID) und gib sie hie untär ii. Wänn dr Händler wieder online isch, bechunnsch e Mail, oder kontaktier dr Händler direkt.",
      "cashinNagad": "Cash In isch bi Nagad nit erlaubt, drum schick bitte Send Money vo äm andere Nagad-Konto.",
      "cashinOther": "Vor em Cash In frag dr Ladä, ob si dr TrxID geh; wenn nit, mach nüt. Alternativ chasch öpper anders bityscha Send Money.",
      "waitTrx": "Nach dr Zaalig wart 10–15 Sekunde und gib dr TrxID hie ii. Du chasch die Syte verlah und bis zu 24 Stunde zruggcho zum auto-verifiziere mit dim TrxID.",
      "goApp": "Geh i d'{provider}-App oder wähl {dialCode} und wähl 'Send Money'.",
      "confirmAuto": "Gib d'kopiert Nummer und d'Bsuechtig ii, bestätig mit dim PIN für d'automatisch Verifizierung.",
      "dontClose": "Bitte schliess die Syte nit",
      "autoVerify": "Dini Zahlig wird automatisch verifiziert",
      "successOffline": "Merci, {name}. Dini Transaktion isch registriert. Dr Händler isch im Momänt offline. Du bechunnsch e Mail, wenn dr Händler wieder online chunt und dini Zahlig bestätigt.",
      "successOnline": "Merci, {name}. Dini Zahlig vu {amount} dür {provider} isch empfaange worde und wird überprüeft."
    },
    "features": {
      "no-code-website": [
        "Erstell und veröffentlich E-Commerce-, Bildungs-, Blog- oder News-Site ohni z'programmieren.",
        "Beispiel: veröffentlige e Landing-Page und e Produktpost us em Kurs-Verkäufer-Dashboard."
      ],
      "custom-domain": [
        "Verbinde dini eigene Domain und bau e professionelli digitale Identität mit schnäller Routing.",
        "Beispiel: Dini Shop lauft uf www.acme.com statt uf äm Platform-Subdomain."
      ],
      "capi": [
        "Sänd Conversion-Events serverseitig für verlässligi Kampagnenmessig.",
        "Beispiel: Es Kauf-Event wird vom Server an d'Ad-Plattform gschickt."
      ],
      "personal-mfs": [
        "Automatisier d'Verifizierig vo unterstützte Personal MFS-Bezahligä.",
        "Beispiel: Es Personal MFS-Zahlig wird mit ere Webshop-Bestellig abgegliche."
      ],
      "local-gateway": [
        "Verbinde lokal Bezahlsystem für regionali Chundä.",
        "Beispiel: Es lokals Chund beendet dr Checkout dür e regionale Gateway."
      ],
      "international-gateway": [
        "Verbinde internazionali Bezahlsystem für Chundä weltweit.",
        "Beispiel: Es usländischä Chund beendet dr Checkout mit ere globale Methode."
      ],
      "notifications": [
        "Schick Zahlungs- und Bestell-Updates an Chundä und Händler.",
        "Beispiel: E erfolgreiche Zahlung löst e Händler-Alarm und e Chunde-Update uus."
      ],
      "courier": [
        "Schick bestätigti Bestellige automatisch i e unterstützti Kurier-Workflow.",
        "Beispiel: E bestätigti COD-Bestellig wird für d'Übergab an dr Kurier vorbereitet."
      ],
      "business-email": [
        "Sänd und empfäng professionelli E-Mails uf diner eigene gebrandete Domain.",
        "Beispiel: sales@acme.com empfängt Anfragen und support@acme.com antwortet."
      ]
    }
  },
  "hat": {
    "checkout": {
      "liveInstruction": "Chwazi metòd live la, antre epi konfime nimewo kont lan w ap voye lajan depi li sou pwochen paj la. Yon sesyon live 10 minit ap kòmanse; voye lajan pandan li ap otomatikman verifye peman an.",
      "trxInstruction": "Fè Cash In nan yon magazen oswa mande yon lòt moun pou Send Money. Apre sa verifye otomatikman ak Transaction ID (TrxID).",
      "enterNumberInstruction": "Antre nimewo w epi klike bouton '{action}'.",
      "offlineTitle": "Aparèy Machann nan Offline",
      "offlineDescription": "Auto-verification pa disponib tanporèman.",
      "copyPersonal": "Kopi nimewo Personal Account ki anlè a.",
      "sendMoneyOffline": "Send Money oswa Cash In sou nimewo ki anlè a, oswa mande yon lòt moun voye lajan.",
      "trxOffline": "Ranmase Transaction ID (TrxID) epi antre li anba a. Lè machann nan vin online, w ap resevwa yon imel, oswa ou ka kontakte machann nan dirèkteman.",
      "cashinNagad": "Cash In pa pèmèt nan Nagad, tanpri Send Money soti nan yon lòt kont Nagad.",
      "cashinOther": "Anvan ou fè Cash In, mande machann nan si li pral bay TrxID; si li pa bay, pa kontinye. Altènativman, mande yon lòt moun Send Money.",
      "waitTrx": "Apre peman an, tann 10–15 segonn epi antre TrxID anba a. Ou ka kite paj sa epi retounen sou paj peman sa a nenpòt ki lè nan lespas 24 èdtan pou verifye otomatikman ak TrxID ou.",
      "goApp": "Ale nan aplikasyon {provider} oswa rele {dialCode} epi chwazi 'Send Money'.",
      "confirmAuto": "Antre nimewo ak montan ou te kopye a, epi konfime avèk PIN ou pou verifye otomatikman.",
      "dontClose": "Tanpri pa fèmen paj sa a",
      "autoVerify": "Peman ou a ap verifye otomatikman",
      "successOffline": "Mèsi, {name}. Transaksyon ou an anrejistre. Machann nan pa konekte kounye a. Ou pral resevwa yon imel lè machann nan vini sou liy epi verifye peman ou.",
      "successOnline": "Mèsi, {name}. Peman {amount} ou te fè atravè {provider} resevwa epi li ap verifye kounye a."
    },
    "features": {
      "no-code-website": [
        "Kreye epi pibliye sit e-commerce, edikasyon, blog, oswa nouvèl san kodaj.",
        "Egzanp: pibliye yon paj aterisaj ak yon post pwodwi depi tablodbò vandè kou a."
      ],
      "custom-domain": [
        "Konekte pwòp domèn ou epi bati yon idantite dijital pwofesyonèl ak routage pi rapid.",
        "Egzanp: magazen ou a kouri sou www.acme.com olye de subdomain platfòm lan."
      ],
      "capi": [
        "Voye evènman konvèsyon sou bò sèvè pou mezi kanpay ki fyab.",
        "Egzanp: yon evènman achte voye depi sèvè a bay platfòm piblisite a."
      ],
      "personal-mfs": [
        "Otomatize verifikasyon peman Personal MFS sipòte yo.",
        "Egzanp: yon peman Personal MFS matche ak lòd sit wèb la."
      ],
      "local-gateway": [
        "Konekte metòd peman lokal pou kliyan rejyonal yo.",
        "Egzanp: yon achtè lokal konplete checkout atravè yon pòtay rejyonal."
      ],
      "international-gateway": [
        "Konekte metòd peman entènasyonal pou kliyan atravè lemond.",
        "Egzanp: yon achtè aletranje konplete checkout ak yon metòd mondyal."
      ],
      "notifications": [
        "Voye mizajou peman ak lòd bay kliyan ak machann.",
        "Egzanp: siksè peman lan deklanche yon alèt pou machann lan ak yon mizajou pou kliyan an."
      ],
      "courier": [
        "Voye lòd konfime yo nan workflow kourye sipòte a otomatikman.",
        "Egzanp: yon lòd COD konfime prepare pou remèt bay kourye a."
      ],
      "business-email": [
        "Voye epi resevwa imèl pwofesyonèl sou pwòp domèn mak ou.",
        "Egzanp: sales@acme.com resevwa demann epi support@acme.com reponn."
      ]
    }
  },
  "her": {
    "checkout": {
      "liveInstruction": "Tjinga modhila ya live, nera na taratara omendjo nomboro ya akaunti yo oya okugandja ombinga ya erarie. Ete ongundi e 10-miniti live session; okuya okururikira ombinga mo, ozongure okuverifikera payment otji naari.",
      "trxInstruction": "Yamona Cash In okuzongondjisa ombinga shoppe po okauha omuntu omu kukauha Send Money. Zongure okuauto-verify na Transaction ID (TrxID).",
      "enterNumberInstruction": "Nera nomboro yawe mo kagura knopu ya '{action}'.",
      "offlineTitle": "Omapango gOmupashi giiyemo (Merchant Device) gi offline",
      "offlineDescription": "Auto-verification okutja okuza okuunda.",
      "copyPersonal": "Kopela Personal Account nomboro yo eendeshi.",
      "sendMoneyOffline": "Send Money po Cash In kusomboro eendeshi, po omuntu omu uwene kukauha ombinga.",
      "trxOffline": "Tjika Transaction ID (TrxID) mo nera okurya kOudho. Tjinga omupashi otji oyemo online, otjengwapo ongandi nge email, po omboha mupu omupashi gidyo.",
      "cashinNagad": "Cash In ohandi kNagad, ongeruka Send Money ke na akaunti ya Nagad yomunene.",
      "cashinOther": "Muva Cash In, seru omu shopkeeper ifa olapa TrxID; mo ifa ka ma, onyango. Omalela, seru omuuntu omu kukauha Send Money.",
      "waitTrx": "Ondi oma ombinga, tarika 10–15 sekondi mo nera okurya TrxID kusini. Uika a page po ulele okurya papage ya payment mu na 24 yero okauto-verify na TrxID yawe.",
      "goApp": "Yenda ku {provider} app po dial {dialCode} mo tihwe 'Send Money'.",
      "confirmAuto": "Nera nomboro ya kopiya mo amount, mo konfirmara na PIN yawe okuauto-verify.",
      "dontClose": "Ovakuruka, onga shuka o page oe",
      "autoVerify": "Okuverifikera ombinga yawe oku auto",
      "successOffline": "Tatima, {name}. Ombinga yo orekodidhwa. Omupashi okuheldi koko offline. Ongi notified nge email mu na omupashi otji oyemo online mo ovetikare ombinga yawe.",
      "successOnline": "Tatima, {name}. Ombinga yawe ya {amount} kuby {provider} oya ohandi mo okuverifikera."
    },
    "features": {
      "no-code-website": [
        "Tjika mo publish e-commerce, education, blog, po news sites ounga kodina.",
        "Ombira: publish landing page mo product post ku dashboard ya seller wa course."
      ],
      "custom-domain": [
        "Poka domain yawe mo tji build professional digital identity na faster routing.",
        "Ombira: store yawe eenda er www.acme.com esikwe ku platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side ombinga nga reliable campaign measurement.",
        "Ombira: purchase event e send ku server na ad platform."
      ],
      "personal-mfs": [
        "Tjita kutja okuzikamisa omafutiro wa Personal MFS nge yandjerwa ku yende otjini.",
        "Ombira: personal MFS payment e match ku website order."
      ],
      "local-gateway": [
        "Connect local payment methods ku regional customers.",
        "Ombira: local buyer e complete checkout via regional gateway."
      ],
      "international-gateway": [
        "Connect international payment methods ku customers worldwide.",
        "Ombira: overseas buyer e complete checkout with a global method."
      ],
      "notifications": [
        "Send payment and order updates ku customers na merchants.",
        "Ombira: payment success e trigger merchant alert na customer update."
      ],
      "courier": [
        "Send confirmed orders into supported courier workflow automatically.",
        "Ombira: confirmed COD order e prepare for courier handoff."
      ],
      "business-email": [
        "Tuma no kugamena email yokuvezelela mo domain yenyu oya tjihererewonwa.",
        "sales@acme.com oiporopo yoombazo oya gamenwa, nonando support@acme.com ota penduka."
      ]
    }
  },
  "hgm": {
    "checkout": {
      "liveInstruction": "Sana live method, garib nūmber ǁke hao ǀuri sa re xi page, ǁkha nūmber ǀuri ǀa, da ǁkhari. 10-minute live sesion ǀo, ǁkhu ǁkhāre; khoǀn ǁkhāre ǀuri kho 'sending money' ǂoaxa auto-verify.",
      "trxInstruction": "Cash In ǁgān shop eo ǀuri ǁkha, kho ǂnā ǀɔi ǀuri Send Money. ǁkhī auto-verify ǂnā Transaction ID (TrxID).",
      "enterNumberInstruction": "ǁkhai nūmber ǀuri ǁkha '{action}' button ǁkhari.",
      "offlineTitle": "Merchant Device ǀo offline",
      "offlineDescription": "Auto-verification ǁkha ǂnā ǀaixanǀa ǂnāxa.",
      "copyPersonal": "Kōpi Personal Account nūmber kha ǁkha.",
      "sendMoneyOffline": "Send Money ka Cash In ǁnūmber ǁkha, ǁkāi ǀuri ǀnān ǁgāa Send Money.",
      "trxOffline": "Khop Transaction ID (TrxID) ǁkhai ǀa, kho ǁkha di. Nūa merchant ǁkha online ǁgai, ǁkhai email ǂnā, ǁkha ka ǁkhoa merchant ǂnā direct.",
      "cashinNagad": "Cash In ǁkha Nagad ǀa ǂnā ǀaixanǀa, ǁkha Send Money kha ǁnūmber Nagad ke.",
      "cashinOther": "Ro Cash In, ǁkhoa shopkeeper ǁkhā do ǁkha TrxID ǁkha; ǁkha ǂnā ǀa, ǁkhāi ǁkha. ǁkha alternative, ǁkhoa ǀuri ǀnān Send Money.",
      "waitTrx": "ǁkha payment, 10–15 sekond ǁkhai, kho ǁkha TrxID ǁkha. ǁkha ǀuri ǁnū page ǁkha ǀuri ǀā 24 hora ǁkha ǁvān auto-verify TrxID ǁkha.",
      "goApp": "Gā to {provider} app ǁkha dial {dialCode} ǁkha 'Send Money'.",
      "confirmAuto": "ǁkha kopii nūmber ǁkha amount, ǁkha confirm ǁkha PIN ǀuri auto-verify.",
      "dontClose": "ǁkha ǂnā ǀa, ǁkha kua ǀa page ǁkha",
      "autoVerify": "ǁkha payment ǀuri ǁkha auto-verify ǂnā",
      "successOffline": "ǀa ǁnâ, {name}. ǁkha transaction ǀuri ǁgai. Merchant ǁkha offline. ǁkha notified ǁkhai email ǁkha my merchant ǁkha online ǁgai mo verify payment.",
      "successOnline": "ǀa ǁnâ, {name}. ǁkha payment {amount} ǁkha {provider} ǁkha ǁgai mo ǁkha verify."
    },
    "features": {
      "no-code-website": [
        "Gāri a publish e-commerce, education, blog, na news sites kho ǁkha without coding.",
        "Example: publish landing page na product post from course seller dashboard."
      ],
      "custom-domain": [
        "Connect khō domain kho build professional digital identity with faster routing.",
        "Example: your store run on www.acme.com insteaḏ of platform subdomain."
      ],
      "capi": [
        "!nâǀâsa server-side conversion event tse ǁnâ-khare tse ǀʼāren ge ǀgôanib kampain-measurement.",
        "khara purchase event tse server-n ge ad platform-n ǀgâb."
      ],
      "personal-mfs": [
        "Mā-amhe Personal MFS mâibasens ǃnôaǃgâsa otomatiki dī.",
        "Personal MFS payment tse website ǃnāb order-n ǁnāb ǃgâab."
      ],
      "local-gateway": [
        "ǀAoni-ǁkhâi customer-nes ra local payment ǃnāb ǁnāb konekt.",
        "ǀAoni ǂkhāib buyer tse regional gateway ǃnāb checkout ǀgâb."
      ],
      "international-gateway": [
        "tse ǁama-ǁkhâi customer-nes ra international payment ǃnāb ǁnāb konekt.",
        "overseas buyer tse global method ǃnāb checkout ǀgâb."
      ],
      "notifications": [
        "payment ǃnāb order update tse customer ǁnāb merchant ǃās ge ǂōǀnāb.",
        "payment success kâ merchant alert ǁnāb customer update ǃāb."
      ],
      "courier": [
        "Confirmed order tsî supported courier ǃnāb workflow ǁnāb automātis ge ǁnāb ǃās.",
        "confirmed COD order tse courier handoff ǀgâb ǃgâab."
      ],
      "business-email": [
        "ǂGâi-branded domain ǁnāb professional email ǃnāb ǂā ǁnāb ǃās ǁnāb ǃgâab.",
        "sales@acme.com ǁnāb inquiry ǀgâb ǁnāb support@acme.com ǁnāb reply ǀgâb."
      ]
    }
  },
  "hif": {
    "checkout": {
      "liveInstruction": "Live method chuniye, agle page par jis account number se aap paise bhejenge use daaliye aur confirm kijiye. 10-minute ka live session shuru hoga; is dauran paise bhejne par payment auto-verify ho jayega.",
      "trxInstruction": "Dukaan se Cash In kijiye ya kisi aur se Send Money karwa lijiye. Phir Transaction ID (TrxID) se auto-verify kijiye.",
      "enterNumberInstruction": "Apna number daaliye aur '{action}' button par click kijiye.",
      "offlineTitle": "Vyāpārī kā upkaran offline hai",
      "offlineDescription": "Auto-verification temporary roop se upalabdh nahin hai.",
      "copyPersonal": "Upar diya gaya Personal Account number copy kijiye.",
      "sendMoneyOffline": "Upar diye gaye number par Send Money ya Cash In kijiye, ya kisi aur se paise bhejne ko kahiye.",
      "trxOffline": "Transaction ID (TrxID) ikattha kijiye aur neeche daaliye. Jab vyāpārī online aayega, aapko email se suchit kiya jayega, ya aap seedha vyāpārī se sampark kar sakte hain.",
      "cashinNagad": "Nagad mein Cash In allowed nahin hai, isliye kripya kisi anya Nagad account se Send Money kijiye.",
      "cashinOther": "Cash In karne se pahle dukandaar se puchhiye ki kya ve TrxID denge; agar nahin, to aage na badhiye. Vikalp ke roop mein kisi aur se Send Money karwa lijiye.",
      "waitTrx": "Bhugtan ke baad 10–15 second intazaar kijiye aur neeche TrxID daaliye. Aap is page ko chhod kar 24 ghante ke andar kisi bhi samay wapas aa kar apne TrxID se auto-verify kar sakte hain.",
      "goApp": "Apne {provider} app par jayiye ya {dialCode} dial kijiye aur 'Send Money' chuniye.",
      "confirmAuto": "Copy kiya hua number aur amount daaliye, phir apne PIN se confirm kijiye taaki auto-verify ho sake.",
      "dontClose": "Kripya is page ko band na karein",
      "autoVerify": "Aapka bhugtan svachalit roop se verify kiya ja raha hai",
      "successOffline": "Dhanyavaad, {name}. Aapka len-den darj kar liya gaya hai. Vyāpārī is samay offline hai. Jab vyāpārī online aakar aapke bhugtan ko verify karega to aapko email ke jariye suchit kiya jayega.",
      "successOnline": "Dhanyavaad, {name}. {provider} ke jariye {amount} ka aapka bhugtan prapt ho gaya hai aur uska verification ho raha hai."
    },
    "features": {
      "no-code-website": [
        "Coding ke bina e-commerce, education, blog, ya news site banayein aur publish kijiye.",
        "Udaharan: course seller dashboard se ek landing page aur product post publish kijiye."
      ],
      "custom-domain": [
        "Apna domain jodiye aur tez routing ke saath ek professional digital pahchaan banaiye.",
        "Udaharan: aapki dukaan www.acme.com par chalegi, platform subdomain par nahi."
      ],
      "capi": [
        "Bharosemand campaign maapan ke liye conversion events server-side bhejiye.",
        "Udaharan: ek purchase event server se ad platform ko bheja jata hai."
      ],
      "personal-mfs": [
        "Supported Personal MFS payment verification ko automate kijiye.",
        "Udaharan: ek Personal MFS payment website order se match hoti hai."
      ],
      "local-gateway": [
        "Kshetriya grahakon ke liye local payment methods connect kijiye.",
        "Udaharan: ek local kharidar regional gateway se checkout complete karta hai."
      ],
      "international-gateway": [
        "Duniya bhar ke grahakon ke liye international payment methods connect kijiye.",
        "Udaharan: ek videshi kharidar global method se checkout complete karta hai."
      ],
      "notifications": [
        "Grahak aur vyāpārī ko payment aur order updates bhejiye.",
        "Udaharan: payment success se vyāpārī ko alert aur grahak ko update milta hai."
      ],
      "courier": [
        "Confirmed orders ko supported courier workflow mein svachalit roop se bhejiye.",
        "Udaharan: ek confirmed COD order courier handoff ke liye taiyar kiya jata hai."
      ],
      "business-email": [
        "Apne branded domain par professional email bhejiye aur prapt kijiye.",
        "Udaharan: sales@acme.com enquiries prapt karta hai aur support@acme.com jawab deta hai."
      ]
    }
  },
  "hmo": {
    "checkout": {
      "liveInstruction": "Selectim live method, putim na confirmim account namba we bai yu salim moni long next peij. 10-minute live sesen bai stat; sapos yu salim moni insait long dispela, payment bai auto-verify.",
      "trxInstruction": "Cash In long shop o askim narapela long Send Money. Bihain auto-verify wantaim Transaction ID (TrxID).",
      "enterNumberInstruction": "Putim namba bilong yu na klik long '{action}' button.",
      "offlineTitle": "Merchant device i offline",
      "offlineDescription": "Auto-verification ino stap nau.",
      "copyPersonal": "Copyim Personal Account namba long antap.",
      "sendMoneyOffline": "Send Money o Cash In long namba we stap antap, o askim narapela long sendim moni.",
      "trxOffline": "Kolem Transaction ID (TrxID) na putim long dispela hap. Taim merchant i kam online bai yu kisim email, o yu inap contactim merchant stret.",
      "cashinNagad": "Cash In i no allow long Nagad, olsem askim yu Send Money long narapela Nagad account.",
      "cashinOther": "Bifo yu Cash In, askim shopkeeper sapos ol bai gibim TrxID; sapos nogat, no go. O askim narapela long Send Money.",
      "waitTrx": "Bihain long payment, wetim 10–15 sekon na putim TrxID long antap. Yu ken go bek long dispela peij insait long 24 awa bilong auto-verify wantaim TrxID.",
      "goApp": "Go long {provider} app o dial {dialCode} na selektim 'Send Money'.",
      "confirmAuto": "Putim copy namba na amount, na confirm wantaim PIN bilong yu bilong auto-verify.",
      "dontClose": "Plis no close-im dispela peij",
      "autoVerify": "Payment bilong yu i stap auto-verify",
      "successOffline": "Tenkyu, {name}. Transaction bilong yu i registrim. Merchant i offline nau. Yu bai kisim email taim merchant i kam online na verifyim payment bilong yu.",
      "successOnline": "Tenkyu, {name}. Payment bilong yu {amount} tru {provider} i kisim na i stap long verify."
    },
    "features": {
      "no-code-website": [
        "Yu ken wokim na publishim e-commerce, education, blog o news sait bilong no coding.",
        "Example: publishim wanpela landing peij na product post long course seller dashboard."
      ],
      "custom-domain": [
        "Konektim yu domain na mekim professional digital nem wantaim kwik routing.",
        "Example: yu stor i run long www.acme.com istap long platform subdomain."
      ],
      "capi": [
        "Senim conversion events long server-side long mekim campaign measurement tru.",
        "Example: wanpela purchase event i sen long server igo long ad platform."
      ],
      "personal-mfs": [
        "Automateim supported Personal MFS payment verification.",
        "Example: wanpela Personal MFS payment i match long website order."
      ],
      "local-gateway": [
        "Konek lokal payment methods bilong regional customers.",
        "Example: wanpela local buyer i completeim checkout tru regional gateway."
      ],
      "international-gateway": [
        "Konek international payment methods bilong customers long whole world.",
        "Example: wanpela overseas buyer i completeim checkout wantaim global method."
      ],
      "notifications": [
        "Senim payment na order updates long customers na merchants.",
        "Example: payment success i triggerim merchant alert na customer update."
      ],
      "courier": [
        "Senim confirmed orders igo long supported courier workflow auto.",
        "Example: wanpela confirmed COD order i redi long courier handoff."
      ],
      "business-email": [
        "Senim na kisim professional email long yu branded domain.",
        "Example: sales@acme.com kisim enquiries na support@acme.com i reply."
      ]
    }
  },
  "hrv": {
    "checkout": {
      "liveInstruction": "Odaberite način uživo, unesite i potvrdite broj računa s kojeg ćete poslati novac na sljedećoj stranici. Započet će 10-minutna live sesija; slanje novca tijekom nje automatski će potvrditi uplatu.",
      "trxInstruction": "Naplatite Cash In u trgovini ili zamolite nekog drugog da izvrši Send Money. Zatim automatski potvrdite pomoću Transaction ID (TrxID).",
      "enterNumberInstruction": "Unesite svoj broj i kliknite na '{action}' gumb.",
      "offlineTitle": "Uređaj trgovca je offline",
      "offlineDescription": "Auto-verifikacija je privremeno nedostupna.",
      "copyPersonal": "Kopirajte gore navedeni Personal Account broj.",
      "sendMoneyOffline": "Izvršite Send Money ili Cash In na gore navedeni broj ili zamolite nekog drugog da pošalje novac.",
      "trxOffline": "Sakupite Transaction ID (TrxID) i unesite ga dolje. Kad trgovac bude online, bit ćete obaviješteni e-poštom ili možete izravno kontaktirati trgovca.",
      "cashinNagad": "Cash In nije dozvoljen u Nagad, stoga molimo izvršite Send Money s drugog Nagad računa.",
      "cashinOther": "Prije Cash In pitajte trgovca hoće li vam dati TrxID; ako neće, nemojte nastaviti. Alternativno, zamolite nekog drugog da izvrši Send Money.",
      "waitTrx": "Nakon uplate pričekajte 10–15 sekundi i unesite TrxID dolje. Možete napustiti ovu stranicu i vratiti se na ovu stranicu plaćanja bilo kada unutar 24 sata kako biste automatski potvrdili pomoću svog TrxID-a.",
      "goApp": "Idite u {provider} aplikaciju ili pozovite {dialCode} i odaberite 'Send Money'.",
      "confirmAuto": "Unesite kopirani broj i iznos, zatim potvrdite svoj PIN-om za automatsku verifikaciju.",
      "dontClose": "Molimo ne zatvarajte ovu stranicu",
      "autoVerify": "Vaša uplata se automatski verificira",
      "successOffline": "Hvala, {name}. Vaša transakcija je zabilježena. Trgovac je trenutno offline. Bit ćete obaviješteni e-poštom nakon što trgovac postane online i potvrdi vašu uplatu.",
      "successOnline": "Hvala, {name}. Vaša uplata od {amount} putem {provider} je zaprimljena i u procesu provjere."
    },
    "features": {
      "no-code-website": [
        "Izradite i objavite e-commerce, edukacijske, blog ili novinske stranice bez kodiranja.",
        "Primjer: objavite landing stranicu i objavu proizvoda iz nadzorne ploče prodavača tečaja."
      ],
      "custom-domain": [
        "Povežite vlastitu domenu i izgradite profesionalni digitalni identitet s bržim rutiranjem.",
        "Primjer: vaša trgovina radi na www.acme.com umjesto na poddomeni platforme."
      ],
      "capi": [
        "Pošaljite konverzijske događaje server-side za pouzdano mjerenje kampanja.",
        "Primjer: događaj kupnje šalje se sa servera platformi za oglašavanje."
      ],
      "personal-mfs": [
        "Automatizirajte provjeru plaćanja podržanih Personal MFS računa.",
        "Primjer: Personal MFS uplata se povezala s narudžbom na web-stranici."
      ],
      "local-gateway": [
        "Povežite lokalne metode plaćanja za regionalne kupce.",
        "Primjer: lokalni kupac završava checkout putem regionalnog gatewaya."
      ],
      "international-gateway": [
        "Povežite međunarodne metode plaćanja za kupce širom svijeta.",
        "Primjer: kupac iz inozemstva dovršava kupnju globalnom metodom."
      ],
      "notifications": [
        "Pošaljite obavijesti o plaćanju i narudžbama kupcima i trgovcima.",
        "Primjer: uspjeh plaćanja pokreće obavijest trgovcu i ažuriranje kupca."
      ],
      "courier": [
        "Automatski pošaljite potvrđene narudžbe u podržani courier workflow.",
        "Primjer: potvrđena COD narudžba priprema se za predaju courieru."
      ],
      "business-email": [
        "Šaljajte i primajte profesionalne e-poruke na vlastitoj brendiranoj domeni.",
        "Primjer: sales@acme.com prima upite, a support@acme.com odgovara."
      ]
    }
  },
  "hun": {
    "checkout": {
      "liveInstruction": "Válassza ki az élő módot, majd a következő oldalon adja meg és erősítse meg azt a számlaszámot, amelyről pénzt fog küldeni. Elindul egy 10 perces élő munkamenet; ha ezalatt küld pénzt, a fizetés automatikusan ellenőrzésre kerül.",
      "trxInstruction": "Cash In a boltból vagy kérje meg valaki mást, hogy végezzen Send Money tranzakciót. Ezután automatikusan ellenőrizze a Transaction ID (TrxID) használatával.",
      "enterNumberInstruction": "Adja meg a számát, majd kattintson a '{action}' gombra.",
      "offlineTitle": "Az eladó eszköze offline",
      "offlineDescription": "Az automatikus ellenőrzés ideiglenesen nem elérhető.",
      "copyPersonal": "Másolja ki a fent található Personal Account számot.",
      "sendMoneyOffline": "Végezzen Send Money vagy Cash In tranzakciót a fenti számra, vagy kérje meg valaki mást, hogy küldjön pénzt.",
      "trxOffline": "Gyűjtse össze a Transaction ID-t (TrxID) és írja be alább. Amikor az eladó online lesz, e-mailben értesítjük, vagy közvetlenül felveheti vele a kapcsolatot.",
      "cashinNagad": "Nagad esetén a Cash In nem engedélyezett, ezért kérjük, hogy egy másik Nagad számláról végezze el a Send Money tranzakciót.",
      "cashinOther": "A Cash In előtt kérdezze meg az eladót, hogy biztosítja-e a TrxID-t; ha nem, ne folytassa. Alternatívaként kérje meg valaki mást, hogy végezzen Send Money tranzakciót.",
      "waitTrx": "A fizetés után várjon 10–15 másodpercet, majd adja meg az alábbi TrxID-t. Ezt az oldalt elhagyhatja, és bármikor visszatérhet erre az oldalra 24 órán belül, hogy TrxID-jával automatikusan ellenőrizze a fizetést.",
      "goApp": "Nyissa meg a {provider} alkalmazást vagy tárcsázza a {dialCode}-t, majd válassza a 'Send Money' lehetőséget.",
      "confirmAuto": "Adja meg a másolt számot és az összeget, majd a PIN-kódjával erősítse meg az automatikus ellenőrzéshez.",
      "dontClose": "Kérjük, ne zárja be ezt az oldalt",
      "autoVerify": "A fizetése automatikusan ellenőrzés alatt áll",
      "successOffline": "Köszönjük, {name}. Tranzakciója rögzítve lett. Az eladó jelenleg offline. E-mailben értesítjük, amikor az eladó visszatér az online állapotba és ellenőrzi a fizetését.",
      "successOnline": "Köszönjük, {name}. A {provider} által küldött {amount} összegű fizetését fogadtuk és ellenőrizzük."
    },
    "features": {
      "no-code-website": [
        "Kódolás nélkül hozzon létre és tegyen közzé e-kereskedelmi, oktatási, blog vagy híroldalakat.",
        "Példa: jelentessen meg egy landing oldalt és termékbejegyzést a tanfolyam eladó irányítópultjáról."
      ],
      "custom-domain": [
        "Csatlakoztassa saját domainjét, és építsen professzionális digitális identitást gyorsabb útválasztással.",
        "Példa: az áruháza a www.acme.com címen fut a platform aldomainje helyett."
      ],
      "capi": [
        "Küldjön szerver-oldali konverziós eseményeket a megbízható kampányméréshez.",
        "Példa: egy vásárlási eseményt a szerver küld az hirdetési platformnak."
      ],
      "personal-mfs": [
        "Automatizálja a támogatott Personal MFS fizetések ellenőrzését.",
        "Példa: egy Personal MFS fizetés egyeztetésre kerül a webáruházi rendeléshez."
      ],
      "local-gateway": [
        "Csatlakoztasson helyi fizetési módszereket a regionális vásárlók számára.",
        "Példa: egy helyi vásárló egy regionális gateway-en keresztül fejezi be a fizetést."
      ],
      "international-gateway": [
        "Csatlakoztasson nemzetközi fizetési módszereket a világ minden tájáról érkező vásárlók számára.",
        "Példa: egy külföldi vásárló globális módszerrel fejezi be a fizetést."
      ],
      "notifications": [
        "Küldjön értesítéseket a fizetésekről és rendelések állapotáról vásárlóknak és kereskedőknek.",
        "Példa: a fizetés sikeressége értesítést küld a kereskedőnek és frissítést a vásárlónak."
      ],
      "courier": [
        "A megerősített rendelések automatikusan bekerülnek a támogatott futárrendszerbe.",
        "Példa: egy megerősített utánvétes rendelést előkészítenek a futár átadásához."
      ],
      "business-email": [
        "Küldjön és fogadjon professzionális e-maileket a saját márkázott domainjén.",
        "Példa: a sales@acme.com fogadja a megkereséseket, a support@acme.com pedig válaszol."
      ]
    }
  },
  "hye": {
    "checkout": {
      "liveInstruction": "Ընտրեք live մեթոդը, հաջորդ էջում մուտքագրեք և հաստատեք այն հաշվի համարը, որը՜րից կուղարկեք միջոցներ։ Սկսվելու է 10 րոպե տևողությամբ live նստաշրջան՝ և դրա ընթացքում ուղարկածը ավտոմատ կհաստատվի։",
      "trxInstruction": "Cash In արեք խանութից կամ խնդրեք ուրիշ մեկին ութուղարկել Send Money։ Ապա ավտոմատ հայտնաբերեք Transaction ID (TrxID)-ով։",
      "enterNumberInstruction": "Մուտքագրեք ձեր համարը և սեղմեք '{action}' կոճակը։",
      "offlineTitle": "Վաճառողի սարքը Offline է",
      "offlineDescription": "Auto-verification-ը ժամանակավորապես անընդմեջ հասանելի չէ։",
      "copyPersonal": "Ավելի վերում նշված Personal Account համարը պատճենեք։",
      "sendMoneyOffline": "Send Money կամ Cash In կատարե՛ք վերևի համարը, կամ խնդրեք ուրիշ մեկին ուղարկել գումար։",
      "trxOffline": "Հավաքեք Transaction ID (TrxID)-ը և մուտքագրեք այն ներքևում։ Երբ վաճառողը կդառնա online, ձեզ կհասցվի հաղորդագրություն էլ.փոստով, կամ կարող եք ուղղակի կապվել վաճառողի հետ։",
      "cashinNagad": "Nagad-ում Cash In թույլատրված չէ, խնդրում ենք կատարեք Send Money այլ Nagad հաշվից։",
      "cashinOther": "Cash In-ից առաջ հարցրեք խանութավարին՝ արդյո՞ք կտրամադրեն TrxID․ եթե ոչ, μην շարունակություն։ Այլընտրանքորեն խնդրեք ուրիշ մեկին կատարել Send Money։",
      "waitTrx": "Վճարումը կատարելուց հետո սպասեք 10–15 վայրկյան և մուտքագրեք TrxID-ն ներքևում։ Դուք կարող եք լքել այս էջը և վերադառնալ վճարման էջին մինչև 24 ժամվա ընթացքում՝ ավտոմատ ստուգելու համար ձեր TrxID-ով։",
      "goApp": "Գնացեք {provider} հավելված կամ զանգահարեք {dialCode} և ընտրեք 'Send Money'։",
      "confirmAuto": "Մուտքագրեք պատճենավորված համարը և գումարը, ապա հաստատեք ձեր PIN-ով՝ ավտոմատ վերբեռնման համար։",
      "dontClose": "Խնդրում ենք չփակել այս էջը",
      "autoVerify": "Ձեր վճարումը ավտոմատ կերպով թերթվում է",
      "successOffline": "Շնորհակալություն, {name}։ Ձեր գործարքը գրանցվել է։ Վաճառողը այժմ offline է։ Երբ վաճառողը կդառնա online և կհաստատի ձեր վճարումը, ձեզ կհատկացվի նամակ էլփոստով։",
      "successOnline": "Շնորհակալություն, {name}։ Ձեր {amount}-ի վճարումը {provider}-ով ստացվել է և այժմ հաստատվում է։"
    },
    "features": {
      "no-code-website": [
        "Ս withoutcoding-ով ստեղծեք և հրապարակեք e-commerce, կրթական, բլոգ կամ լրատվական կայքեր։",
        "Օրինակ՝ հրապարակեք landing էջ և արտադրանքի գրառում՝ course seller dashboard-ից։"
      ],
      "custom-domain": [
        "Կցեք ձեր սեփական տիրույթը և ստեղծեք պրոֆեսիոնալ թվային ինքնություն արագ երթուղավորմամբ։",
        "Օրինակ՝ ձեր խանութը يعمل է www.acme.com հասցեով ոչ թե platform-ի ենթատիրույթով։"
      ],
      "capi": [
        "Ուղարկեք conversion իրադարձություններ server-side` հուսալի արշավային չափորոշման համար։",
        "Օրինակ՝ purchase իրադարձությունը ուղարկվում է սերվերից դեպի գովազդային հարթակը։"
      ],
      "personal-mfs": [
        "Ավտոմատացրե՛ք աջակցվող Personal MFS վճարումների հաստատումն։",
        "Օրինակ՝ Personal MFS վճարումը համարվում է կայքի պատվերի հետ։"
      ],
      "local-gateway": [
        "Միացրեք տեղական վճարային մեթոդները տարածաշրջանային հաճախորդների համար։",
        "Օրինակ՝ տեղացի գնորդը ավարտում է վճարումը միջոցով տարածաշրջանային gateway։"
      ],
      "international-gateway": [
        "Միացրեք միջազգային վճարային մեթոդները ամբողջ աշխարհի հաճախորդների համար։",
        "Օրինակ՝ օտարերկրյա գնորդը ավարտում է վճարումը գլոբալ մեթոդով։"
      ],
      "notifications": [
        "Ուղարկեք վճարման և պատվերի լրացումներ հաճախորդներին և վաճառողներին։",
        "Օրինակ՝ վճարումը հաջողությամբ նշելուց հետո վաճառողը և հաճախորդը ստանում են համապատասխան ծանուցումներ։"
      ],
      "courier": [
        "Ավտոմատ ուղարկեք հաստատված պատվերները աջակցվող courier workflow մեջ։",
        "Օրինակ՝ հաստատված COD պատվերը պատրաստվում է courier-ին հանձնելու համար։"
      ],
      "business-email": [
        "Ուղարկեք և ստացեք պրոֆեսիոնալ էլ-փոստ ձեր սեփական բրենդավորված տիրույթով։",
        "Օրինակ՝ sales@acme.com ստանում է հարցումներ, իսկ support@acme.com պատասխանում է։"
      ]
    }
  },
  "ind": {
    "checkout": {
      "liveInstruction": "Pilih metode live, masukkan dan konfirmasi nomor rekening yang akan Anda gunakan untuk mengirim uang pada halaman berikutnya. Sesi live 10 menit akan dimulai; mengirim uang selama sesi tersebut akan memverifikasi pembayaran secara otomatis.",
      "trxInstruction": "Lakukan Cash In dari toko atau minta orang lain untuk melakukan Send Money. Kemudian verifikasi otomatis menggunakan Transaction ID (TrxID).",
      "enterNumberInstruction": "Masukkan nomor Anda dan klik tombol '{action}'.",
      "offlineTitle": "Perangkat Pedagang Offline",
      "offlineDescription": "Auto-verification sementara tidak tersedia.",
      "copyPersonal": "Salin nomor Personal Account di atas.",
      "sendMoneyOffline": "Lakukan Send Money atau Cash In ke nomor di atas, atau minta orang lain untuk mengirim uang.",
      "trxOffline": "Kumpulkan Transaction ID (TrxID) dan masukkan di bawah. Saat pedagang online, Anda akan diberitahu melalui email, atau Anda dapat menghubungi pedagang secara langsung.",
      "cashinNagad": "Cash In tidak diizinkan di Nagad, jadi silakan lakukan Send Money dari akun Nagad lain.",
      "cashinOther": "Sebelum Cash In, tanyakan kepada penjual apakah mereka akan memberikan TrxID; jika tidak, jangan lanjutkan. Atau, minta orang lain untuk melakukan Send Money.",
      "waitTrx": "Setelah pembayaran, tunggu 10–15 detik dan masukkan TrxID di bawah. Anda dapat meninggalkan halaman ini dan kembali ke halaman pembayaran ini kapan saja dalam 24 jam untuk melakukan auto-verify menggunakan TrxID Anda.",
      "goApp": "Buka aplikasi {provider} atau panggil {dialCode} dan pilih 'Send Money'.",
      "confirmAuto": "Masukkan nomor yang disalin dan jumlahnya, lalu konfirmasi dengan PIN Anda untuk auto-verify.",
      "dontClose": "Tolong jangan tutup halaman ini",
      "autoVerify": "Pembayaran Anda sedang diverifikasi secara otomatis",
      "successOffline": "Terima kasih, {name}. Transaksi Anda telah dicatat. Pedagang saat ini offline. Anda akan diberitahu melalui email setelah pedagang online dan memverifikasi pembayaran Anda.",
      "successOnline": "Terima kasih, {name}. Pembayaran Anda sebesar {amount} melalui {provider} telah diterima dan sedang diverifikasi."
    },
    "features": {
      "no-code-website": [
        "Buat dan terbitkan situs e-commerce, edukasi, blog, atau berita tanpa coding.",
        "Contoh: terbitkan landing page dan posting produk dari dashboard penjual kursus."
      ],
      "custom-domain": [
        "Hubungkan domain Anda dan bangun identitas digital profesional dengan routing lebih cepat.",
        "Contoh: toko Anda berjalan di www.acme.com bukan subdomain platform."
      ],
      "capi": [
        "Kirim event konversi secara server-side untuk pengukuran kampanye yang dapat diandalkan.",
        "Contoh: event pembelian dikirim dari server ke platform iklan."
      ],
      "personal-mfs": [
        "Otomatiskan verifikasi pembayaran Personal MFS yang didukung.",
        "Contoh: pembayaran Personal MFS dicocokkan dengan pesanan di situs."
      ],
      "local-gateway": [
        "Hubungkan metode pembayaran lokal untuk pelanggan regional.",
        "Contoh: pembeli lokal menyelesaikan checkout melalui gateway regional."
      ],
      "international-gateway": [
        "Hubungkan metode pembayaran internasional untuk pelanggan di seluruh dunia.",
        "Contoh: pembeli luar negeri menyelesaikan checkout dengan metode global."
      ],
      "notifications": [
        "Kirim pembaruan pembayaran dan pesanan ke pelanggan dan pedagang.",
        "Contoh: keberhasilan pembayaran memicu peringatan ke pedagang dan pembaruan ke pelanggan."
      ],
      "courier": [
        "Kirim pesanan yang dikonfirmasi ke workflow kurir yang didukung secara otomatis.",
        "Contoh: pesanan COD yang dikonfirmasi dipersiapkan untuk penyerahan ke kurir."
      ],
      "business-email": [
        "Kirim dan terima email profesional di domain bermerek Anda sendiri.",
        "Contoh: sales@acme.com menerima pertanyaan dan support@acme.com membalas."
      ]
    }
  },
  "isl": {
    "checkout": {
      "liveInstruction": "Veldu 'live' aðferðina, sláðu inn og staðfestu reikningsnúmerið sem þú munt senda peninga frá á næstu síðu. 10 mínútna lifandi lota hefst; ef þú sendir peninga á meðan hún stendur mun greiðsla sjálfkrafa vera staðfest.",
      "trxInstruction": "Gerðu Cash In í búð eða biddu einhvern annan um að gera Send Money. Síðan staðfestu sjálfkrafa með Transaction ID (TrxID).",
      "enterNumberInstruction": "Sláðu inn númerið þitt og smella á '{action}' hnappinn.",
      "offlineTitle": "Græja söluaðila er ótengd (offline)",
      "offlineDescription": "Auto-verification er tímabundið óaðgengileg.",
      "copyPersonal": "Afritaðu Personal Account númerið hér að ofan.",
      "sendMoneyOffline": "Gerðu Send Money eða Cash In á númerið hér að ofan, eða biddu einhvern annan um að senda peninga.",
      "trxOffline": "Safnaðu Transaction ID (TrxID) og sláðu það inn hér að neðan. Þegar söluaðilinn kemst á netið verður þú látinn vita með tölvupósti, eða þú getur haft beint samband við söluaðilann.",
      "cashinNagad": "Cash In er ekki leyfilegt í Nagad, vinsamlegast Send Money frá öðrum Nagad reikningi.",
      "cashinOther": "Fyrir Cash In, spurðu afgreiðslumanninn hvort hann muni gefa TrxID; ef ekki, haltu ekki áfram. Einnig geturðu beðið einhvern annan um að gera Send Money.",
      "waitTrx": "Eftir greiðslu, bíddu 10–15 sekúndur og sláðu inn TrxID hér að neðan. Þú getur yfirgefið þessa síðu og komið aftur á greiðslusíðuna hvenær sem er innan 24 klukkustunda til að sjálfvirkt staðfesta með TrxID þínum.",
      "goApp": "Farðu í {provider} appið eða hringdu í {dialCode} og veldu 'Send Money'.",
      "confirmAuto": "Sláðu inn afritaða númerið og upphæðina, staðfestu síðan með PIN til að auto-verify.",
      "dontClose": "Vinsamlegast lokaðu ekki þessari síðu",
      "autoVerify": "Greiðslan þín er að sjálfvirkt staðfestast",
      "successOffline": "Takk, {name}. Við höfum skráð viðskiptin þín. Söluaðilinn er ekki á netinu núna. Þú færð tilkynningu með tölvupósti þegar söluaðilinn kemur á netið og staðfestir greiðsluna þína.",
      "successOnline": "Takk, {name}. Greiðsla þín upp á {amount} í gegnum {provider} hefur borist og er í staðfestingarferli."
    },
    "features": {
      "no-code-website": [
        "Búðu til og birtið vefsíður fyrir netverslun, menntun, blogg eða fréttir án þess að kóða.",
        "Dæmi: birta lendingarsíðu og vöruinnlegg úr stjórnborði námskeiðsseljanda."
      ],
      "custom-domain": [
        "Tengdu eigið lén og byggðu upp fagmannlega stafræna auðkenningu með hraðari leiðun.",
        "Dæmi: verslunin þín keyrir á www.acme.com í stað pall-undirléns."
      ],
      "capi": [
        "Sendu umskiptisatburði (conversion events) frá netþjóni til áreiðanlegrar mælingar herferða.",
        "Dæmi: kaup-atburður er sendur frá netþjóni til auglýsingapalls."
      ],
      "personal-mfs": [
        "Sjálfvirkni við staðfestingu styðtra Personal MFS greiðslna.",
        "Dæmi: Personal MFS greiðsla er tengd við pöntun á vefsíðu."
      ],
      "local-gateway": [
        "Tengdu staðbundnar greiðsluleiðir fyrir svæðisbundna viðskiptavini.",
        "Dæmi: staðbundinn kaupandi ljúkar innkaupagreiðslu í gegnum svæðisbundinn gateway."
      ],
      "international-gateway": [
        "Tengdu alþjóðlegar greiðsluleiðir fyrir viðskiptavini um allan heim.",
        "Dæmi: erlendur kaupandi klárar greiðslu með alþjóðlegri aðferð."
      ],
      "notifications": [
        "Sendu greiðslu- og pöntunartilkynningar til viðskiptavina og söluaðila.",
        "Dæmi: greiðsla staðfest kallar á tilkynningu til söluaðila og uppfærslu fyrir viðskiptavininn."
      ],
      "courier": [
        "Sendu staðfestar pantanir sjálfvirkt inn í studda sendingarferla (courier workflow).",
        "Dæmi: staðfest COD-pöntun er undirbúin fyrir afhendingu til sendibýlis."
      ],
      "business-email": [
        "Sendu og taktu á móti faglegum tölvupóstum á þínu eigin merktu léni.",
        "Dæmi: sales@acme.com fær fyrirspurnir og support@acme.com svarar."
      ]
    }
  },
  "jam": {
    "checkout": {
      "liveInstruction": "Pick di live method, put in an confirm di account number weh yuh a go send money from pan di next page. A 10-minute live session ago start; send money during dat an di payment will auto-verify.",
      "trxInstruction": "Cash In from a shop or ask somebody else fi do a Send Money. Den auto-verify wid di Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter yuh number an click di '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification temporarily nuh available.",
      "copyPersonal": "Copy di Personal Account number weh deh up deh.",
      "sendMoneyOffline": "Send Money or Cash In to di number up deh, or ask somebody else fi send money.",
      "trxOffline": "Tek di Transaction ID (TrxID) an enter it below. When di merchant come online yuh will get email, or yuh can contact di merchant straight.",
      "cashinNagad": "Cash In nuh allow in Nagad, so please Send Money from anadda Nagad account.",
      "cashinOther": "Before Cash In, ask di shopkeeper if dem will give di TrxID; if dem nah, nuh go forward. Else ask somebody else fi Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds an enter di TrxID below. Yuh can leave dis page an come back to dis payment page anytime within 24 hours fi auto-verify wid yuh TrxID.",
      "goApp": "Go to di {provider} app or dial {dialCode} an select 'Send Money'.",
      "confirmAuto": "Enter di copied number an amount, den confirm wid yuh PIN fi auto-verify.",
      "dontClose": "Please no close dis page",
      "autoVerify": "Yuh payment a get verified automatically",
      "successOffline": "Tanks, {name}. Yuh transaction record deh. Di merchant offline now. Yuh will get email when di merchant come online an verify yuh payment.",
      "successOnline": "Tanks, {name}. Yuh payment of {amount} through {provider} get receive an a get verified."
    },
    "features": {
      "no-code-website": [
        "Create an publish e-commerce, education, blog, or news sites widout coding.",
        "Example: publish a landing page an product post from di course seller dashboard."
      ],
      "custom-domain": [
        "Connect yuh own domain an build a professional digital identity wid faster routing.",
        "Example: yuh store run pan www.acme.com instead a platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side fi reliable campaign measurement.",
        "Example: a purchase event get send from di server to di ad platform."
      ],
      "personal-mfs": [
        "Aatameet di verifikieshan fi supuotid Personal MFS piement.",
        "Example: a Personal MFS payment get match to di website order."
      ],
      "local-gateway": [
        "Connect local payment methods fi regional customers.",
        "Example: a local buyer complete checkout thru a regional gateway."
      ],
      "international-gateway": [
        "Connect international payment methods fi customers worldwide.",
        "Example: an overseas buyer complete checkout wid a global method."
      ],
      "notifications": [
        "Send payment an order updates to customers an merchants.",
        "Example: payment success mek a merchant alert an customer update."
      ],
      "courier": [
        "Putt confirmed orders inna one supported courier workflow automatically.",
        "Example: a confirmed COD order get prepare fi courier handoff."
      ],
      "business-email": [
        "Send an receive professional email pon yuh own branded domain.",
        "Example: sales@acme.com receive inquiries an support@acme.com reply."
      ]
    }
  },
  "kal": {
    "checkout": {
      "liveInstruction": "Pickimi live-metoda, qupperulluunniit konto-nummeri inuuneq nittartakkatigut ilanngullutit aamma nassuiaavoq. 10-minuttimik live-session ima aallartissaaq; tassani tunniussinermut atatillugu ilaqutariit automatiskimik uppernarsassaaq.",
      "trxInstruction": "Cash In aammattaaq angallattoq imaluunniit inunnik allanik Send Money oqarpoq. Taavalu automatiskimik misissorneqassaaq Transaction ID (TrxID)-mik.",
      "enterNumberInstruction": "Nummerit attassiuk '{action}' knoppi akissukkit.",
      "offlineTitle": "Merchant immiaq offline-aaniittut",
      "offlineDescription": "Auto-verification imaluunniit nunarsuarmi tamakkua qassuteqartut ilaapput.",
      "copyPersonal": "Personal Account nummeri qupperneq kopiimmik atorlugu.",
      "sendMoneyOffline": "Send Money imaluunniit Cash In qupperneq nummerimut, imaluunniit inunnik allanik qinnuteqaatit paasinnittoq.",
      "trxOffline": "Transaction ID (TrxID) tigusissavatit aammalu aappassinneqarluni nassuiorneqassaaq. Merchant online-sillugu email-ikkut nalunaarutigineqassaaq, imaluunniit pisariaqartillugu merchant-illu attaveqarsinnaavoq.",
      "cashinNagad": "Nagad-imi Cash In akuerineqaratanngilaq, taamaattumik Send Money atorneqassaaq Nagad konto-nik allanik.",
      "cashinOther": "Cash In-muk kingorna ilinniarneqarnerani trgoversoq TrxID nallersuutigaa? Naamik ta'wanaammat ingerlaqqinneq ingerlanneqassanngilaq. Allappoq taamaaliorluni Send Money.",
      "waitTrx": "Kassartimik kingorna 10–15 sekunderscore ateqarluni TrxID quppernermut ilanngullugu. Atuakkanik aatsaat 24-t sinnerlugit qimaqqissinnaavutit auto-verify-mik TrxID-kkunni.",
      "goApp": "Tunngaviit {provider} app-imiik oqarpat imaluunniit {dialCode} nummeri dial-ikkit aamma 'Send Money' takussavat.",
      "confirmAuto": "Kopiisimavoq nummeri aamma amount illigitillugu, pinnngortitillugu PIN-kkut nassuiarneqassaaq auto-verify-malillugit.",
      "dontClose": "Aallaqqaqqittut atorluarlugit isornartorsiuutit aningaasatigut aqutsineqigut",
      "autoVerify": "Ullut akuerineq automatiskimik misissorneqassaaq",
      "successOffline": "Qujannarpoq, {name}. Aningaasarniarnermik eqqortumik nalunaarutigineqartoq. Merchant nunaq alianaatsuuvoq. Merchant online-ersillugu uunga email-ikkut nalunaarfigisassavutit aammalu kiisalu uppernarsassaaq.",
      "successOnline": "Qujannarput, {name}. {provider}-mik {amount} atorlugit aningaasanik tuniniaaneq qasuersaalluni nassaarneqarpoq aammalu misissorneqassaaq."
    },
    "features": {
      "no-code-website": [
        "Coding-ikkullu iluarsaaneq atorlugu e-commerce, undervisning, blog imaluunniit narlunneq saitinik pilersitsisinnaavutit.",
        "Assersuutigalugu: kursussinermut seller dashboard-it saqqummersitsineq landing page aamma product post."
      ],
      "custom-domain": [
        "Domain-iussinermut attavilersorneqassaaq aamma professional digital-imik siulersorneqarneq siullermik.",
        "Assersuutigalugu: butik-ip www.acme.com-ikkut aaqqissuussinissaq platform subdomain-imik sananeqanngitsoq."
      ],
      "capi": [
        "Conversion events server-side-ikkut nassiussineq campaign-llu akuerineq naammassisinnaaneranik.",
        "Assersuutigalugu: purchase event server-imiit ad platform-imeersoq nassiutillugu."
      ],
      "personal-mfs": [
        "Automatiskimik Support-imooruserluni Personal MFS-kkut betalings-ikkullu nassuiaaneq.",
        "Assersuutigalugu: Personal MFS-payment website order-illu naapertorlugu matched."
      ],
      "local-gateway": [
        "Kujammut immikkoortumik purchaser-kkut lokal payment-metoder-attaveqarit.",
        "Assersuutigalugu: lokal buyer regional gateway-ikkut checkout-p iluani akuerineq."
      ],
      "international-gateway": [
        "Aaqaluttorujussuaq payment-metoder nunarsuarmi tamani attavigit.",
        "Assersuutigalugu: aviisiut country-mi purchaser global method-ikkut checkout-p naammattorsinnaavaa."
      ],
      "notifications": [
        "Payment aamma order updates-illu customers-ikkut merchants-ikkut nassiussigit.",
        "Assersuutigalugu: payment success merchant-ikkut alert aamma customer-update pilersinneqarluni."
      ],
      "courier": [
        "Confirmed orders-ine supported courier workflow-imi automatiskimik nassiunneqassapput.",
        "Assersuutigalugu: confirmed COD-order courier handoff-inut atortut pilersaaruteqarpaaq."
      ],
      "business-email": [
        "Branded domain-itit atorlugu professional email-ikkut nassiunneq atuakkit.",
        "Assersuutigalugu: sales@acme.com meat enquiries kisimavaat aamma support@acme.com uunga akissuteqarsinnaavoq."
      ]
    }
  },
  "kat": {
    "checkout": {
      "liveInstruction": "აირჩიეთ live მეთოდი, შეიყვანეთ და დაადასტურეთ შემდეგ გვერდზე ანგარიშის ნომერი, რომლის საშუალებითაც ფულს გაუგზავნით. დაიწყება 10 წუთიანი live სესია; სესიის დროს თანხის გაგზავნამ ავტომატურად დაადასტურებს გადახდას.",
      "trxInstruction": "გააკეთეთ Cash In მაღაზიაში ან სთხოვეთ ვინმეს გააკეთოს Send Money. შემდეგ ავტომატურად შეამოწმეთ Transaction ID (TrxID)-ით.",
      "enterNumberInstruction": "შეიყვანეთ თქვენი ნომერი და დააჭირეთ '{action}' ღილაკს.",
      "offlineTitle": "ვაჭრის მოწყობილობა ონლაინში არ არის",
      "offlineDescription": "Auto-verification დროებით მიუწვდომელია.",
      "copyPersonal": "დაკოპირეთ ზემოთ მოცემული Personal Account ნომერი.",
      "sendMoneyOffline": "გაგზავნეთ Send Money ან Cash In ზემოთ მოცემულ ნომერზე, ან სთხოვეთ სხვას გამოაგზავნოს თანხა.",
      "trxOffline": "შეაგროვეთ Transaction ID (TrxID) და შეიყვანეთ ქვემოთ. როცა ვაჭარი დაბრუნდება ონლაინზე, თქვენ მიიღებთ შეტყობინებას ელ-ფოსტით, ან შეგიძლიათ დაუკავშირდეთ ვაჭარს პირდაპირ.",
      "cashinNagad": "Nagad-ში Cash In არ არის ნებადართული, ამიტომ გთხოვთ გააკეთოთ Send Money სხვა Nagad ანგარიშიდან.",
      "cashinOther": "Cash In-ის წინ ჰკითხეთ მოვაჭრეს, მისცემს თუ არა TrxID-ს; თუ არა, არ გააგრძელოთ. სხვა ალტერნატივაა, სთხოვოთ ვინმეს გააკეთოს Send Money.",
      "waitTrx": "გადახდის შემდეგ დაიცადეთ 10–15 წამი და შეიყვანეთ TrxID ქვემოთ. შეგიძლიათ დატოვოთ ეს გვერდი და დაბრუნდეთ ამ გადამხდელ გვერდზე ნებისმიერ დროს 24 საათის განმავლობაში, რათა auto-verify თქვენს TrxID-ით.",
      "goApp": "გაითვალისწინეთ {provider} აპლიკაცია ან დარეკეთ {dialCode}-ზე და შეარჩიეთ 'Send Money'.",
      "confirmAuto": "შეიყვანეთ დაკოპირებული ნომერი და თანხა, შემდეგ დაადასტურეთ PIN-ით ავტომატური შემოწმებისთვის.",
      "dontClose": "გთხოვთ, არ დახუროთ ეს გვერდი",
      "autoVerify": "თქვენი გადახდა ავტომატურად შემოწმდება",
      "successOffline": "გმადლობთ, {name}. თქვენი ტრანზაქცია ჩაიწერა. ვაჭარი ამჟამად ოფლაინია. როცა ვაჭარი დამოწმების შემდეგ ონლაინ გახდება, თქვენ გადაგეგზავნებათ შეტყობინება ელ-ფოსტით.",
      "successOnline": "გმადლობთ, {name}. თქვენი {amount}-ის გადახდა {provider}-ის საშუალებით მიღებულია და მიმდინარეობს შემოწმება."
    },
    "features": {
      "no-code-website": [
        "შექმენით და გამოაქვეყნეთ e-commerce, საგანმანათლებლო, ბლოგ ან ახალი ამბების საიტები კოდირების გარეშე.",
        "მაგალითი: გამოაქვეყნეთ ლენდინგ გვერდი და პროდუქტის პოსტი course seller-ის დაფიდან."
      ],
      "custom-domain": [
        "დაკავშირეთ თქვენი დომენი და შექმენით პროფესიონალური ციფრული იდენტობა სწრაფი მარშრუტიზაციით.",
        "მაგალითი: თქვენი მაღაზია იმუშავებს www.acme.com- ზე პლატფორმის სუბდომენის ნაცვლად."
      ],
      "capi": [
        "გავრცელეთ conversion საქმეები server-side-ზე საიმედო კამპანიის გაზომვისთვის.",
        "მაგალითი: purchase მოვლენას სერვერი გაუგზავნის რეკლამებისთვის."
      ],
      "personal-mfs": [
        "ავტომატიზაცია მხარდაჭერილი Personal MFS გადახდების შეთანხმების.",
        "მაგალითი: Personal MFS გადახდა ემთხვევა ვებ-ორების შეკვეთას."
      ],
      "local-gateway": [
        "დაკავშირეთ ადგილობრივი გადახდის მეთოდები რეგიონული მომხმარებლისთვის.",
        "მაგალითი: ადგილობრივი მყიდველი დაასრულებს გადახდას რეგიონული gateway-ის საშუალებით."
      ],
      "international-gateway": [
        "დაკავშირეთ საერთაშორისო გადახდის მეთოდები მომხმარებელთაათვის მსოფლიოს მასშტაბით.",
        "მაგალითი: საზღვარგარეთ მყიდველი დაასრულებს გადახდას გლობალური მეთოდით."
      ],
      "notifications": [
        "გაგზავნეთ გადახდის და შეკვეთის განახლებები მომხმარებლებსა და ვაჭრებს.",
        "მაგალითი: გადახდის წარმატება გაააქტიურებს ვაჭრის შეტყობინებას და მომხმარებლის განახლებას."
      ],
      "courier": [
        "ავტომატურად გაგზავნეთ დადასტურებული შეკვეთები მხარდაჭერილ courier workflow-ს.",
        "მაგალითი: დადასტურებული COD შეკვეთა მზადდება კურიერისთვის გადაცემისათვის."
      ],
      "business-email": [
        "გაგზავნეთ და მიიღეთ პროფესიონალური ელ-ფოსტა თქვენს ბრენდირებულ დომენზე.",
        "მაგალითი: sales@acme.com იღებს მოთხოვნებს და support@acme.com პასუხობს."
      ]
    }
  },
  "kaz": {
    "checkout": {
      "liveInstruction": "Live әдісін таңдаңыз, келесі бетте ақша жіберетін есеп-шот нөмірін енгізіп растап қойыңыз. 10 минуттық live сессия басталады; сол сессияда ақша жіберсеңіз, төлем автоматты түрде тексеріледі.",
      "trxInstruction": "Дүкеннен Cash In жасаңыз немесе біреуден Send Money жасауын сұраңыз. Содан кейін Transaction ID (TrxID) арқылы автоматты түрде тексеріңіз.",
      "enterNumberInstruction": "Өз нөміріңізді енгізіп '{action}' батырмасын басыңыз.",
      "offlineTitle": "Merchant құрылғысы офлайн",
      "offlineDescription": "Auto-verification уақытша қолжетімсіз.",
      "copyPersonal": "Жоғарыдағы Personal Account нөмірін көшіру.",
      "sendMoneyOffline": "Жоғарыдағы нөмірге Send Money немесе Cash In жасаңыз, немесе біреуден ақша жіберуді сұраңыз.",
      "trxOffline": "Transaction ID (TrxID) жинап, оны төменге енгізіңіз. Merchant желіге шыққанда сізге электрондық пошта арқылы хабарлама келеді немесе тікелей merchant-пен байланыса аласыз.",
      "cashinNagad": "Nagad-та Cash In рұқсат етілмейді, сондықтан басқа Nagad есепшотынан Send Money жасаңыз.",
      "cashinOther": "Cash In жасаудан бұрын дүкеншіге TrxID береді ме деп сұраңыз; егер бермесе, жалғастырмаңыз. Немесе біреуден Send Money жасауын сұраңыз.",
      "waitTrx": "Төлемнен кейін 10–15 секунд күтіп, төменге TrxID енгізіңіз. Осы беттен шығып, 24 сағат ішінде кез келген уақытта TrxID арқылы автоматты тексеру үшін қайта орала аласыз.",
      "goApp": "{provider} қосымшасына өтіңіз немесе {dialCode}-ға қоңырау шалып, 'Send Money' таңдаңыз.",
      "confirmAuto": "Көшірілген нөмір мен соманы енгізіп, PIN-пен растап auto-verify жасаңыз.",
      "dontClose": "Осы бетті жаппаңызшы",
      "autoVerify": "Сіздің төлеміңіз автоматты түрде тексерілуде",
      "successOffline": "Рақмет, {name}. Сіздің транзакцияңыз тіркелді. Merchant қазіргі уақытта офлайн. Merchant желіге шыққаннан кейін төлеміңіз расталғанда сізге электрондық пошта арқылы хабарлайды.",
      "successOnline": "Рақмет, {name}. {provider} арқылы {amount} сомасындағы төлеміңіз қабылданды және тексерілуде."
    },
    "features": {
      "no-code-website": [
        "Код жазбай-ақ e-commerce, білім, блог немесе жаңалықтар сайттарын жасаңыз және жариялаңыз.",
        "Мысалы: course seller басқару панелінен landing бет пен өнім жазбасын жариялау."
      ],
      "custom-domain": [
        "Өз доменіңізді қосып, жылдамырақ бағыттау арқылы кәсіби цифрлық имидж құрыңыз.",
        "Мысалы: дүкеніңіз платформаның ішкі домені емес, www.acme.com-де жұмыс істейді."
      ],
      "capi": [
        "Сервер жағынан conversion оқиғаларын жіберіп, науқанды сенімді өлшеуді қамтамасыз етіңіз.",
        "Мысалы: сатып алу оқиғасы серверден жарнама платформасына жіберіледі."
      ],
      "personal-mfs": [
        "Қолдау көрсетілетін Personal MFS төлемдерін автоматты тексеріңіз.",
        "Мысалы: Personal MFS төлемі сайттағы тапсырысқа сәйкес келеді."
      ],
      "local-gateway": [
        "Аймақтық клиенттер үшін жергілікті төлем әдістерін қосыңыз.",
        "Мысалы: жергілікті сатып алушы региональды шлюз арқылы төлем аяқтайды."
      ],
      "international-gateway": [
        "Әлем бойынша клиенттерге халықаралық төлем әдістерін қосыңыз.",
        "Мысалы: шетелдік сатып алушы жаһандық әдіс арқылы төлем жасайды."
      ],
      "notifications": [
        "Төлем және тапсырыс жаңартуларын клиенттерге және сатушыларға жіберіңіз.",
        "Мысалы: төлем сәтті болғанда сатушыға ескерту және клиентке жаңарту жіберіледі."
      ],
      "courier": [
        "Расталған тапсырыстарды автоматты түрде қолдау көрсетілетін курьер жұмыс ағымына жіберіңіз.",
        "Мысалы: расталған COD тапсырыс курьерге тапсыруға дайындалады."
      ],
      "business-email": [
        "Өз брендті доменіңізде кәсіби электрондық поштаны жіберіп, қабылдаңыз.",
        "Мысалы: sales@acme.com сұрауларды қабылдайды, support@acme.com жауап береді."
      ]
    }
  },
  "kck": {
    "checkout": {
      "liveInstruction": "Kopa live method, pangu ng’ari account number oyo utafikiri wa kutuma pesa ukakweka na page ya kuja. Kwenye 10-dakika live session ita start; kutuma pesa wakati ule kutahakikisha malipo kwa auto.",
      "trxInstruction": "Fanya Cash In kutoka dukani au muombe mtu mwingine afanye Send Money. Basi auto-verify kwa kutumia Transaction ID (TrxID).",
      "enterNumberInstruction": "Ingiza namba yako na bonyeza '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification haina uwezo kwa sasa.",
      "copyPersonal": "Nakili namba ya Personal Account iliyo juu.",
      "sendMoneyOffline": "Tuma Send Money au fanya Cash In kwa namba ya juu, au muombe mtu mwingine atume pesa.",
      "trxOffline": "Kusanya Transaction ID (TrxID) na uingize hapa chini. Wakati merchant atakuwa online, utaarifiwa kwa barua pepe, au unaweza kuwasiliana na merchant moja kwa moja.",
      "cashinNagad": "Cash In haikubaliwi katika Nagad, tafadhali fanya Send Money kutoka akaunti nyingine ya Nagad.",
      "cashinOther": "Kabla ya Cash In, muulize shopkeeper kama watakupa TrxID; ikiwa hawatakupa, usiendelee. Kabla yake, muombe mtu mwingine atume Send Money.",
      "waitTrx": "Baada ya malipo, subiri 10–15 sekunde na uingize TrxID hapa chini. Unaweza kuacha ukurasa huu na kurudi kwenye ukurasa huu wa malipo wakati wowote ndani ya masaa 24 ili auto-verify kwa kutumia TrxID yako.",
      "goApp": "Nenda kwenye {provider} app au piga {dialCode} na chagua 'Send Money'.",
      "confirmAuto": "Weka namba iliyokopiwa na kiasi, kisha thibitisha kwa PIN yako ili auto-verify.",
      "dontClose": "Tafadhali usifunge ukurasa huu",
      "autoVerify": "Malipo yako yanathibitishwa kwa auto",
      "successOffline": "Asante, {name}. Muamala wako umeandikwa. Merchant yuko offline kwa sasa. Utaarifiwa kwa barua pepe baada ya merchant kuja online na kuthibitisha malipo yako.",
      "successOnline": "Asante, {name}. Malipo yako ya {amount} kupitia {provider} imepokelewa na inathibitishwa."
    },
    "features": {
      "no-code-website": [
        "Tengeneza na uchapishe tovuti za e-commerce, elimu, blog, au habari bila kuandika msimbo.",
        "Mfano: chapisha ukurasa wa kutua na chapisho la bidhaa kutoka dashibodi ya muuzaji wa kozi."
      ],
      "custom-domain": [
        "Unganisha domain yako mwenyewe na ujenge utambulisho wa kidijitali wa kitaalamu kwa njia ya routing ya haraka.",
        "Mfano: duka lako linaendesha kwenye www.acme.com badala ya subdomain ya jukwaa."
      ],
      "capi": [
        "Tuma conversion events server-side kwa upimaji wa kampeni unaoaminika.",
        "Mfano: tukio la ununuzi linatumwa kutoka kwa server hadi jukwaa la matangazo."
      ],
      "personal-mfs": [
        "Automatisha uhakiki wa malipo za supported Personal MFS.",
        "Mfano: malipo ya Personal MFS yanalingana na oda kwenye tovuti."
      ],
      "local-gateway": [
        "Unganisha mbinu za malipo za eneo kwa wateja wa kanda.",
        "Mfano: mnunuzi wa mtaa anakamilisha checkout kupitia gateway ya kanda."
      ],
      "international-gateway": [
        "Unganisha mbinu za malipo za kimataifa kwa wateja ulimwenguni kote.",
        "Mfano: mnunuzi wa kigeni anamaliza checkout kwa njia ya kimataifa."
      ],
      "notifications": [
        "Tuma sasisho za malipo na oda kwa wateja na wachuuzi.",
        "Mfano: mafanikio ya malipo husababisha onyo kwa muuzaji na sasisho kwa mteja."
      ],
      "courier": [
        "Tuma maagizo yaliyothibitishwa kwenye mtiririko kazi wa courier unaoungwa mkono moja kwa moja.",
        "Mfano: oda ya COD iliyothibitishwa inatayarishwa kwa mratibu wa courier."
      ],
      "business-email": [
        "Tuma na pokea barua pepe za kitaaluma kwenye domain yako yenye chapa.",
        "Mfano: sales@acme.com inapokea maswali na support@acme.com inajibu."
      ]
    }
  },
  "bwg": {
    "checkout": {
      "liveInstruction": "Sarudza nzira ye live, nyora uye simbisa nhamba yePersonal Account yaunenge uchitumira mari kubva pairi papeji rinotevera. Session ye live yemaminitsi 10 ichatanga; kutumira mari panguva yayo kunozoita kuti payment iauto-verify.",
      "trxInstruction": "Ita Cash In kubva kuchitoro kana kukumbira mumwe munhu kuti aSend Money. Wobva waauto-verify uchishandisa Transaction ID (TrxID).",
      "enterNumberInstruction": "Nyora nhamba yako wobva wadzvanya bhatani '{action}'.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification haina kuwanikwa kwechinguvana.",
      "copyPersonal": "Kopa nhamba yePersonal Account iri pamusoro.",
      "sendMoneyOffline": "Send Money kana kuita Cash In ku nhamba iri pamusoro, kana kukumbira mumwe munhu kuti aSend Money.",
      "trxOffline": "Tora Transaction ID (TrxID) uye uiise pazasi. Kana merchant akavapo paonline, uchaziviswa neemail, kana unogona kubata merchant zvakananga.",
      "cashinNagad": "Cash In haina kubvumidzwa muNagad, saka ndapota aSend Money kubva kune imwe Nagad account.",
      "cashinOther": "Usati waita Cash In, bvunza muridzi wechitoro kana vachizopa TrxID; kana vasingapi, usaramba uchifambira mberi. Semimwe nzira, bvunza mumwe munhu kuti aSend Money.",
      "waitTrx": "Mushure mekubhadhara, mirira 10–15 masekonzi wobva wapinza TrxID pazasi. Unogona kubva papeji rino wodzokera kune ino payment page chero nguva mukati me24 awa kuti uauto-verify uchishandisa TrxID yako.",
      "goApp": "Enda ku {provider} app kana dhaira {dialCode} uye sarudza 'Send Money'.",
      "confirmAuto": "Pinda nhamba yawakakopa uye amount, wobva wasimbisa nePIN yako kuti uauto-verify.",
      "dontClose": "Ndapota usabvisa peji rino",
      "autoVerify": "Kubhadhara kwako kuri kuongororwa otomatiki",
      "successOffline": "Ndatenda, {name}. Transaction yako yarekodhwa. Merchant parizvino ari offline. Uchaziviswa neemail mushure mekunge merchant aenda online uye aongorora payment yako.",
      "successOnline": "Ndatenda, {name}. Kubhadhara kwako kwe {amount} kuburikidza ne {provider} kwagamuchirwa uye kuri kuongororwa."
    },
    "features": {
      "no-code-website": [
        "Gadzira uye uburitse mawebhusaiti e-commerce, zvedzidzo, blog, kana nhau pasina coding.",
        "Muenzaniso: buritsa landing page uye product post kubva ku dashboard yomutengesi wekosi."
      ],
      "custom-domain": [
        "Batanidza domain yako uye ivake chimiro chedhijitari chine hunyanzvi nekutumira nekukurumidza.",
        "Muenzaniso: chitoro chako chinoshanda pa www.acme.com panzvimbo pe subdomain yeplatform."
      ],
      "capi": [
        "Tumira conversion events server-side kuti uwane kuyera kwemishandirapamwe kunovimbika.",
        "Muenzaniso: chiitiko chekutenga chinotumirwa kubva kuseva kuenda ku ad platform."
      ],
      "personal-mfs": [
        "Otomatisa verification yemubhadharo wePersonal MFS inotsigirwa.",
        "Muenzaniso: mubhadharo wePersonal MFS unoenderana neodha yewebhusaiti."
      ],
      "local-gateway": [
        "Batanidza nzira dzekubhadhara dzenharaunda kune vatengi vemudunhu.",
        "Muenzaniso: mutengi wemuno anopedzisa checkout kuburikidza ne regional gateway."
      ],
      "international-gateway": [
        "Batanidza nzira dzekubhadhara dzekunze kune vatengi pasi rese.",
        "Muenzaniso: mutengi wekunze anopedzisa checkout achishandisa global method."
      ],
      "notifications": [
        "Tumira zviziviso zvemubhadharo uye odha kuvatengi uye kuvatengesi.",
        "Muenzaniso: kubudirira kwemubhadharo kunokonzera ziviso kumutengesi uye kuvandudzwa kumutengi."
      ],
      "courier": [
        "Tumira maodha akasimbiswa mu workflow yemucourier inotsigirwa otomatiki.",
        "Muenzaniso: oda yeCOD yakasimbiswa inogadzirirwa kuendesa ku courier."
      ],
      "business-email": [
        "Tumira uye gamuchira email nyanzvi pa domain yako yakabrandirwa.",
        "Muenzaniso: sales@acme.com inogamuchira mibvunzo uye support@acme.com inopindura."
      ]
    }
  },
  "cal": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Sewi e-komenas, edükasion, blog, atau nius sihot woŋ i tiyelú walú me gumuŋú koding.",
        "Publish eŋang an landing page me product post ghalú me seller dashboard."
      ],
      "custom-domain": [
        "Faŋiighiyoeghu domain omo ghadi me ghiyal affaes repaach me professional digital identity.",
        "Store-amu eŋaŋ aŋ moŋoŋ www.acme.com nge naŋni ghal subdomain-n liyoŋ a platform."
      ],
      "capi": [
        "Sowei conversion events server-side me chul kkan me maperti e campaign measurement.",
        "A purchase event eŋaŋ sowei me server ya me ad platform."
      ],
      "personal-mfs": [
        "Automaatighiyoeghu verification me payment ni supportakle me Personal MFS me MFS.",
        "Personal MFS payment e match woŋ i website order."
      ],
      "local-gateway": [
        "Faŋiighiyoeghu local payment methods me customer ni ghal region.",
        "A local buyer e fini checkout ghadi me regional gateway."
      ],
      "international-gateway": [
        "Faŋiighiyoeghu international payment methods me customer ni ghal worlú.",
        "A overseas buyer e fini checkout me global method."
      ],
      "notifications": [
        "Sowei update me payment me order me customers me merchants.",
        "Mwalú me payment success e ghal alert me merchant me update me customer."
      ],
      "courier": [
        "Sowei confirmed orders me ghal supported courier workflow otomaatik.",
        "A confirmed COD order e maas re waal para courier handoff."
      ],
      "business-email": [
        "Sowei me fani email professional ghal domain omo ni branded-omu.",
        "sales@acme.com e fani inquiries me support@acme.com e reply."
      ]
    }
  },
  "cat": {
    "checkout": {
      "liveInstruction": "Seleccioneu el mètode en viu; a la pàgina següent introduïu i confirmeu el número del compte des del qual Send Money. S'iniciarà una sessió en viu de 10 minuts; enviar diners durant aquesta sessió verificarà el pagament automàticament.",
      "trxInstruction": "Fes Cash In des d'una botiga o demana a algú altre que faci Send Money. Després verifica automàticament amb el Transaction ID (TrxID).",
      "enterNumberInstruction": "Introdueix el teu número i fes clic al botó '{action}'.",
      "offlineTitle": "Dispositiu del comerciant fora de línia",
      "offlineDescription": "La verificació automàtica no està disponible temporalment.",
      "copyPersonal": "Copia el número de Personal Account que hi ha a sobre.",
      "sendMoneyOffline": "Fes Send Money o Cash In al número anterior, o demana a algú altre que faci Send Money.",
      "trxOffline": "Recopila el Transaction ID (TrxID) i introdueix-lo a continuació. Quan el comerciant estigui en línia, se t'avisarà per correu electrònic, o pots contactar directament amb el comerciant.",
      "cashinNagad": "No està permès fer Cash In a Nagad, així que si us plau fes Send Money des d'un altre compte Nagad.",
      "cashinOther": "Abans de fer Cash In, pregunta al dependent si facilitarà el TrxID; si no, no prossegueixis. Alternativament, demana a algú altre que faci Send Money.",
      "waitTrx": "Després del pagament, espera 10–15 segons i introdueix el TrxID a continuació. Pots sortir d'aquesta pàgina i tornar a aquesta pàgina de pagament en qualsevol moment dins de les 24 hores per verificar automàticament amb el teu TrxID.",
      "goApp": "Ves a l'aplicació {provider} o marca {dialCode} i selecciona 'Send Money'.",
      "confirmAuto": "Introdueix el número copiat i l'import, després confirma amb el teu PIN per verificar automàticament.",
      "dontClose": "Si us plau, no tanquis aquesta pàgina",
      "autoVerify": "El teu pagament s'està verificant automàticament",
      "successOffline": "Gràcies, {name}. La teva transacció ha estat registrada. El comerciant està actualment fora de línia. Seràs notificat per correu electrònic quan el comerciant torni a estar en línia i verifiqui el teu pagament.",
      "successOnline": "Gràcies, {name}. El teu pagament de {amount} a través de {provider} ha estat rebut i està en procés de verificació."
    },
    "features": {
      "no-code-website": [
        "Crea i publica llocs d'e-commerce, educació, blog o notícies sense programar.",
        "Exemple: publica una landing page i una publicació de producte des del tauler del venedor del curs."
      ],
      "custom-domain": [
        "Connecta el teu propi domini i construeix una identitat digital professional amb enrutament més ràpid.",
        "Exemple: la teva botiga funciona a www.acme.com en lloc d'un subdomini de la plataforma."
      ],
      "capi": [
        "Envia esdeveniments de conversió server-side per a una mesura de campanyes fiable.",
        "Exemple: un esdeveniment de compra s'envia des del servidor a la plataforma d'anuncis."
      ],
      "personal-mfs": [
        "Automatitza la verificació de pagaments de Personal MFS compatibles.",
        "Exemple: un pagament Personal MFS s'associa a la comanda del lloc web."
      ],
      "local-gateway": [
        "Connecta mètodes de pagament locals per a clients regionals.",
        "Exemple: un comprador local completa el checkout a través d'una passarel·la regional."
      ],
      "international-gateway": [
        "Connecta mètodes de pagament internacionals per a clients d'arreu del món.",
        "Exemple: un comprador a l'estranger completa el checkout amb un mètode global."
      ],
      "notifications": [
        "Envia actualitzacions de pagament i comanda als clients i comerciants.",
        "Exemple: l'èxit del pagament desencadena una alerta al comerciant i una actualització al client."
      ],
      "courier": [
        "Envia comandes confirmades a un flux de treball de courier compatible de manera automàtica.",
        "Exemple: una comanda COD confirmada es prepara per a l'entrega al courier."
      ],
      "business-email": [
        "Envia i rep correu electrònic professional amb el teu propi domini de marca.",
        "Exemple: sales@acme.com rep consultes i support@acme.com respon."
      ]
    }
  },
  "ces": {
    "checkout": {
      "liveInstruction": "Vyberte live metodu, na další stránce zadejte a potvrďte číslo účtu, ze kterého budete Send Money. Spustí se 10minutová live relace; odeslání peněz během ní automaticky ověří platbu.",
      "trxInstruction": "Proveďte Cash In v obchodě nebo požádejte někoho jiného, aby provedl Send Money. Poté ověřte automaticky pomocí Transaction ID (TrxID).",
      "enterNumberInstruction": "Zadejte své číslo a klikněte na tlačítko '{action}'.",
      "offlineTitle": "Zařízení obchodníka offline",
      "offlineDescription": "Auto-verifikace není dočasně k dispozici.",
      "copyPersonal": "Zkopírujte výše uvedené číslo Personal Account.",
      "sendMoneyOffline": "Proveďte Send Money nebo Cash In na výše uvedené číslo, nebo požádejte někoho jiného, aby poslal peníze.",
      "trxOffline": "Získejte Transaction ID (TrxID) a zadejte jej níže. Když bude obchodník online, budete informováni e-mailem, nebo můžete obchodníka kontaktovat přímo.",
      "cashinNagad": "Cash In není v Nagad povolen, prosím proveďte Send Money z jiného Nagad účtu.",
      "cashinOther": "Před Cash In se zeptejte prodavače, zda poskytne TrxID; pokud ne, nepokračujte. Alternativně požádejte někoho jiného, aby provedl Send Money.",
      "waitTrx": "Po platbě počkejte 10–15 sekund a zadejte TrxID níže. Můžete stránku opustit a kdykoli během 24 hodin se vrátit na tuto stránku platby a automaticky ověřit pomocí vašeho TrxID.",
      "goApp": "Přejděte do aplikace {provider} nebo vytočte {dialCode} a zvolte 'Send Money'.",
      "confirmAuto": "Zadejte zkopírované číslo a částku, potom potvrďte PINem pro auto-verifikaci.",
      "dontClose": "Prosím, nezavírejte tuto stránku",
      "autoVerify": "Vaše platba je automaticky ověřována",
      "successOffline": "Děkujeme, {name}. Vaše transakce byla zaznamenána. Obchodník je momentálně offline. Budete informováni e-mailem poté, co obchodník přejde online a ověří vaši platbu.",
      "successOnline": "Děkujeme, {name}. Vaše platba ve výši {amount} přes {provider} byla přijata a probíhá její ověřování."
    },
    "features": {
      "no-code-website": [
        "Vytvořte a publikujte e‑commerce, vzdělávací, blogové nebo zpravodajské stránky bez kódování.",
        "Příklad: publikujte landing page a příspěvek o produktu z dashboardu prodejce kurzu."
      ],
      "custom-domain": [
        "Připojte vlastní doménu a vytvořte profesionální digitální identitu s rychlejším směrováním.",
        "Příklad: váš obchod běží na www.acme.com místo subdomény platformy."
      ],
      "capi": [
        "Odesílejte konverzní události server-side pro spolehlivé měření kampaní.",
        "Příklad: událost nákupu je odeslána ze serveru do reklamní platformy."
      ],
      "personal-mfs": [
        "Automatizujte ověřování plateb Personal MFS, které jsou podporovány.",
        "Příklad: platba z Personal MFS je spárována s objednávkou na webu."
      ],
      "local-gateway": [
        "Připojte lokální platební metody pro regionální zákazníky.",
        "Příklad: místní kupující dokončí checkout přes regionální bránu."
      ],
      "international-gateway": [
        "Připojte mezinárodní platební metody pro zákazníky po celém světě.",
        "Příklad: zahraniční kupující dokončí checkout pomocí globální metody."
      ],
      "notifications": [
        "Odesílejte zákazníkům a obchodníkům aktualizace o platbě a objednávce.",
        "Příklad: úspěšná platba vyvolá upozornění obchodníkovi a aktualizaci zákazníkovi."
      ],
      "courier": [
        "Odesílejte potvrzené objednávky do podporovaného kurýrního workflow automaticky.",
        "Příklad: potvrzená COD objednávka je připravena k předání kurýrovi."
      ],
      "business-email": [
        "Odesílejte a přijímejte profesionální e‑maily na vlastní branded doméně.",
        "Příklad: sales@acme.com přijímá dotazy a support@acme.com odpovídá."
      ]
    }
  },
  "cha": {
    "checkout": {
      "liveInstruction": "Choosesen i live method, laman i next page, enter yan confirm i account number na i para u Send Money desde yan. Un 10-minute live session kuminza; cuando u Send Money i tiempo-ña, u auto-verify i payment.",
      "trxInstruction": "Hafa Cash In gi shop o hungok håfa otro manen-ña para u Send Money. Luego auto-verify gamit i Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter i na'ån-mu yan click i '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification ti disponible temporaryo.",
      "copyPersonal": "Copy i Personal Account number gi i tano arriba.",
      "sendMoneyOffline": "Send Money pat Cash In gi i number arriba, pat hungok otro para u Send Money.",
      "trxOffline": "Kolekta i Transaction ID (TrxID) yan enter-ña ha'ane. Cuando umayo online i merchant, u notifika hao gi email, pat u ma-contact hao directu gi merchant.",
      "cashinNagad": "Cash In ti mameståben gi Nagad, sånta Please Send Money gi otro Nagad account.",
      "cashinOther": "Antes de Cash In, ask i shopkeeper kung ma-provide-ña i TrxID; lao måtai, lao bai hu fanma'go' på'go. Alternativu, ask otro para u Send Money.",
      "waitTrx": "Despues i payment, fanhå' 10–15 segundos yan enter i TrxID gi bajo. Må'pos na måtcho' para hu este na page yan måtcho' para este payment page pot i tiempo de 24 oras para u auto-verify gamit i TrxID-mu.",
      "goApp": "Go gi i {provider} app pat dial {dialCode} yan choose 'Send Money'.",
      "confirmAuto": "Enter i copied number yan amount, después confirm with PIN-mu para auto-verify.",
      "dontClose": "Please ti guaha fanbale i page-ña",
      "autoVerify": "Guaha verification na fanfañågo gi payment-mu",
      "successOffline": "Si Yu'os ma'åse', {name}. Inrekordåo i transaction-mu. Offline i merchant gi este na tiempo. U notifika hao gi email despues i merchant u umay online yan u verify i payment-mu.",
      "successOnline": "Si Yu'os ma'åse', {name}. In receive i payment-mu na {amount} via {provider} yan guaha todu ha'ane para i verification."
    },
    "features": {
      "no-code-website": [
        "Create yan publish e-commerce, education, blog, pat news sites gi minagof na måtto na ai'å-ña i coding.",
        "Example: publish un landing page yan product post gi course seller dashboard."
      ],
      "custom-domain": [
        "Konekta i domain-mu yan hulat un professional digital identity yan mas tåtnok na routing.",
        "Example: i store-mu mantraba gi www.acme.com en instead i platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side para kumpleto yan reliable na campaign measurement.",
        "Example: un purchase event u send ginen server gi ad platform."
      ],
      "personal-mfs": [
        "Automatize i verification para suportå-ña na Personal MFS payments.",
        "Example: un personal MFS payment u match gi website order."
      ],
      "local-gateway": [
        "Konekta local payment methods para regional customers.",
        "Example: un local buyer kumpleto i checkout pot un regional gateway."
      ],
      "international-gateway": [
        "Konekta international payment methods para customers gi todo i guinife'-ña na tåno'.",
        "Example: un overseas buyer kumpleto i checkout gamit un global method."
      ],
      "notifications": [
        "Send payment yan order updates para customers yan merchants.",
        "Example: payment success u trigger un merchant alert yan customer update."
      ],
      "courier": [
        "Send confirmed orders gi un supported courier workflow otomátikmente.",
        "Example: un confirmed COD order u prepare para courier handoff."
      ],
      "business-email": [
        "Send yan receive professional email gi i brand-nu na domain.",
        "Example: sales@acme.com umimaila inquiries yan support@acme.com u responde."
      ]
    }
  },
  "ckb": {
    "checkout": {
      "liveInstruction": "ڕێگەی live هەڵبژێرە، ژماره‌ى Personal Account کە لە خوارەوە دەتەوێت لە پارە ناردن بەھێڵیت لە پەڕەی داهاتوو داخڵ بکەوە و دڵنیابکە. ماوەى 10 خولەکیشتی live دەستی پێدەکات؛ لە ماوەی ئەوەدا Send Money کردنی پارە پارەیەک خۆبەخۆ دەسەڵات دەدات بۆ پەسەندکردنی پارەدان.",
      "trxInstruction": "لەمەودا Cash In لە فرۆشگا بکە یان لە کەسێکی تر بخوێنەوە بۆ ئەوەی Send Money بکات. دواتر بە Transaction ID (TrxID) خۆبەخۆ پەسەند بکە.",
      "enterNumberInstruction": "ژماره‌ى خۆت داخڵ بکە و کرتە لەسەر دوگمەی '{action}' بکە.",
      "offlineTitle": "ئامێرەکەی پارچەڕاگەیەرەوە Offline",
      "offlineDescription": "خۆپەسەندکردن کاتیەکیەکی نەدەپەیوەندراوە.",
      "copyPersonal": "ژماره‌ى Personal Account سەرەوە کۆپی بکە.",
      "sendMoneyOffline": "Send Money یان Cash In بۆ ژماره‌ى سەرەوە بکە، یان قسە بکە لەسەر ئەوە کە کەسێکی تر Send Money بکات.",
      "trxOffline": "Transaction ID (TrxID) ئەوە دەگرت و لە خوارەوە داخڵ بکە. کاتێک پارچەڕاگەیەرەوە هەڵاتەسەر ئەوەی آنلاین بێت، بە ایمەیل ئاگادارت دەکەین، یان دەتوانیت ڕاستەوخۆ پەیوەندیت بکەیت بە پارچەڕاگەیەر.",
      "cashinNagad": "Cash In لە Nagad رێگە پێ نادات، تکایە لێرجSend Money بکە ژماره‌یەکی تری Nagad account.",
      "cashinOther": "پێش Cash In، لە فرۆشگا پرسە ئایا دەدەن TrxID یان نا؛ ئەگەر نا، بەردەوام مەبە. یان دەتوانیت لە کەسێکی تر بخوایی بێت بۆ Send Money.",
      "waitTrx": "دوای پارەدان، چاوەڕوانبە 10–15 چرکە و TrxID لە خوارەوە داخڵ بکە. دەتوانیت ئەم پەڕەیە بێجیت و هەرکاتێک لە ماوەى 24 کاتژمێر دەگەڕێیت بۆ ئەم پەڕەی پارەدانەوە بۆ خۆپەسەندکردن بە TrxID-ت.",
      "goApp": "بڕۆ بۆ ئەپێکی {provider} یان دایل بکە {dialCode} و 'Send Money' هەڵبژێرە.",
      "confirmAuto": "ژماره‌ى کۆپی کراو و amount داخل بکە، دواتر بە PIN-ت دڵنیابکە بۆ خۆپەسەندکردن.",
      "dontClose": "تکایە ئەم پەڕەیە داخەماڵنەکە",
      "autoVerify": "پارەدانی تۆ لە ڕێگەی خۆکار دەسەڵاتێت",
      "successOffline": "سوپاس، {name}. پارچەکە تۆمارکرا. پارچەڕاگەیەر ئێستا offline-ە. پاش ئەوەی پارچەڕاگەیەر دوبارە online بێت و پارەدانی تۆ پەسەند بکات، بە ایمەیل ئاگادارت دەکەین.",
      "successOnline": "سوپاس، {name}. پارەدانی تۆی {amount} بەڕێگەی {provider} وەرگرترا و لە پێشوەختەوە دەستپێدەکات بۆ پەسەندکردن."
    },
    "features": {
      "no-code-website": [
        "بێ کۆد کردنی وێبسایتەکان بنێسە و بڵاو بکەرەوە بۆ e-commerce، پەروەردە، بلاگ یان هەواڵ.",
        "نمونە: landing page و product post لە dashboard ی فرۆشی کۆرسەکە بڵاو بکەرەوە."
      ],
      "custom-domain": [
        "دۆمینەکەت پەیوەند بکە و ناسنامەیەکی دیجیڤیتاڵی پڕۆفەشنال بسازە بە ڕاوتینگی خێراتر.",
        "نمونە: فرۆشگا تە لە www.acme.com کاردەکات بەجای subdomain ی پلاتفۆرم."
      ],
      "capi": [
        "ئەڤەنتەکانی گۆڕانکاری (conversion events) لە server-side بنێرە بۆ پێوەندیدانی پەیوەندیدار لە هەژماری کا مپەین.",
        "نمونە: Event ی خریدار لە server نێردرا بۆ پلاتفۆرم ی ڕیکلام."
      ],
      "personal-mfs": [
        "خۆکار بکە verification ی پارەدانەکانی Personal MFS کە پشتگیری دەکرێن.",
        "نمونە: پارەدانێکی Personal MFS پێکدەگرێت بە داواکاریی وێبگە."
      ],
      "local-gateway": [
        "شێوازی پارەدانیی محلی پەیوەند بکە بۆ کڕیارە ناوچەییەکان.",
        "نمونە: کڕیارێکی محلی checkout تە تکمیل دەکات بە regional gateway."
      ],
      "international-gateway": [
        "شێوازی پارەدانی نێودەوڵەتی پەیوەند بکە بۆ کڕیارە سەردەمی.",
        "نمونە: کڕیارێکی دەرەوە checkout تە بە global method تکمیل دەکات."
      ],
      "notifications": [
        "ناردنی ئاگاداریەکانی پارەدان و داواکاری بۆ کڕیار و پارچەڕاگەیەر.",
        "نمونە: سەرکەوتنی پارەدان هەڵبژاردنێک دەنێت بۆ پارچەڕاگەیەر و نوێکردنەوە بۆ کڕیار."
      ],
      "courier": [
        "داواکاریە پەسەندکراوەکان بۆ workflow ی courier ی پشتگیری کراو پاشەکەوت بکە بە خۆکاری.",
        "نمونە: داواکاری COD پەسەندکراو بۆ بەدیهێنانی courier ئامادە دەکرێت."
      ],
      "business-email": [
        "ناردن و وەرگرتنی ئیمەیلی پڕۆفەشنال لە دۆمینێکی براندکراوت.",
        "نمونە: sales@acme.com وەرگرتنی پرسیارەکان دەکات و support@acme.com وەڵام دەدات."
      ]
    }
  },
  "cnr": {
    "checkout": {
      "liveInstruction": "Izaberite live metodu, unesite i potvrdite broj računa s kojeg ćete Send Money na sljedećoj stranici. Počeće 10‑minutna live sesija; slanje novca tokom nje će automatski potvrditi uplatu.",
      "trxInstruction": "Napravite Cash In u prodavnici ili zamolite nekog drugog da Send Money. Zatim automatski potvrdite koristeći Transaction ID (TrxID).",
      "enterNumberInstruction": "Unesite svoj broj i kliknite na dugme '{action}'.",
      "offlineTitle": "Uređaj trgovca offline",
      "offlineDescription": "Auto-verifikacija trenutno nije dostupna.",
      "copyPersonal": "Kopirajte broj Personal Account iznad.",
      "sendMoneyOffline": "Send Money ili Cash In na gornji broj, ili zamolite nekog drugog da pošalje novac.",
      "trxOffline": "Sakupite Transaction ID (TrxID) i unesite ga ispod. Kad trgovac bude online bićete obaviješteni putem emaila, ili možete direktno kontaktirati trgovca.",
      "cashinNagad": "Cash In nije dozvoljen u Nagad, molimo Send Money sa drugog Nagad računa.",
      "cashinOther": "Prije Cash In pitajte prodavca hoće li dati TrxID; ako ne, nemojte nastavljati. Alternativno, zamolite nekog drugog da Send Money.",
      "waitTrx": "Nakon uplate sačekajte 10–15 sekundi i unesite TrxID ispod. Možete napustiti ovu stranicu i vratiti se na ovu stranicu plaćanja u bilo kojem trenutku u roku od 24 sata da automatski potvrdite koristeći svoj TrxID.",
      "goApp": "Idite u {provider} aplikaciju ili birajte {dialCode} i izaberite 'Send Money'.",
      "confirmAuto": "Unesite kopirani broj i iznos, zatim potvrdite PIN-om da bi se auto-verifikovalo.",
      "dontClose": "Molimo vas nemojte zatvarati ovu stranicu",
      "autoVerify": "Vaša uplata se automatski provjerava",
      "successOffline": "Hvala, {name}. Vaša transakcija je zabilježena. Trgovac je trenutno offline. Bićete obaviješteni putem emaila nakon što trgovac dođe online i potvrdi vašu uplatu.",
      "successOnline": "Hvala, {name}. Vaša uplata od {amount} putem {provider} je primljena i u procesu provjere."
    },
    "features": {
      "no-code-website": [
        "Kreirajte i objavite e‑commerce, obrazovne, blog ili news sajtove bez kodiranja.",
        "Primjer: objavite landing page i product post iz dashboarda prodavca kursa."
      ],
      "custom-domain": [
        "Povežite vlastiti domen i izgradite profesionalni digitalni identitet s bržim rutiranjem.",
        "Primjer: vaša prodavnica radi na www.acme.com umjesto na subdomenu platforme."
      ],
      "capi": [
        "Šaljite conversion events server-side za pouzdano mjerenje kampanja.",
        "Primjer: purchase event se šalje sa servera na oglasnu platformu."
      ],
      "personal-mfs": [
        "Automatizujte provjeru plaćanja za podržani Personal MFS.",
        "Primjer: personal MFS uplata se podudara sa narudžbinom na sajtu."
      ],
      "local-gateway": [
        "Povežite lokalne metode plaćanja za regionalne kupce.",
        "Primjer: lokalni kupac završava checkout preko regionalnog gateway-a."
      ],
      "international-gateway": [
        "Povežite međunarodne metode plaćanja za kupce širom svijeta.",
        "Primjer: kupac iz inostranstva završava checkout globalnom metodom."
      ],
      "notifications": [
        "Šaljite obavještenja o plaćanju i narudžbama kupcima i trgovcima.",
        "Primjer: uspjeh plaćanja pokreće obavještenje trgovcu i ažuriranje kupcu."
      ],
      "courier": [
        "Automatski šaljite potvrđene narudžbe u podržani courier workflow.",
        "Primjer: potvrđena COD narudžba se priprema za predaju courier-u."
      ],
      "business-email": [
        "Šaljite i primajte profesionalne e‑mailove na vlastitom brendiranoj domeni.",
        "Primjer: sales@acme.com prima upite i support@acme.com odgovara."
      ]
    }
  },
  "crs": {
    "checkout": {
      "liveInstruction": "Chwazi live method, antre ek konfirme number kont la kot ou pou Send Money depi lo prosenn pahz. En sesyon live 10-minit pou koumans; send money pandan sa letan pou auto-verify payment la.",
      "trxInstruction": "Fer Cash In kot en shop oubyen demann enn lot dimoun pour Send Money. Apre sa auto-verify avek Transaction ID (TrxID).",
      "enterNumberInstruction": "Antre ou number ek klik lo bouton '{action}'.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification pa disponib pour en moman.",
      "copyPersonal": "Kopi number Personal Account ki anlè.",
      "sendMoneyOffline": "Send Money ouswa fer Cash In lo number anlè, ou demann enn lot dimoun pour Send Money.",
      "trxOffline": "Rasanble Transaction ID (TrxID) ek antre li anba. Kan merchant vinn online, nou pou aviz ou par email, ouswa ou kapab kontakte merchant dirèkteman.",
      "cashinNagad": "Cash In pa permet dan Nagad, alor s'il vous plaît Send Money depi en lot Nagad account.",
      "cashinOther": "Avan Cash In, demann shopkeeper si i pou donn TrxID; si non, pa kontinyen. Oubyen demann enn lot dimoun pour Send Money.",
      "waitTrx": "Apre payman, espere 10–15 segonn ek antre TrxID anba. Ou kapav sorti depi sa pahz la ek retourn pour fer auto-verify avek ou TrxID an okenn moman dan 24 ore.",
      "goApp": "Ale dan app {provider} ouswa dial {dialCode} ek seleksyonn 'Send Money'.",
      "confirmAuto": "Antre number ou finn kopi ek amount, apre konfirme avek ou PIN pour auto-verify.",
      "dontClose": "Silvouple pa ferm sa pahz",
      "autoVerify": "Ou payman pe ganny verify otomatikman",
      "successOffline": "Mersi, {name}. Ou transaction in ganny anrezistre. Merchant i aktuelman offline. Nou pou aviz ou par email apre merchant vin online ek verify ou payman.",
      "successOnline": "Mersi, {name}. Ou payman {amount} atraver {provider} in ganny resevwar ek pe ganny verify."
    },
    "features": {
      "no-code-website": [
        "Kreye ek pibliye sit e-commerce, ledikasyon, blog, ou news san cod.",
        "Egzanp: pibliye en landing page ek en product post depi dashboard seller kur."
      ],
      "custom-domain": [
        "Konekte ou prop domen ek konstwi en idantite dijital profesyonnel avek routin pli vit.",
        "Egzanp: ou magazin kouri lo www.acme.com olye en subdomain platform."
      ],
      "capi": [
        "Anvoy conversion events server-side pour mezir kanpay ki fiable.",
        "Egzanp: en purchase event i ganny anvoye depi server al lo ad platform."
      ],
      "personal-mfs": [
        "Automatiz verification pour supported Personal MFS payments.",
        "Egzanp: en personal MFS payment i matche avek lòd lo sit web."
      ],
      "local-gateway": [
        "Konekte metòd peman lokal pour kliyan regional.",
        "Egzanp: en lokal achtater terminen checkout atraver en regional gateway."
      ],
      "international-gateway": [
        "Konekte metòd peman entènasyonal pour kliyan toulezour dan lemonn.",
        "Egzanp: en achtater estranze terminen checkout avek en global method."
      ],
      "notifications": [
        "Anvoy mizazou peman ek lòd a kliyan ek merchants.",
        "Egzanp: sikses peman i deklans enn alert pou merchant ek en update pou kliyan."
      ],
      "courier": [
        "Anvoy lòd konfirme dan en workflow courier supported otomatikman.",
        "Egzanp: en lòd COD konfirme i prepare pour handoff avek courier."
      ],
      "business-email": [
        "Anvoy ek resevwar imèl profesyonnel lo ou prop domen brandé.",
        "Egzanp: sales@acme.com resevwar demandes ek support@acme.com reponn."
      ]
    }
  },
  "div": {
    "checkout": {
      "liveInstruction": "Fenehakah live method, itha hiy funuvaa account number jeheyning jehey fahuvaa miadhu. 10-minute live session thibaagefah nuvanee; miadhu dheyn hiy koh, Send Money miadhu payment ah auto-verify kuran.",
      "trxInstruction": "Shop-ge koba Cash In gothah koh beynun miadhu hamaige vegen Send Money kuran. Thibaage Transaction ID (TrxID) vaahaka auto-verify kuran.",
      "enterNumberInstruction": "Fainu number thibaage ' {action} ' button miadhu click kuran.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification thibaagege miadhu nufah meehakah dheyn na.",
      "copyPersonal": "Velaa Personal Account number ah copy kuran.",
      "sendMoneyOffline": "Send Money athoba Cash In miadhu number ah, athoba aaigen miadhu koh beynun Send Money kura.",
      "trxOffline": "Transaction ID (TrxID) govaafaivaa miadhu vaahaka thibaage hama thibaage input kuran. Merchant online nuvanee miadhu, email ah thibaage notify kuran, miadhu direct ga merchant eh contact kuran.",
      "cashinNagad": "Nagad ah Cash In vaahaka miadhu izin nuvaa, hiy beynun Nagad account miadhu Send Money kuran.",
      "cashinOther": "Cash In kurun koh miadhu, shopkeeper koh ah TrxID vaahaka feynakah hurihaa; nukura, miadhu fahuvaa kuran. Atho, aaigen miadhu beynun Send Money kohveri.",
      "waitTrx": "Payment eh kuraigen miadhu, 10–15 seconds ethuru vaa eh TrxID input kuran. 24 ghaval dho theh miadhu, miadhu page ah baigen vaguthah kohveri miadhu payment page gavaalh nuvanee maa auto-verify kuran TrxID miadhu vaa.",
      "goApp": " {provider} app ge vaahaka go kuran athoba dial {dialCode} kuran, 'Send Money' select kuran.",
      "confirmAuto": "Copy kurigen number ah amount input kuran, PIN vah confirm kuran vaahaka auto-verify kuran.",
      "dontClose": "Thibaageh miadhu miadhu page kuh close kuran koh nuvanee",
      "autoVerify": "Mi transaction ah automatic ah verify kuran",
      "successOffline": "Shukuriyaa, {name}. Mi transaction record kurevifaivaa. Merchant ah haleefaalhu offline nuvanee. Merchant online nuvanee miadhu verify kurigen miadhu, email ah thibaage notify kuran.",
      "successOnline": "Shukuriyaa, {name}. {provider} ah {amount} miadhu transaction miadhu vaahaka miadhu receive kurevifaivaa, miadhu verify kuran thibaage ge."
    },
    "features": {
      "no-code-website": [
        "Coding kuraa koh nuvanee e-commerce, education, blog, gothah news sites create and publish kuran.",
        "Example: course seller dashboard gavaalh landing page eh product post publish kuran."
      ],
      "custom-domain": [
        "Guthu domain connect kuran eh professional digital identity build kuraigen faster routing thibaage.",
        "Example: store gavaalh www.acme.com ah run kurevifaivaa instead platform subdomain."
      ],
      "capi": [
        "Server-side ge conversion events send kuran reliable campaign measurement vaahaka.",
        "Example: purchase event server ge nethin ad platform ge send kuran."
      ],
      "personal-mfs": [
        "Supported Personal MFS payment verification automate kuran.",
        "Example: personal MFS payment website order ge match kuran."
      ],
      "local-gateway": [
        "Regional customers ge local payment methods connect kuran.",
        "Example: local buyer regional gateway ge through checkout complete kuran."
      ],
      "international-gateway": [
        "Worldwide customers ge international payment methods connect kuran.",
        "Example: overseas buyer global method ge use kurigen checkout complete kuran."
      ],
      "notifications": [
        "Customers ah merchants ge payment and order updates send kuran.",
        "Example: payment success merchant ah alert send kuran and customer ah update."
      ],
      "courier": [
        "Confirmed orders supported courier workflow ah otomatik ah send kuran.",
        "Example: confirmed COD order courier handoff ge prepare kuran."
      ],
      "business-email": [
        "Own branded domain ah professional email send and receive kuran.",
        "Example: sales@acme.com inquiries receive kuran and support@acme.com reply kuran."
      ]
    }
  },
  "dzo": {
    "checkout": {
      "liveInstruction": "ཡིག་ཆ་ལྷག་གི་ལས་ཀ་གནང་བ་གདོད་དང་བྱང་ཁུངས་ནས་ཁྲིམས་གྱི་གསལ་བསྒྲགས་འབད། དེ་ལྟར་ཁྱེད་ཀྱིས Send Money བྱེད་མཁན་དང་མཉམ་འབྲེལ་གནང་བ་གི་ཐོག་མར མི་སྐབས་བརྒྱབ་ན་ཉི་ཤུའི་སྐར་མོག་གི་10 སྐར་མཚན་ལུས་གྲོས་འགན་འགག་ཡོད། དུས་ཚོད་ངུ་Send Money་བྱས་ན། ཁྱེད་ཀྱི་དངོས་གྲངས་གྱི་འབྲེལ་འདྲི་དེ་དང་མཉམ་འབྲེལ་བྱས་payment་རང་གིས་བསྒྱུར་འབྱོར་འབྱོར་གྲུབ་པ་བྱེད།",
      "trxInstruction": "ཚོང་ཁང་ནས Cash In་བྱས་ན་ཡང་ན་གདམ་གནང་གི་མི་གནང་བ་རང་གིས Send Money་བྱེད་གི་རེད། དེ་ལས་Transaction ID (TrxID) ལུས་མེད་བསྒྱུར་འབྱོར་འབྱོར།",
      "enterNumberInstruction": "ཁྱེད་ཀྱི་ཁ་ཚོད་བཤད་དང '{action}' སྒོར་ཞུ་བཏང་།",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification ད་ལྟའི་གདོང་བཅས་མེད།",
      "copyPersonal": "ངོས་འཛིན་གྱི་ཨང་གྲངས Personal Account ལུས་མཉམ་ག་སྐོར་གདོང་གཏོང་།",
      "sendMoneyOffline": "Send Money ཡང་ན Cash In་བྱས་ན་དེ་གི་ཨང་གྲངས་ལ་རྩོལ་གནང་གི་ཡིན། ཡང་ན་གདམ་གནང་གི་མི་གནང་བ་ལག་ལེན་གནང་།",
      "trxOffline": "Transaction ID (TrxID) དང་བཤད་བྱས་ན་གོ་བཙུགས་དང་ཚུལ་ཁྲིད་བཞག། དེ་ནས་merchant་གྱིས་འགྲོ་ན་ཁྱེད་ལ email གྱིས་ཕྱིར་ལོག་གི་ཚིག་ཐོག་ལོག་གི་ཤེས་བྱེད་འབྱོར་གྲུབ། ཡང་ན་ཁྱེད་ཀྱིས་གསུང་དབང་ལས་སྐྱེལ་འབད་ནི་ཆོག།",
      "cashinNagad": "Nagad ནང་ལ Cash In མ་རུང་། དེ་ལས་འདས་མི་བྱས་དགོས་Send Money ཨིན་ནི་གནང་དེ་གི་དགོས་མེད།",
      "cashinOther": "Cash In མ་ཟིན་གནས་སུ་བསྟན་ནས་འདི་ལས་མི་ཚུལ་ཁྲིད་ཡིན་ནི་ཁ་ལག་བརྗེ་བྱེད་དགོས་ཡིན་ནི་སྙིང་ལོག་དང་མེད་རེད་ནི་གནང་བ་མ་འབྱོར། དྭངས་ཕྱིས་མི་གནང་བ་གདམ་གནང་བ་དང་ལག་ལེན།",
      "waitTrx": "དེ་ལས་འདི་ལས་འདིའི་ལོག་གི་གནས་སུ་སྐར་མ་ཉིན་བཅུ་དང་བརྒྱ་ཕྲག་ལ་སྐུལ་བརྗེ་ཞིང་TrxID ལུས་མཉམ་བཤད་ནི་འབྱོར། ཁྱེད་ཀྱིས་དེ་ལས་ཤོག་ལ་ཕབ་རབ་དེ་དང་ལོག་བཞིན་ནི་ཡིན་ན་ཡང་རེད 24 ཧེ་མོ་ནས་auto-verify TrxID ལས་འབྱོར་འབྱོར་གྲུབ།",
      "goApp": "འགྲོ་དགོས་སྒོ་གི {provider} app ལུས་མངོན་ནི་ཡང་ན། {dialCode} བསྐྱར་གནས་ཀྱིས 'Send Money' གྲུབ་གནང་།",
      "confirmAuto": "ངོས་འཛིན་བྱས་ཡོད་མི་ཨང་དང་ཇི་སྦྱོར་དང་ཚུལ་ཁྲིད་འདི་ནས PIN གིས་འཕྲིན་ཐོག་ལས་བསྒྱུར་འབྱོར།",
      "dontClose": "ཁྱེད་ཀྱི་དེའི་དྲ་ཡིག་མི་བྱུང་འཕྲིན་གསུམ།",
      "autoVerify": "ཁྱེད་ཀྱི་དངོས་གྲངས་རྫོགས་སྒོར་རིམ་བྱེད་ཡོད།",
      "successOffline": "ཐུགས་རྗེ་ཆེ་, {name}。ཁྱེད་ཀྱི་ལས་ཀ་སྒྲིག་འཛིན་ཡོད། ད་ལྟའི་ཅིག་མི་སྲུང་པ། དྲུག་པ་ཡིན་ན་དེ་ལས་merchant་ཡང་ཟླ་བྱིས་ཡིག་ཙམ་ནས་ཁྱེད་ལ་ཕྱིར་ལོག་གི་རྟེན་ཐག་ལ་བསམ་ཚུལ་བྱེད་ནི་འབྱོར།",
      "successOnline": "ཐུགས་རྗེ་ཆེ་, {name}。ཁྱེད་ཀྱི་དངོས་གྲངས་{amount} གིས་{provider} ལྟ་བུལ་བྱེད་ཡོད་དང་འདི་ནས་བསྒྱུར་འབྱོར་གྲུབ་གྱི་ཡིན།"
    },
    "features": {
      "no-code-website": [
        "མི་ཧེང་སྦྱོང་མིན་ coding ལག་དེ་མེད་ e-commerce、education、blog、news ལ་དགོས་མཁོ་བྱས་གནང་",
        "དབང་དེབ།: landing page དང product post གིས་ course seller dashboard ལས་བྱེད།"
      ],
      "custom-domain": [
        "ཁྱེད་ཀྱིས་ཌོ་མིན་མཁོ་བྱས་དང་ professional digital identity བསྐོར་མཐུད་ཚུལ་ལེན་",
        "དབང་དེབ།: www.acme.com ལ་ཁྱེད་ཀྱི་ཉེན་ཆེན་མེད།"
      ],
      "capi": [
        "conversion events གིས་ server-side ལ་འབད་དང་ campaign measurement ལ་བདེན་པའི་གནས་ཚུལ་བཟོ་",
        "དབང་དེབ།: purchase event གིས་ server ལས་ ad platform ལ་ཕུལ་བྱེད་"
      ],
      "personal-mfs": [
        "Personal MFS གི་དངོས་གྲངས་ཁུངས་གི་ payment verification རང་བཞིན་འབད་",
        "དབང་དེབ།: personal MFS payment གིས་ website order ལ་འདེམས་"
      ],
      "local-gateway": [
        "རིགས་གནས་ཀྱི་ local payment methods འགྲེལ་བཤད་མཐུན་",
        "དབང་དེབ།: local buyer གིས་ regional gateway ལ་ནང་འགྲོ་བྱས་checkout ལས་འབད་"
      ],
      "international-gateway": [
        "འཛམ་གླིང་གྱི་ payment methods འགྲེལ་བཤད་མཐུན་",
        "དབང་དེབ།: overseas buyer གིས་ global method ལ་ཐོག་ལས་checkout 完成"
      ],
      "notifications": [
        "payment དང་ order updates ལ་དེབ་དང་དེབ་ཚུལ་ལུས་ customers དང་ merchants ལས་ཕུལ་",
        "དབང་དེབ།: payment success གིས་ merchant alert དང་ལས་གཞིས་ཀྱི་རིགས་"
      ],
      "courier": [
        "confirmed orders དེབ་སྤྱོད་ཐང་ལྷུང་ལ་གནང་ courier workflow ལ་བསྐུར་",
        "དབང་དེབ།: confirmed COD order ལ་སྤྱོད་བྱས་ལ་ཁུངས་གཏོང་གྲུབ"
      ],
      "business-email": [
        "own branded domain ལ་མགོན་པའི་ professional email ཕུལ་དང་ཟླ་བྱིས་གནང་",
        "དབང་དེབ།: sales@acme.com གིས་འདི་དགོས་ཡོད་དང་ support@acme.com ལས་ལེན་"
      ]
    }
  },
  "est": {
    "checkout": {
      "liveInstruction": "Valige live-meetod, sisestage ja kinnitage konto number, millest te järgmisel lehel Send Money teete. Käivitatakse 10‑minutiline live‑sessioon; selle ajal raha saatmine kinnitab makse automaatselt.",
      "trxInstruction": "Tee Cash In poest või palu kedagi teist teha Send Money. Seejärel kinnitage automaatselt Transaction ID (TrxID) abil.",
      "enterNumberInstruction": "Sisestage oma number ja klõpsake nuppu '{action}'.",
      "offlineTitle": "Kaupmehe seade on võrguühenduseta",
      "offlineDescription": "Auto‑verifitseerimine ei ole ajutiselt saadaval.",
      "copyPersonal": "Kopeerige ülalolev Personal Account number.",
      "sendMoneyOffline": "Tehke Send Money või Cash In ülaltoodud numbrile või paluge kedagi teist Send Money teha.",
      "trxOffline": "Koguge Transaction ID (TrxID) ja sisestage see all. Kui kaupmees on taas võrgus, saadetakse teile teavitus e‑kirjaga või võite kaupmehega otse ühendust võtta.",
      "cashinNagad": "Nagadis Cash In pole lubatud, seega palun tehke Send Money mõnelt teiselt Nagad kontolt.",
      "cashinOther": "Enne Cash In'i küsige poekalt, kas nad annavad TrxID; kui mitte, ärge jätkake. Alternatiivselt paluge kedagi teist teha Send Money.",
      "waitTrx": "Pärast makset oodake 10–15 sekundit ja sisestage all TrxID. Võite sellelt lehelt lahkuda ja naasta selle makselehe juurde mis tahes ajal 24 tunni jooksul, et auto‑verifitseerida oma TrxID abil.",
      "goApp": "Minge {provider} rakendusse või valige {dialCode} ja valige 'Send Money'.",
      "confirmAuto": "Sisestage kopeeritud number ja summa, seejärel kinnitage oma PIN‑koodiga, et auto‑verifitseerida.",
      "dontClose": "Palun ärge sulgege seda lehte",
      "autoVerify": "Teie makset kontrollitakse automaatselt",
      "successOffline": "Aitäh, {name}. Teie tehing on salvestatud. Kaupmees on praegu offline. Kui kaupmees tuleb online ja kinnitab teie makse, teavitatakse teid e‑kirjaga.",
      "successOnline": "Aitäh, {name}. Teie {amount} suurune makse läbi {provider} on vastu võetud ja on kontrollimisel."
    },
    "features": {
      "no-code-website": [
        "Looge ja avaldage e‑kaup, hariduse, blogi või uudiste saite ilma kodeerimiseta.",
        "Näide: avaldage maandumisleht ja tootepostitus kursuse müüja armatuurlaudilt."
      ],
      "custom-domain": [
        "Ühendage oma domeen ja looge professionaalne digitaalne identiteet kiirema reitimisega.",
        "Näide: teie pood töötab aadressil www.acme.com platvormi alamdomeeni asemel."
      ],
      "capi": [
        "Saada serveripoolseid konversioonisündmusi usaldusväärseks kampaaniate mõõtmiseks.",
        "Näide: ostusündmus saadetakse serverist reklaamiplatvormile."
      ],
      "personal-mfs": [
        "Automatiseerige toetatud Personal MFS maksete verifitseerimine.",
        "Näide: Personal MFS makse vastab veebisaidi tellimusele."
      ],
      "local-gateway": [
        "Ühendage kohalikke maksevõimalusi piirkondlike klientide jaoks.",
        "Näide: kohalik ostja lõpetab kassasüsteemi läbi regionaalse gateway."
      ],
      "international-gateway": [
        "Ühendage rahvusvahelised maksevõimalused klientidele üle kogu maailma.",
        "Näide: välismaine ostja lõpetab kassasüsteemi globaalsete meetoditega."
      ],
      "notifications": [
        "Saadake makse‑ ja tellimuste värskendusi klientidele ja kaupmeestele.",
        "Näide: makse edukus vallandab kaupmehe teate ja kliendi värskenduse."
      ],
      "courier": [
        "Saatke kinnitatud tellimused automaatselt toetatud kullerworkflow'sse.",
        "Näide: kinnitatud COD‑tellimus valmistatakse ette kullerile üleandmiseks."
      ],
      "business-email": [
        "Saatke ja võtke vastu professionaalset e‑posti oma bränditud domeeni kaudu.",
        "Näide: sales@acme.com saab päringuid ja support@acme.com vastab."
      ]
    }
  },
  "fao": {
    "checkout": {
      "liveInstruction": "Vel ein live metodu, set inn og vátta kontonummar, ið tú fert at Send Money frá á næstu síðuni. Ein 10‑minutta live sessión byrjar; at senda pengar meðan hon varir vil sjálvvirkina gjaldið.",
      "trxInstruction": "Ger Cash In í handlinum ella bið onkran annar at Send Money. So sjálvvirkið við Transaction ID (TrxID).",
      "enterNumberInstruction": "Skriv inn tín nummar og trýst á '{action}' knøttin.",
      "offlineTitle": "Handilsmaðurin er offline",
      "offlineDescription": "Sjálvvirkni av viring er bráðliga ikki tøkt.",
      "copyPersonal": "Kopiera Personal Account nummari omanfyri.",
      "sendMoneyOffline": "Send Money ella ger Cash In til nummari omanfyri, ella bið onkran annan at Send Money.",
      "trxOffline": "Savna Transaction ID (TrxID) og set hann inn niðanfyri. Tá handilsmaðurin kemur online, verður tú kunnað umleið per teldupost, ella tú kanst seta teg í samband beinleiðis við handilsmannin.",
      "cashinNagad": "Cash In er ikki loyvt í Nagad, so vinarliga Send Money frá einum øðrum Nagad kontu.",
      "cashinOther": "Áðrenn Cash In, spur poingin um tey vilja geva TrxID; um nei, framhald ikki. Evt. bið onkran annan at Send Money.",
      "waitTrx": "Eftir gjaldið, bíða 10–15 sekund og set TrxID inn niðanfyri. Tú kanst fara burtur frá hesi síðu og koma aftur til hesa gjaldsíðuna síðan nakað tíð innan 24 tímar fyri at sjálvvirkna við tínum TrxID.",
      "goApp": "Far til {provider} appina ella ring {dialCode} og velja 'Send Money'.",
      "confirmAuto": "Skriv inn kopiera nummari og upphædd, so vátta við PIN fyri at sjálvvirkna.",
      "dontClose": "Vinarliga lat vera at stoypa hesa síðuna",
      "autoVerify": "Tín gjalding verður verifiserað sjálvvirkandi",
      "successOffline": "Takk, {name}. Tín transaktión er skrásett. Handilsmaðurin er í løtuni offline. Tú verður kunnað umleið við telduposti tá handilsmaðurin kemur online og vellir tín gjalding.",
      "successOnline": "Takk, {name}. Tín gjalding uppá {amount} við {provider} er móttikin og verður verifiserað."
    },
    "features": {
      "no-code-website": [
        "Skapa og útgeva e‑handil, útbúgving, blog ella tíðindasíður uttan kodun.",
        "Dømi: útgeva eina landing page og vørupost frá kurs seljari dashboard."
      ],
      "custom-domain": [
        "Teng títt eigið domæni og bygg eina professionella digitala identitet við skjótari routing.",
        "Dømi: títt butik rennur á www.acme.com í staðin fyri eitt platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side fyri álítandi kampagneymeting.",
        "Dømi: eitt keypisviðburður verður sendur frá server til ad platform."
      ],
      "personal-mfs": [
        "Automatisera stuðlaða Personal MFS gjalda viring.",
        "Dømi: ein personal MFS gjalding samsvarar við vefsíðu bílegging."
      ],
      "local-gateway": [
        "Teng lokal gjaldsmøguleikar fyri regionalar kundar.",
        "Dømi: ein lokal keypari fullføra checkout gjøgnum eina regional gateway."
      ],
      "international-gateway": [
        "Teng altjóða gjaldsmøguleikar fyri kundar kring heimin.",
        "Dømi: ein útlanda keypari fullføra checkout við einari global methodu."
      ],
      "notifications": [
        "Send gjalds‑ og bíleggingaruppdateringar til kundar og handilsfólk.",
        "Dømi: gjalds‑sannføring fremur eina varsuing til handilsfólk og eina uppdatering til kundan."
      ],
      "courier": [
        "Send váttaðar bíleggingar automatisk inn í eina stuðlaða courier workflow.",
        "Dømi: ein váttað COD bílegging verður tilreiðar til handoff til courier."
      ],
      "business-email": [
        "Send og móttaka professionell teldupost á tínum egnu brandaða domæni.",
        "Dømi: sales@acme.com móttakar fyrispurningar og support@acme.com svarar."
      ]
    }
  },
  "afr": {
    "checkout": {
      "liveInstruction": "Kies die regstreekse metode, voer en bevestig die rekeningnommer waarvan jy geld sal stuur op die volgende bladsy. 'n 10-minuut lewendige sessie sal begin; die stuur van geld tydens daardie sessie sal die betaling outomaties verifieer.",
      "trxInstruction": "Cash In by 'n winkel of vra iemand anders om Send Money. Verifieer dan outomaties met die Transaction ID (TrxID).",
      "enterNumberInstruction": "Voer jou nommer in en klik die '{action}'-knoppie.",
      "offlineTitle": "Handelaarstoestel Aflyn",
      "offlineDescription": "Outoverifikasie is tydelik nie beskikbaar nie.",
      "copyPersonal": "Kopieer die Personal Account-nommer hierbo.",
      "sendMoneyOffline": "Send Money of Cash In na die nommer hierbo, of vra iemand anders om geld te stuur.",
      "trxOffline": "Versamel die Transaction ID (TrxID) en voer dit hieronder in. Wanneer die handelaar aanlyn kom, sal jy per e-pos in kennis gestel word, of jy kan die handelaar direk kontak.",
      "cashinNagad": "Cash In is nie in Nagad toegelaat nie, stuur asseblief Send Money vanaf 'n ander Nagad-rekening.",
      "cashinOther": "Vra die winkelier voor Cash In of hulle die TrxID sal verskaf; indien nie, gaan nie voort nie. Alternatiewelik, vra iemand anders om Send Money.",
      "waitTrx": "Na betaling, wag 10–15 sekondes en voer die TrxID hieronder in. Jy kan hierdie bladsy verlaat en binne 24 uur op enige tyd terugkeer na hierdie betaalblad om outoverifikasie met jou TrxID te doen.",
      "goApp": "Gaan na die {provider} app of skakel {dialCode} en kies 'Send Money'.",
      "confirmAuto": "Voer die gekopieerde nommer en bedrag in, bevestig dan met jou PIN om outomaties te verifieer.",
      "dontClose": "Moet asseblief nie hierdie bladsy sluit nie",
      "autoVerify": "Jou betaling word outomaties geverifieer",
      "successOffline": "Dankie, {name}. Jou transaksie is aangeteken. Die handelaar is tans aflyn. Jy sal per e-pos gewaarsku word nadat die handelaar aanlyn kom en jou betaling verifieer.",
      "successOnline": "Dankie, {name}. Jou betaling van {amount} deur {provider} is ontvang en word geverifieer."
    },
    "features": {
      "no-code-website": [
        "Skep en publiseer e-handel-, opvoedkundige-, blog- of nuuswebwerwe sonder kodering.",
        "Voorbeeld: publiseer 'n landingsblad en produkplasing vanaf die kursusverkoper-dashboard."
      ],
      "custom-domain": [
        "Koppel jou eie domein en bou 'n professionele digitale identiteit met vinniger routering.",
        "Voorbeeld: jou winkel werk op www.acme.com in plaas van 'n platform-subdomein."
      ],
      "capi": [
        "Stuur omskakelingsgebeure vanaf die bediener vir betroubare veldtogmeting.",
        "Voorbeeld: 'n aankoopgebeurtenis word vanaf die bediener na die advertensieplatform gestuur."
      ],
      "personal-mfs": [
        "Automatiseer ondersteunde personal MFS-betaalverifikasie.",
        "Voorbeeld: 'n personal MFS-betaling word gematch met die webwerfbestelling."
      ],
      "local-gateway": [
        "Koppel plaaslike betaalmetodes vir streekskliënte.",
        "Voorbeeld: 'n plaaslike koper voltooi afrekening deur 'n streeks-gateway."
      ],
      "international-gateway": [
        "Koppel internasionale betaalmetodes vir kliënte wêreldwyd.",
        "Voorbeeld: 'n oorsese koper voltooi afrekening met 'n globale metode."
      ],
      "notifications": [
        "Stuur betaling- en bestelopdaterings aan kliënte en handelaars.",
        "Voorbeeld: betalingsukses veroorsaak 'n handelaarwaarskuwing en 'n kliëntopdatering."
      ],
      "courier": [
        "Stuur bevestigde bestellings outomaties in 'n ondersteunde koerierwerkvloeireël.",
        "Voorbeeld: 'n bevestigde COD-bestelling word voorberei vir koerier-oordrag."
      ],
      "business-email": [
        "Stuur en ontvang professionele e-pos op jou eie handelsmerkdomein.",
        "Voorbeeld: sales@acme.com ontvang navrae en support@acme.com antwoord."
      ]
    }
  },
  "amh": {
    "checkout": {
      "liveInstruction": "ቀጥታ ዘዴን ይምረጡ፣ በሚቀጥለው ገፅ ከሚላኩበት መለያ ቁጥር ያስገቡና ያረጋግጡ። 10 ደቂቃ የሚቆይ ቀጥታ ስብሰባ ይጀምራል፤ በዚህ ወቅት ገንዘብ ማስገባት ክፍያውን በራስሰር ይረጋገጣል።",
      "trxInstruction": "Cash In ከሱቅ ወይም ከሌላ ሰው ይፈልጉ እና እሱ ይላክ Send Money። ከዚያም Transaction ID (TrxID) በመጠቀም በራስሰር ይዘወትሩ።",
      "enterNumberInstruction": "ቁጥርዎን ያስገቡ እና '{action}' ቁልፍን ይጫኑ።",
      "offlineTitle": "የንግድ መሣሪያ ከመስመር ውጭ ነው",
      "offlineDescription": "የራስ-ማረጋገጫ አገልግሎት ጊዜያዊ እንዳይገኝ ነው።",
      "copyPersonal": "ከላይ ያለውን Personal Account ቁጥር ያቅዱ።",
      "sendMoneyOffline": "Send Money ወይም Cash In ወደ ላይ ያለው ቁጥር ላኩ, ወይም ሌላ ሰው እንዲላክ ጠይቁ።",
      "trxOffline": "Transaction ID (TrxID) ያሰቡና በታች ያስገቡ። ንግድ ሲመጣ ወደ መስመር ላይ ይሆናል፣ በኢሜይል ይንቀሳቀሳል ወይም ቀጥሎ ንግድኩን መደወል ይችላሉ።",
      "cashinNagad": "Cash In በNagad ውስጥ የማይፈቀድ ስለሆነ፣ እባክዎን ከሌላ የNagad አካውንት ይጠቀሙ እና Send Money ያድርጉ።",
      "cashinOther": "Cash In ከመድረሻ ቀደም ሲል ሱቅ ባለቤት የTrxID እንዲሰጥ ይጠይቁ፤ ካልሰጠ አትቀጥሉ። ወይም ሌላ ሰው እንዲላክ ጠይቁ።",
      "waitTrx": "ክፍያ በኋላ 10–15 ሰከንዶች ይጠብቁ እና የTrxID በታች ያስገቡ። ይህን ገጽ መለቀቅ ይችላሉ እና በ24 ሰዓታት ውስጥ በማንኛውም ጊዜ ይመለሱ እና በTrxID በራስሰር ይረጋገጡ።",
      "goApp": "ወደ {provider} መተግበሪያ ይሂዱ ወይም {dialCode} ይደውሉ እና 'Send Money' ይምረጡ።",
      "confirmAuto": "የተቅጂውን ቁጥር እና መጠን ያስገቡ፣ ከዚያ በPINዎ ያረጋግጡ እንዲረጋገጥ።",
      "dontClose": "እባክዎን ይህን ገፅ አትዝጁ።",
      "autoVerify": "ክፍያዎ በራስ-ማረጋገጫ እየተረጋገጠ ነው።",
      "successOffline": "እናመሰግናለን፣ {name}። ግብይትዎ ተመዝግቧል። ንግድው በዚህ ጊዜ ከመስመር ውጭ ነው። ንግድው ሲመጣ እና ክፍያዎን ሲያረጋግጥ በኢሜይል ይገልጥላችሁ።",
      "successOnline": "እናመሰግናለን፣ {name}። በ{provider} የተከፈለው {amount} ክፍያዎ ተቀብሏል እና እየተረጋገጠ ነው።"
    },
    "features": {
      "no-code-website": [
        "እንደ ኢ-ኮሜርስ፣ ትምህርት፣ ብሎግ ወይም ዜና ገፆች ያስፈጽሙና ያትሙ ያልነበረ ኮድ ያስፈልጋል ያለውን ሳይኮድ በመጠቀም።",
        "course seller dashboard ላይ landing page እና product post ያትሙ።"
      ],
      "custom-domain": [
        "ራስዎን የድር ስም (domain) ያገናኙ እና ከፍተኛ ፈጣን መላኪያ ጋር የሙያ ዲጂታል መለያ ይገነቡ።",
        "ለምሳሌ፡ ሱቅዎ www.acme.com ላይ ይሂዳል ከፍ የማይደርስ የመድረክ ንዑስ-ድር ስር የሚገኝ ነገር ይሆናል።"
      ],
      "capi": [
        "የቅድሚያ ለውጥ ክስተቶችን ከሰርቨር ወጥ ይላኩ ለታማኝ የዘርፎች መጠን መለኪያ።",
        "ለምሳሌ፡ የግዢ ክስተት ከሰርቨር ወደ ማስታወቂያ መድረክ ይላካል።"
      ],
      "personal-mfs": [
        "የደጋፊ Personal MFS የክፍያ ማረጋገጫን ማስተካከል።",
        "ለምሳሌ፡ የpersonal MFS ክፍያ ከድር ገጽ ትዕዛዝ ጋር ይዛላቸዋል።"
      ],
      "local-gateway": [
        "ለክልላዊ ደንበኞች የክልላዊ ክፍያ መንገዶችን ያገናኙ።",
        "ለምሳሌ፡ አንድ ክልላዊ ግዢ በክልላዊ ገበታ (gateway) ውስጥ ክፍያውን ይጨርሳል።"
      ],
      "international-gateway": [
        "ለዓለም አቀፍ ደንበኞች የክፍያ ዘዴዎችን ያገናኙ።",
        "ለምሳሌ፡ ከአገር ውጭ የሚመጣ ግዢ በአለም አቀፍ ዘዴ ክፍያውን ይጨርሳል።"
      ],
      "notifications": [
        "የክፍያና የትዕዛዝ አዘል ለደንበኞችና ለንግዶች ይላኩ።",
        "ለምሳሌ፡ የክፍያ ስኬት የንግድ ማስጠንቀቂያን እና የደንበኛ አዘልን ያከናውናል።"
      ],
      "courier": [
        "የተፈጸመ ትዕዛዝ ለደጋፊ ኩሪየር ሂደት በራስሰር ይግባ።",
        "ለምሳሌ፡ የCOD ድርጊት ተፈጻሚ እንደሆነ ለኩሪየር ዝግጅት ይዘጋጃል።"
      ],
      "business-email": [
        "በራስዎ የባለ ምርት የድር ስም ላይ ሙያዊ ኢሜይል ይላኩና ይቀበሉ።",
        "ለምሳሌ፡ sales@acme.com ጥያቄዎችን ይቀበላል እና support@acme.com ይሰጥ መልስ።"
      ]
    }
  },
  "arc": {
    "checkout": {
      "liveInstruction": "ܒܚܘܼܪܝܼܐ ܕܚܝܐ ܐܝܟ ܬܒܚܝܪ، ܠܐܚܪܢܐ ܦܬܚ ܘܫܩܠ ܒܠܚܫܚܐ ܡܐܕܥܢܐ ܕܬܫܠܚ ܡܢܗ ܕܥܠܘܢ. ܥܣܪܝܢ ܪܘܛܒܬܐ ܕܩܛܥܬܐ ܕܚܝܐ ܬܚܠܐ ܐܢܝܬ؛ ܒܬܪ ܕܬܫܠܚ ܟܣܦܐ ܒܝܕܗ ܢܬܡܫܟ ܕܢܗܘܐ ܐܘܬܘ-ܡܬܪܝܢܐ ܠܟܠܦܬܐ.",
      "trxInstruction": "Cash In ܡܢ ܚܪܘܦܐ ܐܘ ܫܐܠ ܠܐܚܪܐ ܕܢܫܠܚ Send Money. ܒܬܪܝܢ ܐܘܬܘ-ܡܬܪܝܢܐ ܒܚܫܝܒܬܐ ܕTransaction ID (TrxID).",
      "enterNumberInstruction": "ܫܡܥ ܡܛܠܟ ܘܐܦܩ '{action}' ܟܠܕܐ.",
      "offlineTitle": "ܡܕܒܪܢܐ ܕܡܫܬܡܫ ܒܝܬ ܡܢܘܫܐ ܕܐܦܘܪ",
      "offlineDescription": "ܐܘܬܘ-ܡܬܪܝܢܐ ܠܒܝܠܝܬܐ ܠܐ ܡܦܬܚܐ ܒܙܒܢܐ.",
      "copyPersonal": "ܦܠܘܓ ܠܢܘܡܪܐ Personal Account ܕܡܥܠܐ.",
      "sendMoneyOffline": "Send Money ܐܘ Cash In ܠܢܘܡܪܐ ܕܡܥܠܐ، ܐܘ ܫܐܠ ܠܐܚܪܐ ܕܢܫܠܚ.",
      "trxOffline": "ܩܒܠ ܠܟܠܦܬܐ Transaction ID (TrxID) ܘܫܡܥܗ ܠܬܚܬ. ܟܕ ܕܡܫܬܡܫ ܝܥܠ ܠܡܪܕܐ ܠܐܘܪܚܐ ܬܢܗܘܢ ܒܝܕ ܐܝܡܝܠ، ܐܘ ܬܚܘܪܐ ܠܡܫܬܡܫ ܐܝܟ ܬܚܘܪ.",
      "cashinNagad": "Cash In ܒܢܓܕ ܠܐ ܦܬܚܐ، ܒܫܠܡ ܫܠܚ Send Money ܡܢ ܚܫܒܐ ܐܚܪܐ ܕNagad.",
      "cashinOther": "ܩܕܡ ܡܢ Cash In، ܫܐܠ ܠܡܓܸܪܩܐ ܐܝܟ ܡܢܗ ܢܬܝܒ ܠܟܠܦܬܐ TrxID; ܐܢ ܠܐ ܝܗܒ ܠܐ ܬܫܠܚ. ܒܚܠܦ ܐܢܐ، ܫܐܠ ܠܐܚܪܐ ܕܢܫܠܚ.",
      "waitTrx": "ܒܬܪ ܫܠܚܐ، 10–15 ܬܪܝܢ ܫܟܢܛܬܐ ܢܩܘܡ ܘܫܡܥ ܠTrxID ܠܬܚܬ. ܬܚܘܪ ܠܦܪܨܐ ܘܬܫܒܩ ܠܗ ܒܟܠ ܙܒܢ ܦܘܪܫܐ 24 ܫܥܬܐ ܠܐܘܬܘ-ܡܬܪܝܢܐ ܥܡ ܠܟܠܦܬܐ.",
      "goApp": "ܙܠ ܠܐܦܠܝܩܐ {provider} ܐܘ ܩܪܝܐ {dialCode} ܘܒܚܪ 'Send Money'.",
      "confirmAuto": "ܫܡܥ ܠܢܘܡܪܐ ܕܩܠܦܬܐ ܘܠܩܥܕܐ، ܘܐܪܓܥ ܒܦܝܢ ܕܕܐ ܠܐܘܬܘ-ܡܬܪܝܢܐ.",
      "dontClose": "ܒܨܪܝܬܐ ܠܐ ܬܣܓܪ ܦܪܨܐ ܗܢܐ",
      "autoVerify": "ܩܫܝܬܐ ܕܟܣܦܐ ܥܒܕܬ ܒܐܘܬܘ-ܡܬܪܝܢܐ",
      "successOffline": "ܬܘܕܝܬܐ، {name}. ܡܚܫܒܬܐ ܕܐܬܐ ܨܒܝܬ. ܡܫܬܡܫ ܗܫܐ ܐܦܘܪ ܗܘܐ. ܬܐ ܬܢܪܘܢ ܒܐܝܡܝܠ ܟܕ ܕܡܫܬܡܫ ܬܥܠ ܘܬܪܝܢ ܐܣܛܪܬܐ ܠܓܒܝ ܩܫܝܬܐ.",
      "successOnline": "ܬܘܕܝܬܐ، {name}. ܡܟܬܒܘܬܟܘܢ ܕ{amount} ܒܝܕ {provider} ܬܠܩܬ ܘܬܢܛܪ ܠܡܬܪܝܢܐ."
    },
    "features": {
      "no-code-website": [
        "ܒܪܝܬ ܘܦܪܫ ܕܐܬܪܐ ܕܡܠܗܡܬܐ، ܒܠܐ ܕܬܚܘܬ ܣܪܛܐ ܕܟܘܕܐ.",
        "ܕܝܠܢܐ: ܦܪܫ ܐܦܬܐ ܘܡܕܥܐ ܕܡܬܠܐ ܡܢ ܠܘܓܐ ܕܡܒܥܐ."
      ],
      "custom-domain": [
        "ܐܬܒܟܪ ܕܡܕܪܐ ܀ ܗܢܐ ܓܕܡܐ ܦܪܫܐ ܠܫܡܐ ܘܐܢܐ ܢܚܒܬ ܫܪܝܪܐ.",
        "ܕܝܠܢܐ: ܚܕܐ ܕܟܪܣܐ ܥܠ www.acme.com ܒܥܠܝܐ ܡܢ ܣܓܐ ܕܦܠܐܬܦܘܪܡ."
      ],
      "capi": [
        "ܫܠܚ ܕܓܙܐ ܕܢܙܠܐ ܡܢ ܣܪܒܪ ܠܐܝܕܐ ܕܡܘܩܕܡܐ ܕܡܕܒܪܢܐ.",
        "ܕܝܠܢܐ: ܓܙܐ ܕܩܝܢܘܬܐ ܡܢ ܣܪܒܪ ܠܡܕܒܪܐ ܕܓܙܐ."
      ],
      "personal-mfs": [
        "ܐܘܬܘܡܐܛܝܙ ܕܒܝܪܝܬ ܠPersonal MFS ܡܬܪܝܢܐ.",
        "ܕܝܠܢܐ: ܓܙܐ ܕPersonal MFS ܐܝܬ ܐܚܕ ܠܡܛܠܐ."
      ],
      "local-gateway": [
        "ܐܬܒܟܪ ܠܡܕܒܪܢܐ ܕܣܘܪܝܬܐ ܕܚܝܒܐ.",
        "ܕܝܠܢܐ: ܡܢܚܝܒܐ ܡܬܠܢܐ ܒܥܒܪ ܒܓܘ ܡܕܒܪܢܐ."
      ],
      "international-gateway": [
        "ܐܬܒܟܪ ܠܡܕܒܪܢܐ ܕܟܠܐ ܕܥܠܡܐ.",
        "ܕܝܠܢܐ: ܡܢ ܒܪܢܐ ܕܠܐܪܥ ܡܬܟܠܠ ܒܐܘܬܘܡ."
      ],
      "notifications": [
        "ܫܠܚ ܕܓܙܐ ܕܟܣܦܐ ܘܕܩܪܝܢܐ ܠܡܬܠܝܢ ܘܠܡܫܬܡܫܝܢ.",
        "ܕܝܠܢܐ: ܢܗܘܐ ܕܟܣܦܐ ܐܫܬܪܪ ܡܛܠܐ ܠܡܫܬܡܫ."
      ],
      "courier": [
        "ܫܠܚ ܛܠܝܢܐ ܕܒܥܠܝܢ ܠܡܕܒܪܐ ܕܩܘܪܝܐ ܒܐܘܬܘ-ܡܬܪܝܢܐ.",
        "ܕܝܠܢܐ: ܡܛܠ ܐܠܐ ܕCOD ܙܥܘܪܐ ܡܬܐܝܢ ܠܩܘܪܝܐ."
      ],
      "business-email": [
        "ܫܠܚ ܘܩܒܠ ܓܒܪܝܐ ܕܐܝܡܝܠ ܒܫܡܐ ܕܕܟܬܐ ܕܐܬܪܐ.",
        "ܕܝܠܢܐ: sales@acme.com ܢܩܒܠ ܫܐܠܬܐ ܘ support@acme.com ܝܬܪܢ ܐܢܬܬ."
      ]
    }
  },
  "aym": {
    "checkout": {
      "liveInstruction": "Live método satañani, aka paginana aka cuenta número uka sarapxiñataki confirmani. 10 minutos ukan live sesión qalltatawa; ukan qalltatanakan dinero yaqha manqhan sartañani ukat pago automático verifikatarakiwa.",
      "trxInstruction": "Cash In tienda ukan jach'a jaqitixa Send Money sasaw sapxiñataki. Ukatxa Transaction ID (TrxID) ukat autoverificarïñataki usi.",
      "enterNumberInstruction": "Número tuqita sarapxiñani ukat '{action}' botónanakaw apasiñani.",
      "offlineTitle": "Comerciante dispositivo off-line ukanwa",
      "offlineDescription": "Auto-verify qalltawayiwa temporariamente janiw waljañatakiti.",
      "copyPersonal": "Arriba Personal Account número qillqañani (copiar).",
      "sendMoneyOffline": "Send Money ukaxa Cash In uka número satañani, jan ukaxa jichha jaqi yaqha jaqitx ukhamarak send money sasaw sapxiñani.",
      "trxOffline": "Transaction ID (TrxID) qapxiñani ukatxa akaqapxiñani. Comerciante linañataki online ukanawa, e-mail ukan thaqhipxäna, jan ukaxa comerciante sartañanwa.",
      "cashinNagad": "Nagad uka Cash In janiw amuyt'añatakiti, ukhamaraki janiw Cash In jani. Aka jisk'achawi, uka jisk'a Nagad cuenta jan ukan send money uka aplikacionaru sarapxiñani.",
      "cashinOther": "Cash In antes, tienda qillqiriw TrxID yaqha uñt'ayapxa sarapxiñani; janiw uñt'ayapxañäti ukaxa, jan ukaxa janiw qallt'añäti. Jan ukaxa yaqha jaqitx Send Money sapxiñani.",
      "waitTrx": "Pago qalltawayax 10–15 segundo qallt'añani ukat TrxID aka qapxiñani. Aka paginaw janiw chiqapxañänti ukat 24 horas ukanxa kimsäw pusi horas jiwasax uka paginapa qallt'añani ukat TrxID ukan autoverificarïta.",
      "goApp": "{provider} app uka luräwi ukan vayañani jan ukaxa {dialCode} qillqañani ukat 'Send Money' sutin apasiñani.",
      "confirmAuto": "Copiado número ukat monto aka sarapxiñani, PIN uka apasiñani ukat autoverificarïta.",
      "dontClose": "Aka paginaxa qallt'añäni janit qallt'añä niw.",
      "autoVerify": "Pagoñxa automatique verifikatatäna",
      "successOffline": "Yuspajara, {name}. Tu transacción registrituwa. Comerciantepa uka jichha tiempo off-line ukanwa. Comerciante online ukanaka pago verificatanak apnaqañataki e-mail uka sarawinaskiwa.",
      "successOnline": "Yuspajara, {name}. {provider} ukanxa {amount} pago jiskt'atawa ukat verificatanak apnaqañawa."
    },
    "features": {
      "no-code-website": [
        "Código sin chiqapxi websituak aynacht'añataki (e-commerce, educación, blog jan noticia).",
        "Ejemplo: landing page ukat producto post uka course seller dashboard ukanwa publicar qallt'añani."
      ],
      "custom-domain": [
        "Jichha dominio tuqita conectar qallt'añani ukat profesional identidad digital uñacht'añani con ruteo más rápido.",
        "Ejemplo: tu tienda www.acme.com ukanwa chiqapxi, plataforma subdominio janiw uskaniti."
      ],
      "capi": [
        "Conversion eventanak server-side ukan sarapxiñani campaña medición aka fiable.",
        "Ejemplo: compra event servidor ukanawa ad platform aruman sarantaskiwa."
      ],
      "personal-mfs": [
        "Personal MFS pago verificatión automatizar qallt'añani (soportado).",
        "Ejemplo: personal MFS pago web ordenanakana match qallt'añani."
      ],
      "local-gateway": [
        "Región ukan clientes para local método de pago conectar qallt'añani.",
        "Ejemplo: lokale comprador regional gateway ukan checkout chikatäna."
      ],
      "international-gateway": [
        "Mundial clientes para internacional método de pago conectar qallt'añani.",
        "Ejemplo: extranjero comprador global método ukan checkout chikatäna."
      ],
      "notifications": [
        "Pago ukat orden actualizaciones clientes ukat comerciantesatak uñacht'añani.",
        "Ejemplo: pago éxito comerciante alerta ukat cliente update qallt'añani."
      ],
      "courier": [
        "Confirmado ordensa automático courier workflow uka junt'añani.",
        "Ejemplo: confirmado COD orden courier handoff satañani."
      ],
      "business-email": [
        "Profesional e-mail tu propio branded dominio ukan sarapxiñani ukat recibir.",
        "Ejemplo: sales@acme.com consultas ukan recibir ukat support@acme.com respuesta ukan enviar."
      ]
    }
  },
  "aze": {
    "checkout": {
      "liveInstruction": "Canlı metodu seçin, növbəti səhifədə pul göndərəcəyiniz hesab nömrəsini daxil edin və təsdiqləyin. 10 dəqiqəlik canlı sessiya başlayacaq; sessiya zamanı pul göndərmək ödənişi avtomatik təsdiqləyəcək.",
      "trxInstruction": "Mağazadan Cash In edin və ya başqasından Send Money etməsini xahiş edin. Sonra Transaction ID (TrxID) ilə avtomatik təsdiqləyin.",
      "enterNumberInstruction": "Nömrənizi daxil edin və '{action}' düyməsini basın.",
      "offlineTitle": "Satıcının Cihazı Offlinedır",
      "offlineDescription": "Avtomatik təsdiqləmə müvəqqəti mövcud deyil.",
      "copyPersonal": "Yuxarıdakı Personal Account nömrəsini kopyalayın.",
      "sendMoneyOffline": "Yuxarıdakı nömrəyə Send Money və ya Cash In edin, yaxud başqasından pul göndərməsini xahiş edin.",
      "trxOffline": "Transaction ID (TrxID) toplayın və onu aşağıda daxil edin. Satıcı onlayn olduqda sizə e-poçtla xəbər veriləcək və ya birbaşa satıcı ilə əlaqə saxlaya bilərsiniz.",
      "cashinNagad": "Cash In Nagad-da icazəli deyil, buna görə zəhmət olmasa başqa Nagad hesabından Send Money edin.",
      "cashinOther": "Cash In etməzdən əvvəl mağaza sahibindən TrxID verib-verməyəcəyini soruşun; əgər vermirlərsə, davam etməyin. Alternativ olaraq, başqasından Send Money etməsini xahiş edin.",
      "waitTrx": "Ödənişdən sonra 10–15 saniyə gözləyin və TrxID-ni aşağıda daxil edin. Bu səhifəni tərk edib 24 saat ərzində istənilən vaxt ödəmə səhifəsinə qayıdaraq TrxID ilə avtomatik təsdiqləyə bilərsiniz.",
      "goApp": "{provider} tətbiqinə keçin və ya {dialCode}-ı yığın və 'Send Money' seçin.",
      "confirmAuto": "Kopyaladığınız nömrəni və məbləği daxil edin, sonra avtomatik təsdiqləmək üçün PIN ilə təsdiqləyin.",
      "dontClose": "Zəhmət olmasa bu səhifəni bağlamayın",
      "autoVerify": "Ödəməniz avtomatik olaraq təsdiqlənir",
      "successOffline": "Təşəkkürlər, {name}. Əməliyyatınız qeydə alındı. Satıcı hazırda offlinedır. Satıcı onlayn olduqdan və ödəmənizi təsdiqlədikdən sonra sizə e-poçt ilə məlumat veriləcək.",
      "successOnline": "Təşəkkürlər, {name}. {provider} vasitəsilə etdiyiniz {amount} məbləğli ödəniş alınmışdır və təsdiqlənir."
    },
    "features": {
      "no-code-website": [
        "Kod yazmadan e-ticarət, təhsil, bloq və ya xəbər saytları yaradın və yayımlayın.",
        "Nümunə: kurs satıcısı panelindən bir açılış səhifəsi və məhsul paylaşımı yayımlayın."
      ],
      "custom-domain": [
        "Öz domeninizi qoşun və daha sürətli yönləndirmə ilə peşəkar rəqəmsal şəxsiyyət yaradın.",
        "Nümunə: mağazanız platformanın subdomeni əvəzinə www.acme.com ünvanında işləyir."
      ],
      "capi": [
        "Etibarlı kampaniya ölçümü üçün server tərəfdən çevrilmə (conversion) hadisələrini göndərin.",
        "Nümunə: satınalma hadisəsi serverdən reklam platformasına göndərilir."
      ],
      "personal-mfs": [
        "Dəstəklənən personal MFS ödəniş təsdiqlərini avtomatlaşdırın.",
        "Nümunə: personal MFS ödənişi vebsayt sifarişi ilə uyğunlaşdırılır."
      ],
      "local-gateway": [
        "Regional müştərilər üçün yerli ödəniş üsullarını qoşun.",
        "Nümunə: yerli alıcı regional gateway vasitəsilə ödəmə prosesini tamamlayır."
      ],
      "international-gateway": [
        "Dünya üzrə müştərilər üçün beynəlxalq ödəniş üsullarını qoşun.",
        "Nümunə: xarici alıcı qlobal bir üsulla ödəmə prosesini tamamlayır."
      ],
      "notifications": [
        "Müştərilərə və satıcılara ödəniş və sifariş yenilikləri göndərin.",
        "Nümunə: ödəniş uğuru satıcı xəbərdarlığı və müştəri yeniləməsi tetikler."
      ],
      "courier": [
        "Təsdiqlənmiş sifarişləri dəstəklənən kuryer iş axınlarına avtomatik göndərin.",
        "Nümunə: təsdiqlənmiş COD sifarişi kuryerə təhvil vermək üçün hazırlanır."
      ],
      "business-email": [
        "Öz markalı domeninizdə peşəkar e-poçt göndərin və qəbul edin.",
        "Nümunə: sales@acme.com sorğuları alır və support@acme.com cavab verir."
      ]
    }
  },
  "bar": {
    "checkout": {
      "liveInstruction": "Wähl de Live-Method, gib auf da nächste Seit de Kontonummer ei, vo de du's Geld schickst, und bestätig's. A 10-Minütige Live-Session fängt o; wennst während dera Session Geld schickst, werd de Zahlung automatisch verifiziert.",
      "trxInstruction": "Mach a Cash In im Laden oda frog oan andern, ob's Send Money macht. Dann automatisch mit da Transaction ID (TrxID) verifizieren.",
      "enterNumberInstruction": "Gib dei Nummer ei und klick auf'n '{action}'-Button.",
      "offlineTitle": "Händlergerät offline",
      "offlineDescription": "D' automatische Verifizierung is vorübergehend ned verfügbar.",
      "copyPersonal": "Kopier de Personal Account-Nummer oben.",
      "sendMoneyOffline": "Send Money oder Cash In an de obenstehende Nummer, oda frog oan andern, ob's Geld schickt.",
      "trxOffline": "Sammle de Transaction ID (TrxID) und gib's unten ei. Wenn da Händler wieder online kimmt, kriagst a E-Mail, oda du kannst da Händler direkt kontaktiern.",
      "cashinNagad": "Cash In is in Nagad ned erlaubt, schick bittschee Send Money von am anderen Nagad-Konto.",
      "cashinOther": "Frog vorn Cash In no'n Laden, ob's da TrxID gibt; wenn ned, mach's ned weiter. Alternativ lass's a andern Send Money machen.",
      "waitTrx": "Nach da Zahlung warte 10–15 Sekundn und gib de TrxID unten ei. Du kannst de Seit verlassa und innerhalb vo 24 Stund jederzeit zurüggörn zum automatisch Verifizieren mit deiner TrxID.",
      "goApp": "Geh in de {provider}-App oder wähl {dialCode} und wähl 'Send Money'.",
      "confirmAuto": "Gib de kopierte Nummer und den Betrag ei, bestätig's mit dein PIN zum automatisch Verifizieren.",
      "dontClose": "Bitte schließ de Seit ned",
      "autoVerify": "Dei Zahlung wird automatisch verifiziert",
      "successOffline": "Vergelt's Gott, {name}. Dei Transaktion is protokolliert. Da Händler is grad offline. Du kriagst a E-Mail, sobald da Händler online kimmt und dei Zahlung verifiziert.",
      "successOnline": "Vergelt's Gott, {name}. Dei Zahlung i.H.v. {amount} über {provider} is eingaht und wird verifiziert."
    },
    "features": {
      "no-code-website": [
        "Erstell und veröffentlich E-Commerce-, Bildungs-, Blog- oder Nachrichten-Websites ohen z'programmieren.",
        "Beispiel: Veröffentliche a Landingpage und a Produkt-Eintrag vom Kurs-Verkäufer-Dashboard."
      ],
      "custom-domain": [
        "Verbind dei eigene Domain und bau a professionelle digitale Identität mit schnellerem Routing auf.",
        "Beispiel: Dei Shop laaft auf www.acme.com statt auf am Plattform-Subdomain."
      ],
      "capi": [
        "Schick Conversion-Ereignisse serverseitig für verlässliche Kampagnenmessung.",
        "Beispiel: A Kauf-Ereignis werd vom Server an d'Werbeplattform gschickt."
      ],
      "personal-mfs": [
        "Automatisier unterstützte personal MFS-Zahlungsbestätigungen.",
        "Beispiel: A personal MFS-Zahlung werd mit da Website-Bestellung abgeglichen."
      ],
      "local-gateway": [
        "Binde lokale Zahlungsmethoden für regionale Kundschaft ein.",
        "Beispiel: A lokale Käufer schließt d'Kasse über an regionalen Gateway ab."
      ],
      "international-gateway": [
        "Binde internationale Zahlungsmethoden für weltweite Kundschaft ein.",
        "Beispiel: A Käufer aus'm Ausland zahlt mit am globalen Verfahren."
      ],
      "notifications": [
        "Schick Zahlungs- und Bestell-Updates an Kundn und Händler.",
        "Beispiel: Zahlungs-Erfolg löst a Händler-Benachrichtigung und a Kunden-Update aus."
      ],
      "courier": [
        "Schick bestätigte Bestellungen automatisch in an unterstützten Kurier-Workflow.",
        "Beispiel: A bestätigte COD-Bestellung werd für d'Übergabe an'n Kurier vorbereitet."
      ],
      "business-email": [
        "Sende und empfange professionelle E-Mails auf deiner eigenen Marken-Domain.",
        "Beispiel: sales@acme.com empfängt Anfragen und support@acme.com antwortet."
      ]
    }
  },
  "bel": {
    "checkout": {
      "liveInstruction": "Выберыце рэжым прамой трансляцыі, увядзіце і пацвердзіце нумар рахунку, з якога будзеце адпраўляць грошы, на наступнай старонцы. Пачнецца 10-хвілінная прамая сесія; адпраўка грошай падчас яе аўтаматычна пацвердзіць плацёж.",
      "trxInstruction": "Зрабіце Cash In у краме або папрасіце іншага чалавека зрабіць Send Money. Пасля гэтага аўтаматычна пацвердзіце з дапамогай Transaction ID (TrxID).",
      "enterNumberInstruction": "Увядзіце свой нумар і націсніце кнопку '{action}'.",
      "offlineTitle": "Прылада прадаўца офлайн",
      "offlineDescription": "Аўтаверыфікацыя часова недаступная.",
      "copyPersonal": "Скапіруйце вышэйзгаданы нумар Personal Account.",
      "sendMoneyOffline": "Зрабіце Send Money або Cash In на вышэйзгаданы нумар, альбо папрасіце кагосьці іншага даслаць грошы.",
      "trxOffline": "Збярыце Transaction ID (TrxID) і ўвядзіце яго ніжэй. Калі прадавец з'явіцца анлайн, вы атрымаеце паведамленне па электроннай пошце, або можаце звязацца з прадаўцом непасрэдна.",
      "cashinNagad": "Cash In у Nagad не дазволены, таму калі ласка, зрабіце Send Money з іншага ўліковага запісу Nagad.",
      "cashinOther": "Перад Cash In спытайце ў прадаўца, ці дасць ён TrxID; калі не, не працягвайце. Альтэрнатыўна, папрасіце каго-небудзь іншага зрабіць Send Money.",
      "waitTrx": "Пасля аплаты пачакайце 10–15 секунд і ўвядзіце TrxID ніжэй. Вы можаце пакінуць гэтую старонку і вярнуцца на старонку аплаты ў любы момант на працягу 24 гадзін для аўтаверыфікацыі з дапамогай вашага TrxID.",
      "goApp": "Перайдзіце ў прыкладанне {provider} або набярыце {dialCode} і выберыце 'Send Money'.",
      "confirmAuto": "Увядзіце скапійаваны нумар і суму, потым пацвердзіце вашым PIN для аўтаматычнай верыфікацыі.",
      "dontClose": "Калі ласка, не зачыняйце гэту старонку",
      "autoVerify": "Ваш плацёж аўтаматычна верыфікуецца",
      "successOffline": "Дзякуй, {name}. Ваша транзакцыя зарэгістраваная. Прадавец зараз афлайн. Вы атрымаеце апавяшчэнне па электроннай пошце пасля таго, як прадавец выйдзе ў сетку і пацвердзіць ваш плацёж.",
      "successOnline": "Дзякуй, {name}. Ваш плацёж у памеры {amount} праз {provider} атрыманы і верыфікуецца."
    },
    "features": {
      "no-code-website": [
        "Стварайце і публікуйце інтэрнэт-крамы, адукацыйныя, блогавыя ці навінавые сайты без праграмацыі.",
        "Прыклад: апублікуйце лэндынг і паст пра прадукт з прыборнай панэлі прадаўца курса."
      ],
      "custom-domain": [
        "Падключыце ўласны дамен і стварыце прафесійную лічбавую ідэнтычнасць з больш хуткім маршрутызацыяй.",
        "Прыклад: ваш магазін працуе на www.acme.com замест платформавага субдамена."
      ],
      "capi": [
        "Адпраўляйце падзеі канверсіі з боку сервера для надзейнага вымярэння кампаній.",
        "Прыклад: падзея пакупкі адпраўляецца з сервера на рэкламную платформу."
      ],
      "personal-mfs": [
        "Аўтаматызуйце падтрыманыя праверкі плацяжоў personal MFS.",
        "Прыклад: плацёж personal MFS супадае з заказам на сайце."
      ],
      "local-gateway": [
        "Падключайце мясцовыя спосабы аплаты для рэгіянальных кліентаў.",
        "Прыклад: мясцовы пакупнік завяршае афармленне заказу праз рэгіянальны шлюз."
      ],
      "international-gateway": [
        "Падключайце міжнародныя спосабы аплаты для кліентаў па ўсім свеце.",
        "Прыклад: замежны пакупнік завяршае афармленне заказу з дапамогай сусветнага метаду."
      ],
      "notifications": [
        "Надзяляйце кліентаў і прадаўцоў абнаўленнямі па аплаце і заказах.",
        "Прыклад: поспех плацяжу выклікае папярэджанне прадаўцу і абнаўленне кліента."
      ],
      "courier": [
        "Аўтаматычна перадавайце пацверджаныя заказы ў падтрымоўваныя кур'ерскія працэсы.",
        "Прыклад: пацверджаны заказ COD падрыхтоўваецца для перадачы кур'еру."
      ],
      "business-email": [
        "Атрымлівайце і адпраўляйце прафесійныя лісты з уласнага брэндавага дамена.",
        "Прыклад: sales@acme.com атрымлівае запыты, а support@acme.com адказвае."
      ]
    }
  },
  "ber": {
    "checkout": {
      "liveInstruction": "Selt tazwara n live, sselked akked sser n compte izeg tiqqayt ad teskrem-ik deg useggas agi. Session live n 10-n tiḍiɣ ad tfeḍ; ma tazmmart-ik ad tṣaffed g wexxam ad yeṛṛu t-verify n ulac.",
      "trxInstruction": "Iɣer Cash In seg tabrat neɣ ssefru iman-inek ad iṭṭu Send Money. Sɣur at verify s Transaction ID (TrxID).",
      "enterNumberInstruction": "Sselked isem-ik ɣer u sduq '{action}'-tasruft.",
      "offlineTitle": "Agemmun n usellam ur yettwasfen",
      "offlineDescription": "Tverify n auto ur yettwamiḍ ara s waggaz.",
      "copyPersonal": "Ssekcem asemm n Personal Account iɣer-agi.",
      "sendMoneyOffline": "Do Send Money neɣ Cash In ɣer asemm n useggas-agi, neɣ ssefru iman n yisem-inek ad iṭṭu.",
      "trxOffline": "Sla Transaction ID (TrxID) akked sseqdec-iyi ɣer uḍer. Ma yella usellam yefka online, ad tzemreḍ a-s email, neɣ teskrem s usellam s wawal.",
      "cashinNagad": "Cash In ur yezmir ara deg Nagad, d acu ara teskrem-it Send Money seg akken aḍu Nagad.",
      "cashinOther": "Hlal ma d-tzemreḍ Cash In, ssaaḍ agar n useggas ma ad d-yettusneɣ TrxID; ma ur yettusneɣ ara, ur beɣiɣ ara ad tettuḍ. Akka, ssefru iman n yisem ad iṭṭu Send Money.",
      "waitTrx": "Ma d-ssir tazmmart, sser 10–15 imesdurar ad d-ḍaṛ ɣer TrxID iḍ-iyi. Tzemreḍ ad tečča useggas-agi akk-d aseqdec u t-tekfa ɣef useggas n useḍȥa 24 wasag s waggaz ad t-verify s TrxID-ik.",
      "goApp": "Ruh i app n {provider} neɣ ddu ḍ {dialCode} u ssel 'Send Money'.",
      "confirmAuto": "Sselked asemm i ssekcem akked amount, ddu ḍ PIN-ik ad t-verify s-auto.",
      "dontClose": "Ar ḥemleɣ ad tḥermeḍ useggas-a",
      "autoVerify": "Tazmmart-ik tella d-yettu-verify s-auto",
      "successOffline": "Tanemmirt, {name}. Tazmmart-ik yetterẓa. Usellam yella uḍer offline. Ad tzemreḍ akkat i email mi yella usellam yefka online akked yesserf tazmmart-ik.",
      "successOnline": "Tanemmirt, {name}. Tazmmart-ik n {amount} s {provider} yettqeddem akk-d yettverify."
    },
    "features": {
      "no-code-website": [
        "Sselked d-nḥu web-sayt n e-commerce, education, blog neɣ news s waɣeṛ ur tesskin ara code.",
        "Asali: sselked landing page akked post n product s dashboard n seller n course."
      ],
      "custom-domain": [
        "Sespel domain-inek i yesɛaḍ ad teqqem awal digital n professional s route iziɣen.",
        "Asali: tiɣri-nnek ttawiḍ deg www.acme.com d tazwara ur ḥeddan ara ɣef subdomain n platform."
      ],
      "capi": [
        "Ssend events n conversion s server-side i tmeasure n campaign imi d-yeḥbul.",
        "Asali: event n purchase yettwassel seg server i platform n ads."
      ],
      "personal-mfs": [
        "Awtomatiz ɣef verify n payment personal MFS i d-ssupporta.",
        "Asali: payment n personal MFS yettamsaḍ ɣer order n website."
      ],
      "local-gateway": [
        "Sespel local payment methods i tcustomers n region.",
        "Asali: buyer local yettqedem checkout s regional gateway."
      ],
      "international-gateway": [
        "Sespel international payment methods i tcustomers ɣer tmeddurt.",
        "Asali: buyer seg walagh yettqedem checkout s global method."
      ],
      "notifications": [
        "Ssend updates n payment akked order i tcustomers akked merchants.",
        "Asali: success n payment yettḥedder alert i merchant akked update i customer."
      ],
      "courier": [
        "Ssend orders n confirm ɣer workflow n courier i d-ssupporta automatikman.",
        "Asali: order n COD confirm yettʿeddem i courier ad itqedem."
      ],
      "business-email": [
        "Ssend akked ssefru professional email s domain n brand-inek.",
        "Asali: sales@acme.com yettqbad queries akked support@acme.com yettrespont."
      ]
    }
  },
  "bis": {
    "checkout": {
      "liveInstruction": "Selevem laev method, putem an confirmem nomoa blong akaunt we bae yu sendem mani long folem pej. Wan 10-minit live session bae stat; sapos yu sendem mani taem long hem, payment bae auto-verify.",
      "trxInstruction": "Cash In long shop o askem narwan fo Send Money. Den auto-verify yusum Transaction ID (TrxID).",
      "enterNumberInstruction": "Putem namba blong yu mo klik long '{action}' button.",
      "offlineTitle": "Masin blong merchant i offline",
      "offlineDescription": "Auto-verification i no stap long present taem.",
      "copyPersonal": "Kopi namba blong Personal Account we stap antap.",
      "sendMoneyOffline": "Send Money o Cash In long namba we stap antap, o askem narwan fo sendem mani.",
      "trxOffline": "Kolem Transaction ID (TrxID) mo putum long hetia. Taim merchant i kam online, bae ol sendem email long yu, o yu save contactem merchant stret.",
      "cashinNagad": "Cash In i no allow long Nagad, so plis Send Money from narra Nagad account.",
      "cashinOther": "Bifo yu Cash In, askem shopkipa sapos hem bae givim TrxID; sapos hem no givim, no gohed. Narafala, askem narwan fo Send Money.",
      "waitTrx": "Afta payment, wetem 10–15 second mo putum TrxID long hetia. Yu save leavem disfala pej mo kam bek long eni taem insaed 24 haoa fo auto-verify yusum TrxID blong yu.",
      "goApp": "Go long {provider} app o dialem {dialCode} mo selektem 'Send Money'.",
      "confirmAuto": "Putem kopied namba mo amount, den confirmem wetem PIN blong auto-verify.",
      "dontClose": "Plis no klosem disfala pej",
      "autoVerify": "Peiment blong yu i stap mekem verify otomatik",
      "successOffline": "Tangkyu, {name}. Transaksen blong yu i register. Merchant nao i offline. Bae yu kasem email taem merchant i kam online mo verifyim peiment blong yu.",
      "successOnline": "Tangkyu, {name}. Peiment blong yu {amount} tru {provider} i kasem mo stap verify."
    },
    "features": {
      "no-code-website": [
        "Mekem mo pablisem e-commerce, education, blog o news website witout kod.",
        "Exampol: pablisem wan landing page mo product post from course seller dashboard."
      ],
      "custom-domain": [
        "Konektem you own domain mo bild wan profesional digital identity wit faster routing.",
        "Exampol: you shop i ron long www.acme.com insted blong platform subdomain."
      ],
      "capi": [
        "Sen conversion events server-side for reliable kampen measurement.",
        "Exampol: wan purchase event sen long server go long ad platform."
      ],
      "personal-mfs": [
        "Automatem supported personal MFS payment verification.",
        "Exampol: wan personal MFS payment i match wetem website order."
      ],
      "local-gateway": [
        "Konekt local payment methods for regional customers.",
        "Exampol: wan local buyer i kompletem checkout tru regional gateway."
      ],
      "international-gateway": [
        "Konekt international payment methods for customers worldwide.",
        "Exampol: wan overseas buyer i kompletem checkout wit global method."
      ],
      "notifications": [
        "Sen payment mo order updates to customers mo merchants.",
        "Exampol: payment success i trigger merchant alert mo customer update."
      ],
      "courier": [
        "Sen confirmed orders into supported courier workflow otomatik.",
        "Exampol: confirmed COD order i prepare for courier handoff."
      ],
      "business-email": [
        "Sen mo kisim profesional email on your own branded domain.",
        "Exampol: sales@acme.com i kisim inquiries mo support@acme.com i reply."
      ]
    }
  },
  "bjz": {
    "checkout": {
      "liveInstruction": "Pick da live method, den pon da next page type an confirm da account number weh yuh a go send money from. A 10-minute live session ago start; if yuh send money while it deh, di payment ago auto-verify.",
      "trxInstruction": "Do Cash In from di shop or ask somebody else fi Send Money. Den auto-verify wid di Transaction ID (TrxID).",
      "enterNumberInstruction": "Type yuh number an click di '{action}' button.",
      "offlineTitle": "Merchant Device a work offline",
      "offlineDescription": "Auto-verification nuh available right now.",
      "copyPersonal": "Copy di Personal Account number weh up ya.",
      "sendMoneyOffline": "Send Money or Cash In to di number up ya, or ask someone else fi send money.",
      "trxOffline": "Collect di Transaction ID (TrxID) an enter it below. When di merchant come online yuh ago get email, or yuh can contact di merchant direct.",
      "cashinNagad": "Cash In nuh allow in Nagad, so please Send Money from anadda Nagad account.",
      "cashinOther": "Before Cash In ask di shopkeeper if dem gone give di TrxID; if dem nah give it, nuh go forward. Else ask someone else fi Send Money.",
      "waitTrx": "After payment wait 10–15 seconds and enter di TrxID below. Yuh can leave dis page and come back anytime inna 24 hours to auto-verify wid yuh TrxID.",
      "goApp": "Go to di {provider} app or dial {dialCode} an select 'Send Money'.",
      "confirmAuto": "Enter di copied number an amount, den confirm wid yuh PIN fi auto-verify.",
      "dontClose": "Please nuh close dis page",
      "autoVerify": "Yuh payment a get verified automatically",
      "successOffline": "Tank yuh, {name}. Yuh transaction record done. Di merchant right now offline. Yuh ago get email when di merchant come online an verify yuh payment.",
      "successOnline": "Tank yuh, {name}. Yuh payment of {amount} tru {provider} don reach an a get verified."
    },
    "features": {
      "no-code-website": [
        "Create an publish e-commerce, education, blog, or news sites widout coding.",
        "Example: publish a landing page an product post from di course seller dashboard."
      ],
      "custom-domain": [
        "Connect yuh own domain an build a professional digital identity wid faster routing.",
        "Example: yuh store run pon www.acme.com insteed of a platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side fi reliable campaign measurement.",
        "Example: a purchase event send from di server to di ad platform."
      ],
      "personal-mfs": [
        "Automate di supported Personal MFS payment verification.",
        "Example: a personal MFS payment match to di website order."
      ],
      "local-gateway": [
        "Connect local payment methods fi regional customers.",
        "Example: a local buyer complete checkout tru a regional gateway."
      ],
      "international-gateway": [
        "Connect international payment methods fi customers worldwide.",
        "Example: an overseas buyer complete checkout wid a global method."
      ],
      "notifications": [
        "Send payment an order updates to customers an merchants.",
        "Example: payment success trigger a merchant alert an customer update."
      ],
      "courier": [
        "Send confirmed order ina wa supported courier workflow automatically.",
        "Example: a confirmed COD order get prepared fi courier handoff."
      ],
      "business-email": [
        "Send an receive professional email on yuh own branded domain.",
        "Example: sales@acme.com receive inquiries an support@acme.com reply."
      ]
    }
  },
  "bos": {
    "checkout": {
      "liveInstruction": "Odaberite način uživo, unesite i potvrdite broj računa s kojeg ćete slati novac na sljedećoj stranici. Počet će 10-minutna live sesija; slanje novca tokom nje automatski će verificirati uplatu.",
      "trxInstruction": "Napravite Cash In u trgovini ili zamolite nekog drugog da Send Money. Zatim automatski verificirajte pomoću Transaction ID (TrxID).",
      "enterNumberInstruction": "Unesite svoj broj i kliknite na '{action}' dugme.",
      "offlineTitle": "Uređaj trgovca je offline",
      "offlineDescription": "Automatska verifikacija je privremeno nedostupna.",
      "copyPersonal": "Kopirajte gore navedeni Personal Account broj.",
      "sendMoneyOffline": "Send Money ili Cash In na gore navedeni broj, ili zamolite nekog drugog da pošalje novac.",
      "trxOffline": "Sakupite Transaction ID (TrxID) i unesite ga ispod. Kada trgovac bude online, bit ćete obaviješteni e-mailom, ili možete direktno kontaktirati trgovca.",
      "cashinNagad": "Cash In nije dozvoljen u Nagad, stoga molimo pošaljite Send Money s drugog Nagad računa.",
      "cashinOther": "Prije Cash In-a pitajte trgovca hoće li dati TrxID; ako neće, nemojte nastaviti. Alternativno, zamolite nekog drugog da Send Money.",
      "waitTrx": "Nakon uplate pričekajte 10–15 sekundi i unesite TrxID ispod. Možete napustiti ovu stranicu i vratiti se na stranicu plaćanja u bilo kojem trenutku unutar 24 sata kako biste automatski verificirali koristeći svoj TrxID.",
      "goApp": "Idite na {provider} aplikaciju ili birajte {dialCode} i odaberite 'Send Money'.",
      "confirmAuto": "Unesite kopirani broj i iznos, zatim potvrdite s vašim PIN-om za automatsku verifikaciju.",
      "dontClose": "Molimo vas nemojte zatvarati ovu stranicu",
      "autoVerify": "Vaša uplata se automatski provjerava",
      "successOffline": "Hvala, {name}. Vaša transakcija je zabilježena. Trgovac je trenutno offline. Bit ćete obaviješteni e-mailom nakon što trgovac dođe online i potvrdi vašu uplatu.",
      "successOnline": "Hvala, {name}. Vaša uplata od {amount} putem {provider} primljena je i provjerava se."
    },
    "features": {
      "no-code-website": [
        "Kreirajte i objavite e-trgovinu, obrazovne, blog ili novinske sajtove bez kodiranja.",
        "Primjer: objavite landing stranicu i post o proizvodu iz panela prodavača kursa."
      ],
      "custom-domain": [
        "Povežite vlastiti domen i izgradite profesionalni digitalni identitet s bržim usmjeravanjem.",
        "Primjer: vaša trgovina radi na www.acme.com umjesto na platformskom poddomeni."
      ],
      "capi": [
        "Pošaljite konverzijske događaje server-side za pouzdano mjerenje kampanja.",
        "Primjer: događaj kupovine šalje se sa servera na oglašivačku platformu."
      ],
      "personal-mfs": [
        "Automatizirajte podržanu verifikaciju plaćanja personal MFS.",
        "Primjer: personal MFS uplata se podudara s narudžbom na web stranici."
      ],
      "local-gateway": [
        "Povežite lokalne metode plaćanja za regionalne kupce.",
        "Primjer: lokalni kupac dovrši checkout putem regionalnog gateway-a."
      ],
      "international-gateway": [
        "Povežite međunarodne metode plaćanja za kupce širom svijeta.",
        "Primjer: kupac iz inostranstva dovrši checkout s globalnom metodom."
      ],
      "notifications": [
        "Pošaljite obavijesti o plaćanju i narudžbama kupcima i trgovcima.",
        "Primjer: uspjeh plaćanja pokreće obavijest trgovcu i ažuriranje kupcu."
      ],
      "courier": [
        "Automatski šaljite potvrđene narudžbe u podržan kurirski tok rada.",
        "Primjer: potvrđena COD narudžba pripremljena je za predaju kuriru."
      ],
      "business-email": [
        "Šaljite i primajte profesionalne e-poruke na vlastitom brendiranom domenu.",
        "Primjer: sales@acme.com prima upite i support@acme.com odgovara."
      ]
    }
  },
  "bul": {
    "checkout": {
      "liveInstruction": "Изберете режима на на живо, въведете и потвърдете номера на сметката, от която ще изпратите пари, на следващата страница. Ще започне 10-минутна сесия на живо; изпращането на пари по време на нея ще верифицира плащането автоматично.",
      "trxInstruction": "Направете Cash In от магазин или помолете някой друг да направи Send Money. След това верифицирайте автоматично с Transaction ID (TrxID).",
      "enterNumberInstruction": "Въведете вашия номер и кликнете бутона '{action}'.",
      "offlineTitle": "Устройство на търговеца офлайн",
      "offlineDescription": "Автоматичната верификация временно не е налична.",
      "copyPersonal": "Копирайте горния номер на Personal Account.",
      "sendMoneyOffline": "Направете Send Money или Cash In на горния номер, или помолете някой друг да изпрати пари.",
      "trxOffline": "Съберете Transaction ID (TrxID) и го въведете по-долу. Когато търговецът стане онлайн, ще бъдете уведомени по имейл или можете да се свържете директно с търговеца.",
      "cashinNagad": "Cash In не е разрешен в Nagad, затова моля направете Send Money от друг Nagad акаунт.",
      "cashinOther": "Преди Cash In попитайте продавача дали ще предостави TrxID; ако не, не продължавайте. Алтернативно, помолете някой друг да направи Send Money.",
      "waitTrx": "След плащането изчакайте 10–15 секунди и въведете TrxID по-долу. Можете да напуснете тази страница и да се върнете на страницата за плащане по всяко време в рамките на 24 часа, за да верифицирате автоматично с вашия TrxID.",
      "goApp": "Отворете приложението {provider} или набeрeте {dialCode} и изберете 'Send Money'.",
      "confirmAuto": "Въведете копирания номер и сумата, след това потвърдете с вашия PIN за автоматична верификация.",
      "dontClose": "Моля, не затваряйте тази страница",
      "autoVerify": "Вашето плащане се проверява автоматично",
      "successOffline": "Благодарим, {name}. Вашата транзакция е записана. Търговецът в момента е офлайн. Ще бъдете уведомени по имейл, след като търговецът стане онлайн и потвърди вашето плащане.",
      "successOnline": "Благодарим, {name}. Вашето плащане от {amount} чрез {provider} е получено и се проверява."
    },
    "features": {
      "no-code-website": [
        "Създавайте и публикувайте електронни магазини, образователни, блог или новинарски сайтове без писане на код.",
        "Пример: публикувайте лендинг страница и продуктова публикация от таблото на продавача на курса."
      ],
      "custom-domain": [
        "Свържете собствен домейн и изградете професионална дигитална идентичност с по-бързо маршрутизиране.",
        "Пример: вашият магазин работи на www.acme.com вместо на поддомейн на платформата."
      ],
      "capi": [
        "Изпращайте conversion събития от страна на сървъра за надеждно измерване на кампании.",
        "Пример: събитие за покупка се изпраща от сървъра към рекламната платформа."
      ],
      "personal-mfs": [
        "Автоматизирайте поддържаната верификация на плащания personal MFS.",
        "Пример: personal MFS плащане се съпоставя със заявка на уебсайта."
      ],
      "local-gateway": [
        "Свържете местни методи за плащане за регионални клиенти.",
        "Пример: местен купувач завършва поръчката чрез регионален gateway."
      ],
      "international-gateway": [
        "Свържете международни методи за плащане за клиенти по целия свят.",
        "Пример: чуждестранен купувач завършва плащането с глобален метод."
      ],
      "notifications": [
        "Изпращайте известия за плащания и поръчки до клиенти и търговци.",
        "Пример: успешното плащане активира предупреждение за търговеца и актуализация за клиента."
      ],
      "courier": [
        "Изпращайте потвърдени поръчки автоматично в поддържан куриерски работен процес.",
        "Пример: потвърдена COD поръчка се подготвя за предаване на куриер."
      ],
      "business-email": [
        "Изпращайте и получавайте професионални имейли на собствен брандиран домейн.",
        "Пример: sales@acme.com получава запитвания и support@acme.com отговаря."
      ]
    }
  },
  "khi": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Create and publish e-commerce, education, blog, or news sites without coding.",
        "Example: publish a landing page and product post from the course seller dashboard."
      ],
      "custom-domain": [
        "Connect your own domain and build a professional digital identity with faster routing.",
        "Example: your store runs on www.acme.com instead of a platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side for reliable campaign measurement.",
        "Example: a purchase event is sent from the server to the ad platform."
      ],
      "personal-mfs": [
        "Automate supported personal MFS payment verification.",
        "Example: a personal MFS payment is matched to the website order."
      ],
      "local-gateway": [
        "Connect local payment methods for regional customers.",
        "Example: a local buyer completes checkout through a regional gateway."
      ],
      "international-gateway": [
        "Connect international payment methods for customers worldwide.",
        "Example: an overseas buyer completes checkout with a global method."
      ],
      "notifications": [
        "Send payment and order updates to customers and merchants.",
        "Example: payment success triggers a merchant alert and customer update."
      ],
      "courier": [
        "Send confirmed orders into a supported courier workflow automatically.",
        "Example: a confirmed COD order is prepared for courier handoff."
      ],
      "business-email": [
        "Send and receive professional email on your own branded domain.",
        "Example: sales@acme.com receives inquiries and support@acme.com replies."
      ]
    }
  },
  "khm": {
    "checkout": {
      "liveInstruction": "ជ្រើសរើសវិធីផ្សាយផ្ទាល់ (live) បញ្ចូល និងបញ្ជាក់លេខគណនីដែលអ្នកនឹងផ្ញើប្រាក់ពីវានៅទំព័របន្ទាប់។ ការផ្សាយផ្ទាល់រយៈពេល 10 នាទីនឹងចាប់ផ្តើម; ការផ្ញើប្រាក់ក្នុងរយៈពេលនេះនឹងធ្វើការផ្ទៀងផ្ទាត់អោយដោយស្វ័យប្រវត្តិ។",
      "trxInstruction": "ធ្វើ Cash In នៅហាងឬស្នើឱ្យអ្នកដ៏ផ្សេងផ្ញើ Send Money។ បន្ទាប់មកធ្វើការផ្ទៀងផ្ទាត់ដោយស្វ័យប្រវត្តិដោយប្រើលេខសម្គាល់ប្រតិបត្តិការ (TrxID).",
      "enterNumberInstruction": "បញ្ចូលលេខរបស់អ្នក ហើយចុចប៊ូតុង '{action}'.",
      "offlineTitle": "ឧបករណ៍ពាណិជ្ជករធ្វើការផ្អាក",
      "offlineDescription": "ការផ្ទៀងផ្ទាត់ដោយស្វ័យប្រវត្តិមិនអាចប្រើបានបណ្តោះអាសន្ន។",
      "copyPersonal": "ចម្លងលេខ Personal Account ខាងលើ។",
      "sendMoneyOffline": "ផ្ញើ Send Money ឬធ្វើ Cash In ទៅលេខខាងលើ ឬស្នើឱ្យអ្នកដ៏ផ្សេងផ្ញើប្រាក់។",
      "trxOffline": "ទទួលលេខសម្គាល់ប្រតិបត្តិការ (TrxID) ហើយបញ្ចូលវាក្រោមនេះ។ ពេលពាណិជ្ជករមកតាមអ៊ីនធឺរណេត អ្នកនឹងទទួលការជូនដំណឹងតាមអ៊ីមែល ឬអាចទាក់ទងពាណិជ្ជករដោយផ្ទាល់។",
      "cashinNagad": "មិនអនុលោមការធ្វើ Cash In នៅ Nagad, សូម Send Money ពីគណនី Nagad ផ្សេងទៀត។",
      "cashinOther": "មុនធ្វើ Cash In សូមសួរអ្នកលក់ថាតើយើងនឹងទទួលបាន TrxID ឬទេ; ប្រសិនបើមិនទាន់មាន កុំបន្ត។ ជាជម្រើសទៀត សូមស្នើឱ្យអ្នកដ៏ផ្សេងផ្ញើ Send Money។",
      "waitTrx": "បន្ទាប់ពីបង់ប្រាក់ សូមរង់ចាំ 10–15 វិនាទី ហើយបញ្ចូល TrxID ខាងក្រោម។ អ្នកអាចចាកចេញពីទំព័រនេះ ហើយត្រឡប់មកទំព័របង្រ្កាបបង់ប្រាក់នេះក្នុងរយៈពេល 24 ម៉ោងណាមួយដើម្បីផ្ទៀងផ្ទាត់ដោយស្វ័យប្រវត្តិដោយប្រើ TrxID។",
      "goApp": "ចូលទៅកម្មវិធី {provider} ឬទូរស័ព្ទលេខ {dialCode} ហើយជ្រើស 'Send Money'.",
      "confirmAuto": "បញ្ចូលលេខដែលបានចម្លង និងចំនួនប្រាក់ រួចបញ្ជាក់ជាមួយ PIN របស់អ្នក ដើម្បីផ្ទៀងផ្ទាត់ដោយស្វ័យប្រវត្តិ។",
      "dontClose": "សូមកុំបិទទំព័រនេះ។",
      "autoVerify": "ការបង់ប្រាក់របស់អ្នកកំពុងត្រូវបានផ្ទៀងផ្ទាត់ដោយស្វ័យប្រវត្តិ។",
      "successOffline": "អរគុណ, {name}។ ប្រតិបត្តិការរបស់អ្នកត្រូវបានកត់ត្រា។ ពាណិជ្ជករកំពុងអอฟឡាញ។ អ្នកនឹងទទួលការជូនដំណឹងតាមអ៊ីមែលបន្ទាប់ពីពាណិជ្ជករមកអនឡាញ និងផ្ទៀងផ្ទាត់ការបង់ប្រាក់របស់អ្នក។",
      "successOnline": "អរគុណ, {name}។ ការបង់ប្រាក់ {amount} តាមរយៈ {provider} របស់អ្នកត្រូវបានទទួល និងកំពុងត្រូវបានផ្ទៀងផ្ទាត់។"
    },
    "features": {
      "no-code-website": [
        "បង្កើត និងផ្សព្វផ្សាយគេហទំព័រជួញដូរ​អេឡិចត្រូនិច ការអប់រំ ប្លុក ឬព័ត៌មានដោយមិនចាំបាច់កូដ។",
        "ឧទាហរណ៍៖ ផ្សព្វផ្សាយទំព័រលេងបង្ហាញ និងប្រកាសទំនិញពីផ្ទាំងគ្រប់គ្រងអ្នកលក់វគ្គសិក្សា។"
      ],
      "custom-domain": [
        "ភ្ជាប់ដែនឈ្មោះផ្ទាល់ខ្លួន និងសាងសង់អត្តសញ្ញាណឌីជីថលវិជ្ជាជីវៈជាមួយការបញ្ជូនលឿនជាងមុន។",
        "ឧទាហរណ៍៖ ហាងរបស់អ្នកដំណើរការនៅ www.acme.com ជំនួសគេហទំព័ររង។"
      ],
      "capi": [
        "ផ្ញើព្រឹត្តការណ៍បម្លែងពីផ្នែកម៉ាស៊ីនបម្រើសម្រាប់ការវាស់វែងយុទ្ធនាការដែលទុកចិត្តបាន។",
        "ឧទាហរណ៍៖ ព្រឹត្តការណ៍ទិញត្រូវបានផ្ញើពីម៉ាស៊ីនបម្រើទៅកាន់វេទិកាផ្សព្វផ្សាយ។"
      ],
      "personal-mfs": [
        "អូតូម៉ាទកក្រើនការផ្ទៀងផ្ទាត់ការបង់ប្រាក់ Personal MFS ដែលគាំទ្រ។",
        "ឧទាហរណ៍៖ ការបង់ប្រាក់ Personal MFS ត្រូវបានផ្គូផ្គងជាមួយសំណើរទិញលើគេហទំព័រ។"
      ],
      "local-gateway": [
        "ភ្ជាប់វិធីបង់ប្រាក់ក្នុងស្រុកសម្រាប់អតិថិជនតំបន់។",
        "ឧទាហរណ៍៖ អ្នកទិញក្នុងតំបន់បញ្ចប់ការទូទាត់តាមរយៈgateway តំបន់។"
      ],
      "international-gateway": [
        "ភ្ជាប់វិធីបង់ប្រាក់អន្ដរជាតិសម្រាប់អតិថិជនពិភពលោក។",
        "ឧទាហរណ៍៖ អ្នកទិញពីក្រៅប្រទេសបញ្ចប់ការទូទាត់ជាមួយវិធីសាកល។"
      ],
      "notifications": [
        "ផ្ញើជូនដំណឹងអំពីការទូទាត់ និងបញ្ជាទិញទៅអតិថិជន និងពាណិជ្ជករ។",
        "ឧទាហរណ៍៖ ការជោគជ័យក្នុងការទូទាត់បង្កើតការជូនដំណឹងទៅពាណិជ្ជករ និងបដិសេធទៅអតិថិជន។"
      ],
      "courier": [
        "បញ្ចូនបញ្ជាទិញដែលបានបញ្ជាក់ចូលទៅក្នុងដំណើរការអ្នកផ្តល់សេវាកម្មដឹកជញ្ជូនដែលគាំទ្រដោយស្វ័យប្រវត្តិ។",
        "ឧទាហរណ៍៖ សំណើ COD ដែលបានបញ្ជាក់ត្រូវបានរៀបចំសម្រាប់ផ្ទេរយកទៅអ្នកផ្តល់សេវាការ។"
      ],
      "business-email": [
        "ផ្ញើ និងទទួលអ៊ីមែលវិជ្ជាជីវៈលើដែនជំនាញរបស់អ្នក។",
        "ឧទាហរណ៍៖ sales@acme.com ទទួលសំណួរ និង support@acme.com ឆ្លើយតប។"
      ]
    }
  },
  "kin": {
    "checkout": {
      "liveInstruction": "Hitamo uburyo bwa live, winjize kandi wemeze nomero y'umukonto uzoherezamo amafaranga ku rupapuro rukurikira. Session ya live y'iminota 10 izatangira; kohereza amafaranga muri iyo session bizahita byemeza ubwishyu.",
      "trxInstruction": "Kora Cash In muri amaduka cyangwa usabe undi muntu gukora Send Money. Hanyuma wemeze kuri automatique ukoresheje Transaction ID (TrxID).",
      "enterNumberInstruction": "Andika nomero yawe hanyuma ukande ku buto '{action}'.",
      "offlineTitle": "Igikoresho cy'umucuruzi kiri Offline",
      "offlineDescription": "Kwemeza kuri automatique ntabwo biboneka by'agateganyo.",
      "copyPersonal": "Koporora nomero ya Personal Account iri hejuru.",
      "sendMoneyOffline": "Ohereza Send Money cyangwa ukore Cash In kuri nomero iri hejuru, cyangwa usabe undi muntu ko yohereza amafaranga.",
      "trxOffline": "Tegereza cyangwa ukusanye Transaction ID (TrxID) ubone kuyandika hasi. Iyo umucuruzi azaba online, uzamenyeshwa kuri email, cyangwa ushobora kuvugana n'umucuruzi ubwe.",
      "cashinNagad": "Cash In ntibyemewe muri Nagad, rero nyamuneka koherereza amafaranga (Send Money) uva kuri konti ya Nagad itandukanye.",
      "cashinOther": "Mbere yo gukora Cash In, saba nyir'ububiko niba bazaguha TrxID; niba batazaguha, ntukomeze. Indi option ni ukusaba undi muntu ko akoherereza amafaranga (Send Money).",
      "waitTrx": "Nyuma yo kwishyura, tegereza amasegonda 10–15 hanyuma winjize TrxID hasi. Ushobora kuva kuri uru rupapuro ukazasubira muri uru rupapuro rw'ubwishyu mu masaha 24 kugira ngo byemezwe kuri automatique ukoresheje TrxID yawe.",
      "goApp": "Jya muri app ya {provider} cyangwa hamagara {dialCode} hanyuma uhitemo 'Send Money'.",
      "confirmAuto": "Andika nomero wakoporoye n'ingano y'amafaranga, wemeze ukoresheje PIN kugira ngo byemezwe kuri automatique.",
      "dontClose": "Nyamuneka ntufunge uru rupapuro",
      "autoVerify": "Ubwishyu bwawe burimo kwemezwa kuri automatique",
      "successOffline": "Urakoze, {name}. Icyo gikorwa cyawe cyanditswe. Umucuruzi muri iki gihe aracyari offline. Uzamenyeshwa kuri email igihe azaba online kandi azemeje ubwishyu bwawe.",
      "successOnline": "Urakoze, {name}. Ubwishyu bwawe bwa {amount} bwakoreshejwe {provider} bwakiriwe kandi burimo kwemezwa."
    },
    "features": {
      "no-code-website": [
        "Shiraho kandi ushyire ahagaragara imbuga za e-commerce, uburezi, blog, cyangwa amakuru utagombye kwandika code.",
        "Urugero: shyira ahagaragara urupapuro rwa landing na post y'ibicuruzwa uvuye muri dashboard y'umucuruzi w'amasomo."
      ],
      "custom-domain": [
        "Huza domaine yawe bwite kandi wubake indangamuntu y'ikoranabuhanga y'umwuga ifite uburyo bwo kuyobora buhuta.",
        "Urugero: iduka ryawe rikora kuri www.acme.com aho kuba subdomain ya platform."
      ],
      "capi": [
        "Ohereza ibihe bya conversion ku ruhande rwa server kugirango ubipime neza mu bikorwa by'ubukangurambaga.",
        "Urugero: igikorwa cyo kugura cyoherezwa na server kuri platform y'amatangazo."
      ],
      "personal-mfs": [
        "Automatike yo kwemeza ubwishyu bwa Personal MFS iyiherereye mu byashyigikiwe.",
        "Urugero: ubwishyu bwa Personal MFS buhuza n'itegeko ry'urubuga."
      ],
      "local-gateway": [
        "Huza uburyo bwo kwishyura bw'aho hantu ku bakiriya b'akarere.",
        "Urugero: umukiriya wo mu karere arangiza checkout binyuze kuri gateway y'akarere."
      ],
      "international-gateway": [
        "Huza uburyo bwo kwishyura mpuzamahanga ku bakiriya bo ku isi hose.",
        "Urugero: umukiriya wo mu mahanga arangiza checkout ukoresheje uburyo bw'isi yose."
      ],
      "notifications": [
        "Ohereza amakuru ku byerekeye ubwishyu n'ibyo watumije ku bakiriya no ku bacuruzi.",
        "Urugero: gutsinda kw'ubwishyu bitera itumanaho ku mucuruzi n'ubutumwa ku mukiriya."
      ],
      "courier": [
        "Ohereza ibyemejwe by'ibyo watumije mu murongo w'akazi w'umukozi w'itumanaho ushyigikiwe mu buryo bwikora.",
        "Urugero: itegeko rya COD ryemejwe ritegurwa kugirango rishikirizwe kuri courier."
      ],
      "business-email": [
        "Ohereza kandi wakire email z'umwuga kuri domaine yawe y'ikimenyetso. ",
        "Urugero: sales@acme.com yakira ibibazo kandi support@acme.com igasubiza."
      ]
    }
  },
  "kir": {
    "checkout": {
      "liveInstruction": "Жанды ыкманы тандаңыз, кийинки бетте акчаны кайсы эсептен жиберээрдигиңизди киргизип жана тастыктаңыз. 10 мүнөттүк live сессия башталат; ошол сессияда акча жөнөтүү төлөмдү авто-тексерүүгө алып келет.",
      "trxInstruction": "Дүкөндөн Cash In кылыңыз же башка бирөөнү Send Money кылып берүүңүздү сураңыз. Андан кийин Transaction ID (TrxID) аркылуу авто-тексерүү жасаңыз.",
      "enterNumberInstruction": "Номерди киргизип, '{action}' баскычын басыңыз.",
      "offlineTitle": "Сатып алуучунун түзмөгү оффлайн",
      "offlineDescription": "Авто-текшерүү убактылуу жеткиликсиз.",
      "copyPersonal": "Жогорудагы Personal Account номерин көчүрүңүз.",
      "sendMoneyOffline": "Жогорудагы номерге Send Money же Cash In жасаңыз, же башка бирөөнү акча жөнөтүүнү сураңыз.",
      "trxOffline": "Transaction ID (TrxID) жыйнап, аны төмөнгө киргизиңиз. Сатып алуучу интернетке чыкканда сизге электрондук почта аркылуу кабар берилет, же түздөн-түз сатуу менен байланышсаңыз болот.",
      "cashinNagad": "Nagad ичинде Cash Inга уруксат жок, ошондуктан башка Nagad эсебинен Send Money жасаңыз.",
      "cashinOther": "Cash In жасоодон мурун сатуу кызматкери TrxID берээрин сураңыз; эгер бербесе, улантпаңыз. Же болбосо башка бирөөнү Send Money кылууну сураңыз.",
      "waitTrx": "Төлөмдөн кийин 10–15 секунд күтүңүз жана төмөндө TrxID киргизиңиз. Сиз бул баракты калтырып же 24 сааттын ичинде кайтып келип TrxID менен авто-текшерүүнү жасай аласыз.",
      "goApp": "{provider} тиркемесине кирип же {dialCode} номерине чалып, 'Send Money' тандаңыз.",
      "confirmAuto": "Көчүрүлгөн номерди жана сумманы киргизип, PIN менен тастыктап авто-текшерүүнү жасаңыз.",
      "dontClose": "Бул баракты жаббаңыз, сураныч",
      "autoVerify": "Сиздин төлөм автоматтык түрдө текшерилүүдө",
      "successOffline": "Рахмат, {name}. Сиздин транзакция катталды. Сатуу учурда оффлайн. Сатуу онлайн болуп, төлөмдү текшергенден кийин сизге электрондук почта аркылуу кабар берилет.",
      "successOnline": "Рахмат, {name}. {provider} аркылуу жасалган {amount} суммасындагы төлөмүңүз кабыл алынып, текшерилүүдө."
    },
    "features": {
      "no-code-website": [
        "Код жазбастан e-commerce, билим берүү, блог же жаңылыктар сайттарын түзүп жарыялаңыз.",
        "Мисал: курсту сатуу панели аркылуу лендинг барак жана продукт постун жарыялоо."
      ],
      "custom-domain": [
        "Өз доминиңизди туташтырып, тезирээк багыттоо менен профессионал цифралык идентификация курыңуз.",
        "Мисал: дүкөнүңүз платформа субдоменинин ордуна www.acme.com аркылуу иштей берет."
      ],
      "capi": [
        "Кампанияны ишенимдүү өлчөө үчүн сервер тараптан conversion окуяларын жибериңиз.",
        "Мисал: сатып алуу окуясы серверден жарнама платформага жөнөтүлөт."
      ],
      "personal-mfs": [
        "Колдоого алынган Personal MFS төлөмүнүн текшерүү процессин автоматташтырыңыз.",
        "Мисал: Personal MFS төлөмү сайттагы заказ менен дал келген учур."
      ],
      "local-gateway": [
        "Аймактык кардарлар үчүн жергиликтүү төлөм ыкмаларын туташыңыз.",
        "Мисал: жергиликтүү сатып алуучу регионалдык шлюз аркылуу чек-аутту бүтүрөт."
      ],
      "international-gateway": [
        "Дүйнө жүзүндөгү кардарлар үчүн эл аралык төлөм ыкмаларын туташыңыз.",
        "Мисал: чет өлкөлүк сатып алуучу глобал ыкма менен чек-аутту бүтүрөт."
      ],
      "notifications": [
        "Төлөм жана заказ жаңыртууларын кардарларга жана соодагерлерге жибериңиз.",
        "Мисал: төлөмдүн ийгилиги соодагерге эскертүү жана кардарга жаңыртуу жиберет."
      ],
      "courier": [
        "Ырасталган заказдарды колдоого алынган курьер иш агымына автоматтык түрдө жибериңиз.",
        "Мисал: ырасталган COD заказ курьерге өткөрүү үчүн даярдалат."
      ],
      "business-email": [
        "Өз брендингиздин доменинде профессионал электрондук каттарды жиберип алыңыз жана кабыл алыңыз.",
        "Мисал: sales@acme.com суроолорду кабыл алат жана support@acme.com жооп берет."
      ]
    }
  },
  "kon": {
    "checkout": {
      "liveInstruction": "Sela mokano ya live, tonda mpe kobongisa numéro ya compte oyo okozipa mbongo na elangibeni ya suka. Session ya live ya dakika 10 ekobanda; kobomba mbongo na kati ya yango ekobenda auto-verify payement.",
      "trxInstruction": "Kobomba Cash In na magazin to kobenga moto mosusu azala apesa Send Money. Na nsima auto-verify na Transaction ID (TrxID).",
      "enterNumberInstruction": "Tonda numéro na yo mpe kiti \"{action}\".",
      "offlineTitle": "Mokanga ya Mosakata Offline",
      "offlineDescription": "Auto-verification ezali temporarily kozala na likama.",
      "copyPersonal": "Kopiya numéro ya Personal Account oyo ezali likolo.",
      "sendMoneyOffline": "Senga Send Money to Cash In na numéro oyo ezali likolo, to senga moto mosusu asala Send Money.",
      "trxOffline": "Kokoma Transaction ID (TrxID) mpe kotinda na nse. Soki mosakata ajangeli online, bakotuna yo na email, to okoki kolobela mosakata moko na moko.",
      "cashinNagad": "Cash In ezali te na Nagad, soki ezali, senga Send Money uta na konti Nagad mosusu.",
      "cashinOther": "Liboso ya Cash In, komi senga na komaka ete bakolinga kopesa yo TrxID; soki bato basali te, kofungola te. Alternative ezali kosenga moto mosusu asala Send Money.",
      "waitTrx": "Na nsima ya paiement, tika 10–15 secondes mpe koma TrxID na nse. Okoki kokima pe kobongela su page mpe kozonga na page ya paiement na tango lolenge moko moke kati na awa 24 heures mpo na auto-verify na TrxID.",
      "goApp": "Kende na app ya {provider} to fonela {dialCode} mpe senga 'Send Money'.",
      "confirmAuto": "Tonda numéro oyo obe kopi mpe motuya, kobongisa na PIN mpo na auto-verify.",
      "dontClose": "S'il vous plaît kobatela te page oyo",
      "autoVerify": "Paye ya yo ezali kozela auto-verification",
      "successOffline": "Melesi mingi, {name}. Transaction na yo ebimi na bokondoli. Mosakata azali offline sikoyo. Okoki kozwa email soki mosakata akomi online mpe asali verification ya paiement.",
      "successOnline": "Melesi mingi, {name}. Paiement ya {amount} na {provider} eyebani mpe ezali kozala na verification."
    },
    "features": {
      "no-code-website": [
        "Sangana pe publie ba sites ya e-commerce, éducation, blog to news na pas besoin ya code.",
        "Exemple: publier landing page mpe post produit uta na dashboard ya vendeur ya cours."
      ],
      "custom-domain": [
        "Koler domaine na yo mpe kosala identité digitale professionnelle na routage ya mingimingi.",
        "Exemple: boutique na yo ekobeta na www.acme.com oyo ezali subdomain ya plateforme."
      ],
      "capi": [
        "Kobimisa conversion events server-side mpo na mesure ya campagne oyo ezalaka fiable.",
        "Exemple: événement d'achat eyebami uta na server pona platforme ya publicité."
      ],
      "personal-mfs": [
        "Automatisez verification ya paiement Personal MFS oyo ebongwanami.",
        "Exemple: paiement Personal MFS ekoki ko matcher na commande ya site."
      ],
      "local-gateway": [
        "Koler méthodes de paiement ya local pona ba clients ya région.",
        "Exemple: acheteur local akomisa checkout na gateway ya région."
      ],
      "international-gateway": [
        "Koler méthodes de paiement internationales pona ba clients na mokili mobimba.",
        "Exemple: acheteur ya pembeni akomisa checkout na méthode globale."
      ],
      "notifications": [
        "Kobenga notifications ya paiement mpe commande pona ba clients mpe ba marchands.",
        "Exemple: succès de paiement ebimisaka alerte pona marchand mpe update pona client."
      ],
      "courier": [
        "Kopesa commandes confirmées mokanda na workflow ya courier oyo ebongi automatiquement.",
        "Exemple: commande COD confirmée eza préparée pona remise na courier."
      ],
      "business-email": [
        "Kobimisa na kozwa emails professionnels na domaine ya marque na yo.",
        "Exemple: sales@acme.com ekobomba demandes mpe support@acme.com ekosubisa."
      ]
    }
  },
  "kwn": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Tonge nokumoneka oma-site go e-commerce, education, blog noma news nonkora code.",
        "publish a landing page na product post mo seller dashboard."
      ],
      "custom-domain": [
        "Yanganisa domain lyoye nokutunga professional digital identity mo okukara ohandi.",
        "store lyoye li longuka po www.acme.com pokulipaga ke platform subdomain."
      ],
      "capi": [
        "Tuma conversion events server-side po kuteya po oupimo woma-campaign aadilika.",
        "oshinima shoku-tenga sha tumwa po kushilyo ku ad platform."
      ],
      "personal-mfs": [
        "Tjikerere verification yomalipo aMFS aPersonal MFS ayene tayi pombwelenge.",
        "personal MFS payment oyapamene yaalandithwa nonkalo yoye mo website order."
      ],
      "local-gateway": [
        "Yanganisa omayendelepo gomalipo gohambo la simo po va-ndona vo muholike.",
        "omutengi wa muni okamuholike okutiya checkout nokuyenda ko regional gateway."
      ],
      "international-gateway": [
        "Yanganisa omayendelepo gomalipo gohambo la shilongo shendi po vandona vo shilongo shomunikifo.",
        "omutengi wa pevi lyoshilongo okutiya checkout neshilongo shokuyenda shokoshiwa shomunikifo."
      ],
      "notifications": [
        "Tuma omaupdate gomalipo nomayele go-order po va-ndona nava-merchants.",
        "payment success otayi lombola ombozipo ya merchant nokuupdate ya customer."
      ],
      "courier": [
        "Tume omayele go-order gaguhanithwe mo courier workflow ya pombwelenge otjiikekerwe.",
        "confirmed COD order otayi lungwavakanithwa po courier handoff."
      ],
      "business-email": [
        "Tuma nonkalamena professional email mo domain lyoye olyo lya brand.",
        "sales@acme.com otayi mono oulondolola noku support@acme.com otayi visikapula."
      ]
    }
  },
  "lao": {
    "checkout": {
      "liveInstruction": "ເລືອກວິທີ live ແລ້ວປ້ອນແລະຢືນຢັນເລກບັນຊີທີ່ທ່ານຈະແຈ້ງເງິນຈາກໃນຫນ້າຕໍ່ໄປ. ການສະແດງສົດ 10 ນາທີຈະເລີ່ມ; ການແຈ້ງເງິນໃນໄລຍະນັ້ນຈະທໍາໃຫ້ການຈ່າຍເງິນຖືກຢືນຢັນໂດຍອັດຕະໂນມັດ.",
      "trxInstruction": "Cash In ຈາກຮ້ານ ຫຼືຂໍໃຫ້ຜູ່ອື່ນ Send Money. ແລ້ວຈົດຢືນຢັນອັດຕະໂນມັດໂດຍການໃຊ້ Transaction ID (TrxID).",
      "enterNumberInstruction": "ປ້ອນເບີຂອງທ່ານ ແລ້ວກົດປຸ່ມ '{action}'.",
      "offlineTitle": "ອຸປະກອນຜູ້ຄ້າອອບໄລນ໌",
      "offlineDescription": "ການຢືນຢັນອັດຕະໂນມັດຊ່ວງຫຼາຍຍັງບໍ່ສາມາດໃຊ້ງານໄດ້.",
      "copyPersonal": "ຄັດລອກເລກ Personal Account ທີ່ເກົ່າຢູ່ຂ້າງເທິງ.",
      "sendMoneyOffline": "Send Money ຫຼື Cash In ໄປຫາເບີນັ້ນ, ຫຼືຂໍໃຫ້ຜູ່ອື່ນຊ່ວຍແຈ້ງ.",
      "trxOffline": "ເກັບ Transaction ID (TrxID) ແລ້ວປ້ອນລົງດ້ານລຸ່ມ. ເມື່ອຜູ້ຄ້າເຂົ້າອອນໄລນ໌ຈະມີການແຈ້ງເຕືອນຜ່ານອີເມວ, ຫຼືທ່ານສາມາດຕິດຕໍ່ຜູ້ຄ້າໂດຍການກ່ອນ.",
      "cashinNagad": "ບໍ່ອະນຸຍາດໃຫ້ Cash In ໃນ Nagad, ດັ່ງນັ້ນກະລຸນາ Send Money ຈາກບັນຊີ Nagad ອື່ນ.",
      "cashinOther": "ກ່ອນທີ່ຈະ Cash In, ຂໍໃຫ້ຜູ້ຂາຍບອກວ່າພວກເຂົາຈະໃຫ້ TrxID ຫຼືບໍ່; ຖ້າບໍ່ມີ, ຢ່າດໍາເນີນການ. ເປັນທາງເລືອກ, ຂໍໃຫ້ຜູ້ອື່ນ Send Money.",
      "waitTrx": "ຫຼັງຈາກຈ່າຍ, ລໍຖ້າ 10–15 ວິນາທີ ແລ້ວປ້ອນ TrxID ຂ້າງລຸ່ມ. ທ່ານສາມາດອອກຈາກໜ້ານີ້ແລະກັບມາໄດ້ໃນໄລຍະ 24 ຊົ່ວໂມງເພື່ອເຮັດ auto-verify ດ້ວຍ TrxID.",
      "goApp": "ໄປຫາແອັບ {provider} ຫຼື ໂທໄປຫາ {dialCode} ແລ້ວເລືອກ 'Send Money'.",
      "confirmAuto": "ປ້ອນເບີທີ່ຄັດລອກແລະຈຳນວນ, ຈຶ່ງຢືນຢັນດ້ວຍ PIN ເພື່ອ auto-verify.",
      "dontClose": "ກະລຸນາຢ່າປິດໜ້ານີ້",
      "autoVerify": "ການຈ່າຍເງິນຂອງທ່ານກຳລັງຖືກຢືນຢັນໂດຍອັດຕະໂນມັດ",
      "successOffline": "ຂອບໃຈ, {name}. ທຸລະກຳຂອງທ່ານຖືກកតຕະຫວ. ຜູ້ຂາຍກຳລັງອອບໄລນ໌. ທ່ານຈະຮັບການແຈ້ງຜ່ານອີເມວຫຼັງຈາກຜູ້ຂາຍມາອອນໄລນ໌ແລະຢືນຢັນການຈ່າຍຂອງທ່ານ.",
      "successOnline": "ຂອບໃຈ, {name}. ການຈ່າຍຂອງທ່ານ {amount} ຜ່ານ {provider} ໄດ້ຮັບແລະກຳລັງຖືກກວດສອບ."
    },
    "features": {
      "no-code-website": [
        "ສ້າງແລະຜະລິດເວັບ e-commerce, ການສຶກສາ, ບລ໋ອກ, ຫຼື ຂ່າວ ໂດຍບໍ່ຕ້ອງຂຽນລະຫັດ.",
        "ຕົວຢ່າງ: ຜະລິດ landing page ແລະ post ສິນຄ້າຈາກ dashboard ຂອງអ្នកຂາຍຄ່ອຍຫຼົງ."
      ],
      "custom-domain": [
        "ເຊື່ອມຕໍ່ໂດເມນຂອງທ່ານແລະສ້າງອິດຕະລະຫັດດິຈິຕາລ໌ມືອຊີດເພື່ອການນຳທາງທີ່ໄວ.",
        "ຕົວຢ່າງ: ຮ້ານຂອງທ່ານດຳເນີນງານໂດຍ www.acme.com ແທນທີ່ຈະເປັນ subdomain ຂອງ platform."
      ],
      "capi": [
        "ສົ່ງກໍລະນີ conversion ຈາກ server-side ເພື່ອການຊື່ຖືຖືກໃຊ້ໃນການຜະລິດການປະກັນ.",
        "ຕົວຢ່າງ: ການຊື້ຖືກສົ່ງຈາກ server ໄປຫາ platform ຕິດຕາງ."
      ],
      "personal-mfs": [
        "ອັດຕະໂນມັດການຢືນຢັນການຈ່າຍເງິນ Personal MFS ທີ່គាំວຕື່ກ.",
        "ຕົວຢ່າງ: ການຈ່າຍ Personal MFS ກົງກັບດ້ານດ້ານການສັ່ງຊື້."
      ],
      "local-gateway": [
        "ເຊື່ອມຕໍ່ວິທີຈ່າຍໃນທ້ອງຖິ່ນ ສໍາລັບລູກຄ້າໃນແຂວງ.",
        "ຕົວຢ່າງ: ຜູ້ຊື້ໃນທ້ອງຖິ່ນສຳເລັດ checkout ຜ່ານ regional gateway."
      ],
      "international-gateway": [
        "ເຊື່ອມຕໍ່ວິທີຈ່າຍລະດັບສາກົນ ສໍາລັບລູກຄ້າທົ່ວໂລກ.",
        "ຕົວຢ່າງ: ຜູ້ຊື້ຈາກຕ່າງປະເທດສຳເລັດ checkout ດ້ວຍວິທີທົ່ວໂລກ."
      ],
      "notifications": [
        "ສົ່ງການອັບເດດການຈ່າຍແລະການສັ່ງໃຫ້ລູກຄ້າ ແລະ ຜູ້ຄ້າ.",
        "ຕົວຢ່າງ: ຄວາມສຳເລັດຂອງການຈ່າຍ ຈະຈ່າຍເປັນການແຈ້ງແຈ້ງແກ່ຜູ້ຄ້າ ແລະ ອັບເດດໃຫ້ລູກຄ້າ."
      ],
      "courier": [
        "ສົ່ງການສັ່ງຍืนยันແລ້ວໄປໃນ workflow ຂອງ courier ທີ່គាំວດໂດຍອັດຕະໂນມັດ.",
        "ຕົວຢ່າງ: ສັ່ງ COD ທີ່ຍืนยันແລ້ວຈະຖືກຈັດເຕີມເພື່ອມອບໃຫ້ courier."
      ],
      "business-email": [
        "ສົ່ງແລະຮັບອີເມວມາຊີວິດຊະນິດໃນ domain ຂອງທ່ານ.",
        "ຕົວຢ່າງ: sales@acme.com ຮັບຄໍາຖາມ ແລະ support@acme.com ຕອບກັບ."
      ]
    }
  },
  "lat": {
    "checkout": {
      "liveInstruction": "Eligite modum vivum, in proximā paginā numerum rationis ex quā pecūniam mittebitis intrate et confirmate. Sessio vivā decem minutōrum incipiet; pecūniam während eā mittĕns, solūtiō auto-verificābitur.",
      "trxInstruction": "Fac Cash In ab tabernā vel pete aliquem alium ut Send Money. Dein auto-verifica per Transaction ID (TrxID).",
      "enterNumberInstruction": "Intrate vestrum numerum et premite puga '{action}'.",
      "offlineTitle": "Instrumentum Mercatoris Offline",
      "offlineDescription": "Auto-verificātiō temporāliter nōn praesto est.",
      "copyPersonal": "Eximite numerum Personal Account suprā.",
      "sendMoneyOffline": "Send Money vel Cash In ad numerum suprā facite, aut pete aliquem alium ut pecūniam mittat.",
      "trxOffline": "Colligite Transaction ID (TrxID) et inserite infra. Cum mercātor rursus online fit, per epistolam electronicam certiēmur, aut potestis mercātōrem directe contingere.",
      "cashinNagad": "Cash In in Nagad non licet; quaesumus Send Money ex aliā Nagad ratiōne.",
      "cashinOther": "Ante Cash In, quaerite a tabernāriō sī TrxID dabitur; sīnī, nōn pergite. Alternātīve, pete alium ut Send Money faciat.",
      "waitTrx": "Post solūtiōnem, expectate 10–15 secundōs et inserite TrxID infra. Hanc paginam relinquere potestis et ad hanc paginam solutionis quovis tempore intra 24 hōrās redire ad auto-verificationem per vestrum TrxID.",
      "goApp": "Ite ad app {provider} aut telephonate {dialCode} et seligite 'Send Money'.",
      "confirmAuto": "Inserite numerum et summam nunc copiātam, tum confirmate cum PIN ut auto-verificētur.",
      "dontClose": "Quaesō nōn claudite hanc paginam",
      "autoVerify": "Vestra solūtiō automatē verificātur",
      "successOffline": "Grātiās, {name}. Vestra transactiō relata est. Mercātor nunc offline est. Per epistulam electronicam certiēmini postquam mercātor rursus online erit et vestra solūtiōnem verificāverit.",
      "successOnline": "Grātiās, {name}. Vestra solūtiō {amount} per {provider} accepta est et verificātur."
    },
    "features": {
      "no-code-website": [
        "Crea et publicā situs e-commerce, educātiōnis, commentāriōrum, vel nūntiōrum sine codicandō.",
        "Exemplum: publicā landing paginam et post productī ex tablō venditoris cursūs."
      ],
      "custom-domain": [
        "Coniunge proprium domain et aedifica professionalem identitātem digitālem cum rapiōre itinere.",
        "Exemplum: vestrum mercātum currit in www.acme.com pro subdomain platformae."
      ],
      "capi": [
        "Mitte conversionēs server-side pro certāre mensūrātiōne campāniae.",
        "Exemplum: eventus emptiōnis mittitur ā server ad plātformam prōnuntiandī."
      ],
      "personal-mfs": [
        "Automatizā verificātiōnem solutionum Personal MFS sublevātārum.",
        "Exemplum: persōnal MFS solūtio congruit cum ordine in situs."
      ],
      "local-gateway": [
        "Coniunge localēs methodōs solutionis pro clientibus regiōnālibus.",
        "Exemplum: emptor localis per portam regionalem concludit checkout."
      ],
      "international-gateway": [
        "Coniunge internationālēs methodōs solutionis pro clientibus undique in orbē.",
        "Exemplum: emptor ultrāmarīnus complet checkout cum methodō globalī."
      ],
      "notifications": [
        "Mitte nūntiōnēs de solutione et ordinibus ad clientes et mercātōrēs.",
        "Exemplum: successus solutionis movet alertam mercātōris et renovātiōnem clientī."
      ],
      "courier": [
        "Mitte ordines confirmātōs in workflow courieriī sublevātī automatice.",
        "Exemplum: ordo COD confirmātus praeparātur ad tradendūm courierī."
      ],
      "business-email": [
        "Mitte et recipi epistulās prōfessiōnālēs in dominio vestro proprīo.",
        "Exemplum: sales@acme.com recipit interrogationēs et support@acme.com respondet."
      ]
    }
  },
  "lav": {
    "checkout": {
      "liveInstruction": "Izvēlieties tiešraides metodi, nākamajā lapā ievadiet un apstipriniet konta numuru, no kura sūtīsiet naudu. Sāksies 10 minūšu tiešraides sesija; naudas nosūtīšana tās laikā automātiski verificēs maksājumu.",
      "trxInstruction": "Veiciet Cash In veikalā vai lūdziet kādam citam veikt Send Money. Pēc tam automātiski verificējiet, izmantojot Transaction ID (TrxID).",
      "enterNumberInstruction": "Ievadiet savu numuru un noklikšķiniet uz pogas '{action}'.",
      "offlineTitle": "Tirgotāja ierīce bezsaistē",
      "offlineDescription": "Automātiskā verificēšana pagaidām nav pieejama.",
      "copyPersonal": "Kopējiet augstāk esošo Personal Account numuru.",
      "sendMoneyOffline": "Veiciet Send Money vai Cash In uz augstāk redzamo numuru vai lūdziet kādu citu nosūtīt naudu.",
      "trxOffline": "Savāciet Transaction ID (TrxID) un ievadiet to zemāk. Kad tirgotājs būs tiešsaistē, saņemsiet paziņojumu pa e-pastu, vai varat tieši sazināties ar tirgotāju.",
      "cashinNagad": "Cash In nav atļauts Nagad, lūdzu, veiciet Send Money no cita Nagad konta.",
      "cashinOther": "Pirms Cash In pajautājiet pārdevējam, vai viņi nodrošinās TrxID; ja nē, nepārtrauciet darbību. Alternatīvi lūdziet kādu citu veikt Send Money.",
      "waitTrx": "Pēc maksājuma pagaidiet 10–15 sekundes un ievadiet TrxID zemāk. Jūs varat pamest šo lapu un atgriezties pie maksājuma lapas jebkurā laikā 24 stundu laikā, lai automātiski verificētu, izmantojot savu TrxID.",
      "goApp": "Atveriet {provider} lietotni vai zvaniet uz {dialCode} un izvēlieties 'Send Money'.",
      "confirmAuto": "Ievadiet nokopēto numuru un summu, pēc tam apstipriniet ar savu PIN, lai automātiski verificētu.",
      "dontClose": "Lūdzu, neaizveriet šo lapu",
      "autoVerify": "Jūsu maksājums tiek automātiski verificēts",
      "successOffline": "Paldies, {name}. Jūsu transakcija ir reģistrēta. Tirgotājs pašlaik ir bezsaistē. Jūs saņemsiet e-pasta paziņojumu, kad tirgotājs būs tiešsaistē un verificēs jūsu maksājumu.",
      "successOnline": "Paldies, {name}. Jūsu maksājums {amount} caur {provider} ir saņemts un tiek verificēts."
    },
    "features": {
      "no-code-website": [
        "Izveidojiet un publicējiet e-komercijas, izglītības, bloga vai ziņu vietnes bez kodēšanas.",
        "Piemērs: publicējiet nolaišanās lapu un produktu ierakstu no kursu pārdevēja vadības paneļa."
      ],
      "custom-domain": [
        "Pieslēdziet savu domēnu un izveidojiet profesionālu digitālo identitāti ar ātrāku maršrutēšanu.",
        "Piemērs: jūsu veikals darbojas vietnē www.acme.com, nevis platformas apakšdomēnā."
      ],
      "capi": [
        "Sūtiet konversiju notikumus servera pusē, lai nodrošinātu uzticamu kampaņu mērīšanu.",
        "Piemērs: pirkuma notikums tiek nosūtīts no servera uz reklāmas platformu."
      ],
      "personal-mfs": [
        "Automatizējiet atbalstīto Personal MFS maksājumu verificēšanu.",
        "Piemērs: Personal MFS maksājums tiek saskaņots ar tīmekļa vietnes pasūtījumu."
      ],
      "local-gateway": [
        "Pievienojiet vietējās maksājumu metodes reģionālajiem klientiem.",
        "Piemērs: vietējais pircējs pabeidz norēķinus caur reģionālo vārteju."
      ],
      "international-gateway": [
        "Pievienojiet starptautiskas maksājumu metodes klientiem visā pasaulē.",
        "Piemērs: ārzemju pircējs pabeidz norēķinus ar globālu metodi."
      ],
      "notifications": [
        "Sūtiet maksājumu un pasūtījumu atjauninājumus klientiem un tirgotājiem.",
        "Piemērs: maksājuma veiksmīga apstrāde izsauc tirgotāja brīdinājumu un klienta atjauninājumu."
      ],
      "courier": [
        "Automātiski sūtiet apstiprinātos pasūtījumus uz atbalstītu kurjerpakalpojumu darba plūsmu.",
        "Piemērs: apstiprināts COD pasūtījums tiek sagatavots kurjera nodošanai."
      ],
      "business-email": [
        "Sūtiet un saņemiet profesionālas e-pasta vēstules uz sava zīmola domēna.",
        "Piemērs: sales@acme.com saņem pieprasījumus un support@acme.com atbild."
      ]
    }
  },
  "lin": {
    "checkout": {
      "liveInstruction": "Kobela méthode ya live, tika nɔ́mero ya compte oyo okosalela kobomba mbongo na page oyo elandaki mpe komonisa yango. Session ya live ya dakika 10 ekobanda; kosala Send Money na session yango ekozala auto-verify ya paiement.",
      "trxInstruction": "Kobomba Cash In na magazin to kosenga moto mosusu azwa ko Send Money. Na nsima, auto-verify na Transaction ID (TrxID).",
      "enterNumberInstruction": "Tika nɔ́mero na yo mpe kiti bouton '{action}'.",
      "offlineTitle": "Bokɔndi ya comercant ezali Offline",
      "offlineDescription": "Auto-verification ezali temporerement kozala na problème.",
      "copyPersonal": "Kopiya numéro ya Personal Account oyo ezali likolo.",
      "sendMoneyOffline": "Kobatela Send Money to Cash In na numéro oyo ezali likolo, to kosenga moto mosusu atinda mbongo.",
      "trxOffline": "Kokoma Transaction ID (TrxID) mpe kozipa yango na nse. Soki comercant akomi online, okozwa notification na email, to okoki kosolola na comercant yango.",
      "cashinNagad": "Cash In ezali te na Nagad; boye senga Send Money uta na compte Nagad mosusu.",
      "cashinOther": "Liboso ya Cash In, pesa question na vendeur soki bakopesa TrxID; soki bakopesi te, kotika te. Alternative ezali kosenga moto mosusu atinda Send Money.",
      "waitTrx": "Sima ya paiement, tika 10–15 secondes mpe tika TrxID na nse. Okoki kokende na page mosusu mpe kozonga awa na page ya paiement na moke ya 24 heures mpo na auto-verify na TrxID.",
      "goApp": "Kende na app ya {provider} to fonela {dialCode} mpe salela 'Send Money'.",
      "confirmAuto": "Tinda numéro oyo oko kopi mpe montant, mpe confirma na PIN mpo auto-verify ebebisa.",
      "dontClose": "S'il vous plaît kobatela te page oyo",
      "autoVerify": "Paiement na yo ezali kozongisa auto-verification",
      "successOffline": "Matondo, {name}. Transaction na yo ebongisami. Comercant azali offline sikoyo. Okozwa email soki comercant akomi online mpe akobongisa paiement na yo.",
      "successOnline": "Matondo, {name}. Paiement na yo ya {amount} na {provider} eyebani mpe ezali kozela verification."
    },
    "features": {
      "no-code-website": [
        "Sangana pe publier ba sites ya e-commerce, enseignement, blog to nouveaux sans ko écrire code.",
        "Exemple: publier landing page mpe product post uta na dashboard ya vendeur ya cours."
      ],
      "custom-domain": [
        "Koler domaine na yo moko mpe salisa identité digitale ya professionel na routage ya rapide.",
        "Exemple: magasin na yo ekoki kozala na www.acme.com esika ya subdomain ya plateforme."
      ],
      "capi": [
        "Envoyer conversion events server-side pona mesure ya campagne oyo esalami na confiance.",
        "Exemple: événement achat eyokani na server epesami na platforme ya publicité."
      ],
      "personal-mfs": [
        "Automatiser verification ya paiement Personal MFS oyo ezali soutenue.",
        "Exemple: paiement Personal MFS emonani na commande ya site."
      ],
      "local-gateway": [
        "Koler méthodes locales ya paiement pona ba clients ya région.",
        "Exemple: acheteur local akokisa checkout na gateway ya région."
      ],
      "international-gateway": [
        "Koler méthodes internationales pona ba clients ya mokili mobimba.",
        "Exemple: acheteur ya pembeni akokisa checkout na méthode globale."
      ],
      "notifications": [
        "Envoyer updates ya paiement mpe commande pona ba clients mpe ba commerçants.",
        "Exemple: succès ya paiement ekolonga alerte pona commerçant mpe update pona client."
      ],
      "courier": [
        "Envoyer commandes confirmées na workflow ya courier oyo ekobanda automatiquement.",
        "Exemple: commande COD confirmée efungwamaka pona kopesa courier."
      ],
      "business-email": [
        "Envoyer mpe recevoir emails professionnels na domaine ya brand na yo.",
        "Exemple: sales@acme.com ekopesa demandes mpe support@acme.com ekopesa réponses."
      ]
    }
  },
  "lit": {
    "checkout": {
      "liveInstruction": "Pasirinkite tiesioginį (live) metodą, kitame puslapyje įveskite ir patvirtinkite sąskaitos numerį, iš kurio siųsite pinigus. Prasidės 10 minučių trukmės tiesioginė sesija; pinigų siuntimas jos metu automatiškai patikrins mokėjimą.",
      "trxInstruction": "Atlikite Cash In parduotuvėje arba paprašykite kažką kito atlikti Send Money. Tada automatiškai patikrinkite naudodami Transaction ID (TrxID).",
      "enterNumberInstruction": "Įveskite savo numerį ir spustelėkite mygtuką '{action}'.",
      "offlineTitle": "Pardavėjo įrenginys neprisijungęs",
      "offlineDescription": "Automatinis tikrinimas laikinai nepasiekiamas.",
      "copyPersonal": "Nukopijuokite aukščiau esantį Personal Account numerį.",
      "sendMoneyOffline": "Atlikite Send Money arba Cash In nurodytu numeriu, arba paprašykite kažko kito išsiųsti pinigus.",
      "trxOffline": "Surinkite Transaction ID (TrxID) ir įveskite jį žemiau. Kai pardavėjas prisijungs, jums bus pranešta el. paštu, arba galite tiesiogiai susisiekti su pardavėju.",
      "cashinNagad": "Cash In Nagad neleidžiamas, todėl prašome atlikti Send Money iš kitos Nagad sąskaitos.",
      "cashinOther": "Prieš atlikdami Cash In, paklauskite pardavėjo, ar jie pateiks TrxID; jei ne, neberinkite procedūros. Alternatyviai, paprašykite kažkieno kito atlikti Send Money.",
      "waitTrx": "Po apmokėjimo palaukite 10–15 sekundžių ir įveskite TrxID žemiau. Galite palikti šį puslapį ir bet kada per 24 valandas grįžti į šį mokėjimo puslapį, kad automatiškai patikrintumėte naudodami savo TrxID.",
      "goApp": "Eikite į {provider} programėlę arba skambinkite {dialCode} ir pasirinkite 'Send Money'.",
      "confirmAuto": "Įveskite nukopijuotą numerį ir sumą, tada patvirtinkite savo PIN kodu, kad automatiškai patikrintumėte.",
      "dontClose": "Prašome neuždaryti šio puslapio",
      "autoVerify": "Jūsų mokėjimas tikrinamas automatiškai",
      "successOffline": "Ačiū, {name}. Jūsų operacija užregistruota. Pardavėjas šiuo metu neprisijungęs. Jūs būsite informuoti el. paštu, kai pardavėjas prisijungs ir patikrins jūsų mokėjimą.",
      "successOnline": "Ačiū, {name}. Jūsų {amount} mokėjimas per {provider} gautas ir tikrinamas."
    },
    "features": {
      "no-code-website": [
        "Kurkite ir publikuokite e.komercijos, švietimo, tinklaraščių ar naujienų svetaines be programavimo.",
        "Pavyzdys: publikuokite nukreipimo puslapį ir produkto įrašą iš kursų pardavėjo skydelio."
      ],
      "custom-domain": [
        "Prijunkite savo domeną ir sukurkite profesionalią skaitmeninę tapatybę su greitesniu maršrutizavimu.",
        "Pavyzdys: jūsų parduotuvė veikia www.acme.com vietoj platformos subdomeno."
      ],
      "capi": [
        "Siųskite konversijų įvykius serverio pusėje patikimam kampanijų matavimui.",
        "Pavyzdys: pirkimo įvykis siunčiamas iš serverio į reklamos platformą."
      ],
      "personal-mfs": [
        "Automatizuokite palaikomų Personal MFS mokėjimų patikrinimą.",
        "Pavyzdys: Personal MFS mokėjimas priskiriamas interneto parduotuvės užsakymui."
      ],
      "local-gateway": [
        "Prijunkite vietines mokėjimo priemones regiono klientams.",
        "Pavyzdys: vietinis pirkėjas užbaigia atsiskaitymą per regioninį gateway."
      ],
      "international-gateway": [
        "Prijunkite tarptautines mokėjimo priemones klientams visame pasaulyje.",
        "Pavyzdys: užsienio pirkėjas baigia atsiskaitymą su globalia priemone."
      ],
      "notifications": [
        "Siųskite mokėjimų ir užsakymų atnaujinimus klientams ir pardavėjams.",
        "Pavyzdys: sėkmingas mokėjimas sukelia pranešimą pardavėjui ir atnaujinimą klientui."
      ],
      "courier": [
        "Automatiškai siųskite patvirtintus užsakymus į palaikomo kurjerio darbo eigą.",
        "Pavyzdys: patvirtintas COD užsakymas paruošiamas kurjeriui."
      ],
      "business-email": [
        "Siųskite ir gaukite profesionalius el. laiškus savo prekės ženklo domene.",
        "Pavyzdys: sales@acme.com gauna užklausas ir support@acme.com atsako."
      ]
    }
  },
  "loz": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Limbisa no kutunga mipekiso ya e-commerce, makola ya vundzukanyo vya ku dyondza, mabuku ya blog tobu makuzi ya ku lomba ku webusaiti me kutala, utelela na ku siamisa kulinga no code.",
        "telela landing page na product post ku seller dashboard ya mkulisa wa makosi."
      ],
      "custom-domain": [
        "Hlanganisa domain yanu yo bwalo u bangele chizwi cha digital chikulubwisa na ku katisa routing yeshili shilumbwa.",
        "store yanu ichali ku www.acme.com peya ku vyepo vya platform subdomain."
      ],
      "capi": [
        "Tumisa conversion events server-side kuti muwone campaign measurement yeshile yachikilekile.",
        "purchase event itumisiwa ku server yo kuenda ku ad platform."
      ],
      "personal-mfs": [
        "Lungamisa automation ya verification ya personal MFS yo tsekelwa.",
        "personal MFS payment ichi fanana na order ya website."
      ],
      "local-gateway": [
        "Hlanganisa local payment methods kuti mupe muvekeli wa region shimo.",
        "mukupi wa local achi kamaliza checkout kubudikila ku gateway ya region."
      ],
      "international-gateway": [
        "Hlanganisa international payment methods kuvekeli vosi vya pasi pose.",
        "mukupi wa ku calo co deso achi kamaliza checkout na method ya global."
      ],
      "notifications": [
        "Tumisa mapepo ya payment na updates ya order kuvekeli na ba merchant.",
        "payment success ichi vumbula alert ku merchant na update ku customer."
      ],
      "courier": [
        "Tumisa maorder ayo ya confirmed mu workflow ya courier yo tsekelwa sondela automatic.",
        "order ya confirmed COD icha lungisisiwa kukhandisa courier handoff."
      ],
      "business-email": [
        "Tumisa kandi punda professional email pa domain yanu ya branded.",
        "sales@acme.com ichi landa masabo na support@acme.com ichi tivule malandelo."
      ]
    }
  },
  "nau": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "E-commerce, education, blog, me news site irû eitsiwo, ngaga coding iauren ea tuŋ.",
        "Publish a landing page me product post eo dogin seller dashboard."
      ],
      "custom-domain": [
        "Connect domain eget ijo am, o eitsiwo professional digital identity odiya, me routing eamiũ tsimine.",
        "Store am eiyit www.acme.com bwain platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side bwe campaign measurement edorer rarũ.",
        "Purchase event eo eitsiwo eiyuwo server ngaga ad platform."
      ],
      "personal-mfs": [
        "Kamao automatic kae obwobwi Personal MFS orrer.",
        "Personal MFS payment eo eiyuwo ngaga website order bwe ematch."
      ],
      "local-gateway": [
        "Connect local payment methods bwe deitab edogoriyin region.",
        "Local buyer eo eitsiwo eiyuwo checkout ngaga regional gateway."
      ],
      "international-gateway": [
        "Connect international payment methods bwe customer eiyuwo tsimine anan.",
        "Overseas buyer eo eitsiwo eiyuwo checkout ngaga global method."
      ],
      "notifications": [
        "Send payment me order updates ngaga customer me merchant.",
        "Payment success eo eitsiwo eirũ merchant alert me customer update."
      ],
      "courier": [
        "Send confirmed orders ngaga supported courier workflow automatically.",
        "Confirmed COD order eo eitsiwo eiyuwo bwe courier handoff."
      ],
      "business-email": [
        "Send me receive professional email dogin domain egen branded am.",
        "sales@acme.com eirũ inquiries me support@acme.com eirũ replies."
      ]
    }
  },
  "nbl": {
    "checkout": {
      "liveInstruction": "Khetha indlela ebukhoma, faka bese uqinisekisa inombolo ye-akhawunti ozothumela kuyo kusiphepha esilandelayo. Kuzoqala iseshini ebukhoma yemizuzu eyi-10; ukuthumela imali phakathi nokho kuzoqinisekisa ukukhokha ngokuzenzakalayo.",
      "trxInstruction": "Yenza i-Cash In esitolo noma cela omunye umuntu ukuthi a-Send Money. Bese uqinisekisa ngokuzenzakalayo usebenzisa i-Transaction ID (TrxID).",
      "enterNumberInstruction": "Faka inombolo yakho bese uchofoza inkinobho ethi '{action}'.",
      "offlineTitle": "Idivayisi yomthengisi ayixhunywanga",
      "offlineDescription": "Ukuqinisekiswa ngokuzenzakalayo okwamanje akutholakali.",
      "copyPersonal": "Kopa inombolo ye-Personal Account engenhla.",
      "sendMoneyOffline": "Send Money noma Cash In enombolweni engenhla, noma cela omunye umuntu ukuthi athumele imali.",
      "trxOffline": "Qoqa i-Transaction ID (TrxID) bese uyifaka ngezansi. Uma umthengisi engaxhunywa ku-inthanethi, uzokwaziswa nge-imeyili, noma ungaxhumana nomthengisi ngqo.",
      "cashinNagad": "Cash In ayivunyelwe ku-Nagad, ngakho ngiyacela Send Money kusuka kwenye i-akhawunti ye-Nagad.",
      "cashinOther": "Ngaphambi kwe-Cash In, buza umthengisi ukuthi bazonikeza i-TrxID; uma bengakwenzi, ungathuthuki. Enye indlela, cela omunye umuntu ukuthi a-Send Money.",
      "waitTrx": "Ngemva kokukhokha, linda imizuzwana engu-10–15 bese ufaka i-TrxID ngezansi. Ungashiya leli khasi ubuyekela kuleli khasi lenkokhelo noma nini phakathi kwamahora angu-24 ukuze uqinisekise ngokuzenzakalayo usebenzisa i-TrxID yakho.",
      "goApp": "Vula uhlelo lokusebenza lwe-{provider} noma shayela {dialCode} bese ukhetha 'Send Money'.",
      "confirmAuto": "Faka inombolo nekota ekhishwe, bese uqinisekisa nge-PIN yakho ukuze kuqinisekiswe ngokuzenzakalayo.",
      "dontClose": "Sicela ungavaleli leli khasi",
      "autoVerify": "Inkokhelo yakho iyaqinisekiswa ngokuzenzakalayo",
      "successOffline": "Ngiyabonga, {name}. Ukuthengiselana kwakho kurekhodiwe. Umthengisi okwamanje akaxhunyiwe. Uzokwaziswa nge-imeyili uma umthengisi esexhumeka futhi eqinisekisa ukukhokha kwakho.",
      "successOnline": "Ngiyabonga, {name}. Inkokhelo yakho engu-{amount} nge-{provider} isamukelwe futhi iyahlolwa."
    },
    "features": {
      "no-code-website": [
        "Dala bese ushicilela amasayithi eze-e-commerce, zemfundo, ibhulogi, noma izindaba ngaphandle kokubhala ikhowudi.",
        "Isibonelo: shicilela ikhasi lokumisa nomkhiqizo kusuka kudeskithophu yomthengisi wezikole."
      ],
      "custom-domain": [
        "Xhuma igama lakho lesizinda futhi wakhe ubunikazi bedijithali obuchwepheshe ngenethiwekhi esheshayo.",
        "Isibonelo: isitolo sakho sisebenza ku-www.acme.com esikhundleni sedomain yenkundla."
      ],
      "capi": [
        "Thumela imicimbi yokuguqulwa kusuka kuseva ukuze kube nokukalwa kwemikhankaso okuthembekile.",
        "Isibonelo: umcimbi wokuthenga uthunyelwa kusuka kuseva uya epulatifomu yezikhangiso."
      ],
      "personal-mfs": [
        "Zenautomatise ukuqinisekiswa kokukhokha kwe-Personal MFS okusekelwayo.",
        "Isibonelo: ukukhokha kwe-Personal MFS kuhlotshaniswa ne-oda lewebhusayithi."
      ],
      "local-gateway": [
        "Xhuma izindlela zendawo zokukhokha zabathengi basendaweni.",
        "Isibonelo: umthengi wasendaweni uqeda inqubo yokukhokha ngegwayi laphakathi."
      ],
      "international-gateway": [
        "Xhuma izindlela zokukhokha zamazwe omhlaba zabathengi bamazwe wonke.",
        "Isibonelo: umthengi wasezwenikazi oqeda ukukhokha nendlela yomhlaba wonke."
      ],
      "notifications": [
        "Thumela izibuyekezo zokukhokha nezama-oda kubathengi nakumthengisi.",
        "Isibonelo: impumelelo yokukhokha idilika isexwayiso somthengisi nesibuyekezo seklayenti."
      ],
      "courier": [
        "Thumela ama-oda aqinisekisiwe kwi-workflow yekhuriya esekelwayo ngokuzenzakalayo.",
        "Isibonelo: i-oda ye-COD eqinisekisiwe ilungiselelwa ukudluliswa kwekhuriya."
      ],
      "business-email": [
        "Thumela futhi wamukele i-imeyili yobungcweti kusizinda sakho esibhrendiwe.",
        "Isibonelo: sales@acme.com yamukela imibuzo kanti support@acme.com iphendula."
      ]
    }
  },
  "ndc": {
    "checkout": {
      "liveInstruction": "Sarudza nzira yebhuku-livhi, nyora bese uqinisekisa inombolo ye-akhawunti ozoyithumela esikrinini esilandelayo. Kuzoqala iseshini ebukhoma yemizuzu eyishumi; ukuthumela imali phakathi neseshini kuzokwenza i-auto-verify yokukhokha.",
      "trxInstruction": "Yenza i-Cash In esitolo noma cela omunye umuntu ukuthi a-Send Money. Bese uyi-auto-verify usebenzisa i-Transaction ID (TrxID).",
      "enterNumberInstruction": "Faka inombolo yakho bese uchofoza inkinobho ethi '{action}'.",
      "offlineTitle": "Idivayisi yomthengisi ayixhunywanga",
      "offlineDescription": "Ukuqinisekiswa ngokuzenzakalayo okwamanje akunakwenzeka.",
      "copyPersonal": "Kopa inombolo ye-Personal Account engenhla.",
      "sendMoneyOffline": "Send Money noma Cash In enombolweni engenhla, noma cela omunye umuntu ukuthi athumele imali.",
      "trxOffline": "Qoqa i-Transaction ID (TrxID) bese uyifaka ngezansi. Lapho umthengisi exhuma ku-intanethi, uzokwaziswa nge-imeyili, noma ungaxhumana nomthengisi ngqo.",
      "cashinNagad": "Cash In ayivunyelwe ku-Nagad, ngakho ngicela Send Money kusuka kwenye i-akhawunti ye-Nagad.",
      "cashinOther": "Ngaphambi kwe-Cash In, buza umthengisi ukuthi bazokunikeza i-TrxID; uma bengakwenzi, ungathuthuki. Enye indlela, cela omunye umuntu ukuthi a-Send Money.",
      "waitTrx": "Ngemuva kokukhokha, linda imizuzwana engu-10–15 bese ufaka i-TrxID ngezansi. Ungashiya leli khasi ubuyela kulo ekhasini lenkokhelo noma yinini phakathi kwamahora angu-24 ukuze u-auto-verify usebenzisa i-TrxID yakho.",
      "goApp": "Vula uhlelo lokusebenza lwe-{provider} noma shayela {dialCode} bese ukhetha 'Send Money'.",
      "confirmAuto": "Faka inombolo nekota ekhonjisiwe, bese uqinisekisa nge-PIN yakho ukuze u-auto-verify.",
      "dontClose": "Ngicela ungavali leli khasi",
      "autoVerify": "Inkokhelo yakho iyaqinisekiswa ngokuzenzakalayo",
      "successOffline": "Ngiyabonga, {name}. Ukuthengiselana kwakho kusebhalwe. Umthengisi okwamanje akanaxhumo. Uzokwaziswa nge-imeyili lapho umthengisi exhuma futhi eqinisekisa ukukhokha kwakho.",
      "successOnline": "Ngiyabonga, {name}. Inkokhelo yakho engu-{amount} nge-{provider} isamukelwe futhi iyaqinisekiswa."
    },
    "features": {
      "no-code-website": [
        "Dala bese ushicilela amasayithi e-e-commerce, ezemfundo, ibhulogi, noma zezindaba ngaphandle kokubhala ikhowudi.",
        "Isibonelo: shicilela ikhasi lokumisa kanye nopost lomkhiqizo kusuka kudeskithophu yomthengisi wezifundo."
      ],
      "custom-domain": [
        "Xhuma igama lakho lesizinda futhi wakhe ubunikazi bedijithali obungochwepheshe ngokudlulisela okusheshayo.",
        "Isibonelo: isitolo sakho sisebenza ku-www.acme.com esikhundleni sedomain yenkundla."
      ],
      "capi": [
        "Thumela imicimbi yokuguqulwa kusuka kuseva ukuze kukalwe imikhankaso ngokuthembeka.",
        "Isibonelo: umcimbi wokuthenga uthunyelwa kusuka kuseva uya epulatifomu yezikhangiso."
      ],
      "personal-mfs": [
        "Zenautomatise ukuqinisekiswa kokukhokha kwe-Personal MFS okusekelwayo.",
        "Isibonelo: ukukhokha kwe-Personal MFS kuhlotshaniswa ne-oda lewebhusayithi."
      ],
      "local-gateway": [
        "Xhuma izindlela zendawo zokukhokha zabathengi basendaweni.",
        "Isibonelo: umthengi wasendaweni uqeda inqubo yokukhokha nge-gateway yendawo."
      ],
      "international-gateway": [
        "Xhuma izindlela zokukhokha zamazwe omhlaba zabathengi bamazwe wonke.",
        "Isibonelo: umthengi wakwamanye amazwe uqeda ukukhokha nendlela yomhlaba wonke."
      ],
      "notifications": [
        "Thumela izibuyekezo zokukhokha nezama-oda kubathengi nakumthengisi.",
        "Isibonelo: impumelelo yokukhokha ivuselela isaziso somthengisi nesibuyekezo sekhasimende."
      ],
      "courier": [
        "Thumela ama-oda aqinisekisiwe ku-workflow yekhuriya esekelwayo ngokuzenzakalayo.",
        "Isibonelo: i-oda ye-COD eqinisekisiwe ilungiselelwa ukudluliswa kwekhuriya."
      ],
      "business-email": [
        "Thumela futhi wamukele i-imeyili yobungcweti kusizinda sakho esibhrendiwe.",
        "Isibonelo: sales@acme.com yamukela imibuzo kanti support@acme.com iphendula."
      ]
    }
  },
  "nde": {
    "checkout": {
      "liveInstruction": "Khetha indlela ebukhoma, faka futhi uqinisekise inombolo ye-akhawunti ozoyithumela kusiphepha esilandelayo. Kuzoqala iseshini ebukhoma yemizuzu eyi-10; ukuthumela imali phakathi nesikhathi kuzokuqinisekisa ukukhokha ngokuzenzakalayo.",
      "trxInstruction": "Yenza i-Cash In esitolo noma cela omunye umuntu ukuthi a-Send Money. Bese uqinisekisa ngokuzenzakalayo usebenzisa i-Transaction ID (TrxID).",
      "enterNumberInstruction": "Faka inombolo yakho bese uchofoza inkinobho ethi '{action}'.",
      "offlineTitle": "Idivayisi lomthengisi ayikuxhumekanga",
      "offlineDescription": "Ukuqinisekiswa ngokuzenzakalayo okwamanje akutholakali.",
      "copyPersonal": "Kopa inombolo ye-Personal Account engenhla.",
      "sendMoneyOffline": "Send Money noma Cash In enombolweni engenhla, noma cela omunye umuntu ukuthi athumele imali.",
      "trxOffline": "Qoqa i-Transaction ID (TrxID) bese uyifaka ngezansi. Lapho umthengisi exhuma, uzokwaziswa nge-imeyili, noma ungaxhumana nomthengisi ngqo.",
      "cashinNagad": "Cash In ayivunyelwe ku-Nagad, ngakho sicela u-Send Money kusuka kwenye i-akhawunti ye-Nagad.",
      "cashinOther": "Ngaphambi kwe-Cash In, buza umthengisi ukuthi bazonikeza i-TrxID; uma bengakwenzi, ungathuthuki. Enye indlela, cela omunye umuntu ukuthi a-Send Money.",
      "waitTrx": "Ngemuva kokukhokha, linda imizuzwana engu-10–15 bese ufaka i-TrxID ngezansi. Ungashiya leli khasi futhi ubuyele kulo noma nini phakathi kwamahora angu-24 ukuze u-auto-verify usebenzisa i-TrxID yakho.",
      "goApp": "Vula uhlelo lokusebenza lwe-{provider} noma shayela {dialCode} bese ukhetha 'Send Money'.",
      "confirmAuto": "Faka inombolo nekota ekopishiwe, bese uqinisekisa nge-PIN yakho ukuze kuqinisekiswe ngokuzenzakalayo.",
      "dontClose": "Sicela ungavali leli khasi",
      "autoVerify": "Inkokhelo yakho iyaqinisekiswa ngokuzenzakalayo",
      "successOffline": "Ngiyabonga, {name}. Ukudayiswa kwakho kurekhodiwe. Umthengisi okwamanje akanaxhumo. Uzokwaziswa nge-imeyili lapho umthengisi exhuma futhi eqinisekisa ukukhokha kwakho.",
      "successOnline": "Ngiyabonga, {name}. Inkokhelo yakho engu-{amount} nge-{provider} isamukelwe futhi iyaqinisekiswa."
    },
    "features": {
      "no-code-website": [
        "Dala futhi ushicilele amasayithi e-commerce, ezemfundo, ibhulogi, noma zezindaba ngaphandle kokubhala ikhowudi.",
        "Isibonelo: shicilela ikhasi lokumisa kanye nopost womkhiqizo kusuka kumenyu yomthengisi wezikole."
      ],
      "custom-domain": [
        "Xhuma isizinda sakho uqobo futhi wakhe ubunikazi bedijithali obuchwepheshe ngokuhamba okusheshayo.",
        "Isibonelo: isitolo sakho sisebenza ku-www.acme.com esikhundleni sedomain yenkundla."
      ],
      "capi": [
        "Thumela imicimbi yokuguqulwa kusuka kuseva ukuze kube nokukalwa kwemikhankaso okuthembekile.",
        "Isibonelo: umcimbi wokuthenga uthunyelwa kusuka kuseva uya epulatifomu yezikhangiso."
      ],
      "personal-mfs": [
        "Zenautomatise ukuqinisekiswa kokukhokha kwe-Personal MFS okwesekelwa.",
        "Isibonelo: ukukhokha kwe-Personal MFS kuhlotshaniswa ne-oda lewebhusayithi."
      ],
      "local-gateway": [
        "Xhuma izindlela zendawo zokukhokha zabathengi basendaweni.",
        "Isibonelo: umthengi wasendaweni uqeda inqubo yokukhokha ngegwayi lwendawo."
      ],
      "international-gateway": [
        "Xhuma izindlela zokukhokha zamanye amazwe zabathengi bomhlaba wonke.",
        "Isibonelo: umthengi wangaphandle uqeda ukukhokha nendlela yomhlaba wonke."
      ],
      "notifications": [
        "Thumela izibuyekezo zokukhokha nezama-oda kubathengi nakumthengisi.",
        "Isibonelo: impumelelo yokukhokha idala isexwayiso somthengisi nesibuyekezo sekhasimende."
      ],
      "courier": [
        "Thumela ama-oda aqinisekisiwe ku-workflow yekhuriya esekelwayo ngokuzenzakalayo.",
        "Isibonelo: i-oda ye-COD eqinisekisiwe ilungiselelwa ukudluliswa kwekhuriya."
      ],
      "business-email": [
        "Thumela futhi wamukele i-imeyili yobungcweti kusizinda sakho esibhrendiwe.",
        "Isibonelo: sales@acme.com yamukela imibuzo kanti support@acme.com iphendula."
      ]
    }
  },
  "ndo": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Tala po ondunge ombali yokutunga naokuputulula e-commerce, eduteka, mbongo yomafita, ke oruhaluka rwonduwa okwaashiwa po okuwina kodihika.",
        "putulula landing page na product post okuva mu seller dashboard ya muntu wa course."
      ],
      "custom-domain": [
        "Twala domain yako shili omolungo oshi okuzaaluwa nokutangela professional digital identity nokuenda ombinga yotumba odhihemo.",
        "store yo i li po www.acme.com pewa kutya oku li pa platform subdomain."
      ],
      "capi": [
        "Tuma server-side conversion events po oku meela measurement ya campaign e ndaali.",
        "purchase event itumwako ku server kaye yaenda ku ad platform."
      ],
      "personal-mfs": [
        "Oshikwatelwa oku automate verification yoomali Personal MFS omolwa.",
        "Personal MFS payment i longa ke i match ne website order."
      ],
      "local-gateway": [
        "Twala local payment methods komi naantu dihinima omukalo gwa region.",
        "omuntu olinga oku siya oku tunga i checkout pashi ya regional gateway."
      ],
      "international-gateway": [
        "Twala international payment methods komi naantu kuvatelapo omukalo gu li worldwide.",
        "omuntu ova kwilonga oku siya oku tunga i checkout uko shili na global method."
      ],
      "notifications": [
        "Tuma payment na order updates ku customers na merchants.",
        "payment success e tuma merchant alert kaye customer update."
      ],
      "courier": [
        "Tuma confirmed orders mu supported courier workflow okwa automatic.",
        "confirmed COD order i lungwa po courier handoff."
      ],
      "business-email": [
        "Tuma na koluta professional email po domain yako ya branded.",
        "sales@acme.com i landa inquiries kaye support@acme.com i twalule replies."
      ]
    }
  },
  "nfr": {
    "checkout": {
      "liveInstruction": "Sélectez la méthode live, entrez et confirmez le numéro de compte d'où vous enverrez de l'argent sur la page suivante. Une session live de 10 minutes commencera; envoyer de l'argent pendant celle-ci vérifiera automatiquement le paiement.",
      "trxInstruction": "Effectuez un Cash In depuis une boutique ou demandez à quelqu'un d'autre de Send Money. Ensuite, vérifiez automatiquement en utilisant le Transaction ID (TrxID).",
      "enterNumberInstruction": "Entrez votre numéro et cliquez sur le bouton '{action}'.",
      "offlineTitle": "Appareil du marchand hors ligne",
      "offlineDescription": "La vérification automatique est temporairement indisponible.",
      "copyPersonal": "Copiez le numéro de Personal Account ci-dessus.",
      "sendMoneyOffline": "Send Money ou Cash In au numéro ci-dessus, ou demandez à quelqu'un d'autre d'envoyer de l'argent.",
      "trxOffline": "Récupérez le Transaction ID (TrxID) et saisissez-le ci-dessous. Lorsque le marchand sera en ligne, vous recevrez une notification par e-mail, ou vous pouvez contacter le marchand directement.",
      "cashinNagad": "Cash In n'est pas autorisé sur Nagad, veuillez donc Send Money depuis un autre compte Nagad.",
      "cashinOther": "Avant un Cash In, demandez au commerçant s'il fournira le TrxID; si ce n'est pas le cas, ne procédez pas. Sinon, demandez à quelqu'un d'autre de Send Money.",
      "waitTrx": "Après le paiement, attendez 10–15 secondes et saisissez le TrxID ci-dessous. Vous pouvez quitter cette page et revenir à cette page de paiement à tout moment dans les 24 heures pour vérifier automatiquement en utilisant votre TrxID.",
      "goApp": "Allez dans l'application {provider} ou composez {dialCode} et sélectionnez 'Send Money'.",
      "confirmAuto": "Entrez le numéro et le montant copiés, puis confirmez avec votre PIN pour vérifier automatiquement.",
      "dontClose": "Veuillez ne pas fermer cette page",
      "autoVerify": "Votre paiement est en cours de vérification automatique",
      "successOffline": "Merci, {name}. Votre transaction a été enregistrée. Le commerçant est actuellement hors ligne. Vous serez informé par e-mail après que le commerçant sera en ligne et aura vérifié votre paiement.",
      "successOnline": "Merci, {name}. Votre paiement de {amount} via {provider} a été reçu et est en cours de vérification."
    },
    "features": {
      "no-code-website": [
        "Créez et publiez des sites e-commerce, éducatifs, blogs ou d'actualités sans coder.",
        "Exemple : publiez une page d'atterrissage et un post produit depuis le tableau de bord du vendeur de cours."
      ],
      "custom-domain": [
        "Connectez votre propre domaine et construisez une identité numérique professionnelle avec un routage plus rapide.",
        "Exemple : votre boutique fonctionne sur www.acme.com au lieu d'un sous-domaine de plateforme."
      ],
      "capi": [
        "Envoyez des événements de conversion côté serveur pour une mesure de campagne fiable.",
        "Exemple : un événement d'achat est envoyé du serveur vers la plateforme publicitaire."
      ],
      "personal-mfs": [
        "Automatisez la vérification des paiements Personal MFS pris en charge.",
        "Exemple : un paiement Personal MFS est associé à la commande du site."
      ],
      "local-gateway": [
        "Connectez des méthodes de paiement locales pour des clients régionaux.",
        "Exemple : un acheteur local termine le paiement via une passerelle régionale."
      ],
      "international-gateway": [
        "Connectez des méthodes de paiement internationales pour des clients du monde entier.",
        "Exemple : un acheteur étranger termine le paiement avec une méthode globale."
      ],
      "notifications": [
        "Envoyez des mises à jour de paiement et de commande aux clients et aux commerçants.",
        "Exemple : le succès du paiement déclenche une alerte au commerçant et une mise à jour client."
      ],
      "courier": [
        "Envoyez automatiquement les commandes confirmées dans un flux de travail de coursier pris en charge.",
        "Exemple : une commande COD confirmée est préparée pour la remise au coursier."
      ],
      "business-email": [
        "Envoyez et recevez des e-mails professionnels sur votre propre domaine de marque.",
        "Exemple : sales@acme.com reçoit des demandes et support@acme.com répond."
      ]
    }
  },
  "niu": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Hana mo e fakahono e ngaahi feitu‘u e-commerce, ako, blog, po ke tau talahe, aunoa mo e kodingi.",
        "publish e landing page mo e product post mai he seller dashboard."
      ],
      "custom-domain": [
        "Fakamau atu e koe a e monūmonū hako haau (domain) ke fakatupu ai e professional digital identity mo e totolo agaia he hala fakafou.",
        "tuku atu e tau fakatino he fale kaufefe haau ke oma he www.acme.com, nai he mena ke he subdomain he platform."
      ],
      "capi": [
        "Fakafano e tau event he fakatokatoka he server-side ke malolo e fuafua he tau kampaini.",
        "fakafano e purchase event mai he server ke he ad platform."
      ],
      "personal-mfs": [
        "Fakaautomatika e verification he totogi he Personal MFS ka fakaaoga e talahau MFS.",
        "ko e totogi Personal MFS ka fakafetui ke he website order."
      ],
      "local-gateway": [
        "Fakamau e tau auala totogi fakatokaloto ma e tau tagata fakatau he motu po e vaha tokoluga.",
        "ko e tagata fakatau fakatokaloto ka fakakatoatoa e checkout he gateway fakatokoloto."
      ],
      "international-gateway": [
        "Fakamau e tau auala totogi fakalotu fakamui ma e tau tagata fakatau he lalolagi katoatoa.",
        "ko e tagata fakatau overseas ka fakakatoatoa e checkout he tau global method."
      ],
      "notifications": [
        "Fakafano e tau fakamaamaaga totogi mo e tau fakauka order ke he tau customer mo e tau merchant.",
        "tiaki e payment success ke fanogonogo e merchant mo e fakamaamaaga ke he customer."
      ],
      "courier": [
        "Fakafano atu oti e tau order kua fakameleta ki loto he galuega courier ka lagomatai, he hala fakaautomatika.",
        "ko e confirmed COD order kua fakatoka ke tuku atu ki he courier handoff."
      ],
      "business-email": [
        "Fakafano mo e mau mai e professional email he monūmonū hako haau kua fakailoa e brand (domain).",
        "sales@acme.com ke mau mai e tau uiui, ti tali mai a support@acme.com."
      ]
    }
  },
  "nno": {
    "checkout": {
      "liveInstruction": "Vel forskjel for live-metoden, skriv inn og stadfest kontonummeret du vil sende pengar frå på neste side. Ei 10-minutters live-økt startar; å sende pengar under økta vil automatisk verifisere betalingen.",
      "trxInstruction": "Gjer ei Cash In i ein butikk eller spør nokon andre om å Send Money. Ver så automatisk med Transaction ID (TrxID).",
      "enterNumberInstruction": "Skriv inn nummeret ditt og trykk på knappen '{action}'.",
      "offlineTitle": "Forhandlaren si eining er offline",
      "offlineDescription": "Automatisk verifikasjon er midlertidig utilgjengeleg.",
      "copyPersonal": "Kopier Personal Account-nummeret ovanfor.",
      "sendMoneyOffline": "Send Money eller Cash In til nummeret ovanfor, eller be nokon andre om å sende pengar.",
      "trxOffline": "Samle Transaction ID (TrxID) og skriv det inn under. Når forhandlaren kjem online blir du varsla på e-post, eller du kan kontakta forhandlaren direkte.",
      "cashinNagad": "Cash In er ikkje tillate i Nagad, så ver venleg og Send Money frå ein annan Nagad-konto.",
      "cashinOther": "Før du gjer ei Cash In, spør butikkaren om han vil gje deg TrxID; hvis ikkje, halda du ikkje fram. Alternativt kan du be nokon andre om å Send Money.",
      "waitTrx": "Etter betalinga, vent 10–15 sekund og skriv inn TrxID under. Du kan forlate denne sida og kome tilbake til denne betalingssida når som helst innan 24 timar for å automatisk verifisere med TrxID-en din.",
      "goApp": "Opna {provider}-appen eller ring {dialCode} og vel 'Send Money'.",
      "confirmAuto": "Skriv inn det kopierte nummeret og beløpet, og stadfest med PIN-koden din for automatisk verifikasjon.",
      "dontClose": "Vennlegst lukk ikkje denne sida",
      "autoVerify": "Betalinga di vert verifisert automatisk",
      "successOffline": "Takk, {name}. Transaksjonen din er registrert. Forhandlaren er førebels offline. Du vil bli varsla på e-post når forhandlaren kjem online og verifiserer betalinga di.",
      "successOnline": "Takk, {name}. Betalinga di på {amount} via {provider} er motteken og vert verifisert."
    },
    "features": {
      "no-code-website": [
        "Lag og publiser nettbutikkar, utdannings-, blogg- eller nyheitssider utan koding.",
        "Døme: publiser ei landingside og eit produktinnlegg frå dashbordet til kurs-seljarar."
      ],
      "custom-domain": [
        "Knytt til ditt eige domene og bygg eit profesjonelt digitalt omdøme med raskare ruting.",
        "Døme: butikken din køyrer på www.acme.com i staden for ein plattform-underdomene."
      ],
      "capi": [
        "Send konverteringshendelsar frå server-sida for påliteleg kampanjemåling.",
        "Døme: eit kjøpe-hendelse vert sendt frå serveren til annonseplattformen."
      ],
      "personal-mfs": [
        "Automatiser støtte for verifikasjon av Personal MFS-betalingar.",
        "Døme: ein Personal MFS-betaling blir matchet med ordren på nettsida."
      ],
      "local-gateway": [
        "Knytt lokale betalingsmetodar for regionale kundar.",
        "Døme: ein lokal kund fullfører kassa gjennom ein regional gateway."
      ],
      "international-gateway": [
        "Knytt internasjonale betalingsmetodar for kundar verda rundt.",
        "Døme: ein utanlandsk kjøpar fullfører kassa med ei global metode."
      ],
      "notifications": [
        "Send betalings- og ordreoppdateringar til kundar og forhandlarar.",
        "Døme: betalingssuksess utløyser ei varsel til forhandlar og oppdatering til kunden."
      ],
      "courier": [
        "Send stadfesta ordre automatisk inn i ein støtta kurerarbeidsflyt.",
        "Døme: ei stadfesta COD-bestilling blir førebudd for overtaking av kurer."
      ],
      "business-email": [
        "Send og motta profesjonell e-post på ditt eige merke-domene.",
        "Døme: sales@acme.com mottek førespurnader og support@acme.com svarar."
      ]
    }
  },
  "nob": {
    "checkout": {
      "liveInstruction": "Velg live-metoden, skriv inn og bekreft kontonummeret du vil sende penger fra på neste side. En 10-minutters live-økt starter; det å sende penger under denne vil automatisk verifisere betalingen.",
      "trxInstruction": "Gjør en Cash In fra en butikk eller be en annen person om å Send Money. Deretter auto-verifiser ved å bruke Transaction ID (TrxID).",
      "enterNumberInstruction": "Skriv inn nummeret ditt og klikk på '{action}'-knappen.",
      "offlineTitle": "Selgerens enhet er frakoblet",
      "offlineDescription": "Automatisk verifisering er midlertidig utilgjengelig.",
      "copyPersonal": "Kopier Personal Account-nummeret ovenfor.",
      "sendMoneyOffline": "Send Money eller Cash In til nummeret ovenfor, eller be noen andre sende penger.",
      "trxOffline": "Samle Transaction ID (TrxID) og skriv den inn nedenfor. Når selgeren kobler seg til, blir du varslet via e-post, eller du kan kontakte selgeren direkte.",
      "cashinNagad": "Cash In er ikke tillatt i Nagad, så vennligst Send Money fra en annen Nagad-konto.",
      "cashinOther": "Før Cash In, spør butikkansvarlig om de vil gi deg TrxID; hvis ikke, ikke fortsett. Alternativt kan du be en annen person om å Send Money.",
      "waitTrx": "Etter betalingen, vent 10–15 sekunder og skriv inn TrxID nedenfor. Du kan forlate denne siden og returnere til denne betalingssiden når som helst innen 24 timer for å auto-verifisere med din TrxID.",
      "goApp": "Gå til {provider}-appen eller ring {dialCode} og velg 'Send Money'.",
      "confirmAuto": "Skriv inn det kopierte nummeret og beløpet, og bekreft med PIN for å auto-verifisere.",
      "dontClose": "Vennligst ikke lukk denne siden",
      "autoVerify": "Betalingen din verifiseres automatisk",
      "successOffline": "Takk, {name}. Transaksjonen din er registrert. Selgeren er for øyeblikket frakoblet. Du vil bli varslet på e-post når selgeren kommer online og verifiserer betalingen.",
      "successOnline": "Takk, {name}. Din betaling på {amount} via {provider} er mottatt og verifiseres."
    },
    "features": {
      "no-code-website": [
        "Opprett og publiser e-handels-, utdannings-, blogg- eller nyhetssider uten koding.",
        "Eksempel: publiser en landingsside og et produktinnlegg fra kurs-selgerens dashbord."
      ],
      "custom-domain": [
        "Koble til ditt eget domene og bygg en profesjonell digital identitet med raskere ruting.",
        "Eksempel: butikken din kjører på www.acme.com i stedet for en plattform-underdomene."
      ],
      "capi": [
        "Send konverteringshendelser server-side for pålitelig måling av kampanjer.",
        "Eksempel: en kjøp-hendelse sendes fra serveren til annonseplattformen."
      ],
      "personal-mfs": [
        "Automatiser verifisering av støttede Personal MFS-betalinger.",
        "Eksempel: en Personal MFS-betaling blir matchet med nettsidebestillingen."
      ],
      "local-gateway": [
        "Koble lokale betalingsmetoder for regionale kunder.",
        "Eksempel: en lokal kjøper fullfører kassen gjennom en regional gateway."
      ],
      "international-gateway": [
        "Koble internasjonale betalingsmetoder for kunder verden over.",
        "Eksempel: en utenlandsk kjøper fullfører kassen med en global metode."
      ],
      "notifications": [
        "Send betalings- og ordreoppdateringer til kunder og selgere.",
        "Eksempel: vellykket betaling utløser et varsel til selgeren og en oppdatering til kunden."
      ],
      "courier": [
        "Send bekreftede ordre automatisk inn i en støttet kurervirksomhet.",
        "Eksempel: en bekreftet COD-bestilling gjøres klar for overlevering til kurér."
      ],
      "business-email": [
        "Send og motta profesjonell e-post på ditt eget merke-domene.",
        "Eksempel: sales@acme.com mottar henvendelser og support@acme.com svarer."
      ]
    }
  },
  "nor": {
    "checkout": {
      "liveInstruction": "Velg live-metoden, skriv inn og bekreft kontonummeret du vil sende penger fra på neste side. En 10-minutters live-økt starter; å sende penger under denne vil automatisk verifisere betalingen.",
      "trxInstruction": "Gjør en Cash In i en butikk eller be en annen om å Send Money. Deretter auto-verifiser ved å bruke Transaction ID (TrxID).",
      "enterNumberInstruction": "Skriv inn nummeret ditt og klikk på '{action}'-knappen.",
      "offlineTitle": "Selgerens enhet er frakoblet",
      "offlineDescription": "Automatisk verifisering er midlertidig utilgjengelig.",
      "copyPersonal": "Kopier Personal Account-nummeret ovenfor.",
      "sendMoneyOffline": "Send Money eller Cash In til nummeret ovenfor, eller be noen andre sende penger.",
      "trxOffline": "Samle Transaction ID (TrxID) og skriv den inn nedenfor. Når selgeren kobler seg til, blir du varslet via e-post, eller du kan kontakte selgeren direkte.",
      "cashinNagad": "Cash In er ikke tillatt i Nagad, så vennligst Send Money fra en annen Nagad-konto.",
      "cashinOther": "Før Cash In, spør butikkansvarlig om de vil gi deg TrxID; hvis ikke, ikke fortsett. Alternativt kan du be en annen person om å Send Money.",
      "waitTrx": "Etter betalingen, vent 10–15 sekunder og skriv inn TrxID nedenfor. Du kan forlate denne siden og returnere til denne betalingssiden når som helst innen 24 timer for å auto-verifisere med din TrxID.",
      "goApp": "Gå til {provider}-appen eller ring {dialCode} og velg 'Send Money'.",
      "confirmAuto": "Skriv inn det kopierte nummeret og beløpet, og bekreft med PIN for å auto-verifisere.",
      "dontClose": "Vennligst ikke lukk denne siden",
      "autoVerify": "Betalingen din verifiseres automatisk",
      "successOffline": "Takk, {name}. Transaksjonen din er registrert. Selgeren er for øyeblikket frakoblet. Du vil bli varslet på e-post når selgeren kommer online og verifiserer betalingen.",
      "successOnline": "Takk, {name}. Din betaling på {amount} via {provider} er mottatt og verifiseres."
    },
    "features": {
      "no-code-website": [
        "Opprett og publiser e-handels-, utdannings-, blogg- eller nyhetssider uten koding.",
        "Eksempel: publiser en landingsside og et produktinnlegg fra kurs-selgerens dashbord."
      ],
      "custom-domain": [
        "Koble til ditt eget domene og bygg en profesjonell digital identitet med raskere ruting.",
        "Eksempel: butikken din kjører på www.acme.com i stedet for en plattform-underdomene."
      ],
      "capi": [
        "Send konverteringshendelser server-side for pålitelig måling av kampanjer.",
        "Eksempel: en kjøp-hendelse sendes fra serveren til annonseplattformen."
      ],
      "personal-mfs": [
        "Automatiser verifisering av støttede Personal MFS-betalinger.",
        "Eksempel: en Personal MFS-betaling blir matchet med nettsidebestillingen."
      ],
      "local-gateway": [
        "Koble lokale betalingsmetoder for regionale kunder.",
        "Eksempel: en lokal kjøper fullfører kassen gjennom en regional gateway."
      ],
      "international-gateway": [
        "Koble internasjonale betalingsmetoder for kunder verden over.",
        "Eksempel: en utenlandsk kjøper fullfører kassen med en global metode."
      ],
      "notifications": [
        "Send betalings- og ordreoppdateringer til kunder og selgere.",
        "Eksempel: vellykket betaling utløser et varsel til selgeren og en oppdatering til kunden."
      ],
      "courier": [
        "Send bekreftede ordre automatisk inn i en støttet kurervirksomhet.",
        "Eksempel: en bekreftet COD-bestilling gjøres klar for overlevering til kurér."
      ],
      "business-email": [
        "Send og motta profesjonell e-post på ditt eget merke-domene.",
        "Eksempel: sales@acme.com mottar henvendelser og support@acme.com svarer."
      ]
    }
  },
  "nrf": {
    "checkout": {
      "liveInstruction": "Sélectionnez la méthode en direct, entrez et confirmez le numéro de compte depuis lequel vous enverrez de l'argent sur la page suivante. Une session en direct de 10 minutes commencera ; envoyer de l'argent pendant celle-ci vérifiera automatiquement le paiement.",
      "trxInstruction": "Faites un Cash In depuis une boutique ou demandez à quelqu'un d'autre de Send Money. Puis vérifiez automatiquement en utilisant le Transaction ID (TrxID).",
      "enterNumberInstruction": "Entrez votre numéro et cliquez sur le bouton '{action}'.",
      "offlineTitle": "Appareil du marchand hors ligne",
      "offlineDescription": "La vérification automatique est temporairement indisponible.",
      "copyPersonal": "Copiez le numéro de Personal Account ci-dessus.",
      "sendMoneyOffline": "Send Money ou Cash In au numéro ci-dessus, ou demandez à quelqu'un d'autre d'envoyer de l'argent.",
      "trxOffline": "Récupérez le Transaction ID (TrxID) et saisissez-le ci-dessous. Lorsquu le marchand sera en ligne, vous serez informé par e-mail, ou vous pourez contacter le marchand directement.",
      "cashinNagad": "Cash In n'est pas autorisé sur Nagad, veuillez donc Send Money depuis un autre compte Nagad.",
      "cashinOther": "Avant de faire un Cash In, demandez au commerçant s'il fournira le TrxID ; si non, ne procédez pas. Autrement, demandez à quelqu'un d'autre de Send Money.",
      "waitTrx": "Après le paiement, attendez 10–15 secondes et saisissez le TrxID ci-dessous. Vous pouvez quitter cette page puis revenir sur cette page de paiement à tout moment dans les 24 heures pour vérifier automatiquement avec votre TrxID.",
      "goApp": "Allez dans l'appli {provider} ou composez {dialCode} et sélectionnez 'Send Money'.",
      "confirmAuto": "Entrez le numéro et le montant copiés, puis confirmez avec votre PIN pour vérification automatique.",
      "dontClose": "Veuillez ne pas fermer cette page",
      "autoVerify": "Votre paiement est en cours de vérification automatique",
      "successOffline": "Mercé, {name}. Votre transaction est enregistrée. Le marchand n'est pas en ligne pour l'instant. Vous serez notifié par e-mail quand le marchand sera en ligne et vérifiera votre paiement.",
      "successOnline": "Mercé, {name}. Votre paiement de {amount} via {provider} a été reçu et est en cours de vérification."
    },
    "features": {
      "no-code-website": [
        "Créez et publiez des sites e-commerce, éducatifs, des blogs ou d'actualités sans coder.",
        "Exemple : publiez une page d'atterrissage et un post produit depuis le tableau de bord du vendeur de cours."
      ],
      "custom-domain": [
        "Connectez vot' propre domaine et bâtissez une identité digitale professionnelle acoumm'un routage pus rapide.",
        "Exemple : vot' boutique tourne sus www.acme.com au lieu d'un sous-domaine d'la plate-forme."
      ],
      "capi": [
        "Envoyez des événements de conversion depuis l'serveur pour mesurage de campagnes fiable.",
        "Exemple : un événement d'achat est envoyé du serveur vers la plateforme de pub."
      ],
      "personal-mfs": [
        "Automatisez la vérification des paiements Personal MFS supportés.",
        "Exemple : un paiement Personal MFS est apparié à la commande du site."
      ],
      "local-gateway": [
        "Connectez des méthodes d'paiement locales pour des clients régionals.",
        "Exemple : un acheteur local finit l'checkout via une passerelle régionale."
      ],
      "international-gateway": [
        "Connectez des méthodes d'paiement internationales pour clients d'tout l'monde.",
        "Exemple : un acheteur d'outre-mer finit l'checkout avec une méthode globale."
      ],
      "notifications": [
        "Envoyez des mises à jour de paiement et d'commande aux clients et commerçants.",
        "Exemple : succès du paiement déclenche un alerte commerçant et une mise à jour client."
      ],
      "courier": [
        "Envoyez automatiquement les commandes confirmées dans un workflow coursier supporté.",
        "Exemple : une commande COD confirmée est préparée pour la remise au coursier."
      ],
      "business-email": [
        "Envoyez et recevez des e-mails professionnels sus vot' propre domaine brandé.",
        "Exemple : sales@acme.com reçoit des demandes et support@acme.com répond."
      ]
    }
  },
  "nso": {
    "checkout": {
      "liveInstruction": "Kgetha mokgwa wa go lebega ka nako ya nnete (live), tsenya gomme o netefatse nomoro ya akhaonto ye o tlo romela go yona leptšeng le le latelago. Go tlo thoma lekga la motsotso ye 10 la live; ge o romela tšhelete gantši ka nako yeo go tlo netefatšwa ka boišegong.",
      "trxInstruction": "Etsa Cash In lebenkeleng goba kōpe motho yo mongwe gore a-Send Money. Ka morago netefatša ka boikgopo (auto-verify) o šomiša Transaction ID (TrxID).",
      "enterNumberInstruction": "Tsenya nomoro ya gago gomme o kgethe konopo ya '{action}'.",
      "offlineTitle": "Sengwalo sa Mmuši se se sa amogelwang (Merchant Device Offline)",
      "offlineDescription": "Netefatšo ya ka boikgopo ga e yo gona nakong ye nnyane.",
      "copyPersonal": "Kopaya nomoro ya Personal Account ye e lego ka godimo.",
      "sendMoneyOffline": "Send Money goba Cash In go nomoro ye e lego ka godimo, goba kōpe motho yo mongwe gore a romele tšhelete.",
      "trxOffline": "Hloga Transaction ID (TrxID) gomme o e tsenye ka tlase. Ge mmuši a tla amogela inthanete, o tla tsebja ka imeile, goba o ka ikopanya le mmuši ka go toba.",
      "cashinNagad": "Cash In ga e a dumelwa ka Nagad, ka fao hle Send Money go tloga ka akhaonto ye nngwe ya Nagad.",
      "cashinOther": "Pele ga Cash In, botšiša mohiri wa lebenkele ge e ba ba tlo go fa TrxID; ge ba sa tlogele selo seo, o se tswe pele. Goba, kōpa motho yo mongwe gore a-Send Money.",
      "waitTrx": "Morago ga tefo, leta metsotso ya 10–15 gomme o tsenye TrxID ka tlase. O ka tlogela letlakala le gomme wa boa go letlakala la tefo nako efe goba efe gare ga dibeke tša 24 go netefatša ka boikgopo o šomiša TrxID ya gago.",
      "goApp": "Ya ka app ya {provider} goba tsenya nomoro ya moletlo {dialCode} gomme o kgethe 'Send Money'.",
      "confirmAuto": "Tsenya nomoro ye o e kopeditšego le moputso, gomme o netefatse ka PIN ya gago gore go tswelele netefatšo ya ka boikgopo.",
      "dontClose": "Hle o se kope letlakala le",
      "autoVerify": "Tefo ya gago e a beakanywa ka boikgopo",
      "successOffline": "Ke a leboga, {name}. Tšweletšo ya gago e ngwaletšwe. Mmuši ga a tšee inthanete gabjale. O tlo tsebja ka imeile ge mmuši a tla amogela inthanete gomme a netefatša tefo ya gago.",
      "successOnline": "Ke a leboga, {name}. Tefo ya gago ya {amount} ka go {provider} e amogetšwe ebile e setse e le go netefatšwa."
    },
    "features": {
      "no-code-website": [
        "Hlama le go phatlalatša mafelelong a e-commerce, thuto, blog, goba tša ditaba ntle le go ngwala khoutu.",
        "Mohlala: phatlalatša leptopo la go amogela le poso ya sehlahisoa go tšwa dashboard ya morekisi wa dithuto."
      ],
      "custom-domain": [
        "Kgokaganya setšhaba sa gago sa domain gomme o agae boitsebiso bja dijithale bja profeshenale ka tsela ya go tsamaya ye e potlako.",
        "Mohlala: lebenkele la gago le šoma go www.acme.com go fapana le subdomain ya sethala."
      ],
      "capi": [
        "Romela ditiragalo tša phetošo server-side bakeng sa tekolo ya mohlolo wa maphulo.",
        "Mohlala: tiragalo ya go reka e romelwa go tšwa server ya go ya go sethala sa papatšo."
      ],
      "personal-mfs": [
        "Kothatša netefatšo ya ditefo tša Personal MFS tšeo di thekgilwego.",
        "Mohlala: tefo ya Personal MFS e baragana le odara ya weposaete."
      ],
      "local-gateway": [
        "Kgokaganya mekgwa ya tefo ya lefelong bakeng sa bareki ba tikologo.",
        "Mohlala: moreki wa lefelong o phethagatša checkout ka gateway ya profinse."
      ],
      "international-gateway": [
        "Kgokaganya mekgwa ya tefo ya machabeng bakeng sa bareki ba lefase ka bophara.",
        "Mohlala: moreki wa nageng ya kantle o phethagatša checkout ka mokgwa wa lefase ka bophara."
      ],
      "notifications": [
        "Romela di-update tša tefo le taelo go bareki le bafenyi.",
        "Mohlala: katlego ya tefo e hlohleletša tsebišo ya morekisi le tlhahlo ya moreki."
      ],
      "courier": [
        "Romela ditaelo tše di netefaditšwego ka tsela ya courier ye e thekgilwego ka boikgopo.",
        "Mohlala: odara ya COD ye e netefaditšwego e lokišetšwa bakeng sa go hlatswa ke courier."
      ],
      "business-email": [
        "Romela gape o amogele imeile ya profeshenale mo domain ya gago ya setlogo.",
        "Mohlala: sales@acme.com e amogela dipotšišo gomme support@acme.com e araba."
      ]
    }
  },
  "ltz": {
    "checkout": {
      "liveInstruction": "Wielt d'Live-Method, gitt d'Kontnummer an an bestätigt se op der nächster Säit, vun där Dir Suen schéckt. Eng 10-Minutte Live-Sessioun fänkt un; Suen ze schécken während dëser Zäit verifizéiert d'Bezuellung automatesch.",
      "trxInstruction": "Cash In vun engem Geschäft oder frot eng aner Persoun fir Send Money. Duerno automatesch verifizéieren mat der Transaction ID (TrxID).",
      "enterNumberInstruction": "Gitt Är Nummer an a klickt op den '{action}' Knäppchen.",
      "offlineTitle": "Händlergerät Offline",
      "offlineDescription": "Auto-Verifikatioun ass temporär net verfügbar.",
      "copyPersonal": "Kopéiert déi uewen Personal Account-Nummer.",
      "sendMoneyOffline": "Maacht Send Money oder Cash In op d'Nummer uewen, oder frot eng aner Persoun fir Geld ze schécken.",
      "trxOffline": "Bekomm d'Transaction ID (TrxID) a gitt se hei drënner an. Wann de Händler erëm online kënnt, kritt Dir eng E-Mail Notifikatioun, oder Dir kënnt de Händler direkt kontaktéieren.",
      "cashinNagad": "Cash In ass bei Nagad net erlaabt; benotzt w.e.g. 'Send Money' vun engem aneren Nagad-Kont.",
      "cashinOther": "Frot de Buttek virum Cash In ob si d'TrxID liwwer; wann net, fuert net weider. Alternativ, frot eng aner Persoun fir Send Money.",
      "waitTrx": "No der Bezuelung waardt 10–15 Sekonnen a gitt d'TrxID hei drënner. Dir kënnt dës Säit verloossen an an den nächsten 24 Stonnen erëm op dës Bezuelungssäit zréckkommen fir mat ärem TrxID automatesch ze verifizéieren.",
      "goApp": "Gitt an d'{provider}-App oder wielt {dialCode} an auswielt 'Send Money'.",
      "confirmAuto": "Gitt d'kopéiert Nummer an den Betrag an bestätegt mat Ärem PIN fir automatesch ze verifizéieren.",
      "dontClose": "Weg Är net dës Säit zouzemaachen",
      "autoVerify": "Är Bezuelung gëtt automatesch verifizéiert",
      "successOffline": "Merci, {name}. Är Transaktioun gouf opgeholl. De Händler ass momentan offline. Dir kritt eng E-Mail Notifikatioun nodeems de Händler erëm online kënnt an Är Bezuelung verifizéiert.",
      "successOnline": "Merci, {name}. Är Bezuelung vun {amount} iwwer {provider} gouf empfaangen an gëtt verifizéiert."
    },
    "features": {
      "no-code-website": [
        "Erstellt an publizéiert E‑Commerce-, Bildungs-, Blog- oder News-Säiten ouni ze coden.",
        "Beispill: publizéiert eng Landing-Page an e Produkt-Post vum Course Seller Dashboard."
      ],
      "custom-domain": [
        "Connectéiert Äre eigenen Domain a baut eng professionell digital Identitéit mat méi séierer Routeroute.",
        "Beispill: Äre Buttek leeft op www.acme.com amplaz op enger Plattform-Subdomain."
      ],
      "capi": [
        "Schéckt Conversion-Events serverseit fir zouverlässeg Kampagnemoossnamme.",
        "Beispill: En Akeef-Event gëtt vum Server un déi Annoncenplattform geschéckt."
      ],
      "personal-mfs": [
        "Automatiséiert ënnerstëtzt Personal MFS Bezuelungsverifikatiounen.",
        "Beispill: Eng Personal MFS Bezuelung gëtt mam Websäite-Befehl ofgeglach."
      ],
      "local-gateway": [
        "Connectéiert lokal Bezuelmethoden fir regional Clienten.",
        "Beispill: En lokale Keefer fäerdeg de Checkout iwwer en regionalen Gateway."
      ],
      "international-gateway": [
        "Connectéiert international Bezuelmethoden fir Clienten weltwäit.",
        "Beispill: En auslännesche Keefer fäerdeg de Checkout mat enger globaler Method."
      ],
      "notifications": [
        "Schéckt Bezuel- an Bestellungsaktualiséierungen un Clienten an Händler.",
        "Beispill: Bezuelungs-Erfolleg triggert eng Händlernotifikatioun an eng Update un de Client."
      ],
      "courier": [
        "Sendt bestätegt Bestellungen automatesch an en ënnerstëtzte Courièr-Workflow.",
        "Beispill: Eng bestätegt COD-Bestellung gëtt fir Courièr-Ofgank virbereet."
      ],
      "business-email": [
        "Schéckt a kritt professionell E-Mail op Ärem eegene Markendomain.",
        "Beispill: sales@acme.com kritt Ufroen an support@acme.com äntwert."
      ]
    }
  },
  "lua": {
    "checkout": {
      "liveInstruction": "Picka mu method ya live, landa namba ya akunio ku mwidika mpe vikala kuyilakana ku peji yo elandi. Sesi ya live ya minuta 10 eyamba; kutuma mbongo na kati ya yango ekosala verifikasyo ya mpasi na automatique.",
      "trxInstruction": "Cash In na shopi to vula moto mosusu asala Send Money. Mpe verifikasyo ekokoma automatique na Transaction ID (TrxID).",
      "enterNumberInstruction": "Tonda namba na yo mpe klikila botoni '{action}'.",
      "offlineTitle": "Device ya Merchant Offline",
      "offlineDescription": "Auto-verifikasyo ezali te ya mokuse.",
      "copyPersonal": "Kopa namba ya Personal Account oyo ezali likolo.",
      "sendMoneyOffline": "Kosala Send Money to Cash In na namba oyo ezali likolo, to talisa moto mosusu asala Send Money.",
      "trxOffline": "Koleka Transaction ID (TrxID) mpe yika yango awa. Soki merchant akende online, yo okozwa email ya notification, to okoki kotala merchant malamu.",
      "cashinNagad": "Cash In ezali péké te na Nagad; s'il vous plaît kosala 'Send Money' uta na compte ya Nagad mosusu.",
      "cashinOther": "Liboso ya Cash In, kopesa motuya na shopkeeper soki akopesa TrxID; soki te, kobanga te koleka. To kopa moto mosusu asala Send Money.",
      "waitTrx": "Na nsima ya paiement, eyanga 10–15 secondes mpe tinda TrxID awa. Okoki kokima pe kozonga na peji oyo na ngonga 24 ora mpo na verifikasyo automatique na TrxID na yo.",
      "goApp": "Kende na app ya {provider} to diali {dialCode} mpe kilomela 'Send Money'.",
      "confirmAuto": "Sala entrée ya namba oyo opusilisaki mpe montant, mpe komikisa na PIN na yo mpo na verifikasyo automatique.",
      "dontClose": "S'il vous plaît kozongisa te peji oyo",
      "autoVerify": "Paiement na yo ezali ko verifier na automatique",
      "successOffline": "Mersí, {name}. Transaction na yo ebengami. Merchant azali offline sikoyo. Okokoma notifié na email tango merchant akoya online mpe akosolola verifikasyo ya paiement na yo.",
      "successOnline": "Mersí, {name}. Paiement ya {amount} na {provider} esili kozwa mpe ezali na verifikasyo."
    },
    "features": {
      "no-code-website": [
        "Somba mpe publie site ya e-commerce, éducation, blog, to information pas na code.",
        "Exemple: publie landing page mpe post produit uta na dashboard ya course seller."
      ],
      "custom-domain": [
        "Konekta domain na yo mpe bâtir identité numérique professionnel na routing oyo ekokisa mingi.",
        "Exemple: boutik na yo ezali na www.acme.com pene na subdomain ya plateforme."
      ],
      "capi": [
        "Tinda conversion events server-side mpo na mesure fiable ya campagne.",
        "Exemple: événement d'achat etali tonda na serveur na plateforme d'annonce."
      ],
      "personal-mfs": [
        "Automatisa verification ya paiement Personal MFS oyo ebongi.",
        "Exemple: paiement Personal MFS ekoki ko matcher na commande ya site."
      ],
      "local-gateway": [
        "Konekta méthodes ya paiement lokales mpo na ba clients ya région.",
        "Exemple: acheteur local akomisa checkout na gateway ya région."
      ],
      "international-gateway": [
        "Konekta méthodes de paiement internationales mpo na clients na mokili mobimba.",
        "Exemple: acheteur international akokisa checkout na méthode globale."
      ],
      "notifications": [
        "Tinda updates ya paiement mpe commande na customers mpe merchants.",
        "Exemple: réussite ya paiement ekotinda alerte na merchant mpe update na customer."
      ],
      "courier": [
        "Tinda commandes confirmées kaka na workflow ya courier oyo ebongi automatiquement.",
        "Exemple: commande COD confirmée ezali préparer mpo na remise na courier."
      ],
      "business-email": [
        "Tinda mpe kozwa email professionnel na domain ya marque na yo.",
        "Exemple: sales@acme.com ekoyoka demandes mpe support@acme.com ekopesa réponses."
      ]
    }
  },
  "mah": {
    "checkout": {
      "liveInstruction": "Kōnono eṃañ etale live, kōtļọk kōmṃan ák ān eenawōj an kont nummer eo ek kōmṃan remōj ioon jān page kōn̄e. Ej til̗ļo iien 10 minūt in live; kōmṃan kab kōmṃan jerbōk ioon bwe ej kōmṃan kaboñ roñoul jān elap in joṃļọk, peļ jān eḷap ej jiban vérifik eo.",
      "trxInstruction": "Cash In ilo shop ak kōmṃan kōmṃan jab jān kōn̄e ibben Send Money. Emak kōn̄an verifik jān Transaction ID (TrxID).",
      "enterNumberInstruction": "Kōnono namba eo im kōn̄e ekōjerōk en, kōmman kōn̄e iakwe '{action}'.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification ej lajeļāek lok in.",
      "copyPersonal": "Kop ij Personal Account number eo ilo elap.",
      "sendMoneyOffline": "Send Money ak Cash In kōn̄e ilo namba eo elap, ak kōnono kōmṃan jen eo emōj aellep jen kōmṃan kōn̄e.",
      "trxOffline": "Kōn̄an Transaction ID (TrxID) im kōnono kōn̄e kōmṃan kōmṃan im. Ij kōmṃan ānbwān merchant ekāle bwe ej kōrōk online, elōñin kōnm̧ool im email, ak kōnono elōñin kōrōk lōmņak merchant langsung.",
      "cashinNagad": "Cash In ej la minlem in ilo Nagad; kōnono kōmṃan kōmṃan 'Send Money' ilo an kont Nagad elaññe.",
      "cashinOther": "Bwe lok Cash In, kōmṃan kōmṃan kōnono wōr jān shopkeeper en bwe ej kōmṃan kaboñ TrxID; ak kōnono la, ej kōnono emōj bwōt. Ak kōmṃan kōmṃan jān mwe emōj an Send Money.",
      "waitTrx": "Bwe im kab kōmṃan kōmṃan, kōmṃan kōn̄e eḷap 10–15 sekōn im kōnono kōn̄e kōmṃan TrxID ilo elap. Kōmṃan īj jān page eo im kōņaan kate an 24 uur im kōmṃan kōmṃan kōn̄e ekāle verifik jān TrxID eo.",
      "goApp": "Kōmṃan in app {provider} ak kōmṃan dial {dialCode} im kōmṃan jelāḷae 'Send Money'.",
      "confirmAuto": "Kōnono namba eo im amount eo ej kopa, remōj kōn̄e kōmṃan kōn̄e PIN eo non auto-verifik.",
      "dontClose": "Kōnono laž im jab kōmṃan pejin eo",
      "autoVerify": "Kōmṃan kab ej verifino automatic",
      "successOffline": "Kom̧mol tata, {name}. Kōmṃan eo ej rej kōm̧m̧an ilo ledger. Merchant ej lajañ ilo online. Kōnono rej kōmṃan in email bwe kajjet emōj merchant ekāle im rej verifino kōmṃan eo.",
      "successOnline": "Kom̧mol tata, {name}. Kōmṃan kab in {amount} ilo {provider} ej reba im rej verifino."
    },
    "features": {
      "no-code-website": [
        "Kōjpar eo im publishe website eo e-commerce, edukation, blog ak news mēḷeḷe elukkun kake ilo code.",
        "Exañpol: publish landing page im product post bwe ej jejet im course seller dashboard."
      ],
      "custom-domain": [
        "Konekt wōt domain noņ eo ak bar kakkwōj identity digital profesional im routing faster.",
        "Exañpol: ilo website eo ej ejelōñ www.acme.com ilo rej jukjuk jen platform subdomain."
      ],
      "capi": [
        "Tōpar conversion events ekar server-side bwe emōj rej jikin raar measur campaign.",
        "Exañpol: purchase event ej tīd server in kōn̄an kompāniet ad platform."
      ],
      "personal-mfs": [
        "Automate verification ilo Personal MFS payments ebebañak supported.",
        "Exañpol: Personal MFS payment ej lakōl match ilo website order."
      ],
      "local-gateway": [
        "Konekt lokāl payment methods noņ customers ilo region.",
        "Exañpol: lokāl buyer ej tōņōk checkout ilo regional gateway."
      ],
      "international-gateway": [
        "Konekt international payment methods noņ customers ilo an world wide.",
        "Exañpol: foreign buyer ej tōņōk checkout ilo global method."
      ],
      "notifications": [
        "Tōpar payment im order updates noņ customers im merchants.",
        "Exañpol: payment success ej kōm̧añ merchant alert im customer update."
      ],
      "courier": [
        "Tōpar confirmed orders ilo supported courier workflow im automatic.",
        "Exañpol: confirmed COD order ej prepare kōn̄e kōjpar kuria handoff."
      ],
      "business-email": [
        "Tōpar im komej email profesional ilo domain eo kōn̄e brand.",
        "Exañpol: sales@acme.com rej kwoj inquiries im support@acme.com rej ripōn."
      ]
    }
  },
  "mey": {
    "checkout": {
      "liveInstruction": "اختر الطريقة الحية، ادخل و أكد رقم الحساب الذي ستُرسل منه المال في الصفحة التالية. ستبدأ جلسة مباشرة لمدة 10 دقائق؛ إرسال المال خلالها سيؤكد الدفع تلقائياً.",
      "trxInstruction": "Cash In من الدكان أو اطلب من شخص آخر أن يقوم بـ Send Money. ثم تحقق تلقائياً باستخدام Transaction ID (TrxID).",
      "enterNumberInstruction": "أدخل رقمك واضغط على زر '{action}'.",
      "offlineTitle": "جهاز التاجر غير متصل",
      "offlineDescription": "التحقق التلقائي غير متاح مؤقتاً.",
      "copyPersonal": "انسخ رقم الـ Personal Account أعلاه.",
      "sendMoneyOffline": "قم بعمل Send Money أو Cash In إلى الرقم أعلاه، أو اطلب من شخص آخر إرسال المال.",
      "trxOffline": "احصل على Transaction ID (TrxID) وادخله أدناه. عندما يعود التاجر على الإنترنت، سيتم إبلاغك عبر البريد الإلكتروني، أو يمكنك الاتصال بالتاجر مباشرة.",
      "cashinNagad": "Cash In غير مسموح في Nagad، لذا يرجى استخدام Send Money من حساب Nagad آخر.",
      "cashinOther": "قبل Cash In، اسأل صاحب المتجر إن كان سيعطي TrxID؛ إن لم يفعل، لا تتابع. كبديل، اطلب من شخص آخر أن يقوم بـ Send Money.",
      "waitTrx": "بعد الدفع انتظر 10–15 ثانية ثم أدخل TrxID أدناه. يمكنك مغادرة هذه الصفحة والعودة إلى صفحة الدفع هذه في أي وقت خلال 24 ساعة للتحقق تلقائياً باستخدام TrxID الخاص بك.",
      "goApp": "اذهب إلى تطبيق {provider} أو اطلب {dialCode} واختر 'Send Money'.",
      "confirmAuto": "أدخل الرقم المنسوخ والمبلغ، ثم أكد برقم PIN الخاص بك للتحقق تلقائياً.",
      "dontClose": "يرجى عدم إغلاق هذه الصفحة",
      "autoVerify": "جاري التحقق من دفعتك تلقائياً",
      "successOffline": "شكراً، {name}. تم تسجيل معاملتك. التاجر حالياً غير متصل. سيتم إعلامك عبر البريد الإلكتروني بعد أن يصبح التاجر متصلاً ويؤكد دفعتك.",
      "successOnline": "شكراً، {name}. تم استلام دفعتك بمقدار {amount} عبر {provider} وهي الآن قيد التحقق."
    },
    "features": {
      "no-code-website": [
        "أنشئ وانشر مواقع تجارة إلكترونية، تعليمية، مدونات أو أخبار بدون برمجة.",
        "مثال: انشر صفحة هبوط ومنشور منتج من لوحة تحكم بائع الدورة."
      ],
      "custom-domain": [
        "ربط نطاقك الخاص وبناء هوية رقمية احترافية مع توجيه أسرع.",
        "مثال: متجرك يعمل على www.acme.com بدلاً من نطاق فرعي للمنصة."
      ],
      "capi": [
        "أرسل أحداث التحويل من جهة الخادم لقياس الحملات بشكل موثوق.",
        "مثال: حدث شراء يُرسل من الخادم إلى منصة الإعلان."
      ],
      "personal-mfs": [
        "أتمتة التحقق من مدفوعات Personal MFS المدعومة.",
        "مثال: مطابقة دفعة Personal MFS مع طلب الموقع."
      ],
      "local-gateway": [
        "ربط طرق الدفع المحلية لعملاء المنطقة.",
        "مثال: مشترٍ محلي يكمل الدفع عبر بوابة إقليمية."
      ],
      "international-gateway": [
        "ربط طرق الدفع الدولية للعملاء حول العالم.",
        "مثال: مشترٍ من الخارج يكمل الدفع بطريقة عالمية."
      ],
      "notifications": [
        "إرسال تحديثات الدفع والطلبات إلى العملاء والتجار.",
        "مثال: نجاح الدفع يرسل تنبيه للتاجر وتحديث للعميل."
      ],
      "courier": [
        "إرسال الطلبات المؤكدة إلى سير عمل ساعي مدعوم تلقائياً.",
        "مثال: طلب COD مؤكد يُجهز لتسليم الساعي."
      ],
      "business-email": [
        "إرسال واستقبال بريد إلكتروني احترافي على نطاق علامتك التجارية.",
        "مثال: sales@acme.com يستقبل الاستفسارات و support@acme.com يرد."
      ]
    }
  },
  "mfe": {
    "checkout": {
      "liveInstruction": "Swazir metòd la live, antre e konfirme nimero kont-la kot ou pou voye lajan depi sou paj kap vini. Ena enn sesyon live 10-minit; si ou voye lajan pandan sa sesyon-la sa pou verify paiement an otomatik.",
      "trxInstruction": "Cash In depi enn magazin ou demann enn lot dimoun pou fer Send Money. Apre verify otomatik avek Transaction ID (TrxID).",
      "enterNumberInstruction": "Antre ou nimero e klik lor bouton '{action}'.",
      "offlineTitle": "Aparey Komersan Offline",
      "offlineDescription": "Auto-verification pa disponib pour enn tans.",
      "copyPersonal": "Kopi nimero Personal Account-la an sus.",
      "sendMoneyOffline": "Fer Send Money ouswa Cash In al nimero an sus, ouswa demande enn lot dimoun pou voye lajan.",
      "trxOffline": "Recupere Transaction ID (TrxID) ek antre li anba. Kan merchant revini online, ou pou resevwar enn notifikasyon par email, ouswa ou kapav kontakte merchant direkt.",
      "cashinNagad": "Cash In pa permet dan Nagad; s'il vous plaît fer 'Send Money' depi enn lezot kont Nagad.",
      "cashinOther": "Anvan fer Cash In, demann shopkeeper si li pou donn TrxID; si non, pa kontinie. Sinon, demann enn lot dimoun fer Send Money.",
      "waitTrx": "Apre peman, atann 10–15 segond e antre TrxID anba. Ou kapav kit sa paj-la ek retourn dan sa paj peman-la nimporte kil letan dan 24-er pou verify otomatik avek ou TrxID.",
      "goApp": "Al dan l'app {provider} ouswa tape {dialCode} ek swazir 'Send Money'.",
      "confirmAuto": "Antre nimero ki ou finn kopi ek montant, apre konfirme avek ou PIN pou auto-verify.",
      "dontClose": "Silvouple pa ferm sa paj-la",
      "autoVerify": "Ou peman pe verifie otomatikman",
      "successOffline": "Mersi, {name}. Ou transaksyon finn anrejistre. Merchant la kouma offline. Ou pou resiv enn email kan merchant revini online e verify ou peman.",
      "successOnline": "Mersi, {name}. Ou peman {amount} atraver {provider} finn resevwar ek pe verifie."
    },
    "features": {
      "no-code-website": [
        "Kre ek pibliye site e-commerce, ledikasion, blog ou news san kod.",
        "Egzanp: pibliye enn landing page ek enn post produs depi dashboard vendour kours."
      ],
      "custom-domain": [
        "Konekte to prop domain ek bati enn idantite digital profesyonnel avek rout pli rapid.",
        "Egzanp: to magazin roule lor www.acme.com invez lor enn subdomain platform."
      ],
      "capi": [
        "Voye evenman conversion server-side pou mezi kanpay ki bizin fiable.",
        "Egzanp: enn event l'achat pe voni depi server ver platform annon."
      ],
      "personal-mfs": [
        "Automatize verification peman Personal MFS ki siporte.",
        "Egzanp: enn peman Personal MFS matche avek la komand lor site."
      ],
      "local-gateway": [
        "Konekte metod peman lokal pou kliyan rezyonal.",
        "Egzanp: enn achtir lokal konplete checkout atraver enn gateway regional."
      ],
      "international-gateway": [
        "Konekte metod peman internasyonal pou kliyan tou lemond.",
        "Egzanp: enn achtir etranze konplete checkout avek enn metod global."
      ],
      "notifications": [
        "Voye miz-a-zour peman ek komand pou kliyan ek merchants.",
        "Egzanp: sikses peman trigg enn alerte pou merchant ek enn update pou kliyan."
      ],
      "courier": [
        "Voye commandes konfime dan enn workflow courier siporte otomatikman.",
        "Egzanp: enn komann COD konfime prepar pou remise courier."
      ],
      "business-email": [
        "Voye e resevwar email profesyonnel lor to prop domain brand.",
        "Egzanp: sales@acme.com resevwar demand ek support@acme.com reponn."
      ]
    }
  },
  "mkd": {
    "checkout": {
      "liveInstruction": "Изберете жив метод, внесете и потврдете број на сметка од кој ќе праќате пари на следната страница. Ќе започне 10-минутна live сесија; испраќањето пари за време на неа ќе ја автоматски потврди уплатата.",
      "trxInstruction": "Cash In од продавница или побарајте некој друг да направи Send Money. Потоа автоматски потврдете користејќи го Transaction ID (TrxID).",
      "enterNumberInstruction": "Внесете го вашиот број и кликнете на копчето '{action}'.",
      "offlineTitle": "Уредот на трговецот е офлајн",
      "offlineDescription": "Авто-потврдата во моментот не е достапна.",
      "copyPersonal": "Копирајте го Personal Account бројот погоре.",
      "sendMoneyOffline": "Направете Send Money или Cash In на бројот погоре, или побарајте некој друг да испрати пари.",
      "trxOffline": "Зајдете го Transaction ID (TrxID) и внесете го подолу. Кога трговецот ќе се јави онлајн, ќе бидете известени по е-пошта, или можете директно да го контактирате трговецот.",
      "cashinNagad": "Cash In не е дозволено во Nagad, па ве молиме направете Send Money од друг Nagad акаунт.",
      "cashinOther": "Пред Cash In, прашајте го продавачот дали ќе обезбеди TrxID; ако не, не продолжувајте. Алтернативно, побарајте некој друг да направи Send Money.",
      "waitTrx": "По плаќањето, почекајте 10–15 секунди и внесете го TrxID подолу. Можете да ја напуштите оваа страница и да се вратите на оваа страница за плаќање во било кое време во рок од 24 часа за автоматско верификување со вашиот TrxID.",
      "goApp": "Отидете во апликацијата {provider} или бирајте {dialCode} и изберете 'Send Money'.",
      "confirmAuto": "Внесете го копираниот број и износот, па потврдете со вашиот PIN за автоматско верификување.",
      "dontClose": "Ве молиме не ја затворајте оваа страница",
      "autoVerify": "Вашата уплата се верификува автоматски",
      "successOffline": "Ви благодариме, {name}. Вашата трансакција е евидентирана. Трговецот моментално е офлајн. Ќе бидете известени по е-пошта откако трговецот ќе се врати онлајн и ќе ја потврди вашата уплата.",
      "successOnline": "Ви благодариме, {name}. Вашата уплата од {amount} преку {provider} е примена и се верификува."
    },
    "features": {
      "no-code-website": [
        "Креирајте и објавувајте е‑трговија, образовни, блог или информативни сајтови без програмирање.",
        "Пример: објавете landing страница и пост за производ од контролниот панел за продавач на курсеви."
      ],
      "custom-domain": [
        "Поврзете свој домен и изградете професионален дигитален идентитет со побрзо рутирање.",
        "Пример: вашата продавница работи на www.acme.com наместо на субдомен на платформата."
      ],
      "capi": [
        "Испратете конверзиски настани од серверот за сигурно мерење на кампањи.",
        "Пример: настан за купување се испраќа од серверот до рекламната платформа."
      ],
      "personal-mfs": [
        "Автоматизирајте потврдување на поддржани Personal MFS плаќања.",
        "Пример: Personal MFS плаќање се поклопува со нарачката на веб‑страницата."
      ],
      "local-gateway": [
        "Поврзете локални методи за плаќање за регионални купувачи.",
        "Пример: локален купувач ги завршува плаќањата преку регионален gateway."
      ],
      "international-gateway": [
        "Поврзете меѓународни методи за плаќање за клиенти низ целиот свет.",
        "Пример: странски купувач завршува наплата со глобална метода."
      ],
      "notifications": [
        "Испраќајте ажурирања за плаќање и нарачки до клиентите и трговците.",
        "Пример: успешна трансакција предизвикува известување до трговец и ажурирање до клиент."
      ],
      "courier": [
        "Испратете потврдени нарачки автоматски во поддржан курирски workflow.",
        "Пример: потврдена COD нарачка се подготвува за предавање на курир."
      ],
      "business-email": [
        "Испраќајте и примајте професионална е‑пошта на вашиот бранд домен.",
        "Пример: sales@acme.com прима прашања а support@acme.com одговара."
      ]
    }
  },
  "mlg": {
    "checkout": {
      "liveInstruction": "Misafidio ny fomba mivantana (live), ampidiro ary ankatoavy ny laharan'ny kaonty handefasanao vola ao amin'ny pejy manaraka. Hanomboka fotoam‑pivoriana mivantana 10 minitra; ny fandefasana vola mandritra izany dia hanamarina ny fandoavana ho azy.",
      "trxInstruction": "Cash In avy amin'ny fivarotana na angataho olona hafa hanao Send Money. Avy eo atao auto‑verify amin'ny Transaction ID (TrxID).",
      "enterNumberInstruction": "Ampidiro ny nomeraonao ary kitiho ny bokotra '{action}'.",
      "offlineTitle": "Fitaovan'ny mpivarotra tsy misy Internet",
      "offlineDescription": "Tsy misy vonjimaika ny fanamarinana mandeha ho azy.",
      "copyPersonal": "Adikao ny laharan'ny Personal Account etsy ambony.",
      "sendMoneyOffline": "Manaova Send Money na Cash In amin'ilay laharana etsy ambony, na angataho olona hafa handefa vola.",
      "trxOffline": "Makà ny Transaction ID (TrxID) ary apetraho eto ambany. Rehefa miverina amin'ny Internet ny mpivarotra dia ho fampahafantarinao amin'ny mailaka, na azonao atao ny mifandray mivantana amin'ny mpivarotra.",
      "cashinNagad": "Tsy avela ny Cash In ao Nagad; azafady manao 'Send Money' avy amin'ny kaonty Nagad hafa.",
      "cashinOther": "Alohan'ny Cash In, fantaro amin'ny mpivarotra raha hanome TrxID izy; raha tsia dia aza mitohy. Raha tsy izany, angataho olona hafa hanao Send Money.",
      "waitTrx": "Rehefa vita ny fandoavana dia miandrasa 10–15 segondra ary ampidiro ny TrxID eto ambany. Azonao atao ny miala amin'ity pejy ity ary miverina amin'ity pejy fandoavana ity amin'ny fotoana rehetra ao anatin'ny 24 ora mba hanaovana auto‑verify amin'ny TrxID‑nao.",
      "goApp": "Mankanesa amin'ny fampiharana {provider} na dial {dialCode} ary safidio 'Send Money'.",
      "confirmAuto": "Ampidiro ny nomerao voadika sy ny vola, avy eo ankatoavy amin'ny PIN‑nao mba hanaovana auto‑verify.",
      "dontClose": "Aza manidy ity pejy ity azafady",
      "autoVerify": "Anaovana verification mandeha ho azy ny fandoavanao",
      "successOffline": "Misaotra, {name}. Voarakitra ny fifanakalozana nataonao. Tsy misy Internet ny mpivarotra amin'izao fotoana izao. Hafan'ny mailaka ianao rehefa miverina online ilay mpivarotra ary manamarina ny fandoavanao.",
      "successOnline": "Misaotra, {name}. Voaray ary anaovana verification ny fandoavanao {amount} tamin'ny alalan'ny {provider}."
    },
    "features": {
      "no-code-website": [
        "Mamolavola sy mamoaka tranonkala e‑commerce, fampianarana, bilaogy na vaovao tsy mila manoratra kaody.",
        "Ohatra: mamoaka pejy fipetrahana (landing page) sy lahatsoratra momba ny vokatra avy amin'ny dashboard mpivarotra fampianarana."
      ],
      "custom-domain": [
        "Ampifandraiso ny domain‑nao ary manorata maha‑izy anao amin'ny endrika matihanina miaraka amin'ny hafatra mandeha haingana kokoa.",
        "Ohatra: ny fivarotanao mampiasa www.acme.com fa tsy subdomain an'ny sehatra."
      ],
      "capi": [
        "Mandefa hetsika conversion avy amin'ny serveur mba hahazoana fandrefesana fampielezan-kevitra azo antoka.",
        "Ohatra: hetsika fividianana alefa avy amin'ny serveur mankany amin'ny sehatra doka."
      ],
      "personal-mfs": [
        "Manam‑piasana mandeha ho azy ny fanamarinana fandoavam‑bola Personal MFS tohanana.",
        "Ohatra: mifanaraka amin'ny baiko ao amin'ny tranonkala ny fandoavana Personal MFS."
      ],
      "local-gateway": [
        "Mampifandray fomba fandoavam‑bola eo an-toerana ho an'ny mpividy eo an-toerana.",
        "Ohatra: mpividy ao an-toerana mamita ny fandoavana amin'ny alalan'ny gateway faritra."
      ],
      "international-gateway": [
        "Mampifandray fomba fandoavam‑bola iraisam‑pirenena ho an'ny mpanjifa manerana izao tontolo izao.",
        "Ohatra: mpividy avy any ivelany mamita ny fandoavana amin'ny fomba manerantany."
      ],
      "notifications": [
        "Mandefa fanavaozam‑pandoavana sy kaomandy ho an'ny mpanjifa sy mpivarotra.",
        "Ohatra: ny fahombiazana amin'ny fandoavana miteraka fampandrenesana ho an'ny mpivarotra ary fanavaozana ho an'ny mpanjifa."
      ],
      "courier": [
        "Mandefa ny kaomandy voamarina ho azy any amin'ny workflow mpandefa (courier) tohanana.",
        "Ohatra: kaomandy COD voamarina dia miomana handeha any amin'ny courier."
      ],
      "business-email": [
        "Mandefa sy mandray mailaka matihanina amin'ny domain‑n'ny marikao.",
        "Ohatra: sales@acme.com mandray fanontaniana ary support@acme.com mamaly."
      ]
    }
  },
  "mlt": {
    "checkout": {
      "liveInstruction": "Agħżel il-metodu live, daħħal u kkonferma n-numru tal-kont minn fejn se tibgħat il-flus fuq il-paġna li jmiss. Tibda sessjoni live ta' 10 minuti; tibgħat il-flus waqt din is-sessjoni se jivverifika l-ħlas awtomatikament.",
      "trxInstruction": "Cash In minn ħanut jew staqsi lil xi ħadd biex jagħmel Send Money. Imbagħad ivverifika awtomatikament billi tuża Transaction ID (TrxID).",
      "enterNumberInstruction": "Daħħal in-numru tiegħek u kklikkja fuq il-buttuna '{action}'.",
      "offlineTitle": "Tagħmir tal-Merċant Offline",
      "offlineDescription": "Il-verifika awtomatika mhix disponibbli temporanjament.",
      "copyPersonal": "Kopja n‑numru tal‑Personal Account hawn fuq.",
      "sendMoneyOffline": "Agħmel Send Money jew Cash In lejn in‑numru hawn fuq, jew staqsi lil xi ħadd ieħor biex jibgħat il-flus.",
      "trxOffline": "Ikkonferma t‑Transaction ID (TrxID) u daħħalha hawn taħt. Meta l‑merċant jerġa' jiġi online, tkun int notifikat bil‑email, jew tista' tikkuntattja l‑merċant direttament.",
      "cashinNagad": "Cash In mhux permess fi Nagad, għalhekk jekk jogħġbok agħmel 'Send Money' minn kont Nagad ieħor.",
      "cashinOther": "Qabel Cash In, staqsi lill‑ħanut jekk se jipprovdu TrxID; jekk le, ma tkomplikx. Alternattivament, staqsi lil xi ħadd ieħor biex jagħmel Send Money.",
      "waitTrx": "Wara l‑ħlas, stenna 10–15 sekonda u daħħal it‑TrxID hawn taħt. Tista' titlaq minn din il‑paġna u tirritorna għal din il‑paġna ta' ħlas in‑naħa ta' kull ħin fi żmien 24 siegħa biex tivverifika awtomatikament bl‑TrxID tiegħek.",
      "goApp": "Mur fil‑app tal‑{provider} jew id‑dial {dialCode} u agħżel 'Send Money'.",
      "confirmAuto": "Daħħal in‑numru kopjat u l‑ammont, imbagħad ikkonferma bil‑PIN tiegħek biex tivverifika awtomatikament.",
      "dontClose": "Jekk jogħġbok ma tagħlaqx din il‑paġna",
      "autoVerify": "Il-ħlas tiegħek qed jiġi vverifikat awtomatikament",
      "successOffline": "Grazzi, {name}. L‑operazzjoni tiegħek ġiet irreġistrata. Il‑merċant bħalissa huwa offline. Inti tkun notifikat bl‑email wara li l‑merċant jidħol online u jikkonferma l‑ħlas tiegħek.",
      "successOnline": "Grazzi, {name}. Il‑ħlas tiegħek ta' {amount} permezz ta' {provider} ġie rċevut u qed jiġi vverifikat."
    },
    "features": {
      "no-code-website": [
        "Oħloq u ippubblika siti e‑commerce, edukattivi, blog jew aħbarijiet mingħajr ma tikteb kodiċi.",
        "Eżempju: ippubblika landing page u post dwar il-prodott mill‑dashboard tal‑vendor tal‑kors."
      ],
      "custom-domain": [
        "Ikkonnettja d‑domain tiegħek stess u ibni identità diġitali professjonali bi routa aktar mgħaġġla.",
        "Eżempju: maħżnek jaħdem fuq www.acme.com minflok subdomain tal‑pjattaforma."
      ],
      "capi": [
        "Ibgħat eventi ta' konverżjoni server‑side għal kejl ta' kampanji affidabbli.",
        "Eżempju: avveniment ta' xiri jintbagħat mis‑server lill‑pjattaforma tal‑reklamar."
      ],
      "personal-mfs": [
        "Awtomatizza l‑verifika ta' pagamenti Personal MFS appoġġjati.",
        "Eżempju: pagament Personal MFS jiġi matched mal‑ordni tas‑sit."
      ],
      "local-gateway": [
        "Ikkonnettja metodi ta' ħlas lokali għall‑klijenti reġjonali.",
        "Eżempju: xiri lokali jtemm il‑checkout permezz ta' gateway reġjonali."
      ],
      "international-gateway": [
        "Ikkonnettja metodi ta' ħlas internazzjonali għall‑klijenti madwar id‑dinja.",
        "Eżempju: xerrej barrani jtemm il‑checkout b'metodu globali."
      ],
      "notifications": [
        "Ibgħat aġġornamenti dwar il‑pagamenti u l‑ordnijiet lill‑klijenti u l‑merċanti.",
        "Eżempju: suċċess tal‑ħlas jikkawża allarm lill‑merċant u aġġornament lill‑klijent."
      ],
      "courier": [
        "Ibgħat ordnijiet kkonfermati awtomatikament fil‑workflow tal‑kurrier appoġġjat.",
        "Eżempju: ordni COD kkonfermata tiġi ppreparata għall‑konsegna lill‑kurrier."
      ],
      "business-email": [
        "Ibgħat u tirċievi email professjonali fuq id‑domain tal‑brand tiegħek.",
        "Eżempju: sales@acme.com jirċievi stħarriġ u support@acme.com jirrispondi."
      ]
    }
  },
  "mon": {
    "checkout": {
      "liveInstruction": "Амьд аргыг сонгоод, дараагийн хуудсан дээрээс мөнгө илгээх дансны дугаарыг оруулж баталгаажуулна уу. 10 минутын live хурал эхэлнэ; энэ хугацаанд мөнгө илгээх нь төлбөрийг автоматаар баталгаажуулна.",
      "trxInstruction": "Дэлгүүрээс Cash In хийх эсвэл хэн нэгэнд Send Money хийхийг хүснэ үү. Дараа нь Transaction ID (TrxID)-ээр автомат баталгаажуулна.",
      "enterNumberInstruction": "Өөрийн дугаарыг оруулаад '{action}' товчийг дарна уу.",
      "offlineTitle": "Худалдагчийн төхөөрөмж офлайн байна",
      "offlineDescription": "Автомат баталгаажуулалт түр хугацаагаар боломжгүй байна.",
      "copyPersonal": "Дээрх Personal Account дугаарыг хуулна уу.",
      "sendMoneyOffline": "Дээрх дугаарт Send Money эсвэл Cash In хийж болно, эсвэл хэн нэгнээс мөнгө илгээхийг гуйна уу.",
      "trxOffline": "Transaction ID (TrxID)-г цуглуулж доор оруулна уу. Худалдагч онлайн болсны дараа танд имэйлээр мэдэгдэгдэнэ, эсвэл та худалдагчтай шууд холбоо барина уу.",
      "cashinNagad": "Nagad-д Cash In хийх зөвшөөрөгдөөгүй тул өөр Nagad дансаас 'Send Money' хийгээрэй.",
      "cashinOther": "Cash In хийхийн өмнө худалдагч TrxID-г өгөх эсэхийг асуу; хэрэв үгүй бол үргэлжлүүлж болохгүй. Эсвэл хэн нэгнээс Send Money хийхийг гуйна уу.",
      "waitTrx": "Төлбөр хийсний дараа 10–15 секунд хүлээж доорх TrxID-г оруулна уу. Та энэ хуудсыг орхиж 24 цагийн дотор хүссэн үедээ энэ төлбөрийн хуудсанд буцаж ирж TrxID-гээсээ авто баталгаажуулж болно.",
      "goApp": "{provider} апп руу орох эсвэл {dialCode} дугаарыг залгаж 'Send Money' сонгоно уу.",
      "confirmAuto": "Хуулсан дугаарыг болон хэмжээг оруулж PIN-ээр баталгаажуулан автоматаар шалгуулна уу.",
      "dontClose": "Энэхүү хуудсыг хааж болохгүй",
      "autoVerify": "Таны төлбөр автоматаар шалгагдаж байна",
      "successOffline": "Баярлалаа, {name}. Таны гүйлгээ бүртгэгдлээ. Худалдагч одоогоор офлайн байна. Худалдагч онлайн болж таны төлбөрийг баталгаажуулсны дараа танд имэйлээр мэдэгдэх болно.",
      "successOnline": "Баярлалаа, {name}. {provider} ашиглан {amount} хэмжээний таны төлбөр хүлээн авсан ба шалгана."
    },
    "features": {
      "no-code-website": [
        "Код бичихгүйгээр цахим худалдаа, боловсрол, блог эсвэл мэдээний сайт үүсгэн нийтэлнэ.",
        "Жишээ: курс худалдаалагчийн dashboard-ээс landing хуудас болон бүтээгдэхүүний бичлэг нийтэлнэ."
      ],
      "custom-domain": [
        "Өөрийн домэйнийг холбож илүү хурдан чиглүүлэлттэй мэргэжлийн дижитал танигдлыг бий болгоно.",
        "Жишээ: таны дэлгүүр www.acme.com дээр ажиллана, платформын subdomain биш."
      ],
      "capi": [
        "Кампанийн найдвартай хэмжилтэд зориулан сервер талаас conversion үйл явдлуудыг илгээ.</",
        "Жишээ: худалдан авах үйл явдал серверээс зар сурталчилгааны платформ руу илгээгдэнэ."
      ],
      "personal-mfs": [
        "Дэмжигдсэн Personal MFS төлбөрийн баталгаажуулалтыг автоматжуулна.",
        "Жишээ: Personal MFS төлбөр нь вэбсайтын захиалгатай таарч тохирно."
      ],
      "local-gateway": [
        "Бүс нутгийн хэрэглэгчдэд зориулсан орон нутгийн төлбөрийн аргуудыг холбож өгнө.",
        "Жишээ: орон нутгийн худалдан авагч бүс нутгийн gateway-аар checkout-г гүйцээнэ."
      ],
      "international-gateway": [
        "Дэлхийн өнцөг булан бүрийн хэрэглэгчдэд зориулсан олон улсын төлбөрийн аргуудыг холбох.",
        "Жишээ: гадаад худалдан авагч глобал аргаар checkout-г гүйцээнэ."
      ],
      "notifications": [
        "Төлбөр болон захиалгын шинэчлэлүүдийг хэрэглэгчид болон худалдаачдад илгээ.",
        "Жишээ: төлбөрийн амжилт нь худалдаачинд сэрэмжлүүлэг болон хэрэглэгчид шинэчлэлт илгээдэг."
      ],
      "courier": [
        "Батлагдсан захиалгуудыг дэмжигдсэн курьерийн workflow‑д автоматаар илгээ.",
        "Жишээ: батлагдсан COD захиалга курьерт шилжүүлэхээр бэлтгэгдэнэ."
      ],
      "business-email": [
        "Өөрийн брэнд домэйнд мэргэжлийн имэйл илгээх, хүлээн авах.",
        "Жишээ: sales@acme.com нь лавлагааг хүлээн авч support@acme.com нь хариу өгнө."
      ]
    }
  },
  "mri": {
    "checkout": {
      "liveInstruction": "Tīpakohia te tikanga ora (live), whakaūhia tō tau pūkete ka tukuna he moni mai i taua pūkete i te whārangi e whai ake nei. Ka tīmata tētahi hui ora 10 meneti; ka tāea te tuku moni i roto i taua wā kia whakamana aunoa i te utu.",
      "trxInstruction": "Kei te mahi Cash In i tētahi toa, ā, pātai ki tētahi atu kia mahi Send Money. Ka whakamana āunoa mā te Transaction ID (TrxID).",
      "enterNumberInstruction": "Tīpako i tō tau, kātahi ka pāwhiri i te pātene '{action}'.",
      "offlineTitle": "Taputapu Kaihoko Kua Kore I te Ipurangi",
      "offlineDescription": "Kāore te whakamana aunoa e wātea mō te wā poto.",
      "copyPersonal": "Tārua te tau Personal Account kei runga nei.",
      "sendMoneyOffline": "Mahia he Send Money, he Cash In rānei ki taua tau kei runga, ā, mēnā kāore, pātai ki tētahi atu kia tuku moni.",
      "trxOffline": "Tīpakohia te Transaction ID (TrxID) ā, tāuru i raro nei. Ka puta te kaihoko ki runga ipurangi, ka whakamōhiotia koe mā te īmēra, ka taea hoki te whakapā tika ki te kaihoko.",
      "cashinNagad": "Kāore te Cash In i whakaaetia i Nagad; tēnā, mahia te 'Send Money' mai i tētahi atu pūkete Nagad.",
      "cashinOther": "I mua i te Cash In, pātai ki te kaitiaki toa mēnā ka whakarato rātou i te TrxID; mēnā kāo, kaua e haere tonu. He ara kē, pātai ki tētahi atu kia mahi Send Money.",
      "waitTrx": "I muri i te utu, tatari 10–15 hēkona ā, tāuru te TrxID i raro nei. Ka taea e koe te waiho i tēnei whārangi ka hoki mai ki tēnei whārangi utu i ngā wā katoa i roto i te 24 haora kia whakamana ā‑aunoa mā tō TrxID.",
      "goApp": "Haere ki te hōtaka {provider} rānei tāpae te {dialCode} ka tīpako 'Send Money'.",
      "confirmAuto": "Tāuru te tau kua tāruatia me te moni, ka whakau mā tō PIN kia whakamana aunoa.",
      "dontClose": "Kāore e tuku kia kati tēnei whārangi",
      "autoVerify": "Kei te whakamana aunoa tō utu",
      "successOffline": "Ngā mihi, {name}. Kua tuhia tō whakawhitinga. Kei waho ipurangi te kaihoko ināianei. Ka whakamōhiotia koe mā te īmēra i te wā ka puta te kaihoko ki runga ipurangi ka whakamana i tō utu.",
      "successOnline": "Ngā mihi, {name}. Kua riro tō utu {amount} mā {provider} ka kei te whakamana."
    },
    "features": {
      "no-code-website": [
        "Hangaia, whakaputahia ngā pae hokohoko, mātauranga, rorohiko rangitaki (blog) rānei, kīhai he tārua waehere.",
        "Tārahi: whakaputahia he whārangi hiki (landing page) me tētahi pou hua mai i te papakupu kaiwhakahaere (course seller dashboard)."
      ],
      "custom-domain": [
        "Whakapāngia tō ake ingoa tūrua (domain) ka waihangahia he tuakiri ā‑ipurangi ngaio me te arahina wawe.",
        "Tārahi: ko tō toa kei runga i www.acme.com kaua i tētahi subdomain o te papa."
      ],
      "capi": [
        "Tukua ngā kaupapa hurihanga (conversion events) mai i te tūmau kia tika ai te ine pānui.",
        "Tārahi: kua tukuna tētahi kaupapa hoko mai i te tūmau ki te papa panui."
      ],
      "personal-mfs": [
        "Aunoa te whakamana i ngā utu Personal MFS kua tautokohia.",
        "Tārahi: ka taurite tētahi utu Personal MFS ki te ota paetukutuku."
      ],
      "local-gateway": [
        "Whakapāngia ngā tikanga utu ā‑rohe mō ngā kiritaki ā‑rohe.",
        "Tārahi: ka oti te tuku moni a te kiritaki ā‑rohe mā tētahi pasarewa ā‑rohe (regional gateway)."
      ],
      "international-gateway": [
        "Whakapāngia ngā tikanga utu ā‑ao mō ngā kiritaki puta noa i te ao.",
        "Tārahi: ka oti te utu a tētahi kiritaki o tāwāhi mā tētahi tikanga ao."
      ],
      "notifications": [
        "Tukua ngā whakahoutanga utu me ngā ota ki ngā kiritaki me ngā kaihoko.",
        "Tārahi: ka whiwhi te kaihoko i tētahi whakaoho me te kiritaki i tētahi whakahoutanga i te angitū utu."
      ],
      "courier": [
        "Tukua ngā ota kua whakamanahia ki tētahi rere‑mahi kaipuke tautokona aunoa.",
        "Tārahi: ka whakaritea he ota COD kua whakamanahia mō te tuku ki te kaipuke."
      ],
      "business-email": [
        "Tukua me te whiwhi īmēra ngaio i runga i tō ake ingoa tūrua.",
        "Tārahi: ka whiwhi a sales@acme.com i ngā pātai ā ka whakautu a support@acme.com."
      ]
    }
  },
  "msa": {
    "checkout": {
      "liveInstruction": "Pilih kaedah langsung, masukkan dan sahkan nombor akaun yang anda akan kirim wang daripada pada halaman seterusnya. Sesi langsung 10 minit akan bermula; menghantar wang semasa sesi akan mengesahkan pembayaran secara automatik.",
      "trxInstruction": "Cash In dari kedai atau minta orang lain lakukan Send Money. Kemudian sahkan secara automatik menggunakan Transaction ID (TrxID).",
      "enterNumberInstruction": "Masukkan nombor anda dan klik butang '{action}'.",
      "offlineTitle": "Peranti Pedagang Luar Talian",
      "offlineDescription": "Pengesahan automatik sedang tidak tersedia buat sementara waktu.",
      "copyPersonal": "Salin nombor Personal Account di atas.",
      "sendMoneyOffline": "Lakukan Send Money atau Cash In ke nombor di atas, atau minta orang lain untuk menghantar wang.",
      "trxOffline": "Dapatkan Transaction ID (TrxID) dan masukkannya di bawah. Apabila pedagang kembali dalam talian, anda akan diberitahu melalui e-mel, atau anda boleh menghubungi pedagang secara langsung.",
      "cashinNagad": "Cash In tidak dibenarkan di Nagad, jadi sila lakukan Send Money dari akaun Nagad lain.",
      "cashinOther": "Sebelum Cash In, tanya pemilik kedai sama ada mereka akan memberikan TrxID; jika tidak, jangan teruskan. Sebagai alternatif, minta orang lain untuk melakukan Send Money.",
      "waitTrx": "Selepas pembayaran, tunggu 10–15 saat dan masukkan TrxID di bawah. Anda boleh meninggalkan halaman ini dan kembali ke halaman pembayaran ini pada bila-bila masa dalam 24 jam untuk pengesahan automatik menggunakan TrxID anda.",
      "goApp": "Pergi ke aplikasi {provider} atau dail {dialCode} dan pilih 'Send Money'.",
      "confirmAuto": "Masukkan nombor yang disalin dan amaun, kemudian sahkan dengan PIN anda untuk pengesahan automatik.",
      "dontClose": "Sila jangan tutup halaman ini",
      "autoVerify": "Pembayaran anda sedang disahkan secara automatik",
      "successOffline": "Terima kasih, {name}. Transaksi anda telah direkodkan. Pedagang pada masa ini luar talian. Anda akan diberitahu melalui e-mel selepas pedagang kembali dalam talian dan mengesahkan pembayaran anda.",
      "successOnline": "Terima kasih, {name}. Pembayaran anda sebanyak {amount} melalui {provider} telah diterima dan sedang disahkan."
    },
    "features": {
      "no-code-website": [
        "Cipta dan terbitkan laman e-dagang, pendidikan, blog atau berita tanpa pengekodan.",
        "Contoh: terbitkan halaman pendaratan dan pos produk dari papan pemuka penjual kursus."
      ],
      "custom-domain": [
        "Sambungkan domain anda sendiri dan bina identiti digital profesional dengan penghalaan yang lebih pantas.",
        "Contoh: kedai anda berjalan di www.acme.com dan bukan subdomain platform."
      ],
      "capi": [
        "Hantar acara penukaran (conversion events) dari server untuk pengukuran kempen yang boleh dipercayai.",
        "Contoh: acara pembelian dihantar dari server ke platform iklan."
      ],
      "personal-mfs": [
        "Automatikkan pengesahan pembayaran Personal MFS yang disokong.",
        "Contoh: pembayaran Personal MFS dipadankan dengan pesanan di laman web."
      ],
      "local-gateway": [
        "Sambungkan kaedah pembayaran tempatan untuk pelanggan serantau.",
        "Contoh: pembeli tempatan menamatkan checkout melalui gateway serantau."
      ],
      "international-gateway": [
        "Sambungkan kaedah pembayaran antarabangsa untuk pelanggan di seluruh dunia.",
        "Contoh: pembeli luar negara menamatkan checkout dengan kaedah global."
      ],
      "notifications": [
        "Hantar kemas kini pembayaran dan pesanan kepada pelanggan dan pedagang.",
        "Contoh: kejayaan pembayaran mencetuskan amaran pedagang dan kemas kini pelanggan."
      ],
      "courier": [
        "Hantar pesanan yang disahkan ke aliran kerja kurier yang disokong secara automatik.",
        "Contoh: pesanan COD yang disahkan disiapkan untuk penyerahan kepada kurier."
      ],
      "business-email": [
        "Hantar dan terima e-mel profesional pada domain jenama anda sendiri.",
        "Contoh: sales@acme.com menerima pertanyaan dan support@acme.com membalas."
      ]
    }
  },
  "mya": {
    "checkout": {
      "liveInstruction": "စာရင်းပေးမည့်နည်းလမ်း (live) ကို ရွေးပါ၊ နောက်စာမျက်နှာတွင် ငွေလွှဲမည့် အကောင့်နံပါတ်ကို ထည့်ပြီး အတည်ပြုပါ။ 10 မိနစ်ကြာ Live အချိန်စတင်ပါမည်။ အချိန်အတွင်းငွေပေးပို့်လျှင် ငွေပေးချေမှုကို အလိုအလျောက် စစ်ဆေးပါမည်။",
      "trxInstruction": "ဆိုင်တစ်ဆိုင်မှ Cash In ပြုလုပ်ပါ သို့မဟုတ် တစ်စုံတစ်ယောက်ကို Send Money ပြုလုပ်ရန် မေတ္တာရပ်ခံပါ။ ထို့နောက် Transaction ID (TrxID) ဖြင့် အလိုအလျောက် စစ်ဆေးပါ။",
      "enterNumberInstruction": "သင့်နံပါတ်ကို ထည့်ပြီး '{action}' ခလုတ်ကို နှိပ်ပါ။",
      "offlineTitle": "ကုန်သည်၏ ကိရိယာ အော့ဖ်လိုင်းဖြစ်နေသည်",
      "offlineDescription": "အလိုအလျောက် စစ်ဆေးခြင်းကို ယာယီအားဖြင့် ရရှိနိုင်မည်မဟုတ်ပါ။",
      "copyPersonal": "အထက်ပါ Personal Account နံပါတ်ကို ကူးယူပါ။",
      "sendMoneyOffline": "အထက်ပါနံပါတ်သို့ Send Money သို့မဟုတ် Cash In ဆောင်ရွက်ပါ၊ သို့မဟုတ် တစ်စုံတစ်ယောက်သို့ ငွေထုတ်ပို့ရန် တောင်းဆိုပါ။",
      "trxOffline": "Transaction ID (TrxID) ကို ရယူပြီး အောက်တွင် ထည့်ပါ။ ကုန်သည် ပြန်လည်အွန်လိုင်းဖြစ်သည့်အခါ သင်သည် အီးမေးလ်ဖြင့် အသိပေးခံရမည်၊ သို့မဟုတ် ကုန်သည်ကို တိုက်ရိုက် ဆက်သွယ်နိုင်ပါသည်။",
      "cashinNagad": "Nagad တွင် Cash In ကို ခွင့်မပြုပါ; ထို့ကြောင့် အခြား Nagad အကောင့်မှ 'Send Money' ပြုလုပ်ပါ။",
      "cashinOther": "Cash In မလုပ်မှီ ဆိုင်မှ TrxID ပေးမလား စစ်ဆေးပါ; မပေးလျှင် ဆက်လက်မလုပ်ရန်။ အခြားနည်းလမ်းအဖြစ် တစ်စုံတစ်ယောက်ကို Send Money ပြုလုပ်ရန် တောင်းပါ။",
      "waitTrx": "ငွေပေးချေပြီးနောက် 10–15 စက္ကန့် စောင့်ပြီး TrxID ကို အောက်တွင် ထည့်ပါ။ သင်သည် ဤစာမျက်နှာကို ထွက်၍ 24 နာရီအတွင်း အချိန်မရွေး ထပ်မံ သို့မဟုတ် ပြန်လည်ရောက်ရှိကာ TrxID ဖြင့် အလိုအလျောက် စစ်ဆေးနိုင်ပါသည်။",
      "goApp": "{provider} အက်ပ်သို့ သွားပါ သို့မဟုတ် {dialCode} ကို ဖုန်းခေါ်ပြီး 'Send Money' ကို ရွေးချယ်ပါ။",
      "confirmAuto": "ကူးယူထားသော နံပါတ်နှင့် ငွေပမာဏကို ထည့်ပြီး PIN ဖြင့် အတည်ပြု၍ အလိုအလျောက် စစ်ဆေးပါ။",
      "dontClose": "ကျေးဇူးပြု၍ ဤစာမျက်နှာကို ပိတ်မထားပါနှင့်",
      "autoVerify": "သင့်ငွေပေးချေမှုကို အလိုအလျောက် စစ်ဆေးနေပါသည်",
      "successOffline": "ကျေးဇူးတင်ပါသည်၊ {name}။ သင့်နှုတ်ယူမှုမှတ်တမ်းတင်ပြီးပါပြီ။ ကုန်သည်သည် လက်ရှိအချိန်တွင် အော့ဖ်လိုင်းဖြစ်သည်။ ကုန်သည် အွန်လိုင်းလာပြီး သင့်ငွေပေးချေမှုကို အတည်ပြုပါက သင်ကို အီးမေးလ်ဖြင့် အသိပေးပါမည်။",
      "successOnline": "ကျေးဇူးတင်ပါသည်၊ {name}။ {provider} ဖြင့် {amount} の သင်၏ငွေပေးချေမှုကို လက်ခံရရှိပြီး စစ်ဆေးနေပါသည်။"
    },
    "features": {
      "no-code-website": [
        "ကုဒ်မဘဲ အွန်လိုင်းစတိုး (e‑commerce), ပညာရေး၊ ဘလော့ဂ် သို့မဟုတ် သတင်းဆိုက်များကို စီမံနှင့် ထုတ်ဝေပါ။",
        "ဥပမာ: သင်တန်းရောင်းသူ dashboard မှ လက်မောင်းစာမျက်နှာ (landing page) နှင့် ကုန်ပစ္စည်း post တစ်ခု ထုတ်ဝေပါ။"
      ],
      "custom-domain": [
        "သင့်ကိုယ်ပိုင် domain ကို ချိတ်ဆက်ပြီး ပရော်ဖက်ရှင်နယ် ဒစ်ဂျစ်တယ် အင်တီတီတီကို ပိုမိုလျင်မြန်သည့် routing ဖြင့် တည်ဆောက်ပါ။",
        "ဥပမာ: သင့်စတိုးကို platform subdomain မဟုတ်ဘဲ www.acme.com ပေါ်တွင် လည်ပတ်သည်။"
      ],
      "capi": [
        "ယုံကြည်စိတ်ချရသော ကှမ်ပိန်းတိုင်းတာမှုများအတွက် conversion events များကို ဆာဗာဘက်မှ ပို့ပါ။",
        "ဥပမာ: ဝယ်ယူမှု γεγονός တစ်ခုကို ဆာဗာမှ ကြော်ငြာပလက်ဖောင်းသို့ ပို့သည်။"
      ],
      "personal-mfs": [
        "ထောက်ပံ့ထားသော Personal MFS ငွေပေးချေမှုများ၏ အတည်ပြုချက်ကို အလိုအလျောက် လုပ်ဆောင်ပါ။",
        "ဥပမာ: Personal MFS ငွေပေးချေမှုတစ်ခုကို ဝဘ်ဆိုက်အမှာစာနှင့် ကိုက်ညီစေသည်။"
      ],
      "local-gateway": [
        "ဒေသခံဖောက်သည်များအတွက် ဒေသခံငွေပေးချေမှုနည်းလမ်းများကို ချိတ်ဆက်ပါ။",
        "ဥပမာ: ဒေသခံဝယ်ယူသူတစ်ဦးသည် ဒေသဆိုင်ရာ gateway ဖြင့် checkout ပြီးဆုံးသည်။"
      ],
      "international-gateway": [
        "ကမ္ဘာတစ်ဝှမ်းရှိ ဖောက်သည်များအတွက် အပြည်ပငွေပေးချေမှုပုံစံများကို ချိတ်ဆက်ပါ။",
        "ဥပမာ: နိုင်ငံခြားထဲက ဝယ်သူတစ်ဦးသည် global method ဖြင့် checkout ပြီးဆုံးသည်။"
      ],
      "notifications": [
        "ငွေပေးချေရန်နှင့် အမှာစာများဆိုင်ရာ အချက်အလက်အသစ်များကို ဖောက်သည်များနှင့် ကုန်သည်များထံ ပို့ပါ။",
        "ဥပမာ: ငွေပေးချေမှုအောင်မြင်မှုသည် ကုန်သည်သို့ သတိပေးမှုနှင့် ဖောက်သည်အပ်ဒိတ်ကို trigger လုပ်သည်။"
      ],
      "courier": [
        "အတည်ပြုသော အမှာစာများကို ထောက်ခံထားသော courier workflow သို့ အလိုအလျောက် ပို့ပါ။",
        "ဥပမာ: အတည်ပြုထားသော COD အမှာစာကို courier အへ လက်ဆောင်ပို့ဆောင်မှုအတွက် ပြင်ဆင်သည်။"
      ],
      "business-email": [
        "သင့်ရဲ့ အမှတ်တံဆိပ် domain ပေါ်တွင် ပရော်ဖက်ရှင်နယ် အီးမေးလ်များ ပို့/လက်ခံပါ။",
        "ဥပမာ: sales@acme.com သည် စုံစမ်းမေးခွန်းများကို လက်ခံပြီး support@acme.com သည် တုံ့ပြန်သည်။"
      ]
    }
  },
  "nya": {
    "checkout": {
      "liveInstruction": "Sankhani njira ya live, lowetsani ndikutsimikizira nambala ya akaunti yomwe mudzatumize ndalama kuchokera papeji lotsatira. Misonkhano ya live ya mphindi 10 idzayamba; kutumiza ndalama nthawi imeneyo kudzatsimikizira malipiro zokha.",
      "trxInstruction": "Panga Cash In ku sitolo kapena pemphani wina kuti akuitse Send Money. Kenako gwiritsani ntchito TrxID kuti muwonetsetse zokha.",
      "enterNumberInstruction": "Lowetsani nambala yanu ndikudina batani lakuti '{action}'.",
      "offlineTitle": "Chipangizo cha Wogulitsa Sichikugwira pa Intaneti",
      "offlineDescription": "Kuwunikira kokha sikukupezeka kwakanthawi.",
      "copyPersonal": "Koperani nambala ya Personal Account yomwe ili pamwambapa.",
      "sendMoneyOffline": "Tumizani Send Money kapena Cash In ku nambala yomwe ili pamwambapa, kapena pemphani wina kuti atumize Send Money.",
      "trxOffline": "Pezani TrxID kenako lowetsani pansipa. Mukangobwera pa intaneti, mudzadziwitsidwa ndi imelo, kapena mutha kulumikizana ndi wogulitsa mwachindunji.",
      "cashinNagad": "Cash In si lovalidwa pa Nagad, choncho chonde tumizani Send Money kuchokera ku akaunti ina ya Nagad.",
      "cashinOther": "Musanalembe Cash In, funsani kasitomala ngati adzapereka TrxID; ngati ayi, musayende patsogolo. Njira ina, pemphani wina kuti atumize Send Money.",
      "waitTrx": "Pambuyo pa malipiro, dikirani masekondi 10–15 ndiyeno lowetsani TrxID pansipa. Mutha kuchoka papeji lino ndi kubwerera pa tsamba la malipiro nthawi iliyonse mkati mwa maola 24 kuti muauto-verify pogwiritsa ntchito TrxID yanu.",
      "goApp": "Pitani ku pulogalamu ya {provider} kapena dial {dialCode} ndikusankha 'Send Money'.",
      "confirmAuto": "Lowetsani nambala yomwe mwakopera ndi kuchuluka, kenako tsimikizani ndi PIN yanu kuti muauto-verify.",
      "dontClose": "Chonde musatseke tsamba lino",
      "autoVerify": "Malipiro anu akuwunikiridwa zokha",
      "successOffline": "Zikomo, {name}. Ntchito yanu yarekodhidwa. Wogulitsa pakadali pano alibe intaneti. Mudzadziwitsidwa ndi imelo atangobwera pa intaneti ndikutsimikiza malipiro anu.",
      "successOnline": "Zikomo, {name}. Malipiro anu a {amount} kudzera pa {provider} alandiridwa ndipo akuwunikiridwa."
    },
    "features": {
      "no-code-website": [
        "Pangani ndi kuyika malo a e-commerce, maphunziro, blog, kapena nkhani popanda kulemba code.",
        "Chitsanzo: yankhulani landing page ndi posita ya chinthu kuchokera mu dashboard ya wogulitsa ma kosi."
      ],
      "custom-domain": [
        "Gwirizanitsani domain yanu ndikupanga mazina amtima apamwamba pa digito ndi kuyendetsa mwachangu.",
        "Chitsanzo: sitolo yanu ikuyenda pa www.acme.com m'malo mwa subdomain ya nsanja."
      ],
      "capi": [
        "Tumizani zochitika za conversion kuchokera ku server kuti mupeza mayeso okhazikika a kampeni.",
        "Chitsanzo: zochitika za kugula zimatumizidwa kuchokera ku server kupita ku nsanja ya malonda."
      ],
      "personal-mfs": [
        "Automate kusanthula malipiro a Personal MFS omwe amathandizidwa.",
        "Chitsanzo: malipiro a Personal MFS amayang'aniridwa ndi lamulo la webusayiti."
      ],
      "local-gateway": [
        "Gwirizanitsani njira zolipirira zakomweko kwa makasitomala am'deralo.",
        "Chitsanzo: wogula waku dera amamaliza checkout kudzera pa gateway yakomweko."
      ],
      "international-gateway": [
        "Gwirizanitsani njira zolipirira zapadziko lonse kwa makasitomala kuchokera padziko lonse.",
        "Chitsanzo: wogula waku kunja amamaliza checkout ndi njira ya padziko lonse."
      ],
      "notifications": [
        "Tumizani zambiri za malipiro ndi ma oda kwa makasitomala ndi ogulitsa.",
        "Chitsanzo: kupambana kwa malipiro kumayambitsa chidziwitso kwa wogulitsa ndi kusintha kwa kasitomala."
      ],
      "courier": [
        "Tumizani ma oda otsimikizika ku njira ya courier yomwe amathandizidwa momwemo.",
        "Chitsanzo: oda ya COD yomwe yatsimikizika ikonzedwa kuti iperekedwe kwa courier."
      ],
      "business-email": [
        "Tumizani ndi kulandira imelo yabizinesi pa domain yanu yokhala ndi brand yanu.",
        "Chitsanzo: sales@acme.com imalandira mafunsiro ndipo support@acme.com imayankha."
      ]
    }
  },
  "nzs": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the TrxID and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Create and publish e-commerce, education, blog, or news sites without coding.",
        "Example: publish a landing page and product post from the course seller dashboard."
      ],
      "custom-domain": [
        "Connect your own domain and build a professional digital identity with faster routing.",
        "Example: your store runs on www.acme.com instead of a platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side for reliable campaign measurement.",
        "Example: a purchase event is sent from the server to the ad platform."
      ],
      "personal-mfs": [
        "Automate supported personal MFS payment verification.",
        "Example: a personal MFS payment is matched to the website order."
      ],
      "local-gateway": [
        "Connect local payment methods for regional customers.",
        "Example: a local buyer completes checkout through a regional gateway."
      ],
      "international-gateway": [
        "Connect international payment methods for customers worldwide.",
        "Example: an overseas buyer completes checkout with a global method."
      ],
      "notifications": [
        "Send payment and order updates to customers and merchants.",
        "Example: payment success triggers a merchant alert and customer update."
      ],
      "courier": [
        "Send confirmed orders into a supported courier workflow automatically.",
        "Example: a confirmed COD order is prepared for courier handoff."
      ],
      "business-email": [
        "Send and receive professional email on your own branded domain.",
        "Example: sales@acme.com receives inquiries and support@acme.com replies."
      ]
    }
  },
  "pap": {
    "checkout": {
      "liveInstruction": "Skohe e metodo live, drenta i konfirma e número di kuenta ku bo ta manda e plata for di siguiente página. Un seshon live di 10 minuto lo kuminsa; manda plata den e período lo auto-verifiká e pago.",
      "trxInstruction": "Hasi Cash In den un tienda òf pidi algu otro pa Send Money. Depois auto-verifiká usa TrxID.",
      "enterNumberInstruction": "Drenta bo número i kliká e botón '{action}'.",
      "offlineTitle": "Dispositivo di Komersiante Offline",
      "offlineDescription": "Auto-verifikashon ta no disponible momentáneamente.",
      "copyPersonal": "Kopia e número di Personal Account ku ta riba.",
      "sendMoneyOffline": "Send Money òf Cash In na e número riba, òf pidi algu otro pa send'e plata.",
      "trxOffline": "Kolektá e TrxID i drenta dje abou. Ora e komersiante ta online, bo lo wak notifikashon pa email, òf bo por kontaktá e komersiante direto.",
      "cashinNagad": "Cash In no ta permití den Nagad, asina por fabor Send Money for di otro cuenta Nagad.",
      "cashinOther": "Antes di Cash In, pidi na e kampanero si nan lo duna bo TrxID; si no, no sigui ku e proseso. Alternativamente, pidi algu otro pa Send Money.",
      "waitTrx": "Despues di pago, spéra 10–15 segundo i drenta e TrxID abou. Bo por sali di e página aki i bolbe na e página di pago den kualker momento den 24 ora pa auto-verifiká usa bo TrxID.",
      "goApp": "Bai na e aplikashon di {provider} òf mtcham {dialCode} i skohe 'Send Money'.",
      "confirmAuto": "Drenta e número ku bo a kopia i e monto, despues konfirma ku bo PIN pa auto-verifiká.",
      "dontClose": "Por fabor no sera e página aki",
      "autoVerify": "Bo pago ta wordu verifiká automáticamente",
      "successOffline": "Masha danki, {name}. Bo transakshon a wordu rekòrdá. E komersiante ta offlain awor. Bo lo risibí un email ora e komersiante ta online i lo verifiká bo pago.",
      "successOnline": "Masha danki, {name}. Bo pago di {amount} via {provider} a wordu risibí i ta wordu verifiká."
    },
    "features": {
      "no-code-website": [
        "Krea i publika webusinan di e-commerce, edukashon, blog, òf notisia sin kodigo.",
        "Ehemplo: publika un landing page y un post di producto for di dashboard di seller di kurso."
      ],
      "custom-domain": [
        "Konekta bo propio dominio i konstrui un identidad digital profesional ku ruta mas rápido.",
        "Ehemplo: bo tienda ta keda na www.acme.com en vez di subdominio di plataforma."
      ],
      "capi": [
        "Manda eventos di konbershon server-side pa medishon de kampaña mas konfiabel.",
        "Ehemplo: un evento di kompra ta manda for di server na e plataforma di ads."
      ],
      "personal-mfs": [
        "Automatisa verifikashon di pago Personal MFS ku ta soportá.",
        "Ehemplo: un pago Personal MFS ta kombiná ku un orden na website."
      ],
      "local-gateway": [
        "Konekta metodos di pago lokal pa klientenan regional.",
        "Ehemplo: un kompradó lokal ta kompletá e checkout via un gateway regional."
      ],
      "international-gateway": [
        "Konekta metodos di pago internacional pa kliente mundialmente.",
        "Ehemplo: un kompradó for di otro pais ta kompletá e checkout ku un metodo global."
      ],
      "notifications": [
        "Manda actualisashon di pago i orden na klientenan i komersiante.",
        "Ehemplo: exito den pago ta genera un alerta pa komersiante i un update pa klienta."
      ],
      "courier": [
        "Manda ordennan konfirmá automaticamente den workflow di courier ku ta soportá.",
        "Ehemplo: un orden COD konfirmá ta prepara pa pas'é na courier."
      ],
      "business-email": [
        "Manda i risibí email profesional riba bo propio dominio ku marka.",
        "Ehemplo: sales@acme.com ta risibí preguntanan i support@acme.com ta responsa."
      ]
    }
  },
  "pau": {
    "checkout": {
      "liveInstruction": "Ngklem el mengil el live, chull el a rechad el account number el ungil a Klech. A 10-minute live session o kmo er a mulai; el Send Money el chim a dil ngii el kau el auto-verify el payment.",
      "trxInstruction": "Cash In tek el shop or rechad el klung el Send Money. Ak el auto-verify el TrxID.",
      "enterNumberInstruction": "Chull el number el ungil, e omel el button '{action}'.",
      "offlineTitle": "Machine a Merchant el Offline",
      "offlineDescription": "Auto-verification a keru el kerang er ilu el ungil.",
      "copyPersonal": "Kopi el Personal Account number el rengil.",
      "sendMoneyOffline": "Send Money or Cash In el number rengil, or rechad el klung el Send Money.",
      "trxOffline": "Kollekt el TrxID el chull el rengil. Ng kmo el merchant oleng el online, el email o ren er a notifi, or el kmo rechad el klung el contactel merchant direkt.",
      "cashinNagad": "Cash In ma oleng el allowed long Nagad, ak el plise Send Money long enom el Nagad account.",
      "cashinOther": "Belng el Cash In, omel el shopkeeper ma ra el providel TrxID; ketang, no oleng el proceed. Alternatif, rechad el klung el Send Money.",
      "waitTrx": "Ari el payment, wait 10–15 seconds el chull el TrxID rengil. Oleng el leave el page el bolk el rena el payment page long 24 hours pa auto-verify usa TrxID.",
      "goApp": "Bai long {provider} app or dial {dialCode} el select 'Send Money'.",
      "confirmAuto": "Chull el copied number el amount, bel el confirm usa PIN blong auto-verify.",
      "dontClose": "Plise no close el page",
      "autoVerify": "Bo payment el auto-verifying",
      "successOffline": "Thank you, {name}. El transaction el rekod. Merchant oleng offline now. Bo lo notifi long email after merchant oleng online el verify bo payment.",
      "successOnline": "Thank you, {name}. Bo payment {amount} long {provider} oleng receive el el verifying."
    },
    "features": {
      "no-code-website": [
        "Moruul e mopublish a site er a siobai, osisechakl, blog, me a lechub e ng chais el diak mousbech a koding.",
        "Publish a rengreng el landing page me a product post er a seller dashboard."
      ],
      "custom-domain": [
        "Mokebit a kloklem el domain e mketmokl a ungil el digital identity er kau el oba a bekerurau el routing.",
        "A store er kau mokiik er a www.acme.com ng di mokiik er a subdomain er a platform."
      ],
      "capi": [
        "Kesiich a conversion events er a server-side el mo diak a klekedall er a measurement er a campaign.",
        "A purchase event ngalek er a server el mo er a ad platform."
      ],
      "personal-mfs": [
        "Moruul el mo automatic a oterekellel a cheral a Personal MFS el kengei er ngii.",
        "a cheral a Personal MFS a mo kldmokl er a order er a website."
      ],
      "local-gateway": [
        "Kokosiich a local payment methods er ngaklei a kliente er a chesemiich el beluu.",
        "A local buyer mechas a checkout er a regional gateway."
      ],
      "international-gateway": [
        "Kokosiich a international payment methods er a kliente er a chelid er a beluu el kiei el kbo momdasu.",
        "A overseas buyer mechas a checkout er a global method."
      ],
      "notifications": [
        "Dilisich me mngilisa a chelsel a klebuked er a payment me a order er ngaklei a customer me a merchant.",
        "Ng di mo successful a payment, mechas a alert er a merchant me a update er a customer."
      ],
      "courier": [
        "Dilisich a confirmed orders el mo er a supported courier workflow er tia el diak a diak le ngmo er kau.",
        "A confirmed COD order mekedam er a courier handoff."
      ],
      "business-email": [
        "Dilisich me delal a professional email er kau el branded domain.",
        "sales@acme.com mechas a inquiries, me support@acme.com mosiik a reply."
      ]
    }
  },
  "pih": {
    "checkout": {
      "liveInstruction": "Choos la live way, typen an confirm la account numba yu go send money from on la next page. Wan 10-minute live session go start; sendin money long dat time go auto-verify la payment.",
      "trxInstruction": "Do Cash In from wan shop or ask anoda pipl fi Send Money. Then auto-verify wit TrxID.",
      "enterNumberInstruction": "Type yu numba an click la '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification no available for now.",
      "copyPersonal": "Copy la Personal Account numba ova.",
      "sendMoneyOffline": "Send Money or Cash In to la numba ova, or ask anoda person fi send money.",
      "trxOffline": "Get la TrxID an type it below. Wen la merchant come online, yu go get email, or yu can contact la merchant direct.",
      "cashinNagad": "Cash In na allowed in Nagad, so plis Send Money from anoda Nagad account.",
      "cashinOther": "Bifo Cash In, ask la shopkeeper if dem go give TrxID; if not, no go. Or ask anoda person fi Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds an enter la TrxID below. Yu can leave dis page an come back any time within 24 hours fi auto-verify wit yu TrxID.",
      "goApp": "Go to la {provider} app or dial {dialCode} an select 'Send Money'.",
      "confirmAuto": "Enter la copied numba an amount, den confirm wit yu PIN fi auto-verify.",
      "dontClose": "Plis no close dis page",
      "autoVerify": "Yu payment a being verified automatically",
      "successOffline": "Tenkyu, {name}. Yu transaction bin record. La merchant offline now. Yu go get email wen la merchant come online an verify yu payment.",
      "successOnline": "Tenkyu, {name}. Yu payment of {amount} tru {provider} bin received an a being verified."
    },
    "features": {
      "no-code-website": [
        "Create an publish e-commerce, education, blog or news sites without coding.",
        "Example: publish a landing page an product post from la course seller dashboard."
      ],
      "custom-domain": [
        "Connect yu own domain an build wan professional digital identity wit faster routing.",
        "Example: yu store run on www.acme.com insted a platform subdomain."
      ],
      "capi": [
        "Sen server-side conversion event foh di server bloa tekem gud trak blong kampen.",
        "Example: wan purchase event go sent from la server to la ad platform."
      ],
      "personal-mfs": [
        "Mekem daa saported Personal MFS peyment verifikeshan ortermatic.",
        "Example: wan Personal MFS payment match wit la website order."
      ],
      "local-gateway": [
        "Connect local payment methods fi regional customers.",
        "Example: wan local buyer complete checkout tru a regional gateway."
      ],
      "international-gateway": [
        "Connect international payment methods fi customers worldwide.",
        "Example: wan overseas buyer complete checkout wit a global method."
      ],
      "notifications": [
        "Send payment an order updates to customers an merchants.",
        "Example: payment success trigger a merchant alert an customer update."
      ],
      "courier": [
        "Sen confirmed orders go insaed wan supported courier workflow otomatikli.",
        "Example: wan confirmed COD order prepare for courier handoff."
      ],
      "business-email": [
        "Send an receive professional email on yu own branded domain.",
        "Example: sales@acme.com receives inquiries an support@acme.com replies."
      ]
    }
  },
  "pov": {
    "checkout": {
      "liveInstruction": "Skreba metoda live, yega i konfirma e numero di konta ku bo ta envia dinhero for di e siguiente pagina. Un seshon live di 10 minutos lo kuminsá; manda dinhero durante ese seshon lo auto-verifiká e pago.",
      "trxInstruction": "Hasi Cash In na un tienda òf pidi otro hende pa Send Money. Despues auto-verifiká ku TrxID.",
      "enterNumberInstruction": "Drenta bo numero i klik '{action}'.",
      "offlineTitle": "Kishin di Komersiante Offline",
      "offlineDescription": "Auto-verifikashon ta no disponible momentáneamente.",
      "copyPersonal": "Kopia e numero di Personal Account riba.",
      "sendMoneyOffline": "Send Money of Cash In na e numero riba, òf pidi otro hende pa send'e plata.",
      "trxOffline": "Kolektá e TrxID i drenta dje abou. Ora e komersiante ta online, bo lo risibí un email, òf bo por kontaktá e komersiante diretamente.",
      "cashinNagad": "Cash In no ta permití na Nagad, asina por fabor Send Money for di otro cuenta Nagad.",
      "cashinOther": "Antes di Cash In, pidi na shopkeeper si nan lo duna bo TrxID; si no, no sigui ku e proseso. Alternativamente, pidi otro hende pa Send Money.",
      "waitTrx": "Despues di pago, spera 10–15 segundo i drenta e TrxID abou. Bo por sali di e pagina aki i bolbe na e pagina di pago den 24 ora pa auto-verifiká usa bo TrxID.",
      "goApp": "Bai na aplikashon di {provider} òf marcar {dialCode} i skohe 'Send Money'.",
      "confirmAuto": "Drenta e numero ku bo a kopia i e monto, despues konfirma ku bo PIN pa auto-verifiká.",
      "dontClose": "Por fabor no sera e pagina aki",
      "autoVerify": "Bo pago ta wordu verifiká automáticamente",
      "successOffline": "Masha danki, {name}. Bo transakshon a wordu rekòrdá. E komersiante ta offlain awor. Bo lo risibí un email ora e komersiante ta online i verifiká bo pago.",
      "successOnline": "Masha danki, {name}. Bo pago di {amount} via {provider} a wordu risibí i ta wordu verifiká."
    },
    "features": {
      "no-code-website": [
        "Krea i publika site di e-commerce, edukashon, blog of notisia sin kodigo.",
        "Ehemplo: publika un landing page i un product post for di dashboard di seller di kursu."
      ],
      "custom-domain": [
        "Konekta bo propio dominio i kreá un identidad digital profesional ku rutu mas rápido.",
        "Ehemplo: bo tienda ta keda na www.acme.com en vez di un subdominio di plataforma."
      ],
      "capi": [
        "Manda eventos di convershon server-side pa un medishon di kampaña mas konfiabel.",
        "Ehemplo: un evento di compra ta manda for di server na plataforma di ads."
      ],
      "personal-mfs": [
        "Automatisa verifikashon di pago Personal MFS ku ta soportá.",
        "Ehemplo: un pago Personal MFS ta koincidí ku e orden na website."
      ],
      "local-gateway": [
        "Konekta metodos di pago lokal pa klientenan regionál.",
        "Ehemplo: un buyer lokal ta kompletá e checkout via un gateway regional."
      ],
      "international-gateway": [
        "Konekta metodos di pago internacional pa klientenan mundialmente.",
        "Ehemplo: un buyer for di otro pais ta kompletá checkout ku un metodo global."
      ],
      "notifications": [
        "Manda actualisashon di pago i orden na klientenan i komersiante.",
        "Ehemplo: eksito den pago ta triga un alerta pa komersiante i un update pa klienta."
      ],
      "courier": [
        "Manda ordennan konfirmá automaticamente den workflow di courier ku ta soportá.",
        "Ehemplo: un orden COD konfirmá ta preparo pa pas'é ku courier."
      ],
      "business-email": [
        "Manda i risibí email profesional riba bo propio branded domain.",
        "Ehemplo: sales@acme.com ta risibí preguntanan i support@acme.com ta responde."
      ]
    }
  },
  "prs": {
    "checkout": {
      "liveInstruction": "روش زنده را انتخاب کنید، شماره حساب را که از آن پول می‌فرستید در صفحه بعد وارد و تأیید کنید. یک جلسه زنده ۱۰ دقیقه‌ای شروع می‌شود؛ ارسال پول در این مدت پرداخت را به‌صورت خودکار تأیید می‌کند.",
      "trxInstruction": "از یک فروشگاه Cash In کنید یا از شخص دیگری بخواهید Send Money کند. سپس با استفاده از TrxID پرداخت را به‌صورت خودکار تأیید کنید.",
      "enterNumberInstruction": "شمارهٔ خود را وارد کنید و دکمهٔ '{action}' را کلیک کنید.",
      "offlineTitle": "دستگاه فروشنده آفلاین است",
      "offlineDescription": "تأیید خودکار موقتا در دسترس نیست.",
      "copyPersonal": "شمارهٔ Personal Account بالارا کپی کنید.",
      "sendMoneyOffline": "Send Money یا Cash In را به شمارهٔ بالا انجام دهید، یا از شخص دیگری بخواهید پول بفرستد.",
      "trxOffline": "TrxID را دریافت کنید و آن را در زیر وارد کنید. وقتی فروشنده آنلاین شود، از طریق ایمیل به شما اطلاع داده خواهد شد، یا می‌توانید مستقیماً با فروشنده تماس بگیرید.",
      "cashinNagad": "Cash In در Nagad مجاز نیست، لطفاً Send Money را از یک حساب Nagad دیگر انجام دهید.",
      "cashinOther": "قبل از Cash In از فروشنده بپرسید که آیا TrxID را خواهد داد؛ اگر نه، ادامه ندهید. یا از شخص دیگری بخواهید Send Money کند.",
      "waitTrx": "پس از پرداخت، ۱۰–۱۵ ثانیه صبر کنید و TrxID را در زیر وارد کنید. می‌توانید این صفحه را ترک کرده و در هر زمان تا ۲۴ ساعت دوباره به همین صفحه پرداخت برگردید تا با TrxID خود تأیید خودکار انجام دهید.",
      "goApp": "به اپ {provider} بروید یا شماره {dialCode} را شماره‌گیری کرده و 'Send Money' را انتخاب کنید.",
      "confirmAuto": "شمارهٔ کپی‌شده و مقدار را وارد کنید، سپس با PIN خود تأیید کنید تا به‌صورت خودکار تأیید شود.",
      "dontClose": "لطفاً این صفحه را نبندید",
      "autoVerify": "پرداخت شما به‌صورت خودکار در حال تأیید است",
      "successOffline": "ممنون، {name}. تراکنش شما ثبت شد. فروشنده در حال حاضر آفلاین است. پس از آنلاین شدن فروشنده و تأیید پرداختتان، از طریق ایمیل مطلع خواهید شد.",
      "successOnline": "ممنون، {name}. پرداخت شما به میزان {amount} از طریق {provider} دریافت شد و در حال تأیید است."
    },
    "features": {
      "no-code-website": [
        "ایجاد و انتشار سایت‌های تجارت الکترونیک، آموزشی، بلاگ یا خبری بدون برنامه‌نویسی.",
        "مثال: انتشار یک صفحه فرود و پست محصول از داشبورد فروشندهٔ دوره."
      ],
      "custom-domain": [
        "دامنهٔ خود را متصل کنید و با مسیردهی سریع‌تر هویت دیجیتال حرفه‌ای بسازید.",
        "مثال: فروشگاه شما روی www.acme.com اجرا می‌شود به‌جای زیردامنهٔ پلتفرم."
      ],
      "capi": [
        "رویدادهای تبدیل را از سمت سرور ارسال کنید برای اندازه‌گیری کمپین قابل‌اعتماد.",
        "مثال: یک رویداد خرید از سرور به پلتفرم تبلیغاتی ارسال می‌شود."
      ],
      "personal-mfs": [
        "تأیید پرداخت‌های Personal MFS پشتیبانی‌شده را خودکار کنید.",
        "مثال: یک پرداخت Personal MFS با سفارش وب‌سایت تطابق داده می‌شود."
      ],
      "local-gateway": [
        "روش‌های پرداخت محلی را برای مشتریان منطقه‌ای متصل کنید.",
        "مثال: یک خریدار محلی پرداخت را از طریق درگاه منطقه‌ای تکمیل می‌کند."
      ],
      "international-gateway": [
        "روش‌های پرداخت بین‌المللی را برای مشتریان در سراسر جهان متصل کنید.",
        "مثال: یک خریدار خارجی پرداخت را با یک روش جهانی تکمیل می‌کند."
      ],
      "notifications": [
        "به‌روزرسانی‌های پرداخت و سفارش را برای مشتریان و فروشندگان ارسال کنید.",
        "مثال: موفقیت پرداخت باعث هشدار فروشنده و به‌روزرسانی مشتری می‌شود."
      ],
      "courier": [
        "سفارش‌های تأییدشده را به‌طور خودکار وارد جریان کاری courier پشتیبانی‌شده کنید.",
        "مثال: یک سفارش COD تأییدشده برای تحویل به courier آماده می‌شود."
      ],
      "business-email": [
        "ایمیل حرفه‌ای را روی دامنهٔ برند خود ارسال و دریافت کنید.",
        "مثال: sales@acme.com پرسش‌ها را دریافت می‌کند و support@acme.com پاسخ می‌دهد."
      ]
    }
  },
  "pus": {
    "checkout": {
      "liveInstruction": "د ژوند طریقه وټاکئ، په بله صفحه کې هغه د حساب شمېره داخل او تایید کړئ چې له هغې به پیسې واستوئ. د ۱۰ دقیقو ژوندۍ غونډه به پیل شي؛ په دې مهال د پیسو لیږد اتوماتیک تایید کوي.",
      "trxInstruction": "له دوکان څخه Cash In وکړئ یا بل څوک څخه وغواړئ چې Send Money وکړي. بیا د TrxID په کارولو سره اتوماتیک تایید وکړئ.",
      "enterNumberInstruction": "خپله شمېره داخل کړئ او د '{action}' تڼۍ کلیک وکړئ.",
      "offlineTitle": "د پلورونکي آله آفلاین ده",
      "offlineDescription": "خودکار تایید لنډمهاله شتون نلري.",
      "copyPersonal": "د Personal Account شمېره پورته کاپي کړئ.",
      "sendMoneyOffline": "Send Money یا Cash In دې پورته شمېري ته وکړئ، یا بلڅوک څخه وغواړئ چې پیسې واستوي.",
      "trxOffline": "TrxID راټول کړئ او لاندې یې داخل کړئ. کله چې پلورونکی آنلاین شي، تاسو به د ایمیل له لارې خبر شئ، یا مستقیم له پلورونکي سره اړیکه ونیسئ.",
      "cashinNagad": "Cash In په Nagad کې اجازه نشته، نو مهرباني وکړئ Send Money د بل Nagad حساب څخه ترسره کړئ.",
      "cashinOther": "د Cash In کولو مخکې له پلورنکي څخه وپوښتئ چې ایا دوی TrxID به درکړي؛ که نه، مه مخکې ځئ. بدیل دا چې بلڅوک څخه وغواړئ چې Send Money وکړي.",
      "waitTrx": "د تادیې وروسته ۱۰–۱۵ ثانیې انتظار وکړئ او لاندې TrxID داخل کړئ. تاسو کولی شئ له دې صفحې ووځئ او تر ۲۴ ساعتونو دننه هر وخت بیرته دې تادیې صفحې ته راشئ ترڅو د خپل TrxID په کارولو سره اتوماتیک تایید وکړئ.",
      "goApp": "{provider} اپ ته لاړ شئ یا {dialCode} وټاکئ او 'Send Money' انتخاب کړئ.",
      "confirmAuto": "کاپي شوې شمېره او مقدار داخل کړئ، بیا د خپل PIN سره تایید کړئ تر څو اتوماتیک تایید شي.",
      "dontClose": "مهرباني وکړئ دا صفحه مه بندهئ",
      "autoVerify": "ستاسو تادیه په اوتومات ډول تاییدېږي",
      "successOffline": "مننه، {name}. ستاسو تراکنش ثبت شو. پلورونکی اوس مهال آفلاین دی. کله چې پلورونکی آنلاین شي او ستاسو تادیه تایید کړي، تاسو ته د ایمیل له لارې خبر درکول کېږي.",
      "successOnline": "مننه، {name}. ستاسو تادیه د {amount} په اندازه د {provider} له لارې ترلاسه شوه او اوس تاییدېږي."
    },
    "features": {
      "no-code-website": [
        "د کود لیکلو پرته د ای-کامرس، زده کړې، بلاګ، یا خبر سایټونه جوړ او خپور کړئ.",
        "مثال: یو landing page او محصولي پوسټ د کورس پلورونکي داشبورډ څخه خپور کړئ."
      ],
      "custom-domain": [
        "خپل ډومین ونښلوئ او د چټک راوتینګ سره مسلکي ډیجیټل هویت جوړ کړئ.",
        "مثال: ستاسو پلورنځی پر www.acme.com پرمخ ځي، نه د پلاتفورم فرعي ډومین."
      ],
      "capi": [
        "د کمپاین د باوري اندازه ګیرۍ لپاره د سرور اړخ ته د بدلون پیښې واستوئ.",
        "مثال: د پیرود پیښه له سرور څخه اعلاناتي پلاتفورم ته لیږل کیږي."
      ],
      "personal-mfs": [
        "د ملاتړ شوي Personal MFS د پیسو تایید اتومات کړئ.",
        "مثال: د Personal MFS پیسې د ویب پاڼې سفارش سره تطبیق کیږي."
      ],
      "local-gateway": [
        "د سیمه ایزو پیرودونکو لپاره سیمه ایز تادیې میتودونه ونښلوئ.",
        "مثال: یو سیمه ایز خریدار د سیمه ایز دروازې له لارې checkout بشپړوي."
      ],
      "international-gateway": [
        "د نړۍوالو پیرودونکو لپاره نړیوال تادیې میتودونه ونښلوئ.",
        "مثال: یو بهرنی خریدار د نړیوالې میتود له لارې checkout بشپړوي."
      ],
      "notifications": [
        "د تادیې او سفارش تازه معلومات پیرودونکو او پلورونکو ته واستوئ.",
        "مثال: د تادیې بریالیتوب د پلورونکي خبرداری او د پیرودونکي تازه معلومات رامنځته کوي."
      ],
      "courier": [
        "تایید شوي فرمایشونه په اوتومات ډول په ملاتړ شوي courier کاري فلو کې واستوئ.",
        "مثال: یو تایید شوی COD فرمایش د courier سپارلو لپاره چمتو کیږي."
      ],
      "business-email": [
        "په خپل برانډډ ډومین کې مسلکي ایمیلونه واستوئ او ترلاسه کړئ.",
        "مثال: sales@acme.com پوښتنې ترلاسه کوي او support@acme.com ځواب ورکوي."
      ]
    }
  },
  "que": {
    "checkout": {
      "liveInstruction": "Pilihaykuy live metodomanta, qhipa pannintinpi apaykuymi ruwanakunapaq chaymi qillqaykuymi, chaymi ruwanakunata apaykuyku. Huk 10-minutu live rikhuymiqa willaykuchkan; ruwasqa waqtapi rikuykuchkanmi, manq'anaqa autoverify chaymi.",
      "trxInstruction": "Cash In ruwankichu tienda-manmi, chayqa mashuq runata p'idiykuy Send Money-chaspa. Chaymanta auto-verifiy-kanaykuy TrxID-nin.",
      "enterNumberInstruction": "Rikuy nimeroniykiwan qillqaykuy, chaymanta ch'askiy '{action}' botón.",
      "offlineTitle": "Merchant Q'ipiqa Offline",
      "offlineDescription": "Auto-verificaciónqa chaypim pasaykuchkanmi.",
      "copyPersonal": "Kopiyachiy Personal Account nimera rikhurqan.",
      "sendMoneyOffline": "Send Money ni Cash In-chispa chay rikhurqan nimera-man, chayqa p'idiykuy mashiq runa sendaykuy.",
      "trxOffline": "Rikhuy TrxID-nin, qhipa qillqay. Merchantqa online-ta rikhuykuchkasqa, email-chawan qillqaykuchkanki, ichaqa directaman merchantman rimanaykuyta qam ruwanki.",
      "cashinNagad": "Nagad-man Cash In mana kaptinqa, chaymi apaykuy Send Money nispa otra Nagad account-manta.",
      "cashinOther": "Cash In-manqa, p'idiykuy tienda-wan rimanaykuy TrxID-rikunata ruwanankunata; if noqa, mana rikuy. Hukmi alternativoqa p'idiykuy mashiq runa Send Money-chaspa.",
      "waitTrx": "Pagarpas, 10–15 segundoqpaq kapuykuy, chaymanta qhipa qillqay TrxID-nin. Manaqa chay paginaman mataq rikhuriychu, chayniykutaqa 24 oraspiqa kachkan, chaymanta auto-verify nisqanta ruwakuykuy TrxID-nin.",
      "goApp": "Pimuy {provider} app-pi ni llamay {dialCode} nispa, chaymanta «Send Money» nispa rikhuy.",
      "confirmAuto": "Kopiyachiy nimera hamuq kashqa chaymi, chaymanta cantidad-nin qillqaykuy, PIN wan confirmaykuypa autoverify kachkanmi.",
      "dontClose": "Ama chinkaychu chay pagina-nata",
      "autoVerify": "Qamrampi pagoqa autoverify kasqa",
      "successOffline": "Gracias, {name}. Qampaq transaksyonka registrachkan. Merchantqa chayllaqa offline. Merchant online-ta riqsichiykuchkasqa, email-chawan yanapachkanki chay ruwana rikhuriyta verifikachiykuchkanku.",
      "successOnline": "Gracias, {name}. Qampaq pago {amount} {provider} nispa kaykunaqa rikuchkaku, chaymanta verifikachkanmi."
    },
    "features": {
      "no-code-website": [
        "Manam qillqaychu kodita rimanakuyta, rikch'aykuy e-commerce, yachay, blog ni qillqakunata publish ruwachiy.",
        "Ejemplo: landing page ni product post nisqawan publish ruwachiy course seller dashboard-mantapuni."
      ],
      "custom-domain": [
        "Rikunapaq domain-ni churaykuy, profesional digital identidad ruwanaykuy, chaymanta llapa rutanakunata yachayman kamachiy.",
        "Ejemplo: qampaq tiendaqa www.acme.com-pi ruwachkan, platform subdomain-man mana."
      ],
      "capi": [
        "Conversion eventos-nata server-pi purikuy ruwanaykuy, kampaña-manta chaskiy aptaqa.",
        "Ejemplo: purchase eventoqa server-manta ad platform-pi ruwanapiq."
      ],
      "personal-mfs": [
        "Automatizay verifychiy Personal MFS pagos nisqata, mana willkasqa ruwachiy.",
        "Ejemplo: personal MFS pagoqa website order-man match chaskiy."
      ],
      "local-gateway": [
        "Rikunachiy local payment metodos regional customers-man.",
        "Ejemplo: local buyerqa checkoutqa regional gateway-manta riray."
      ],
      "international-gateway": [
        "Rikunachiy international payment metodos global customers-man.",
        "Ejemplo: overseas buyerqa checkoutqa global method-manta riray."
      ],
      "notifications": [
        "Pago-ni order updates-nata customers-man merchants-manta ruwanaykuy.",
        "Ejemplo: pago exitoqa merchant alert ni customer update nispa willakuy."
      ],
      "courier": [
        "Confirmed ordenman courier workflow support-chawan autoy ruwanaykuy.",
        "Ejemplo: confirmed COD ordenqa courier handoff nispa preparay."
      ],
      "business-email": [
        "Profesional email-nata qampaq brand domain-man hina pichaykuy sendi ruwanaykuy kiyuq.",
        "Ejemplo: sales@acme.com consultaqkunata riksichiy, support@acme.com rurasqanta jawab ruwanchik."
      ]
    }
  },
  "rar": {
    "checkout": {
      "liveInstruction": "Tīpiri i te ara ora, tomo e ravea rā e tau pūkete ka tuku koe i te moni i te whārangi muri. Ka tīmata te hui ora 10-meneti; ka tuku moni i taua wā ka whakamana aunoa i te utu.",
      "trxInstruction": "Cash In i te toa, peera rā, ui atu kia tētahi atu kia Send Money. Ka whakamana aunoa mā te whakamahi i te TrxID.",
      "enterNumberInstruction": "Tomo i tō tau, ka pā te pātene '{action}'.",
      "offlineTitle": "Pūrere Kaihoko Kua Kore I Runga I Te Ipurangi",
      "offlineDescription": "Kāore te whakamana aunoa e wātea mō te wā poto.",
      "copyPersonal": "Tārua te tau o te Personal Account kei runga.",
      "sendMoneyOffline": "Send Money rānei Cash In ki te tau kei runga, me te ui ki tētahi atu kia send money māna.",
      "trxOffline": "Kohikohia te TrxID ka tomo i raro nei. Ina hoki ka puta te kaihoko i runga ipurangi, ka whakamohiotia koe mā te īmēra, rānei ka whakapā tōtika ki te kaihoko.",
      "cashinNagad": "Kāore e whakaaetia te Cash In i Nagad, no reira tēnā, Send Money mai i tētahi atu pūkete Nagad.",
      "cashinOther": "I mua i te Cash In, pātai ki te kairēti mēnā ka whakarato rātou i te TrxID; ki te kore, kaua e anga whakamua. Ētahi atu kōwhiringa, ui ki tētahi atu kia Send Money.",
      "waitTrx": "I muri i te utu, tatari 10–15 hēkona ka tomo i te TrxID i raro. Ka taea e koe te wehe i tēnei whārangi, ka hoki mai anō i ngā wā katoa i roto i te 24 haora kia whakamana aunoa mā tō TrxID.",
      "goApp": "Haere ki te taupānga {provider} rānei tīpako {dialCode} ka kōwhiri 'Send Money'.",
      "confirmAuto": "Tomo i te tau kua tāruatia me te moni, ka whakamanahia mā tō PIN kia whakamana aunoa.",
      "dontClose": "Kāore e tino pai kia kati i tēnei whārangi",
      "autoVerify": "Kei te whakamana aunoa i tō utu",
      "successOffline": "Ngā mihi, {name}. Kua rekohetia tō whakawhitinga. Kei te kore i runga ipurangi te kaihoko i tēnei wā. Ka whakamōhiotia koe mā te īmēra ka hoki mai te kaihoko ki runga ipurangi kia whakamana i tō utu.",
      "successOnline": "Ngā mihi, {name}. Kua riro tō utu {amount} mā {provider} ā, kei te whakamanahia inaianei."
    },
    "features": {
      "no-code-website": [
        "Hanga tō pae hokohoko, mātauranga, rangitaki, rānei pae rongoānō me te kore e tuhi waehere.",
        "Tauira: whakaputa he whārangi taki (landing page) me tētahi pou hua mai i te papatohu kaituaki akoranga."
      ],
      "custom-domain": [
        "Whakakotahitia tō ake ingoa rohe (domain) kia hanga ai he tuakiri matihiko ngaio me te rerenga tere ake.",
        "Tauira: kei te whakahaere tō toa i runga i www.acme.com hei utu i tētahi subdomain o te papa."
      ],
      "capi": [
        "Tukua ngā tānga hurihuri (conversion events) mai i te tūmau kia kitea ai ngā ine kaupapa pakari.",
        "Tauira: ka tukuna tētahi tānga hoko mai i te tūmau ki te papa pānui."
      ],
      "personal-mfs": [
        "Aunoa te whakamana i ngā utu Personal MFS tautokona.",
        "Tauira: ka ōrite tētahi utu Personal MFS ki te ota paetukutuku."
      ],
      "local-gateway": [
        "Whakakotahitia ngā tikanga utu ā-rohe mō ngā kiritaki ā-rohe.",
        "Tauira: ka whakaoti tētahi kaihoko ā-rohe i te tiro hoko ma te kuaha ā-rohe."
      ],
      "international-gateway": [
        "Whakakotahitia ngā tikanga utu ā-ao mō ngā kiritaki i te ao katoa.",
        "Tauira: ka whakaoti tētahi kaihoko o tāwāhi i te tiro hoko mā tētahi tikanga ao."
      ],
      "notifications": [
        "Tukua ngā whakahōutanga utu me ngā ota ki ngā kiritaki me ngā kaihoko.",
        "Tauira: ka akiaki te angitū utu i tētahi whakatūpato kaihoko me tētahi whakahōutanga kiritaki."
      ],
      "courier": [
        "Tukua ngā ota kua whakamanahia ki te mahi kuriā tautokona aunoa.",
        "Tauira: ka whakaritea tētahi ota COD kua whakamanahia kia tukuna ki te kuriā."
      ],
      "business-email": [
        "Tukua ka whiwhi īmēra ngaio i runga i tō ake rohe tohu (branded domain).",
        "Tauira: ka whiwhi pātai a sales@acme.com ka utu ai support@acme.com."
      ]
    }
  },
  "roh": {
    "checkout": {
      "liveInstruction": "Tschaivla la metoda live, metta ed entrar e confermar il numer da conto da nua vus ans far sin la pagina proxim. Ina 10 minutas sessiun live cumenza; trametter daners durant quella sesiun vegn verifitgà automaticamain il pajament.",
      "trxInstruction": "Far Cash In d'in butia u dumandar ad in'otra persuna da Send Money. Suenter verifitgescha automaticamain cun il TrxID.",
      "enterNumberInstruction": "Enter tai numer e clicca sin il buttun '{action}'.",
      "offlineTitle": "Apparat dal merchanta offline",
      "offlineDescription": "La verifitgar auto na è betg disponibla temporarmain.",
      "copyPersonal": "Copia il numer dal Personal Account scrit survart.",
      "sendMoneyOffline": "Send Money u Cash In sin il numer survart, u dumanda ad in'autra persuna da send money.",
      "trxOffline": "Racunai il TrxID e entrar quel qua sut. Cura ch'il merchanta vegn online vegnirai avisà per email, u ti pos s'engaschar direct cun il merchanta.",
      "cashinNagad": "Cash In n'è betg lubì en Nagad, perquai per plaschair Send Money d'in auter conto Nagad.",
      "cashinOther": "Avant Cash In dumonda il vendider sch'el porscha il TrxID; schi na, na cuntinuescha betg. U ramass a in'otra persuna per Send Money.",
      "waitTrx": "Suenter il pajament spetta 10–15 secundas e enterscha il TrxID sut. Ti pos chalar questa pagina e returnar ad ella en qualsiasi mumain entaifer 24 uras per verifitgar automaticamain cun tia TrxID.",
      "goApp": "Va en l'app da {provider} u laja {dialCode} e tscherna 'Send Money'.",
      "confirmAuto": "Entra il numer copià e la summa, suenter conferma cun tia PIN per verifitgar automaticamain.",
      "dontClose": "Per plaschair na clera betg questa pagina",
      "autoVerify": "Tes pajament vegn verifitgà automaticamain",
      "successOffline": "Grazia fich, {name}. Tia transacziun è vegnida registrada. Il merchanta è actualmain offline. Ti vegnias avisà per email suenter ch'il merchanta vegn online e verifitgescha tes pajament.",
      "successOnline": "Grazia fich, {name}. Ties pajament da {amount} tras {provider} è vegnì recepi e vegn verifitgà."
    },
    "features": {
      "no-code-website": [
        "Crear e publichar sitgs d'e-commerce, educaziun, blog u novitads senza scriver code.",
        "Exempel: publitgar ina pagina d'atterrament e in post da product dal painel dal selar dal curs."
      ],
      "custom-domain": [
        "Collegar tes agen domain e construir ina identitad digital professiunala cun rutaziuns pli sveltas.",
        "Exempel: tes butia funcziuna sin www.acme.com invezi ch'ina subdomain da la plattafuorma."
      ],
      "capi": [
        "Trametter events da conversion server-side per ina mesiraziun da campagna fidabla.",
        "Exempel: in event d'acquist vegn tramess dal server tar la plattafuorma da publicitad."
      ],
      "personal-mfs": [
        "Automatisar la verifitgar da pagaments Personal MFS sustegnì.",
        "Exempel: in pagament Personal MFS vegn cumparà cun l'orden dal website."
      ],
      "local-gateway": [
        "Collegar metodas da pajaments localas per clients regiunals.",
        "Exempel: in cumprader local cumplettescha il checkout tras in gateway regiunale."
      ],
      "international-gateway": [
        "Collegar metodas da pajaments internaziunalas per clients sin l'entir mund.",
        "Exempel: in cumprader da l'exteriur cumplettescha il checkout cun ina metoda globala."
      ],
      "notifications": [
        "Trametter actualisaziuns da pajaments e orders a clients e merchantas.",
        "Exempel: il success da pajament spertga in signal al merchanta e in update al client."
      ],
      "courier": [
        "Trametter orders confermadas en in workflow da courier sustegnì automaticamain.",
        "Exempel: in order COD confermà vegn preparà per la passaziun al courier."
      ],
      "business-email": [
        "Trametter e survegnir mail professiunals sin tes agen domain brandà.",
        "Exempel: sales@acme.com survegn dumondas e support@acme.com respunda."
      ]
    }
  },
  "ron": {
    "checkout": {
      "liveInstruction": "Selectați metoda live, introduceți și confirmați numărul contului de pe care veți trimite bani pe pagina următoare. O sesiune live de 10 minute va începe; trimiterea banilor în acest interval va verifica plata automat.",
      "trxInstruction": "Faceți Cash In dintr-un magazin sau rugați pe altcineva să Send Money. Apoi verificați automat folosind TrxID.",
      "enterNumberInstruction": "Introduceți numărul dvs. și faceți click pe butonul '{action}'.",
      "offlineTitle": "Dispozitivul comerciantului este offline",
      "offlineDescription": "Verificarea automată nu este disponibilă temporar.",
      "copyPersonal": "Copiați numărul Personal Account de mai sus.",
      "sendMoneyOffline": "Trimiteți Send Money sau Cash In la numărul de mai sus, sau rugați pe altcineva să trimită bani.",
      "trxOffline": "Colectați TrxID și introduceți-l mai jos. Când comerciantul va fi online, veți fi notificat prin e-mail, sau puteți contacta comerciantul direct.",
      "cashinNagad": "Cash In nu este permis în Nagad, deci vă rugăm să Send Money dintr-un alt cont Nagad.",
      "cashinOther": "Înainte de Cash In, întrebați vânzătorul dacă vă va oferi TrxID; dacă nu, nu continuați. Alternativ, rugați pe altcineva să Send Money.",
      "waitTrx": "După plată, așteptați 10–15 secunde și introduceți TrxID mai jos. Puteți părăsi această pagină și reveni la această pagină de plată în orice moment în 24 de ore pentru a verifica automat folosind TrxID-ul dvs.",
      "goApp": "Mergeți la aplicația {provider} sau formați {dialCode} și selectați 'Send Money'.",
      "confirmAuto": "Introduceți numărul copiat și suma, apoi confirmați cu PIN-ul pentru a verifica automat.",
      "dontClose": "Vă rugăm să nu închideți această pagină",
      "autoVerify": "Plata dumneavoastră este verificată automat",
      "successOffline": "Mulțumim, {name}. Tranzacția dvs. a fost înregistrată. Comercianul este în prezent offline. Veți fi notificat prin e-mail după ce comerciantul va veni online și va verifica plata.",
      "successOnline": "Mulțumim, {name}. Plata dvs. de {amount} prin {provider} a fost primită și este în curs de verificare."
    },
    "features": {
      "no-code-website": [
        "Creați și publicați site-uri de e-commerce, educație, blog sau știri fără codare.",
        "Exemplu: publicați o pagină de destinație și o postare de produs din panoul vânzătorului cursului."
      ],
      "custom-domain": [
        "Conectați-vă propriul domeniu și construiți o identitate digitală profesională cu rutare mai rapidă.",
        "Exemplu: magazinul dvs. rulează pe www.acme.com în loc de un subdomeniu al platformei."
      ],
      "capi": [
        "Trimiteți evenimente de conversie server-side pentru o măsurare fiabilă a campaniilor.",
        "Exemplu: un eveniment de cumpărare este trimis de la server către platforma de reclame."
      ],
      "personal-mfs": [
        "Automatizați verificarea plăților Personal MFS acceptate.",
        "Exemplu: o plată Personal MFS este potrivită cu comanda de pe site."
      ],
      "local-gateway": [
        "Conectați metode locale de plată pentru clienții regionali.",
        "Exemplu: un cumpărător local finalizează checkout-ul printr-un gateway regional."
      ],
      "international-gateway": [
        "Conectați metode internaționale de plată pentru clienți din întreaga lume.",
        "Exemplu: un cumpărător din străinătate finalizează checkout-ul cu o metodă globală."
      ],
      "notifications": [
        "Trimiteți actualizări despre plăți și comenzi către clienți și comercianți.",
        "Exemplu: succesul plății declanșează un alert pentru comerciant și o actualizare pentru client."
      ],
      "courier": [
        "Trimiteți comenzile confirmate într-un flux de lucru courier suportat automat.",
        "Exemplu: o comandă COD confirmată este pregătită pentru predare curierului."
      ],
      "business-email": [
        "Trimiteți și primiți email profesional pe propriul domeniu branduit.",
        "Exemplu: sales@acme.com primește cereri și support@acme.com răspunde."
      ]
    }
  },
  "uzb": {
    "checkout": {
      "liveInstruction": "Keyingi sahifada jonli usulni tanlang, yuboriladigan hisob raqamini kiriting va tasdiqlang. 10 daqiqalik jonli sessiya boshlanadi; bu vaqt ichida pul yuborilsa toʻlov avtomatik tekshiriladi.",
      "trxInstruction": "Doʻkondan Cash In qiling yoki boshqa birovdan Send Money soʻrang. Soʻng TrxID yordamida avtomatik tasdiqlang.",
      "enterNumberInstruction": "Raqamingizni kiriting va '{action}' tugmasini bosing.",
      "offlineTitle": "Sotuvchi qurilmasi oflayn",
      "offlineDescription": "Avtomatik tasdiqlash vaqtincha mavjud emas.",
      "copyPersonal": "Yuqoridagi Personal Account raqamini nusxa oling.",
      "sendMoneyOffline": "Yuqoridagi raqamga Send Money yoki Cash In qiling, yoki boshqa birovdan pul yuborishini soʻrang.",
      "trxOffline": "TrxID ni oling va quyiga kiriting. Sotuvchi onlaynga oʻtganda sizga email orqali xabar yuboriladi yoki toʻgʻridan-toʻgʻri sotuvchi bilan bogʻlanishingiz mumkin.",
      "cashinNagad": "Nagadda Cash In ruxsat etilmagan, shuning uchun iltimos boshqa Nagad hisobidan Send Money qiling.",
      "cashinOther": "Cash In qilishdan oldin doʻkon egasidan ular TrxID taqdim etadimi soʻrang; agar yoʻq boʻlsa, davom etmang. Yoki boshqa birovdan Send Money soʻrang.",
      "waitTrx": "Toʻlovdan soʻng 10–15 soniya kutib, quyiga TrxID ni kiriting. Siz ushbu sahifani 24 soat ichida istalgan vaqtda tark etib, TrxID bilan avtomatik tasdiqlash uchun qaytishingiz mumkin.",
      "goApp": "{provider} ilovasiga oʻting yoki {dialCode} raqamini terib 'Send Money' ni tanlang.",
      "confirmAuto": "Nusxalangan raqam va summani kiriting, so‘ng avtomatik tasdiqlash uchun PIN-kodingiz bilan tasdiqlang.",
      "dontClose": "Iltimos, ushbu sahifani yopmang.",
      "autoVerify": "Sizning toʻlovingiz avtomatik tarzda tekshirilmoqda",
      "successOffline": "Rahmat, {name}. Sizning tranzaksiyangiz qayd etildi. Sotuvchi hozirda oflayn. Sotuvchi onlayn boʻlib toʻlovni tasdiqlagach, sizga email orqali xabar yuboriladi.",
      "successOnline": "Rahmat, {name}. {provider} orqali yuborilgan {amount} miqdoridagi toʻlov qabul qilindi va tasdiqlanmoqda."
    },
    "features": {
      "no-code-website": [
        "Kod yozmasdan e‑tijorat, taʼlim, blog yoki yangiliklar saytlarini yarating va nashr qiling.",
        "Misol: kurs sotuvchisi boshqaruv panelidan landing sahifa va mahsulot postini nashr qiladi."
      ],
      "custom-domain": [
        "Oʻz domeningizni ulang va tezroq yoʻnaltirish bilan professional raqamli identifikator yarating.",
        "Misol: doʻkoningiz platforma subdomeni oʻrniga www.acme.com manzilida ishlaydi."
      ],
      "capi": [
        "Ishonchli reklama kampaniyalarini o‘lchash uchun conversion (konversiya) eventlarini server tomonida yuboring.",
        "Misol: xarid voqeasi serverdan reklam platformasiga yuboriladi."
      ],
      "personal-mfs": [
        "Qoʻllab‑quvvatlanadigan Personal MFS toʻlovlarini avtomatlashtirilgan tarzda tasdiqlang.",
        "Misol: personal MFS toʻlovi veb‑saytdagi buyurtma bilan mos keladi."
      ],
      "local-gateway": [
        "Mintaqaviy mijozlar uchun mahalliy toʻlov usullarini ulang.",
        "Misol: mahalliy xaridor mintaqaviy gateway orqali checkoutni yakunlaydi."
      ],
      "international-gateway": [
        "Dunyo boʻylab mijozlar uchun xalqaro toʻlov usullarini ulang.",
        "Misol: chet eldan buyurtma beruvchi global usul orqali checkoutni yakunlaydi."
      ],
      "notifications": [
        "Mijozlar va sotuvchilarga toʻlov va buyurtma yangiliklarini yuboring.",
        "Misol: toʻlov muvaffaqiyatli boʻlganda sotuvchiga ogohlantirish va mijozga yangilanish yuboriladi."
      ],
      "courier": [
        "Tasdiqlangan buyurtmalarni qoʻllab‑quvvatlanadigan kurer ish oqimiga avtomatik yuboring.",
        "Misol: tasdiqlangan COD buyurtma kurer topshirigʻi uchun tayyorlanadi."
      ],
      "business-email": [
        "Oʻz brendingiz domenida professional email joʻnatish va qabul qilishni yoqing.",
        "Misol: sales@acme.com soʻrovlarni qabul qiladi va support@acme.com javob beradi."
      ]
    }
  },
  "ven": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Vhala na u sumbedza ma-site a e-commerce, u guda, blog kana mutsiko wa vhukuma zwi songo shuma khodi.",
        "sumbedza landing page na product post u bva kha seller dashboard ya muvhengi wa course."
      ],
      "custom-domain": [
        "Konektisa domain yau na u lwa na tshileme tsha digital tsha professional nga u kona u fhindula nga vhukuma.",
        "store yau i khou tshimbidza kha www.acme.com khwine ho tou dovha hafhu ho vha na platform subdomain."
      ],
      "capi": [
        "Tumisela conversion events server-side u ita uri u engetelela u vhidziwa ha campaign zwi tou lavhelekela.",
        "purchase event i tumelwa u bva kha server iya kha ad platform."
      ],
      "personal-mfs": [
        "Shandulula u vhona zwikonelelo zwa Personal MFS payment zwine zwa tsireledzwa.",
        "Personal MFS payment i thedela na website order."
      ],
      "local-gateway": [
        "Konektisa zwimelo zwa payment zwa ndeme kha vhatevheli vha khondo ya inwi.",
        "muthengesi wa nga vhone a dovha a ita checkout nga regional gateway."
      ],
      "international-gateway": [
        "Konektisa zwimelo zwa payment zwa shango hone hafhu kha vhatevheli vha shango linyalo.",
        "muthengesi wa khandanelaho u ita checkout nga method ya tshitshavha tsha shango."
      ],
      "notifications": [
        "Tumisela zwikhouḓo zwa payment na update dza order kha vhatevheli na vahandisi.",
        "payment success i khumba alert ya merchant na update ya muthengesi."
      ],
      "courier": [
        "Tumisela order dza fhethu dzi khou vhambedza kha courier workflow ine ya tsireledzwa nga u fhindula nga vha tshifhinga.",
        "confirmed COD order i khou bviswa ro vha ro lugiswa u ya courier."
      ],
      "business-email": [
        "Tumisela na u wana imeili dza professional kha domain yau ya branded.",
        "sales@acme.com i khou wana inquiries naho support@acme.com i tshi vhala mibvele."
      ]
    }
  },
  "xho": {
    "checkout": {
      "liveInstruction": "Khetha indlela ephilayo, faka kwaye uqinisekise inombolo ye-akhawunti oya kuthumela kuyo imali kwiphepha elilandelayo. Kuya kuqala iseshoni ephilayo yemizuzu eyi-10; ukuthumela imali ngexesha layo kuya kuqinisekisa intlawulo ngokuzenzekelayo.",
      "trxInstruction": "Yenza Cash In kwivenkile okanye cela omnye umntu ukuba enze Send Money. Emva koko qinisekisa ngokuzenzekelayo usebenzisa TrxID.",
      "enterNumberInstruction": "Faka inombolo yakho uze ucofe iqhosha elithi '{action}'.",
      "offlineTitle": "Isixhobo somthengisi asinayo i-intanethi",
      "offlineDescription": "Ukuqinisekiswa ngokuzenzekelayo akukhoyo okwexeshana.",
      "copyPersonal": "Kopa inombolo ye-Personal Account engentla.",
      "sendMoneyOffline": "Yenza Send Money okanye Cash In kunombolo engentla, okanye cela omnye umntu ukuba athumele imali.",
      "trxOffline": "Qokelela iTransaction ID (TrxID) uze uyifake ngezantsi. Xa umthengisi ekwi-intanethi, uza kwaziswa nge-imeyile, okanye unokunxibelelana ngqo nomthengisi.",
      "cashinNagad": "Cash In ayivumelekanga kuNagad, ngoko nceda wenze Send Money ukusuka kwenye i-akhawunti yeNagad.",
      "cashinOther": "Ngaphambi kwe-Cash In, buza umthengisi ukuba uza kunika i-TrxID; ukuba hayi, musa ukuqhubeka. Okanye cela omnye umntu ukuba enze Send Money.",
      "waitTrx": "Emva kokuhlawula, linda imizuzwana eyi-10–15 uze ufake i-TrxID ngezantsi. Unokushiya eli phepha uye kwelo xesha uze ubuyele naliphi na ixesha phakathi kweeyure ezili-24 ukuze uqinisekise ngokuzenzekelayo usebenzisa iTrxID yakho.",
      "goApp": "Ngena kwi {provider} app okanye shaya {dialCode} uze ukhethe 'Send Money'.",
      "confirmAuto": "Faka inombolo nemali owukopileyo, uze uqinisekise nge-PIN yakho ukuze kuqinisekiswe ngokuzenzekelayo.",
      "dontClose": "Nceda ungavaleli leli phepha.",
      "autoVerify": "Intlawulo yakho iya kuqinisekiswa ngokuzenzekelayo",
      "successOffline": "Enkosi, {name}. Uthengiselwano lwakho lugcinwe. Umthengisi okweli xesha akwi-intanethi. Uza kwaziswa nge-imeyile xa umthengisi engena kwi-intanethi aze aqinisekise intlawulo yakho.",
      "successOnline": "Enkosi, {name}. Intlawulo yakho eyi-{amount} nge-{provider} yamkelwe kwaye iya kuqinisekiswa."
    },
    "features": {
      "no-code-website": [
        "Yakha kwaye ushicilele iiwebhusayithi ze-e-commerce, imfundo, iblog, okanye iindaba ngaphandle kokubhala ikhowudi.",
        "Umzekelo: shicilela iphepha lokufika (landing page) kunye nenkcazo yemveliso ukusuka kwidashboard yomthengisi wekhosi."
      ],
      "custom-domain": [
        "Qhagamshela idomain yakho kwaye wakhe inkangeleko yedijithali enobungcali ngokuhamba okukhawulezayo.",
        "Umzekelo: isitore sakho sisebenza ku-www.acme.com endaweni yesubdomain yeqonga."
      ],
      "capi": [
        "Thumela i-conversion events nge-server ukuze kufezekiswe ukulinganiswa okuzinzileyo kwemikhankaso.",
        "Umzekelo: isiganeko sokuthenga sithunyelwa kuseva siya kwiqonga leentengiso."
      ],
      "personal-mfs": [
        "Zenzele ngokuzenzekelayo ukuqinisekiswa kweetyala ze-Personal MFS ezixhaswayo.",
        "Umzekelo: intlawulo ye-Personal MFS iyahambelana nento oyiyalelayo kwiwebhusayithi."
      ],
      "local-gateway": [
        "Qhagamshela iindlela zokuhlawula zengingqi kubathengi bendawo.",
        "Umzekelo: umthengi wengingqi ugqiba i-checkout nge-regional gateway."
      ],
      "international-gateway": [
        "Qhagamshela iindlela zokuhlawula zamazwe ngamazwe kubathengi behlabathi lonke.",
        "Umzekelo: umthengi ongaphandle kwezwe ugqiba i-checkout ngendlela ye-global."
      ],
      "notifications": [
        "Thumela izaziso zentlawulo kunye nezaziso zokuyalela kubathengi nasemthengisini.",
        "Umzekelo: impumelelo yokuhlawula iqalisa isilumkiso kumthengisi kunye nokubuyekezwa kumthengi."
      ],
      "courier": [
        "Thumela ngokuzenzekelayo ama-odolo aqinisekisiweyo kwinkqubo yokusebenza yekhuriya exhaswayo.",
        "Umzekelo: i-ODer ye-COD eqinisekisiweyo ilungiselelwa ukudluliselwa kukhuriya."
      ],
      "business-email": [
        "Thumela kwaye wamkele i-imeyile yobungcali kwidomain yakho yophawu.",
        "Umzekelo: sales@acme.com ifumana imibuzo kwaye support@acme.com iphendula."
      ]
    }
  },
  "zdj": {
    "checkout": {
      "liveInstruction": "Sélectionnez la méthode live, saisissez et confirmez le numéro de compte à partir duquel vous enverrez l'argent sur la page suivante. Une session live de 10 minutes commencera ; l'envoi d'argent pendant cette période vérifiera automatiquement le paiement.",
      "trxInstruction": "Faites un Cash In depuis un magasin ou demandez à quelqu'un d'autre de Send Money. Puis vérifiez automatiquement en utilisant le Transaction ID (TrxID).",
      "enterNumberInstruction": "Saisissez votre numéro et cliquez sur le bouton '{action}'.",
      "offlineTitle": "Appareil du commerçant hors ligne",
      "offlineDescription": "La vérification automatique est temporairement indisponible.",
      "copyPersonal": "Copiez le numéro de Personal Account ci‑dessus.",
      "sendMoneyOffline": "Effectuez un Send Money ou un Cash In vers le numéro ci‑dessus, ou demandez à quelqu'un d'autre d'envoyer de l'argent.",
      "trxOffline": "Récupérez le Transaction ID (TrxID) et saisissez‑le ci‑dessous. Lorsque le commerçant sera en ligne, vous serez notifié par email, ou vous pouvez contacter le commerçant directement.",
      "cashinNagad": "Le Cash In n'est pas autorisé sur Nagad, veuillez donc Send Money depuis un autre compte Nagad.",
      "cashinOther": "Avant le Cash In, demandez au commerçant s'il fournira le TrxID ; si non, ne procédez pas. Alternativement, demandez à quelqu'un d'autre de Send Money.",
      "waitTrx": "Après le paiement, attendez 10–15 secondes et saisissez le TrxID ci‑dessous. Vous pouvez quitter cette page et revenir à cette page de paiement à tout moment dans les 24 heures pour vérifier automatiquement en utilisant votre TrxID.",
      "goApp": "Allez dans l'application {provider} ou composez {dialCode} et sélectionnez 'Send Money'.",
      "confirmAuto": "Saisissez le numéro copié et le montant, puis confirmez avec votre PIN pour vérifier automatiquement.",
      "dontClose": "Veuillez ne pas fermer cette page",
      "autoVerify": "Votre paiement est en cours de vérification automatique",
      "successOffline": "Merci, {name}. Votre transaction a été enregistrée. Le commerçant est actuellement hors ligne. Vous serez notifié par email après que le commerçant sera en ligne et aura vérifié votre paiement.",
      "successOnline": "Merci, {name}. Votre paiement de {amount} via {provider} a été reçu et est en cours de vérification."
    },
    "features": {
      "no-code-website": [
        "Créez et publiez des sites e‑commerce, éducatifs, de blog ou d'actualités sans coder.",
        "Exemple : publiez une page d'atterrissage et une fiche produit depuis le tableau de bord du vendeur de cours."
      ],
      "custom-domain": [
        "Connectez votre propre domaine et construisez une identité digitale professionnelle avec un routage plus rapide.",
        "Exemple : votre boutique fonctionne sur www.acme.com au lieu d'un sous‑domaine de la plateforme."
      ],
      "capi": [
        "Envoyez des événements de conversion côté serveur pour une mesure de campagne fiable.",
        "Exemple : un événement d'achat est envoyé depuis le serveur vers la plateforme publicitaire."
      ],
      "personal-mfs": [
        "Automatisez la vérification des paiements Personal MFS pris en charge.",
        "Exemple : un paiement Personal MFS est associé à la commande du site web."
      ],
      "local-gateway": [
        "Connectez des méthodes de paiement locales pour des clients régionaux.",
        "Exemple : un acheteur local termine le paiement via une passerelle régionale."
      ],
      "international-gateway": [
        "Connectez des méthodes de paiement internationales pour des clients du monde entier.",
        "Exemple : un acheteur étranger finalise le checkout avec une méthode globale."
      ],
      "notifications": [
        "Envoyez des mises à jour de paiement et de commande aux clients et commerçants.",
        "Exemple : le succès d'un paiement déclenche une alerte pour le commerçant et une mise à jour pour le client."
      ],
      "courier": [
        "Envoyez automatiquement les commandes confirmées dans un flux de travail de coursier pris en charge.",
        "Exemple : une commande COD confirmée est préparée pour la remise au coursier."
      ],
      "business-email": [
        "Envoyez et recevez des emails professionnels sur votre propre domaine de marque.",
        "Exemple : sales@acme.com reçoit les demandes et support@acme.com répond."
      ]
    }
  },
  "zib": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Create and publish e-commerce, education, blog, or news sites without coding.",
        "Example: publish a landing page and product post from the course seller dashboard."
      ],
      "custom-domain": [
        "Connect your own domain and build a professional digital identity with faster routing.",
        "Example: your store runs on www.acme.com instead of a platform subdomain."
      ],
      "capi": [
        "Send conversion events server-side for reliable campaign measurement.",
        "Example: a purchase event is sent from the server to the ad platform."
      ],
      "personal-mfs": [
        "Automate supported personal MFS payment verification.",
        "Example: a personal MFS payment is matched to the website order."
      ],
      "local-gateway": [
        "Connect local payment methods for regional customers.",
        "Example: a local buyer completes checkout through a regional gateway."
      ],
      "international-gateway": [
        "Connect international payment methods for customers worldwide.",
        "Example: an overseas buyer completes checkout with a global method."
      ],
      "notifications": [
        "Send payment and order updates to customers and merchants.",
        "Example: payment success triggers a merchant alert and customer update."
      ],
      "courier": [
        "Send confirmed orders into a supported courier workflow automatically.",
        "Example: a confirmed COD order is prepared for courier handoff."
      ],
      "business-email": [
        "Send and receive professional email on your own branded domain.",
        "Example: sales@acme.com receives inquiries and support@acme.com replies."
      ]
    }
  },
  "zul": {
    "checkout": {
      "liveInstruction": "Khetha indlela ebukhoma, faka futhi uqinisekise inombolo ye-akhawunti ozoyithumela kuyo imali ekhasini elilandelayo. Kuzoqala iseshini ebukhoma yamaminithi angu-10; ukuthumela imali phakathi naleso sikhathi kuzokwenza ukuthi inkokhelo iqinisekiswe ngokuzenzakalelayo.",
      "trxInstruction": "Yenza Cash In esitolo noma cela omunye umuntu ukuba enze Send Money. Bese uqinisekisa ngokuzenzakalelayo usebenzisa i-TrxID.",
      "enterNumberInstruction": "Faka inombolo yakho bese uchofoza inkinobho ethi '{action}'.",
      "offlineTitle": "Idivayisi yomthengisi ayixhunyiwe",
      "offlineDescription": "Ukuqinisekiswa okuzenzakalelayo okwamanje akutholakali.",
      "copyPersonal": "Kopisha inombolo ye-Personal Account engenhla.",
      "sendMoneyOffline": "Thumela imali (Send Money) noma wenze Cash In kunombolo engenhla, noma cela omunye umuntu ukuthi athumele imali.",
      "trxOffline": "Qoqa i-Transaction ID (TrxID) bese uyifaka ngezansi. Lapho umthengisi ese-inthanethi, uzokwaziswa nge-imeyili, noma ungaxhumana nomthengisi ngqo.",
      "cashinNagad": "Cash In akuvunyelwe ku-Nagad, ngakho sicela wenze Send Money kusuka kwenye i-akhawunti ye-Nagad.",
      "cashinOther": "Ngaphambi kokwenza i-Cash In, buza umthengisi ukuthi uzohlinzeka nge-TrxID; uma cha, ungayiqhubeki. Okunye, cela omunye umuntu ukuba enze Send Money.",
      "waitTrx": "Ngemva kokukhokha, linda imizuzwana engu-10–15 bese ufaka i-TrxID ngezansi. Ungashiya leli khasi ubuyela kulo nganoma yisiphi isikhathi phakathi kwamahora angu-24 ukuze uqinisekise ngokuzenzakalelayo usebenzisa i-TrxID yakho.",
      "goApp": "Iya kuhlelo lokusebenza {provider} noma shaya {dialCode} bese ukhetha 'Send Money'.",
      "confirmAuto": "Faka inombolo nenani olikopile, bese uqinisekisa nge-PIN yakho ukuze kuqinisekiswe ngokuzenzakalelayo.",
      "dontClose": "Sicela ungavaleli leli khasi",
      "autoVerify": "Inkokhelo yakho iyaqinisekiswa ngokuzenzakalelayo",
      "successOffline": "Ngiyabonga, {name}. Ukuthengiselana kwakho kuqoshiwe. Umthengisi okwamanje akaxhunyiwe. Uzokwaziswa nge-imeyili ngemva kokuthi umthengisi exhumekile futhi aqinisekise inkokhelo yakho.",
      "successOnline": "Ngiyabonga, {name}. Inkokhelo yakho engu-{amount} nge-{provider} yamukelwe futhi iyaqinisekiswa."
    },
    "features": {
      "no-code-website": [
        "Yakha futhi ushicilele amawebhusayithi e-commerce, emfundo, amabhulogi, noma wezindaba ngaphandle kokubhala ikhodi.",
        "Isibonelo: shicilela ikhasi lokufika (landing page) kanye nesikhangiso somkhiqizo kusuka kumphathi wokuthengisa wekhosi."
      ],
      "custom-domain": [
        "Xhuma idomain yakho futhi wakhe ubunikazi bedijithali obuchwepheshe ngokudluliswa okusheshayo.",
        "Isibonelo: isitolo sakho sisebenza ku-www.acme.com esikhundleni se-subdomain ye-platform."
      ],
      "capi": [
        "Thumela imicimbi yokuguqulwa (conversion events) ngase-server ukuze ulinganise imikhankaso ngendlela ethembekile.",
        "Isibonelo: umcimbi wokuthenga uthunyelwa kuseva uye ephulatifomu yezikhangiso."
      ],
      "personal-mfs": [
        "Zenzele ngokuzenzakalelayo ukuqinisekiswa kokukhokha kwe-Personal MFS okuxhaswayo.",
        "Isibonelo: ukukhokha kwe-Personal MFS kuhlotshaniswa ne-oda lewebhusayithi."
      ],
      "local-gateway": [
        "Xhuma izindlela zendawo zokukhokha zama-khasimende endaweni yangakini.",
        "Isibonelo: umthengi wendawo uqeda i-checkout nge-regional gateway."
      ],
      "international-gateway": [
        "Xhuma izindlela zokukhokha zamazwe ngamazwe kubathengi emhlabeni wonke.",
        "Isibonelo: umthengi ongaphandle kwezwe uqeda i-checkout ngendlela yomhlaba wonke."
      ],
      "notifications": [
        "Thumela izaziso zokukhokha nezama-oda kumakhasimende nakubathengisi.",
        "Isibonelo: impumelelo yokukhokha ivuselela isexwayiso kumthengisi nokubuyekezwa kumkhasimende."
      ],
      "courier": [
        "Thumela ngokuzenzakalelayo ama-oda aqinisekisiwe ohlelweni lomsebenzi lwekuriya oluxhaswayo.",
        "Isibonelo: i-oda ye-COD eqinisekisiwe ilungiselelwa ukuthunyelwa kukhuriya."
      ],
      "business-email": [
        "Thumela futhi wamukele i-imeyili yobungcweti kudomain yakho yophawu.",
        "Isibonelo: sales@acme.com imukela imibuzo futhi support@acme.com iphendula."
      ]
    }
  },
  "run": {
    "checkout": {
      "liveInstruction": "Hitamwo uburyo bwa live, andika kandi wemeze nomero y'akuntee uzoherezamwo amafaranga ku rupapuro rukurikira. Isesiyo ya live izotangura iminota 10; kohereza amafaranga muri iyo gihe bizohita byemezwa.",
      "trxInstruction": "Gira Cash In mw'iduka canke usabe uwundi muntu akore Send Money. Hanyuma wemeze ukoresheje Transaction ID (TrxID).",
      "enterNumberInstruction": "Injiza nomero yawe hanyuma ukande kuri bouton '{action}'.",
      "offlineTitle": "Igikoresho c'umucuruzi kiri Offline",
      "offlineDescription": "Kwemezwa kwa auto ntibiboneka muri iki gihe.",
      "copyPersonal": "Koporora nomero ya Personal Account iri hejuru.",
      "sendMoneyOffline": "Kora Send Money canke Cash In kuri nomero iri hejuru, canke usabe uwundi muntu kohereza amafaranga.",
      "trxOffline": "Kura Transaction ID (TrxID) hanyuma uyandike hasi. Iyo umucuruzi azokongera kuba online, uzohabwa ubutumwa kuri email, canke urashobora kuvugana n'umucuruzi mu buryo butaziguye.",
      "cashinNagad": "Cash In ntiyemewe muri Nagad, rero nyamuneka kora Send Money ukoresheje konti ya Nagad itandukanye.",
      "cashinOther": "Mbere ya Cash In, bwira umucuruzi niba azotanga TrxID; niba atabishobora, ntukomeze. Ikindi, saba uwundi muntu gukora Send Money.",
      "waitTrx": "Nyuma yo kwishyura, tegereza amasegonda 10–15 hanyuma winjize TrxID hasi. Urashobora kuva kuri uru rupapuro ukagaruka kuri uru rupapuro rw'ubwishinwa mu masaha 24 kugira ngo ukore kwemeza ukoresheje TrxID yawe.",
      "goApp": "Jya muri porogaramu ya {provider} canke hamagara {dialCode} hanyuma uhitemo 'Send Money'.",
      "confirmAuto": "Injiza umubare wakopeye n'ikiguzi, hanyuma wemeze ukoresheje PIN yawe kugira ngo byemezwe mu buryo bwikora.",
      "dontClose": "Ndakwinginze ntushe uru rupapuro.",
      "autoVerify": "Kwishura kwawe kuriko kurahabwa kwemezwa ako kanya.",
      "successOffline": "Urakoze, {name}. Iyandikwa ry'igikorwa ryawe ryakozwe. Umucuruzi ubu ari offline. Uzohabwa ubutumwa kuri email igihe umucuruzi azoba online maze akemeze kwishyura kwawe.",
      "successOnline": "Urakoze, {name}. Kwishyura kwawe kwa {amount} ukoresheje {provider} kwakiriwe kandi kuriko kurahabwa kwemezwa."
    },
    "features": {
      "no-code-website": [
        "Hanga kandi usohore imbuga z'ubucuruzi, ivyigisho, blog canke amakuru utarinze kwandika code.",
        "Urugero: usohora urupapuro rwa landing na post y'igicuruzwa ukoresheje dashboard y'umucuruzi."
      ],
      "custom-domain": [
        "Huzagura domain yawe bwite kandi wubake indangamuntu ya digital ifise routing yihuta.",
        "Urugero: iduka ryawe rikora kuri www.acme.com aho kuba kuri subdomain ya platform."
      ],
      "capi": [
        "Ohereza conversion events kuri server kugira ugire uburyo bwizewe bwo gupima campagne.",
        "Urugero: igikorwa cyo kugura giterwa kuva kuri server kijana ku rubuga rwamamaza."
      ],
      "personal-mfs": [
        "Automatisa kwemezwa kwishyurwa kwa Personal MFS gushigikiwe.",
        "Urugero: kwishyurwa kwa Personal MFS guhuzwa n'itegeko ry'uru rubuga."
      ],
      "local-gateway": [
        "Hurashe uburyo bw'ubwishinwa bw'akarere ku bakiriya b'akarere.",
        "Urugero: umukiriya wo mu karere ararangiza checkout ukoresheje gateway y'akarere."
      ],
      "international-gateway": [
        "Hugura uburyo bw'ubwishinwa mpuzamahanga ku bakiriya bo ku isi yose.",
        "Urugero: umukiriya wo mu mahanga ararangiza checkout ukoresheje uburyo mpuzamahanga."
      ],
      "notifications": [
        "Ohereza amakuru y'ubwishinwa n'ibimenyesho ku bakiriya n'abacuruzi.",
        "Urugero: kwemeza kw'ubwishinwa bitera ubutumwa ku mucuruzi n'ikibandanyo ku mukiriya."
      ],
      "courier": [
        "Ohereza amadosiye yemejwe mu nzira ya courier yishyigikiwe ubwayo.",
        "Urugero: itegeko rya COD ryemejwe ritegurwa ngo ryoherezwe kuri courier."
      ],
      "business-email": [
        "Ohereza kandi uronka email y'umwuga ukoresheje domain yawe yanditse.",
        "Urugero: sales@acme.com irakiriye ubusabe kandi support@acme.com isubiza."
      ]
    }
  },
  "sag": {
    "checkout": {
      "liveInstruction": "Ködö na live bî ti, zâ na tôkö na konfîmê na numéro akun bâ ti ngbâsä na so. Live session ti 10 minutî; kömbâ na sommon na session wâ na auto-verify pagî na païment.",
      "trxInstruction": "Fâ Cash In na magaïnga na ani bî kêtê na Send Money. Lâ na konfîmê na Transaction ID (TrxID).",
      "enterNumberInstruction": "Lê na numéro mo na kanda '{action}'.",
      "offlineTitle": "Appareyî na mucirièr offline",
      "offlineDescription": "Auto-verify ti bântê mo.",
      "copyPersonal": "Kòpî na numéro Personal Account na sô.",
      "sendMoneyOffline": "Ködö Send Money ô Cash In na numéro sô, ô fâ na mbi na kömbâ na sommon.",
      "trxOffline": "Tâ Transaction ID (TrxID) na wè na tî na ïsi. Sâna mucirièr bae online, i zâ yê tî na email, ô we kêndâ na mucirièr ti trực tiếp.",
      "cashinNagad": "Cash In ti kêtê na Nagad, lo ké, fâ Send Money na rekening Nagad mô tasâ.",
      "cashinOther": "Kambê Cash In, tî na mayâ na magaïnga sâ na kêtê TrxID; sâ ni, tî kêtê. Kana, tî na mbi na fâ Send Money.",
      "waitTrx": "Banda na païment, tèndê 10–15 sekondi na vê TrxID na ïsi. I pâ na lâ na page yâ ti na rétour na page ya païment na bâ 24 ora na auto-verify na TrxID mo.",
      "goApp": "Tâ na app ya {provider} ô hâma {dialCode} na sêkselekte 'Send Money'.",
      "confirmAuto": "Tanga numéro ti kopiye na montant ti kopiye, kéta na konfirmé na PIN na yo pou vérification automatique.",
      "dontClose": "Mbi, ti mêtê page yâ.",
      "autoVerify": "Païment mo na konto na ti na vérifikâ na auto.",
      "successOffline": "Mersi, {name}. Transaction mo na enregistré. Mucirièr bâ offline. I zâ tî na email qui mucirièr bae online na vérifi païment mo.",
      "successOnline": "Mersi, {name}. Païment mo {amount} na {provider} zâ reçu na ti na vérifikâ."
    },
    "features": {
      "no-code-website": [
        "Yângâ na publîshi site e-commerce, éducation, blog ô news sans code.",
        "Exemple: publîshi landing page na produit post na dashboard vendeur du cours."
      ],
      "custom-domain": [
        "Konekta domain mo na bâ propre ô bâ bâtî identité digitale professionnelle avec routage plus rapide.",
        "Exemple: boutique mo na www.acme.com au lieu na sous-domaine plateforme."
      ],
      "capi": [
        "Envoye conversion events côté serveur pour mesure fiab de campagne.",
        "Exemple: evento d'achat envoyé du serveur au plate-forme publicitaire."
      ],
      "personal-mfs": [
        "Automatisa vérification païment Personal MFS supporté.",
        "Exemple: païment Personal MFS correspond au commande site web."
      ],
      "local-gateway": [
        "Konekta méthodes locales de paiement pour clients régionaux.",
        "Exemple: acheteur local termine checkout via gateway régional."
      ],
      "international-gateway": [
        "Konekta méthodes internationales pour clients mondiaux.",
        "Exemple: acheteur étranger termine checkout via méthode globale."
      ],
      "notifications": [
        "Envoye mises à jour de paiement et commande aux clients et marchands.",
        "Exemple: succès de paiement déclenche alerte marchand et mise à jour client."
      ],
      "courier": [
        "Envoye commandes confirmées dans workflow courier supporté automatiquement.",
        "Exemple: commande COD confirmée préparée pour remise au courier."
      ],
      "business-email": [
        "Envoye et reçois email professionnel sur domaine de marque.",
        "Exemple: sales@acme.com reçoit demandes et support@acme.com répond."
      ]
    }
  },
  "slk": {
    "checkout": {
      "liveInstruction": "Vyberte režim live, zadajte a potvrďte číslo účtu, z ktorého budete posielať peniaze, na nasledujúcej stránke. Spustí sa 10-minútová živá relácia; posielanie peňazí počas nej spôsobí automatické overenie platby.",
      "trxInstruction": "Urobte Cash In v obchode alebo požiadajte niekoho iného, aby vykonal Send Money. Potom sa automaticky overí pomocou Transaction ID (TrxID).",
      "enterNumberInstruction": "Zadajte svoje číslo a kliknite na tlačidlo '{action}'.",
      "offlineTitle": "Zariadenie obchodníka offline",
      "offlineDescription": "Automatické overenie je dočasne nedostupné.",
      "copyPersonal": "Skopírujte vyššie uvedené číslo Personal Account.",
      "sendMoneyOffline": "Vykonajte Send Money alebo Cash In na uvedené číslo, alebo požiadajte niekoho iného, aby poslal peniaze.",
      "trxOffline": "Získajte Transaction ID (TrxID) a zadajte ho nižšie. Keď obchodník bude online, budete upozornení e-mailom, alebo môžete obchodníka kontaktovať priamo.",
      "cashinNagad": "Cash In nie je povolený v Nagad, preto prosím vykonajte Send Money z iného účtu Nagad.",
      "cashinOther": "Pred Cash In sa opýtajte predavača, či poskytne TrxID; ak nie, nepokračujte. Alternatívne požiadajte niekoho iného, aby vykonal Send Money.",
      "waitTrx": "Po platbe počkajte 10–15 sekúnd a zadajte TrxID nižšie. Túto stránku môžete opustiť a vrátiť sa na ňu kedykoľvek do 24 hodín, aby ste vykonali automatické overenie pomocou svojho TrxID.",
      "goApp": "Prejdite do aplikácie {provider} alebo vytočte {dialCode} a vyberte 'Send Money'.",
      "confirmAuto": "Zadajte skopírované číslo a sumu, potom potvrďte svojím PIN kódom pre automatické overenie.",
      "dontClose": "Prosím, nezatvárajte túto stránku",
      "autoVerify": "Vaša platba sa automaticky overuje",
      "successOffline": "Ďakujeme, {name}. Váš prevod bol zaznamenaný. Obchodník je momentálne offline. Budete e-mailom informovaní, keď obchodník bude online a overí vašu platbu.",
      "successOnline": "Ďakujeme, {name}. Vaša platba vo výške {amount} cez {provider} bola prijatá a je overovaná."
    },
    "features": {
      "no-code-website": [
        "Vytvorte a publikujte e‑commerce, vzdelávacie, blogové alebo spravodajské weby bez písania kódu.",
        "Príklad: publikujte landing page a produktový príspevok z dashboardu predajcu kurzu."
      ],
      "custom-domain": [
        "Pripojte vlastnú doménu a vytvorte profesionálnu digitálnu identitu s rýchlejším smerovaním.",
        "Príklad: váš obchod beží na www.acme.com namiesto subdomény platformy."
      ],
      "capi": [
        "Odosielajte konverzné udalosti zo servera pre spoľahlivé meranie kampaní.",
        "Príklad: udalosti nákupu sa posielajú zo servera na reklamnú platformu."
      ],
      "personal-mfs": [
        "Automatizujte overovanie platieb Personal MFS, ktoré sú podporované.",
        "Príklad: platba Personal MFS je spárovaná s objednávkou na webe."
      ],
      "local-gateway": [
        "Pripojte lokálne platobné metódy pre regionálnych zákazníkov.",
        "Príklad: miestny kupujúci dokončí pokladňu cez regionálnu bránu."
      ],
      "international-gateway": [
        "Pripojte medzinárodné platobné metódy pre zákazníkov po celom svete.",
        "Príklad: zahraničný kupujúci dokončí pokladňu globálnou metódou."
      ],
      "notifications": [
        "Odosielajte aktualizácie platieb a objednávok zákazníkom a obchodníkom.",
        "Príklad: úspech platby spustí upozornenie obchodníkovi a informáciu zákazníkovi."
      ],
      "courier": [
        "Automaticky posielajte potvrdené objednávky do podporovaného kuriérskeho workflow.",
        "Príklad: potvrdená COD objednávka je pripravená na odovzdanie kuriérovi."
      ],
      "business-email": [
        "Posielajte a prijímajte profesionálne e-maily na vlastnej značkovej doméne.",
        "Príklad: sales@acme.com prijíma dopyty a support@acme.com odpovedá."
      ]
    }
  },
  "slv": {
    "checkout": {
      "liveInstruction": "Izberite način 'live', vnesite in potrdite številko računa, s katerega boste na naslednji strani pošiljali denar. Začne se 10-minutna seja v živo; pošiljanje denarja med sejo bo samodejno preverilo plačilo.",
      "trxInstruction": "Naredite Cash In pri trgovini ali prosite nekoga drugega, naj izvede Send Money. Nato se samodejno preveri z uporabo Transaction ID (TrxID).",
      "enterNumberInstruction": "Vnesite svojo številko in kliknite gumb '{action}'.",
      "offlineTitle": "Trgovčeva naprava je brez povezave",
      "offlineDescription": "Samodejno preverjanje trenutno ni na voljo.",
      "copyPersonal": "Kopirajte zgornjo številko Personal Account.",
      "sendMoneyOffline": "Pošljite Send Money ali Cash In na zgornjo številko ali prosite nekoga drugega, naj pošlje denar.",
      "trxOffline": "Pridobite Transaction ID (TrxID) in ga vnesite spodaj. Ko bo trgovec spet na spletu, boste obveščeni po e-pošti ali se lahko neposredno obrnete na trgovca.",
      "cashinNagad": "Cash In ni dovoljen pri Nagad, zato prosimo izvedite Send Money z drugega Nagad računa.",
      "cashinOther": "Pred Cash In povprašajte trgovca, ali bo zagotovil TrxID; če ne, ne nadaljujte. Alternativno prosite nekoga drugega, naj izvede Send Money.",
      "waitTrx": "Po plačilu počakajte 10–15 sekund in vnesite TrxID spodaj. To stran lahko zapustite in se nanjo vrnete kadarkoli v 24 urah, da samodejno preverite s svojim TrxID.",
      "goApp": "Pojdite v aplikacijo {provider} ali pokličite {dialCode} in izberite 'Send Money'.",
      "confirmAuto": "Vnesite kopirano številko in znesek, nato potrdite s svojo PIN-kodo za samodejno preverjanje.",
      "dontClose": "Prosimo, ne zapirajte te strani",
      "autoVerify": "Vaše plačilo se samodejno preverja",
      "successOffline": "Hvala, {name}. Vaša transakcija je bila zabeležena. Trgovec je trenutno brez povezave. Obvestili vas bomo po e-pošti, ko bo trgovec spet na spletu in preveril vaše plačilo.",
      "successOnline": "Hvala, {name}. Vaše plačilo v višini {amount} preko {provider} je bilo prejeto in je v postopku preverjanja."
    },
    "features": {
      "no-code-website": [
        "Ustvarite in objavite e-trgovino, izobraževalne, blog ali novičarske strani brez programiranja.",
        "Primer: objavite pristajalno stran in objavo izdelka iz nadzorne plošče prodajalca tečaja."
      ],
      "custom-domain": [
        "Povežite svojo domeno in zgradite profesionalno digitalno identiteto z bolj hitrim usmerjanjem.",
        "Primer: vaša trgovina deluje na www.acme.com namesto na poddomeni platforme."
      ],
      "capi": [
        "Pošljite konverzijske dogodke na strežnik za zanesljivo merjenje kampanj.",
        "Primer: dogodek nakupa se pošlje s strežnika na oglaševalsko platformo."
      ],
      "personal-mfs": [
        "Avtomatizirajte preverjanje plačil Personal MFS, ki so podprta.",
        "Primer: plačilo Personal MFS je ujemeno z naročilom na spletnem mestu."
      ],
      "local-gateway": [
        "Povežite lokalne načine plačila za regionalne stranke.",
        "Primer: lokalni kupec zaključi blagajno prek regionalne prehoda."
      ],
      "international-gateway": [
        "Povežite mednarodne načine plačila za stranke po vsem svetu.",
        "Primer: tuji kupec zaključi blagajno z globalno metodo."
      ],
      "notifications": [
        "Pošljite obvestila o plačilih in naročilih strankam in trgovcem.",
        "Primer: uspeh plačila sproži obvestilo trgovcu in posodobitev za stranko."
      ],
      "courier": [
        "Samodejno pošljite potrjena naročila v podprti kurirski potek dela.",
        "Primer: potrjeno COD naročilo je pripravljeno za predajo kurirju."
      ],
      "business-email": [
        "Pošiljanje in prejemanje profesionalne e-pošte na lastni blagovni domeni.",
        "Primer: sales@acme.com prejme povpraševanja in support@acme.com odgovori."
      ]
    }
  },
  "smi": {
    "checkout": {
      "liveInstruction": "Válgát live-muđđi, geavvát ja vahkki kontu­nummu mii don boađát vástádusat ovddas. Live-sessuvdna háliiduvvo 10 minuhta; rievdaduvvon rahpat geat dás eanetšat dieđusáiggiin resultta auto-verify.",
      "trxInstruction": "Dávvudat Cash In beapmámus vai buktit ovttas ja geavahit Send Money. Dasa máŋga auto-verify Transaction ID (TrxID) vuođul.",
      "enterNumberInstruction": "Geavvát numberi ja klikkat '{action}'-buttón.",
      "offlineTitle": "Bargguidge apparáhta offline",
      "offlineDescription": "Auto-verify ii leat daddjo dál.",
      "copyPersonal": "Koppi Personal Account-numberi mii lea gillii.",
      "sendMoneyOffline": "Geavvát Send Money dahje Cash In gillii numberii, vai geavvát álggahus ovttas dálgeguin.",
      "trxOffline": "Gaskat Transaction ID (TrxID) ja geavvát soames. Gos bargguide lea online, donnan ealáskahttit e-poasta, vai leat joatkkat barggádit čuovgga.",
      "cashinNagad": "Cash In ii leat vel Nagad, don galgá geavvahit Send Money mainnačuovgga Nagad-konttastin.",
      "cashinOther": "Eanet Cash In, bukta barggá geavvát dihtii maid don boađehaš TrxID; jos ii, ii leiddu. Vai geavvát álggahus ovttas máŋga Send Money.",
      "waitTrx": "Maššát rahpa, várri 10–15 sekundda ja geavvát TrxID ovdal. Don sáhtát leavehtit dáss-ja eai ja boađehttit dál ovdal 24 diimmuidekkohti, man auto-verify sáhttá geavahit TrxID.",
      "goApp": "Gat {provider}-appis vai dálla {dialCode} ja váldde 'Send Money'.",
      "confirmAuto": "Vástidit kopierea nummára ja summu, de potvrđet PIN-ášat dálvvo automahttalaš ovttadit.",
      "dontClose": "Ii lahka dássat lávet",
      "autoVerify": "Dittu rahpa lea automatalaččat vuođđun",
      "successOffline": "Giitu, {name}. Doaibma dihtii lea guovddášuvvan. Bargguidde lea dábálaš offline. Don boađehiid e-poasta gielddit go bargguidde lea online ja vérifisere rahpa.",
      "successOnline": "Giitu, {name}. Doaibma dihtii {amount} via {provider} leat váldán ja leat vérifiseret."
    },
    "features": {
      "no-code-website": [
        "Gahit ja publiser e‑commerce, education, blog dahje news-saitat ilbmi koodadit mii vaiššun.",
        "Dát eanet: publiser landing-page ja produktpost dahká dashboard kursa vara."
      ],
      "custom-domain": [
        "Connecta du domaiin ja byggat professionála digital identitehta maid leat fastare routing.",
        "Dát eanet: du shop bargá oaidná www.acme.com istit platform subdomain."
      ],
      "capi": [
        "Sendu conversion events server-side dakkárstuvvon kampanjemái.",
        "Dát eanet: purchase-event boađe serveristte ad-platforma."
      ],
      "personal-mfs": [
        "Automatisea supported Personal MFS-báhču verifikašuvdna.",
        "Dát eanet: Personal MFS-báhču lea matched maŋŋil web-ordera."
      ],
      "local-gateway": [
        "Connecta lokála payment-metodat regionála customera.",
        "Dát eanet: lokal buyer dahkat checkout girjii regional gateway."
      ],
      "international-gateway": [
        "Connecta internationála payment-metodat customera buot birra.",
        "Dát eanet: overseas buyer dahkat checkout global method."
      ],
      "notifications": [
        "Sendu payment ja order-uppdateringa customera ja merchantta.",
        "Dát eanet: payment-success váldá merchant-alert ja customer-update."
      ],
      "courier": [
        "Sendu confirmed orders i supported courier workflow automatalaččat.",
        "Dát eanet: confirmed COD-order lea gearvvuhttán courier-handover."
      ],
      "business-email": [
        "Sendu ja receive professional e‑mail du branded domainis.",
        "Dát eanet: sales@acme.com receive enquiries ja support@acme.com deaddji."
      ]
    }
  },
  "smo": {
    "checkout": {
      "liveInstruction": "Filifili le auala ola, ulufale ma faamau le numera teugatupe o le a e lafoina mai ai tupe i le itulau sosoo. O le a amata se taimi ola e 10 minute; o le lafoina o tupe i lena taimi o le a otometi ai ona faʻamaonia le totogi.",
      "trxInstruction": "Fai Cash In i le faleoloa poʻo fesili i se isi e faia le Send Money. Ona otometi lea ona faʻamaonia faʻaaogaina le Transaction ID (TrxID).",
      "enterNumberInstruction": "Ulufale lau numera ma kiliki le ki '{action}'.",
      "offlineTitle": "Mea faigaluega a le faufale ua le talia i le initoneti",
      "offlineDescription": "O le faʻamaoniga otometi e le maua i le taimi nei.",
      "copyPersonal": "Kopi le numera o le Personal Account i luga.",
      "sendMoneyOffline": "Fai Send Money poʻo Cash In i le numera i luga, poʻo fesili i se isi e lafoina tupe.",
      "trxOffline": "Aoina le Transaction ID (TrxID) ma ulufale i lalo. A o le faufale ua toe iai i luga ole initoneti, o le a lafoina atu se imeli i le auiliiliga, pe e mafai ona e faʻafesoʻotaʻi saʻo le faufale.",
      "cashinNagad": "E le talia le Cash In i Nagad, o lea faʻamolemole faia Send Money mai se isi teugatupe Nagad.",
      "cashinOther": "Aʻo leʻi fai Cash In, fesili i le faioloa pe o le a tuuina mai e latou le TrxID; afai leai, aua le faʻaauau. Poʻo le isi, fesili se isi e faia le Send Money.",
      "waitTrx": "Ina ua uma le totogi, faatali 10–15 sekone ma ulufale le TrxID i lalo. E mafai ona e tuua lenei itulau ma toe foi i soo se taimi i totonu o le 24 itula e otometi ai ona faʻamaonia faʻaaogaina lau TrxID.",
      "goApp": "Alu i le app a le {provider} poʻo telefoni i le {dialCode} ma filifili 'Send Money'.",
      "confirmAuto": "Ulufale le numera ma le aofaʻi na e kopiina, ona faʻamaonia ma lau PIN e otometi ai le siaki.",
      "dontClose": "Fa'amolemole aua e tapuni lenei itulau",
      "autoVerify": "O lau totogi o lo'o fa'amaonia otometi",
      "successOffline": "Fa'afetai, {name}. Ua fa'amauina lau fefa'ataua'iga. O lo'o le talia i le initoneti le faioloa i le taimi nei. O le a e logoina e ala i le imeli pe a toe iai i luga ole initoneti le faioloa ma faʻamaonia lau totogi.",
      "successOnline": "Fa'afetai, {name}. Ua taliaina lau totogi o le {amount} e ala i {provider} ma o lo'o fa'amaonia."
    },
    "features": {
      "no-code-website": [
        "Fausia ma fa'apublish 'site' e-commerce, a'oa'oga, blog, po'o tala e aunoa ma le tusia o code.",
        "Fa'ata'ita'iga: fa'apublish se landing page ma se pou o oloa mai le dashboard o le tagata fa'atau ta'aloga."
      ],
      "custom-domain": [
        "Fesoʻotaʻi lau lava domain ma fausia se faʻailoga numera fa'apolofesa ma faʻasalalauga vave.",
        "Fa'ata'ita'iga: o lau faleoloa e fa'agaoioia i le www.acme.com nai lo se subdomain o le tulaga."
      ],
      "capi": [
        "Auina atu conversion events i le server-side mo fua mautinoa o le taua o le kampeni.",
        "Fa'ata'ita'iga: o se mea na faʻatau atu e auina mai i le server i le tulaga fa'asalalauga."
      ],
      "personal-mfs": [
        "Fa'autometi le faʻamaoniga totogi a Personal MFS e lagolagoina.",
        "Fa'ata'ita'iga: o se totogi Personal MFS e fetaui ma le oka i le upega tafa'ilagi."
      ],
      "local-gateway": [
        "Fesoʻotaʻi metotia totogi lotoifale mo tagata faʻaoga i le itumalo.",
        "Fa'ata'ita'iga: o se tagata fa'atau lotoifale e fa'ataunu'u le siaki i le ala o le faitotoa lotoifale."
      ],
      "international-gateway": [
        "Fesoʻotaʻi metotia totogi faavaomalo mo tagata faʻatau i le lalolagi atoa.",
        "Fa'ata'ita'iga: o se tagata fa'atau i fafo e fa'ataunu'u le siaki ma se metotia lalolagi."
      ],
      "notifications": [
        "Auina mai fa'afouga totogi ma oka i tagata fa'atau ma faufale.",
        "Fa'ata'ita'iga: o le manuia o le totogi e liliu i se faʻasilasilaga i le faufale ma se faʻafouga i le tagata faʻatau."
      ],
      "courier": [
        "Auina otometi oka faʻamaonia i se faiga suʻesuʻe courier lagolagoina.",
        "Fa'ata'ita'iga: o se oka COD faʻamaonia ua saunia mo le tufatufaina atu i le courier."
      ],
      "business-email": [
        "Auina ma maua imeli faʻapolofesa i lau lava domain faʻailoga.",
        "Fa'ata'ita'iga: sales@acme.com maua fesili ma support@acme.com tali atu."
      ]
    }
  },
  "sna": {
    "checkout": {
      "liveInstruction": "Sarudza nzira ye live, pinda uye simbisa nhamba yeakaunti yaunenge uchatumira mari kubva papeji rinotevera. Musangano we live uchatanga kwemaminetsi gumi; kutumira mari panguva yacho kuchaita kuti kubhadhara kuongororwe otomatiki.",
      "trxInstruction": "Ita Cash In kuchitoro kana kukumbira mumwe munhu kuti aite Send Money. Zvadaro ongorora otomatiki uchishandisa Transaction ID (TrxID).",
      "enterNumberInstruction": "Pinda nhamba yako wobva wadzvanya bhatani '{action}'.",
      "offlineTitle": "Chishandiso chemutengesi chiri Offline",
      "offlineDescription": "Kuongororwa kwe auto hakuchawanikwe kwechinguvana.",
      "copyPersonal": "Kopa nhamba ye Personal Account iri pamusoro.",
      "sendMoneyOffline": "Tumira Send Money kana Cash In kunhamba iri pamusoro, kana kukumbira mumwe munhu kuti atumire mari.",
      "trxOffline": "Tora Transaction ID (TrxID) woipinza pasi. Kana mutengesi ava online, uchaziviswa neemail, kana unogona kusangana nemutengesi zvakananga.",
      "cashinNagad": "Cash In haigamuchirwi mu Nagad, saka ndapota ita Send Money kubva kune imwe Nagad account.",
      "cashinOther": "Usati waita Cash In, bvunza muridzi wechitoro kana vachazopa TrxID; kana vasina, usarega kuenderera. Kana zvimwe, bvunza mumwe munhu kuti aite Send Money.",
      "waitTrx": "Pashure pekubhadhara, mirira masekondi 10–15 woisa TrxID pazasi. Unogona kusiya peji iri wozoidzoka chero nguva mukati memaawa 24 kuti uongorore otomatiki uchishandisa TrxID yako.",
      "goApp": "Enda kuapp ye {provider} kana fonera {dialCode} wobva wasarudza 'Send Money'.",
      "confirmAuto": "Isa nhamba yawakakopa uye mari, wobva wasimbisa nePIN yako kuti zviongororwe otomatiki.",
      "dontClose": "Ndapota usavhare peji iri",
      "autoVerify": "Kubhadhara kwako kuri kuongororwa otomatiki",
      "successOffline": "Ndatenda, {name}. Kutengeserana kwako kwanyorwa. Mutengesi parizvino ari offline. Uchaziviswa neemail kana mutengesi ava online uye asimbisa kubhadhara kwako.",
      "successOnline": "Ndatenda, {name}. Kubhadhara kwako kwe {amount} kuburikidza ne {provider} kwagamuchirwa uye kuri kuongororwa."
    },
    "features": {
      "no-code-website": [
        "Gadzira uye uburitse saiti dze e-commerce, dzidzo, bhurogu, kana nhau pasina kugadzira code.",
        "Muenzaniso: buritsa peji re landing uye chinyorwa chechigadzirwa kubva kudhibhodhi remutengesi wekosi."
      ],
      "custom-domain": [
        "Batanidza domain yako wovaka chimiro chedhijitari chehunyanzvi chine nzira inokurumidza.",
        "Muenzaniso: chitoro chako chinomhanya pa www.acme.com panzvimbo yepasi-domain yeplatform."
      ],
      "capi": [
        "Tumira conversion events server-side kuti uwane kuyera kwakavimbika kwemakampeni.",
        "Muenzaniso: chiitiko chekuzvitengera chinotumirwa kubva kuseva kuenda kupepanhau rezviziviso."
      ],
      "personal-mfs": [
        "Otomatisa kuongororwa kwemubhadharo we Personal MFS inotsigirwa.",
        "Muenzaniso: mubhadharo we Personal MFS unoenderana neodha yepawebhu."
      ],
      "local-gateway": [
        "Batanidza nzira dzekubhadhara dzekuno kune vatengi venzvimbo.",
        "Muenzaniso: mutengi wemuno anopedzisa checkout kuburikidza negateway yenharaunda."
      ],
      "international-gateway": [
        "Batanidza nzira dzekubhadhara dzekunze kune vatengi pasi rese.",
        "Muenzaniso: mutengi wekunze anopedzisa checkout nemaitiro epasi rese."
      ],
      "notifications": [
        "Tumira zviziviso zvekubhadhara uye odha kune vatengi nevashambadzi.",
        "Muenzaniso: kubudirira kwekubhadhara kunokonzeresa chiziviso kumutengesi uye kuvandudzwa kumutengi."
      ],
      "courier": [
        "Tumira maodha akasimbiswa mu workflow yekuendesa inotsigirwa otomatiki.",
        "Muenzaniso: odha yeCOD yasimbiswa inogadzirirwa kutumirwa kune courier."
      ],
      "business-email": [
        "Tumira ugamuchire maemail ehunyanzvi pa domain yako yekutengesa.",
        "Muenzaniso: sales@acme.com inogamuchira mibvunzo uye support@acme.com inopindura."
      ]
    }
  },
  "som": {
    "checkout": {
      "liveInstruction": "Xulo habka live, geli oo xaqiiji lambarka akoonka aad lacag ka soo diri doonto bogga xiga. Kulan live ah ayaa bilaaban doona 10 daqiiqo; dirista lacagta inta uu socdo waxay si otomaatig ah u xaqiijin doontaa lacag-bixinta.",
      "trxInstruction": "Samee Cash In dukaanka ama weydii qof kale inuu sameeyo Send Money. Markaas si otomaatig ah u xaqiiji adigoo isticmaalaya Transaction ID (TrxID).",
      "enterNumberInstruction": "Geli lambarkaaga oo guji badhanka '{action}'.",
      "offlineTitle": "Qalabka Iibiyaha Offline yahay",
      "offlineDescription": "Xaqiijinta otomaatiga ah si ku meel gaar ah looma heli karo.",
      "copyPersonal": "Nuqul ka samee lambarka Personal Account ee kor ku xusan.",
      "sendMoneyOffline": "Samee Send Money ama Cash In lambarka kor ku xusan, ama weydii qof kale inuu lacag soo diro.",
      "trxOffline": "Ururi Transaction ID (TrxID) oo geli hoos. Marka iibiyuhu markale online noqdo, waxaad heli doontaa ogeysiis emayl ahaan, ama si toos ah ula xiriiri kartaa iibiyaha.",
      "cashinNagad": "Cash In looma oggola Nagad, fadlan samee Send Money adoo isticmaalaya akoon Nagad kale.",
      "cashinOther": "Kahor Cash In weydii qofka dukaanka haddii uu bixin doono TrxID; haddii kale, ha sii wadin. Ama weydii qof kale inuu sameeyo Send Money.",
      "waitTrx": "Kadib lacag-bixinta, sug 10–15 ilbiriqsi oo geli TrxID hoos. Waxaad ka bixi kartaa boggan oo aad ku soo laaban kartaa wakhti kasta 24 saac gudaheed si aad si otomaatig ah u xaqiijiso adigoo isticmaalaya TrxID-gaaga.",
      "goApp": "Tag app-ka {provider} ama wac {dialCode} oo dooro 'Send Money'.",
      "confirmAuto": "Geli lambarka iyo iyo iyo nuqul ka samaysay iyo iyo iyo, ka dibna ku xaqiiji PIN-kaaga si si otomaatig ah loo hubiyo.",
      "dontClose": "Fadlan ha xirin boggan",
      "autoVerify": "Lacag-bixintaada si otomaatig ah ayaa loo xaqiijinayaa",
      "successOffline": "Waad mahadsan tahay, {name}. Hawshaada waa la diiwaan geliyey. Iibiyuhu hadda waa offline. Waxaad emayl ahaan lagu ogeysiin doonaa marka iibiyuhu online noqdo oo uu xaqiijiyo lacag-bixintaada.",
      "successOnline": "Waad mahadsan tahay, {name}. Lacag-bixintaada {amount} ee lagu soo maraayo {provider} waa la helay waxaana lagu xaqiijinayaa."
    },
    "features": {
      "no-code-website": [
        "Samee oo daabac bogag e-commerce, waxbarasho, blog, ama warar adoon qoraal code samayn.",
        "Tusaale: daabac bog landing ah iyo boostada badeecad ka socota dashboard-ka iibiye koorso."
      ],
      "custom-domain": [
        "Ku xidh domain-kaaga gaarka ah oo dhis aqoonsi dijitaal xirfadeed oo leh marin degdeg badan.",
        "Tusaale: dukaankaaga wuxuu ku shaqeeyaa www.acme.com halkii uu ka ahaan lahaa subdomain-ka madal."
      ],
      "capi": [
        "Dir conversion events dhinaca server-ka si loo helo cabbir ololayaal lagu kalsoonaan karo.",
        "Tusaale: dhacdada iibsiga ayaa laga soo diraa server-ka loona diraa madal xayeysiis."
      ],
      "personal-mfs": [
        "Otomatigee xaqiijinta lacag-bixinta Personal MFS ee la taageeray.",
        "Tusaale: lacag-bixinta Personal MFS ayaa la isbarbar dhigaa amarka webka."
      ],
      "local-gateway": [
        "Ku xir hababka lacag-bixinta maxaliga ah macaamiisha gobolka.",
        "Tusaale: iibsade maxalli ah ayaa ku dhammeysta checkout iyada oo loo marayo gateway goboleed."
      ],
      "international-gateway": [
        "Ku xir hababka lacag-bixinta caalamiga ah macaamiisha adduunka oo dhan.",
        "Tusaale: iibsade dibadda ah ayaa ku dhammeysta checkout hab caalami ah."
      ],
      "notifications": [
        "Dir ogeysiisyada lacag-bixinta iyo amarrada macaamiisha iyo iibiyeyaasha.",
        "Tusaale: guusha lacag-bixinta waxay kicisaa digniin iibiyaha iyo cusbooneysiin macaamilka."
      ],
      "courier": [
        "Si otomaatig ah u dir amarrada la xaqiijiyay gudaha hab-socodka courier ee la taageeray.",
        "Tusaale: amar COD la xaqiijiyay ayaa loo diyaariyaa in lagu wareejiyo courier-ka."
      ],
      "business-email": [
        "Dir oo hel iimayl xirfadeed oo ku saabsan domain-kaaga summadaysan.",
        "Tusaale: sales@acme.com wuxuu helaa weydiimo iyo support@acme.com wuu ka jawaabaa."
      ]
    }
  },
  "sot": {
    "checkout": {
      "liveInstruction": "Kgetha tsela ya live, kenya mme o netefatse nomoro ya akhaonto eo o tla romelang chelete go yona letlhaping le latelang. Selelo sa live se tla thoma metsotso e 10; ho romela chelete nakong eo ho tla netefatsa tefo ka otometiki.",
      "trxInstruction": "Etsa Cash In lebenkeleng kapa kopa motho e mong ho etsa Send Money. Ebe e netefatsoa ka tlhahlobo ea Transaction ID (TrxID).",
      "enterNumberInstruction": "Kenya nomoro ya gago efela o tobone konopo ya '{action}'.",
      "offlineTitle": "Sesebediswa sa Murchenti se se Online",
      "offlineDescription": "Ho netefatsa ka auto ha ho fumanehe nako ya heno.",
      "copyPersonal": "Khutlolla nomoro ya Personal Account e ka godimo.",
      "sendMoneyOffline": "Romela Send Money goba Cash In ho nomoro e kahodimodimo, kapa kopa motho e mong ho romela chelete.",
      "trxOffline": "Kopanefa Transaction ID (TrxID) mme o e kenye tlase. Ha murchent a boa online, o tla tsebiswa ka email, kapa o ka ikopanya le murchent ka kotloloho.",
      "cashinNagad": "Cash In e sa lumelloe ho Nagad, ka kopo etsa Send Money ho tsoa akhaonteng e ngwe ya Nagad.",
      "cashinOther": "Pele ho Cash In, botsa mong'a lebenkele hore na o tla fana ka TrxID; haeba a sa fane, o se ke wa tswela pele. Kapa kopa motho e mong ho etsa Send Money.",
      "waitTrx": "Kamora tefo, emela 10–15 metsotsoana mme o kenye TrxID tlase. O ka tlohela leqephe lena mme wa boela ho le bona neng kapa neng nakong ya dihora tse 24 ho etsa auto-verify ka TrxID ya hao.",
      "goApp": "E-ea ho app ya {provider} kapa letsetsa {dialCode} mme o kgethe 'Send Money'.",
      "confirmAuto": "Kenya nomoro eo u e kopitsitseng le chelete, ebe u netefatsa ka PIN ea hao hore e hlahlojoe ka mokhoa o iketsang.",
      "dontClose": "Ka kopo o se ke wa koala leqephe lena",
      "autoVerify": "Tefo ya hao e hlahlojoa ka otomate",
      "successOffline": "Rea leboha, {name}. Phetolelo ya gago e ngodisitswe. Murchent o teng offline jwale. O tla tsebiswa ka email ha murchent a boela online mme a netefatsa tefo ya hao.",
      "successOnline": "Rea leboha, {name}. Tefo ya hao ya {amount} ka {provider} e amohetse mme e hlahlojoa."
    },
    "features": {
      "no-code-website": [
        "Bopa mme o phatlalatse diwebsaete tsa e‑commerce, thuto, blog kapa ditaba ntle le ho ngola k'homphutha code.",
        "Mohlala: phatlalatsa landing page le poso ya sehlahisoa ho tsoa dashboard ya morekisi wa kose."
      ],
      "custom-domain": [
        "Hokela domain ya hao e ikgethileng mme o thehe boitsebiso ba digital ba profeshenale ka tsela e potlakileng.",
        "Mohlala: lebenkele la hao le tsamaiswa ho www.acme.com ho fapana le subdomain ya sethala."
      ],
      "capi": [
        "Romella conversion events server-side bakeng sa tekanyo e tshepehang ya dikampeni.",
        "Mohlala: tlhahiso ya theko e romelwa ho seva ho ea sethaleng sa papatso."
      ],
      "personal-mfs": [
        "Iketsetse netefatso ya ditefello tsa Personal MFS tse tsheptjheng.",
        "Mohlala: tefo ya Personal MFS e bapetshwa le odara ya websaete."
      ],
      "local-gateway": [
        "Hokela mekgwa ya tefo ya lehae bakeng sa bareki ba sebaka.",
        "Mohlala: moreki wa lehae o qeta checkout ka gateway ya sebaka."
      ],
      "international-gateway": [
        "Hokela mekgwa ya tefo ya lefatshe ka bophara bakeng sa bareki ba dinaheng tse ding.",
        "Mohlala: moreki wa kantle o qeta checkout ka mokhoa oa lefatše ka bophara."
      ],
      "notifications": [
        "Romella litsebiso tsa tefo le ditaelo ho bareki le barekisi.",
        "Mohlala: katleho ya tefo e tsosa tsebiso ho morekisi le ntlafatso ho moreki."
      ],
      "courier": [
        "Romella ditaelo tse netefaditsweng ka mokhoa o tshehetswang wa courier ka boiketsetso.",
        "Mohlala: odara ya COD e netefaditsweng e lokiselitsoe ho fanoea courier."
      ],
      "business-email": [
        "Romella le ho amohela imeile ya profeshenale hodima domain ya hao ya lets'oao.",
        "Mohlala: sales@acme.com e amohela lipotso mme support@acme.com e araba."
      ]
    }
  },
  "sqi": {
    "checkout": {
      "liveInstruction": "Zgjidhni metodën live, shkruani dhe konfirmoni numrin e llogarisë nga i cili do të dërgoni para në faqen tjetër. Do të fillojë një sesion live 10-minutësh; dërgimi i parave gjatë sesionit do ta verifikojë pagesën automatikisht.",
      "trxInstruction": "Bëni Cash In në një dyqan ose kërkoni dikë tjetër që të bëjë Send Money. Pastaj verifikoni automatikisht duke përdorur Transaction ID (TrxID).",
      "enterNumberInstruction": "Shkruani numrin tuaj dhe klikoni butonin '{action}'.",
      "offlineTitle": "Pajisja e tregtarit jashtë linje",
      "offlineDescription": "Verifikimi automatik është përkohësisht i papranueshëm.",
      "copyPersonal": "Kopjoni numrin e Personal Account të mësipërm.",
      "sendMoneyOffline": "Bëni Send Money ose Cash In në numrin e mësipërm, ose kërkoni dikë tjetër të dërgojë para.",
      "trxOffline": "Merrni Transaction ID (TrxID) dhe vendoseni më poshtë. Kur tregtari të jetë online, do të njoftoheni me email, ose mund të kontaktoni tregtarin direkt.",
      "cashinNagad": "Cash In nuk lejohet në Nagad, kështu që ju lutemi bëni Send Money nga një llogari tjetër Nagad.",
      "cashinOther": "Përpara Cash In, pyetni shitësin nëse do të sigurojë TrxID; nëse jo, mos vazhdoni. Si alternativë, kërkoni dikë tjetër të bëjë Send Money.",
      "waitTrx": "Pas pagesës, prisni 10–15 sekonda dhe vendosni TrxID më poshtë. Mund të largoheni nga kjo faqe dhe të riktheheni në çdo kohë brenda 24 orëve për të verifikuar automatikisht duke përdorur TrxID tuaj.",
      "goApp": "Shkoni te aplikacioni {provider} ose thirrni {dialCode} dhe zgjidhni 'Send Money'.",
      "confirmAuto": "Fut numrin dhe shumën e kopjuar, pastaj konfirmo me PIN-in tënd për verifikim automatik.",
      "dontClose": "Ju lutemi mos e mbyllni këtë faqe",
      "autoVerify": "Pagesa juaj po verifikohet automatikisht",
      "successOffline": "Faleminderit, {name}. Transaksioni juaj është regjistruar. Tregtari aktualisht është offline. Do të njoftoheni me email pasi tregtari të vijë online dhe të verifikojë pagesën tuaj.",
      "successOnline": "Faleminderit, {name}. Pagesa juaj prej {amount} përmes {provider} është pranuar dhe po verifikohet."
    },
    "features": {
      "no-code-website": [
        "Krijoni dhe publikoni faqe e‑commerce, edukimi, blog ose lajme pa kodim.",
        "Shembull: publikoni një landing page dhe postim produkti nga paneli i shitësit të kursit."
      ],
      "custom-domain": [
        "Lidheni domain-in tuaj dhe ndërtoni një identitet digjital profesional me routing më të shpejtë.",
        "Shembull: dyqani juaj funksionon në www.acme.com në vend të një nën-domeni të platformës."
      ],
      "capi": [
        "Dërgoni conversion events server-side për matje të besueshme të fushatave.",
        "Shembull: një event blerjeje dërgohet nga serveri te platforma e reklamave."
      ],
      "personal-mfs": [
        "Automatizoni verifikimin e pagesave Personal MFS të mbështetura.",
        "Shembull: një pagesë Personal MFS lidhet me porosinë në ueb."
      ],
      "local-gateway": [
        "Lidheni metoda lokale pagese për klientët rajonalë.",
        "Shembull: një blerës lokal përfundon checkout përmes një gateway rajonal."
      ],
      "international-gateway": [
        "Lidheni metoda ndërkombëtare pagese për klientët në mbarë botën.",
        "Shembull: një blerës i jashtëm përfundon checkout me një metodë globale."
      ],
      "notifications": [
        "Dërgoni azhurnime pagese dhe porosish për klientët dhe tregtarët.",
        "Shembull: suksesi i pagesës shkakton një njoftim për tregtarin dhe një përditësim për klientin."
      ],
      "courier": [
        "Dërgoni porositë e konfirmuara në një rrjedhë pune kuriere të mbështetur automatikisht.",
        "Shembull: një porosi COD e konfirmuar përgatitet për dorëzim te kurieri."
      ],
      "business-email": [
        "Dërgoni dhe merrni email profesional në domain-in tuaj të brendshëm.",
        "Shembull: sales@acme.com pranon kërkesa dhe support@acme.com përgjigjet."
      ]
    }
  },
  "srp": {
    "checkout": {
      "liveInstruction": "Odaberite live način, unesite i potvrdite broj računa sa kojeg ćete slati novac na narednoj stranici. Počeće 10-minutna live sesija; slanje novca tokom nje će automatski verifikovati uplatu.",
      "trxInstruction": "Napravite Cash In u prodavnici ili zamolite nekog drugog da izvrši Send Money. Zatim se automatski verifikuje koristeći Transaction ID (TrxID).",
      "enterNumberInstruction": "Unesite vaš broj i kliknite na dugme '{action}'.",
      "offlineTitle": "Uređaj prodavca je offline",
      "offlineDescription": "Automatska verifikacija je privremeno nedostupna.",
      "copyPersonal": "Kopirajte gore navedeni broj Personal Account.",
      "sendMoneyOffline": "Pošaljite Send Money ili Cash In na gore navedeni broj, ili zamolite nekog drugog da pošalje novac.",
      "trxOffline": "Preuzmite Transaction ID (TrxID) i unesite ga ispod. Kada prodavac bude online, bićete obavešteni putem imejla, ili možete direktno kontaktirati prodavca.",
      "cashinNagad": "Cash In nije dozvoljen kod Nagad, zato molimo napravite Send Money sa drugog Nagad naloga.",
      "cashinOther": "Pre Cash In, pitajte prodavca da li će obezbediti TrxID; ako neće, nemojte nastaviti. Alternativno, zamolite nekog drugog da izvrši Send Money.",
      "waitTrx": "Posle uplate, sačekajte 10–15 sekundi i unesite TrxID ispod. Možete napustiti ovu stranicu i vratiti se u bilo kom trenutku u roku od 24 sata da automatski verifikujete koristeći vaš TrxID.",
      "goApp": "Idite u {provider} aplikaciju ili pozovite {dialCode} i izaberite 'Send Money'.",
      "confirmAuto": "Унесите копирани број и износ, затим потврдите својим ПИН-ом за аутоматску верификацију.",
      "dontClose": "Molimo vas ne zatvarajte ovu stranicu",
      "autoVerify": "Vaša uplata se automatski verifikuje",
      "successOffline": "Hvala, {name}. Vaša transakcija je zabeležena. Prodavac je trenutno offline. Bićete obavešteni putem imejla kada prodavac bude online i potvrdi vašu uplatu.",
      "successOnline": "Hvala, {name}. Vaša uplata od {amount} preko {provider} je primljena i u procesu verifikacije."
    },
    "features": {
      "no-code-website": [
        "Kreirajte i objavite e‑commerce, edukacione, blog ili news sajtove bez programiranja.",
        "Primer: objavite landing stranicu i post o proizvodu iz kontrolne table prodavca kursa."
      ],
      "custom-domain": [
        "Povežite sopstveni domen i izgradite profesionalni digitalni identitet sa bržim routovanjem.",
        "Primer: vaša prodavnica radi na www.acme.com umesto na poddomeni platforme."
      ],
      "capi": [
        "Šaljite conversion events server-side za pouzdano merenje kampanja.",
        "Primer: događaj kupovine se šalje sa servera na platformu za oglase."
      ],
      "personal-mfs": [
        "Automatizujte verifikaciju plaćanja Personal MFS koja je podržana.",
        "Primer: Personal MFS uplata se povezuje sa porudžbinom na sajtu."
      ],
      "local-gateway": [
        "Povežite lokalne metode plaćanja za regionalne kupce.",
        "Primer: lokalni kupac završava checkout preko regionalnog gateway-a."
      ],
      "international-gateway": [
        "Povežite međunarodne metode plaćanja za kupce širom sveta.",
        "Primer: kupac iz inostranstva završava checkout globalnom metodom."
      ],
      "notifications": [
        "Šaljite obaveštenja o plaćanju i porudžbinama kupcima i prodavcima.",
        "Primer: uspeh uplate pokreće obaveštenje za prodavca i ažuriranje za kupca."
      ],
      "courier": [
        "Automatski šaljite potvrđene porudžbine u podržani courier workflow.",
        "Primer: potvrđena COD porudžbina se priprema za predaju courier-u."
      ],
      "business-email": [
        "Šaljite i primajte profesionalne imejlove na sopstvenom brendiranom domenu.",
        "Primer: sales@acme.com prima upite i support@acme.com odgovara."
      ]
    }
  },
  "ssw": {
    "checkout": {
      "liveInstruction": "Khetsa indlela ye-live, faka futsi uvumele inombolo ye-akhawunti lotawuthumela ngayo imali ekhasini lelalandzelako. Kuzoke kuqale umhlangano we-live wemizuzu leyi-10; kuthumela imali ngesikhathi kusivuselela kuzoqinisekisa kutsfutfukiswa kwekutfola imali.",
      "trxInstruction": "Yenta Cash In esitolo noma cela lomunye kutsi enze Send Money. Emuva kwaloko kuzoqinisekiswa ngokuzenzakalelayo usebentisa Transaction ID (TrxID).",
      "enterNumberInstruction": "Faka inombolo yakho bese ucofa inkinobho '{action}'.",
      "offlineTitle": "Umshini wemthengisi uvaliwe (Offline)",
      "offlineDescription": "Kukhipha kwenqubo yokuziqinisekisa (auto-verify) okwamanje akukhoni.",
      "copyPersonal": "Kopa inombolo ye-Personal Account lephakathi phezulu.",
      "sendMoneyOffline": "Thumela Send Money noma Cash In kunombolo lephakathi phezulu, noma cela lomunye kutsi athumele imali.",
      "trxOffline": "Khetha i-Transaction ID (TrxID) bese uyifaka phansi. Ngesikhatsi umthengisi abuye abe online, uyokwaziswa nge-imeyili, noma ungaxhumana nomthengisi ngokuqondile.",
      "cashinNagad": "Cash In ayivunyelwe ku-Nagad, ngako-ke ngiyacela wenta Send Money kusuka ku-akhawunti lehlukile ye-Nagad.",
      "cashinOther": "Ngaphambi kwe-Cash In, buza umthengisi ukuthi ngabe uzonika i-TrxID; nangabe hayi, ungayi phambili. Noma cela lomunye atente Send Money.",
      "waitTrx": "Emuva kokukhokha, linda imizuzwana le-10–15 bese ufaka i-TrxID phansi. Ungashiya leli khasi bese ubuya nanoma yisiphi sikhathi kungakapheli emahora la-24 ukuze u-auto-verify usebenzisa i-TrxID yakho.",
      "goApp": "Hamba kuhlelo lokusebenza {provider} noma shayela {dialCode} bese ukhetha 'Send Money'.",
      "confirmAuto": "Faka inombolo lenikopile kanye lemali, bese uqinisekisa nge-PIN yakho ukuze kuhlolwe ngokuzenzekelayo.",
      "dontClose": "Ngiyacela ungavali leli khasi",
      "autoVerify": "Inkokhelo yakho iyaqinisekiswa ngokuzenzakalelayo",
      "successOffline": "Ngiyabonga, {name}. Ukudayisa kwakho kuqoshiwe. Umthengisi okwamanje uvaliwe (offline). Uzokwaziswa nge-imeyili uma umthengisi esebuye abe online bese eqinisekisa inkokhelo yakho.",
      "successOnline": "Ngiyabonga, {name}. Inkokhelo yakho ye-{amount} nge-{provider} yamukelwe futhi iyaqinisekiswa."
    },
    "features": {
      "no-code-website": [
        "Yakha bese ushicilela amawebhusayithi e-commerce, imfundo, ibhulogi, noma izindaba ngaphandle kokubhala ikhodi.",
        "Isibonelo: shicilela i-landing page kanye nendatshana yomkhiqizo kusuka ku-dashboard yomthengisi wekhosi."
      ],
      "custom-domain": [
        "Xhuma i-domain yakho yangasese bese wakhe ubunikazi bedijithali obusezingeni eliphezulu ngenhlangano esheshayo.",
        "Isibonelo: isitolo sakho sisebenza ku-www.acme.com esikhundleni se-subdomain yeplathifomu."
      ],
      "capi": [
        "Thumela conversion events ku-server-side ukuze kukalwe imikhankaso ngokuthembekile.",
        "Isibonelo: isigameko sokuthenga sithunyelwa kusukela ku-server siyofika ephathelene nezikhangiso."
      ],
      "personal-mfs": [
        "Zenzele ngokuzenzakalelayo ukuqinisekiswa kokukhokha kwe-Personal MFS okuxhaswayo.",
        "Isibonelo: ukukhokha kwe-Personal MFS kuhlanganiswa ne-oda lewebhusayithi."
      ],
      "local-gateway": [
        "Xhuma izindlela zokukhokha zendawo zamakhasimende endaweni.",
        "Isibonelo: umthengi wasendaweni uqeda i-checkout nge-gateway yendawo."
      ],
      "international-gateway": [
        "Xhuma izindlela zokukhokha zamazwe ngamazwe zamakhasimende emhlabeni jikelele.",
        "Isibonelo: umthengi wasemazweni angaphandle uqeda i-checkout ngendlela yomhlaba wonke."
      ],
      "notifications": [
        "Thumela izibuyekezo zokukhokha nama-oda kumakhasimende nasabatshali.",
        "Isibonelo: ukwenzeka kwempumelelo kokukhokha kudala isexwayiso somthengisi nokuvuselelwa kumthengi."
      ],
      "courier": [
        "Thumela ama-oda aqinisekisiwe ngokuzenzakalela ku-workflow ye-courier exhaswayo.",
        "Isibonelo: i-ODA ye-COD eqinisekisiwe ilungiselelwa ukudluliselwa ku-courier."
      ],
      "business-email": [
        "Thumela futhi wamukele imeyili yobungcweti kudomain yakho ebambe uphawu.",
        "Isibonelo: sales@acme.com yamukela imibuzo kanti support@acme.com iyaphendula."
      ]
    }
  },
  "swa": {
    "checkout": {
      "liveInstruction": "Chagua njia ya live, ingiza na thibitisha namba ya akaunti utakayotumia kutuma pesa katika ukurasa ujao. Kikao cha live cha dakika 10 kitaanza; kutuma pesa ndani yake kutathibitisha malipo kiotomatiki.",
      "trxInstruction": "Fanya Cash In kutoka dukani au muulize mtu mwingine atume Send Money. Kisha thibitisha kiotomatiki ukitumia Transaction ID (TrxID).",
      "enterNumberInstruction": "Ingiza nambari yako na bonyeza kitufe cha '{action}'.",
      "offlineTitle": "Kifaa cha Muuzaji Hakipo Mtandaoni",
      "offlineDescription": "Uthibitishaji wa kiotomatiki haupatikani kwa muda.",
      "copyPersonal": "Nakili namba ya Personal Account iliyoko juu.",
      "sendMoneyOffline": "Tuma Send Money au fanya Cash In kwa nambari iliyo juu, au muulize mtu mwingine atume pesa.",
      "trxOffline": "Pata Transaction ID (TrxID) na uiweke hapa chini. Wakati muuzaji atakapewa mtandaoni, utapokelewa taarifa kwa barua pepe, au unaweza kuwasiliana na muuzaji moja kwa moja.",
      "cashinNagad": "Cash In hairuhusiwi kwenye Nagad; tafadhali tumia Send Money kutoka kwenye akaunti nyingine ya Nagad.",
      "cashinOther": "Kabla ya kufanya Cash In, muulize mfanyabiashara kama watatoa TrxID; ikiwa hawatatoa, usiendelee. Vinginevyo, muulize mtu mwingine atume Send Money.",
      "waitTrx": "Baada ya malipo, subiri 10–15 sekunde na ingiza TrxID hapa chini. Unaweza kuondoka kwenye ukurasa huu na kurudi kwa ukurasa huu wa malipo wakati wowote ndani ya masaa 24 ili kuthibitisha kiotomatiki kutumia TrxID yako.",
      "goApp": "Nenda kwenye app ya {provider} au piga {dialCode} na chagua 'Send Money'.",
      "confirmAuto": "Weka nambari uliyoikopia na kiasi, kisha thibitisha kwa PIN yako ili kuthibitisha kiotomatiki.",
      "dontClose": "Tafadhali usifunge ukurasa huu",
      "autoVerify": "Malipo yako yanathibitishwa kiotomatiki",
      "successOffline": "Asante, {name}. Muamala wako umeandikwa. Muuzaji kwa sasa hayupo mtandaoni. Utapokea notisi kwa barua pepe baada ya muuzaji kuwa mtandaoni na kuthibitisha malipo yako.",
      "successOnline": "Asante, {name}. Malipo yako ya {amount} kupitia {provider} yametumwa na yanathibitishwa."
    },
    "features": {
      "no-code-website": [
        "Tengeneza na kuchapisha tovuti za e-commerce, elimu, blogu, au habari bila kuandika code.",
        "Mfano: chapisha ukurasa wa kutua na chapisho la bidhaa kutoka dashibodi ya muuzaji wa kozi."
      ],
      "custom-domain": [
        "Unganisha domain yako mwenyewe na jenga utambulisho wa dijitali wa kitaalamu kwa njia ya upitishaji wa haraka.",
        "Mfano: duka lako linaendesha kwenye www.acme.com badala ya subdomain ya jukwaa."
      ],
      "capi": [
        "Tuma matukio ya uongofu server-side kwa upimaji wa kampeni ulio imara.",
        "Mfano: tukio la ununuzi linatumwa kutoka server kwenda kwa jukwaa la matangazo."
      ],
      "personal-mfs": [
        "Sahihisha uthibitisho wa malipo za Personal MFS zinazoungwa mkono kwa njia ya automatiska.",
        "Mfano: malipo ya Personal MFS yanalingana na oda kwenye tovuti."
      ],
      "local-gateway": [
        "Unganisha njia za malipo za ndani kwa wateja wa kikanda.",
        "Mfano: mnunuzi wa ndani anakamilisha checkout kupitia gateway ya kikanda."
      ],
      "international-gateway": [
        "Unganisha njia za malipo za kimataifa kwa wateja kote duniani.",
        "Mfano: mnunuzi wa kigeni anakamilisha checkout kwa njia ya kimataifa."
      ],
      "notifications": [
        "Tuma taarifa za malipo na masasisho ya oda kwa wateja na wauzaji.",
        "Mfano: mafanikio ya malipo yataleta arifa kwa muuzaji na sasisho kwa mteja."
      ],
      "courier": [
        "Tuma maagizo yaliyothibitishwa kwenye mtiririko unaoungwa mkono wa courier moja kwa moja.",
        "Mfano: oda ya COD iliyothibitishwa inaandaliwa kwa mpitishio kwa courier."
      ],
      "business-email": [
        "Tuma na pokea barua pepe za kitaalamu kwenye domain yako yenye chapa.",
        "Mfano: sales@acme.com inapokea maswali na support@acme.com inajibu."
      ]
    }
  },
  "tet": {
    "checkout": {
      "liveInstruction": "Escolhe metoda live, tau no konfirma númeru konta ne'ebé ita sei hato'o pesa husi iha pagina seluk. Sessão live 10 minutu sei komesa; envia durante sessãon sei verifica otomátikamente ne'e pagamentu.",
      "trxInstruction": "Halo Cash In hosi loja ka husu ema seluk atu Send Money. Depois, verifica otomátikamente uza Transaction ID (TrxID).",
      "enterNumberInstruction": "Hatama númeru ho klika botao '{action}'.",
      "offlineTitle": "Aparelhu Komersiante La iha Online",
      "offlineDescription": "Verifikasaun otomátika la dispoñível temporáriamente.",
      "copyPersonal": "Kopia númeru Personal Account ne'ebe iha liuhusi.",
      "sendMoneyOffline": "Hato'o Send Money ka Halo Cash In ba númeru ne'e, ka husu ema seluk atu sendu.",
      "trxOffline": "Kolekta Transaction ID (TrxID) no hatama iha he'e. Bainhira comerciante mai online, ita sei hetan notifika ba email, ka ita bele kontakta comerciante direitu.",
      "cashinNagad": "Cash In la permitidu iha Nagad; favór sendu Send Money husi konta Nagad seluk.",
      "cashinOther": "Antes halo Cash In, husu loja se sira sei fornese TrxID; se la, la procede. Alternative, husu ema seluk atu Send Money.",
      "waitTrx": "Depois pagamentu, espera 10–15 segundos no hatama TrxID iha he'e. Ita bele sai husi pagina ne'e no fila fali iha pagina pagamentu iha 24 oras hodi verifica otomátikamente uza TrxID.",
      "goApp": "Bai ba app {provider} ka liga {dialCode} no seleksona 'Send Money'.",
      "confirmAuto": "Hatama númeru no montante ne'ebé ita kopia, depois konfirma ho PIN atu verifica otomátikamente.",
      "dontClose": "Favor la fifú o tan foka página ne'e",
      "autoVerify": "Pagamentu ita-nia sei verifica otomátikamente",
      "successOffline": "Obrigadu, {name}. Transasaun ida ne'e registradu. Comerciante agora la iha online. Ita sei hetan notifika ba email depois comerciante mai online no confirma pagamentu.",
      "successOnline": "Obrigadu, {name}. Pagamentu ida {amount} liuhusi husi {provider} hetan no sei verifica."
    },
    "features": {
      "no-code-website": [
        "Kria no publica sítios e-commerce, edukasaun, blog ka naran tan laimporta ne'ebé, tanba la need code.",
        "Exemplu: publica landing page no publika produtu hosi dashbordu vendedor kursu."
      ],
      "custom-domain": [
        "Konekta domain ida ne'ebé ita nia ho halo identidade digital profissional ho rutu maibé ki'ik.",
        "Exemplu: loja ita uza www.acme.com iha laran dominiu platforma."
      ],
      "capi": [
        "Tuma eventus conversao server-side hodi mensura kampanha atu segur.",
        "Exemplu: eventu compra mai husi server ba plataforma anunciu."
      ],
      "personal-mfs": [
        "Automatiza verifikasaun malpar MFS Personal ne'ebé suportadu.",
        "Exemplu: pagamento Personal MFS ho pedido iha website sei sinja."
      ],
      "local-gateway": [
        "Konekta metodu pagamentu lokal ba konsumidor regionál.",
        "Exemplu: cliente lokal akompleta checkout atraves gateway regional."
      ],
      "international-gateway": [
        "Konekta metodu pagamentu internasionál ba klientela mundial.",
        "Exemplu: comprador estranjeiru akompleta checkout ho metoda global."
      ],
      "notifications": [
        "Tuma atualizasaun pagamentu no pedido ba klienti no comerciante.",
        "Exemplu: sucesso pagamentu halo alertu ba comerciante no atualizasaun ba klienti."
      ],
      "courier": [
        "Tuma pedido confirmadu ba fluxu courier suportadu automaticamente.",
        "Exemplu: pedido COD confirmadu prepara atu entrega ba courier."
      ],
      "business-email": [
        "Tuma no recebe email profissional iha domain tua branded.",
        "Exemplu: sales@acme.com simu inkuiridas no support@acme.com responde."
      ]
    }
  },
  "tgk": {
    "checkout": {
      "liveInstruction": "Усули live-ро интихоб кунед, дар саҳифаи оянда рақами ҳисоберо, ки аз он пул мефиристед, ворид ва тасдиқ намоед. Сессияи 10 дақиқагӣ оғоз мешавад; фиристодани пул дар давоми он пардохтро ба таври автоматӣ тасдиқ мекунад.",
      "trxInstruction": "Cash In-ро аз мағоза анҷом диҳед ё аз касе хоста Send Money кунад. Пас аз он, бо истифодаи Transaction ID (TrxID) ба таври автоматӣ тасдиқ кунед.",
      "enterNumberInstruction": "Рақами худро ворид кунед ва тугмаи '{action}'-ро зер кунед.",
      "offlineTitle": "Дастгоҳи фурӯшанда офлайн аст",
      "offlineDescription": "Тасдиқи автоматӣ муваққатан дастрас нест.",
      "copyPersonal": "Рақами Personal Account-и болоиро нусхабардорӣ кунед.",
      "sendMoneyOffline": "Send Money кунед ё Cash In ба рақами боло, ё аз касе хоста Send Money кунад.",
      "trxOffline": "Transaction ID (TrxID)-ро гиред ва онро поён ворид кунед. Ҳангоми баргаштан ба онлайн фурӯшанда ба шумо тавассути почта огоҳӣ фиристода мешавад, ё шумо метавонед мустақиман бо фурӯшанда тамос гиред.",
      "cashinNagad": "Cash In дар Nagad иҷозат дода намешавад, пас лутфан Send Money аз ҳисоби дигари Nagad анҷом диҳед.",
      "cashinOther": "Пеш аз Cash In, аз соҳибмағоза пурсед, ки оё онҳо TrxID медиҳанд; агар не, идома надиҳед. Дар акси ҳол, аз касе онро Send Money кунед.",
      "waitTrx": "Пас аз пардохт, 10–15 сония интизор шавед ва TrxID-ро поён ворид кунед. Шумо метавонед ин саҳифаро тарк кунед ва дар давоми 24 соат ба ин саҳифаи пардохт баргардед, то бо TrxID-и худ тасдиқи автоматӣ кунед.",
      "goApp": "Ба барномаи {provider} равед ё {dialCode}-ро занед ва 'Send Money'-ро интихоб кунед.",
      "confirmAuto": "Рақам ва маблағи нусхашударо ворид кунед, сипас бо PIN-и худ тасдиқ кунед, то ба таври автоматӣ тасдиқ шавад.",
      "dontClose": "Лутфан ин саҳифаро пӯш накунед",
      "autoVerify": "Пардохти шумо ба таври автоматӣ тафтиш карда мешавад",
      "successOffline": "Ташаккур, {name}. Амалиётатон сабт шуд. Фурӯшанда ҳозир офлайн аст. Пас аз онлайн шудан ва тасдиқ намудани пардохти шумо, ба шумо тавассути почта огоҳӣ фиристода мешавад.",
      "successOnline": "Ташаккур, {name}. Пардохти шумо ба маблағи {amount} тавассути {provider} қабул шуд ва ҳоло тафтиш карда мешавад."
    },
    "features": {
      "no-code-website": [
        "Эҷод ва нашри сайтҳои e-commerce, таълимӣ, блог ё хабарӣ бе навиштани код.",
        "Мисол: нашри саҳифаи лендинг ва пости маҳсулот аз панели фурӯшандаи курс."
      ],
      "custom-domain": [
        "Доменаи шахсии худро пайваст кунед ва бо роутинги тезтар шиносномаи рақамии касбиро созед.",
        "Мисол: мағозаи шумо дар www.acme.com кор мекунад ба ҷои субдоменҳои платформа."
      ],
      "capi": [
        "Фиристодани рӯйдодҳои табдили server-side барои ченкунии боэътимоди кампайн.",
        "Мисол: рӯйдоди харид аз сервер ба платформаи таблиғот фиристода мешавад."
      ],
      "personal-mfs": [
        "Автоматизатсияи тафтиши пардохтҳои Personal MFS, ки дастгирӣ мешаванд.",
        "Мисол: пардохти Personal MFS ба фармоиши вебсайт мувофиқ карда мешавад."
      ],
      "local-gateway": [
        "Пайваст кардани усулҳои пардохти маҳаллӣ барои муштариён дар минтақа.",
        "Мисол: харидори маҳаллӣ тавассути gateway минтақавӣ checkout-ро анҷом медиҳад."
      ],
      "international-gateway": [
        "Пайваст кардани усулҳои пардохти байналмилалӣ барои муштариён дар ҳамаи давлатҳо.",
        "Мисол: харидори хориҷа checkout-ро бо усули глобалӣ анҷом медиҳад."
      ],
      "notifications": [
        "Ирсол намудани хабарҳо оид ба пардохт ва фармоиш ба муштариён ва фурӯшандагон.",
        "Мисол: муваффақияти пардохт огоҳи барои фурӯшанда ва навсозии муштариро ба вуҷуд меорад."
      ],
      "courier": [
        "Автоматика фиристодани фармоишҳои тасдиқшуда ба ҷараёни кори courier-и дастгиришаванда.",
        "Мисол: фармоиши COD тасдиқшуда барои супориш ба courier омода мешавад."
      ],
      "business-email": [
        "Фиристодан ва қабул кардани почтаи касбӣ дар домени бренди худ.",
        "Мисол: sales@acme.com дархостҳоро мегирад ва support@acme.com посух медиҳад."
      ]
    }
  },
  "tir": {
    "checkout": {
      "liveInstruction": "ምርጫ ዘይትረፍ (live) ይምረጡ፣ ቁጽሪ ሒሳብ ዝትልእ ብገጽ ቀጺሉን ምረጹ። ሓደ 10 ደቒቕ ዘይፈጥር ስብሓት ይጀምር፤ እዚ ዘይብሉ ግዜ ገንዘብ ምልክት ዝተላኸ እንተ እቲ ክንደይ ሕማቕ ኣይኮነን።",
      "trxInstruction": "Cash In ካብ ሱቅ ይኸውን ወይ ሰብ ካብ ሞን ይላክ Send Money ይጠይቁ። ከምዚ ዝኣለ ኣብ Transaction ID (TrxID) ብዘይ ኣብዚ ኣብ ራስዎ እንዳትረጉ።",
      "enterNumberInstruction": "ቁጽሪካ ያብሉ እና ቁልፊ '{action}' ይጫኑ።",
      "offlineTitle": "መኽንያታ ንሻሩ ኣይብሉን (Merchant Device Offline)",
      "offlineDescription": "ናይ ሕጊ ሓራዊ ምረጋገጥ ግዜያዊ ኣይተወሰነን።",
      "copyPersonal": "ቁጽሪ Personal Account ካብ ኣንጻር ቅድሚ ይቅየሩ።",
      "sendMoneyOffline": "Send Money ይላኩ ወይ Cash In ናይ ኣንቲ ቁጽሪ ይፈጽሙ፣ ወይ ሰብ ኣብ ከኣ ይላክ Send Money ይጠይቁ።",
      "trxOffline": "Transaction ID (TrxID) አገኙ እና ታቕርፉ ኣብ ታሕቲ ይግበሩ። መሸጫኦም ኣብቲ ነቲ ወደ መገናእታ ሲምን ኢ-ሜይል እዩ ዝኾነ ናብካ እንዲደርስ ይርከብ፣ ወይ ቀጻሊ ንመሸጫኦም ይግባእ።",
      "cashinNagad": "Cash In ብNagad ኣይፈቀድን፣ እቲ Send Money ካብ ካልእ Nagad ኣካውንት ይረጋገጡ።",
      "cashinOther": "ካርእ ንCash In፣ ሱቅ ዝብል እዩ ዝኾነ ንTrxID ይሰጣ እዩ ወይ እንታይ ኣሎ ይጠይቁ፤ ካይኮነ ኣብዚ አትተኸኣሉ። ብቐሊ ሰብ ይላክ Send Money ይጠይቁ።",
      "waitTrx": "ከም ክፍሊ ከይቲ 10–15 ሰከንዶ ይጠብቁ እና TrxID ኣብ ታሕቲ ይኽተሉ። እቲ ገጽካ ልበስ ትችላለህ እና ናብ እዚ ገጽ ዝኾነ ገንዘብ ግብሪ 24 ሰዓታት ውሽጢ እዚ TrxID ብምጥቃም ኣብዚ ክትርከብ።",
      "goApp": "ወደ {provider} ኣፕ ይሂዱ ወይ {dialCode} ይጨውቁ እና 'Send Money' ይምረጡ።",
      "confirmAuto": "ቁጽሪ ዝቕደለካ እና መጠን ያብሉ፣ ከዝተሓለፈ PIN ብጥሪ ናብ ሕጊ ኣብዚ ይርከብ።",
      "dontClose": "ንግሕዝ እተወዳእታ ዘይዝርዝር ይርቁ ንገጽን እቲ",
      "autoVerify": "ክፍሊካ ብሓንቲ ኣውቶማቲካ ይርከብ",
      "successOffline": "ናይ ምስጋና, {name}. ግብሪካ ተመዝጊበ። መሸጫ ኣብዚ ግዜ ኣይብሉን። ኣብ ነቲ ሰዓት ክመጽእ ብይኩን ናብ ኦንላይን እንደይ ዝተረጋገጸ ኢዩ፣ እንተደገ ኢዩ ናብካ ኣብ ኢ-ሜይል ይሰዓሉ።",
      "successOnline": "ናይ ምስጋና, {name}. ክፍሊካ {amount} ብ{provider} ተቀበሉ እና ኣብ ግዜ ይርከብ።"
    },
    "features": {
      "no-code-website": [
        "ምፍጣርን ምትርካይ ብሽራፍ ዘይኮድ ኣብ ኢ-ኮምርስ፣ ትምህርቲ፣ ብሎግ ወይ ዜና ገፅ ምፍኣል።",
        "ምሳና: ምስ ታቦል ወይ ምሳሌ ምስል ካብ dashboard ተማሪ ሸጪ ገፅ ምቅላብ።"
      ],
      "custom-domain": [
        "ዳሜንን ክልተይ ማብራሪ ስም ገብር ኣብ ዝዕብይ ዝፈጥር መርገፂ ዝገብር።",
        "ምሳና: ድንበርካ www.acme.com ብርኽብ እዩ እንተ ካብ subdomain ፕላትፎርም ይርከብ።"
      ],
      "capi": [
        "ናይ conversion events ሰርቨር-side ምልኣይ ይላእን ንመሰረታዊ መንገዲ ምምሕዳር ካብ kampane.",
        "ምሳና: ተግባር ዝገበረ ግዜ ካብ server ወደ ad platform ይላእ።"
      ],
      "personal-mfs": [
        "ብኣዳማ ዝርከብ ዝፈጠረ Personal MFS ክፍሊ ምርከብ ኣውቶማቲካ እዩ ዝተደረገ።",
        "ምሳና: ዝተሰጠ ክፍሊ Personal MFS ናይ website order ይስማዕ።"
      ],
      "local-gateway": [
        "ናይ ኣካባቢ ክፍሊ መንገዲ ኣብ አካባቢ ዝኽእል ደንበኞች ይግብሩ።",
        "ምሳና: ናይ ኣካባቢ ዋጋ ይጨምር እንተ ዝፈጥረ checkout ብ regional gateway."
      ],
      "international-gateway": [
        "ናይ ዓለም ክፍሊ መንገዲ ኣብ ዓለም ኣብ ገዛ ደንበኞች ይግብሩ።",
        "ምሳና: ወጻኢ እተደገ ሸክላ ክፍሊ ብ global method ይተኣተፋ።"
      ],
      "notifications": [
        "ኣብ ክፍሊን ኣብ ኦርደር ምልእኽቲ ንደንበኞች እና ንሻሩ ይላእ።",
        "ምሳና: ስእሊ ክፍሊ ስንክል ማስታወቂ ለሻሩ እና ለደንበኛ መልእኽቲ ይልእ።"
      ],
      "courier": [
        "ኣብ ዝደገፈ የcourier ስርዓት ተረጋጊ የተሰጠ ኦርደር ኣውቶማቲካ ይላእ።",
        "ምሳና: ኦርደር COD ዝተረጋገጸ ኣብ ሕሱር ክውሰድ ይዘው ለcourier ይዘው ይደርስ።"
      ],
      "business-email": [
        "ኣብ ሕቶ ናብ ኣካባቢ ዘለኻ ዳሜን ስም ኢሜይል መልእኽቲ ይላእን እና ይቀበሉ።",
        "ምሳና: sales@acme.com ጥያቄ ይቀበል እና support@acme.com ይመልሳል።"
      ]
    }
  },
  "tkl": {
    "checkout": {
      "liveInstruction": "Filifili le auala live, fakaofi mai pea faamaonia le numera te te tuku tupe mei ai i le itulau sosoo. O le 10-miniti live session o le a amata; afai e ta'ua le tupe i totonu, o le a fa'a-verify otometi le totogi.",
      "trxInstruction": "Fai Cash In mai te faleoloa po o fesili ki se tagata ke Send Money. A'o le ki, fa'aaoga le Transaction ID (TrxID) ke fa'amaonia otometi.",
      "enterNumberInstruction": "Ufiufi ho numera pea kiliki le pulesi '{action}'.",
      "offlineTitle": "Mea o le Merchant E Le Online",
      "offlineDescription": "E le maua le fa'amaoniga otometi mo se taimi puupuu.",
      "copyPersonal": "Kopi le numera Personal Account i luga.",
      "sendMoneyOffline": "Send Money po'o le faia o Cash In i le numera i luga, po'o fesili se isi tagata e Send Money.",
      "trxOffline": "Aoao le Transaction ID (TrxID) ma ufiufi i lalo. A'o toe foi le merchant i le online, o le a e iloa i le imeli, po'o le mafai ona feso'ota'i vavalalata le merchant.",
      "cashinNagad": "E le fa'atagaina le Cash In i Nagad; fa'amolemole Send Money mai se isi Nagad account.",
      "cashinOther": "A'o le'i faia Cash In, fesili i le tagata faleoloa pe latou te tu'uina TrxID; afai e le fa'atulaga, aua le faaauau. Pe a leai, fesili se isi tagata e Send Money.",
      "waitTrx": "A mae'a le totogi, fa'atali 10–15 sekone ma ufiufi le TrxID i lalo. E mafai ona e alu mai i lenei itulau ma toe foi i so'o se taimi i totonu o le 24 itula e fa'a-verify otometi fa'aaoga ai lau TrxID.",
      "goApp": "Alu i le app {provider} po'o puna {dialCode} ma filifili 'Send Money'.",
      "confirmAuto": "Ufiufi le numera ma le aofa'i na e kopi, ona faamaonia lea ma lau PIN e fa'amaonia otometi.",
      "dontClose": "Fa'amolemole aua ne'i tapuni lenei itulau",
      "autoVerify": "O lo'o fa'amaonia otometi lau totogi",
      "successOffline": "Fa'afetai, {name}. Ua fa'amauina lau fefa'ataua'iga. O le merchant e le o online i le taimi nei. O le a e maua se fa'asilasilaga i le imeli pe a toe maua le merchant i le online ma fa'amaonia lau totogi.",
      "successOnline": "Fa'afetai, {name}. Ua mautinoa ma maua lau totogi {amount} e ala i le {provider} ma o lo'o fa'amaonia."
    },
    "features": {
      "no-code-website": [
        "Fausia ma fa'apipi'i 'e-commerce', 'education', 'blog', po'o 'news' website e aunoa ma le tusia o code.",
        "Fa'ata'ita'iga: fa'apipi'i se landing page ma se product post mai le dashboard o le course seller."
      ],
      "custom-domain": [
        "Feso'ota'i lau lava domain ma fausia se igoa fa'apisinisi i le upega ma le saoasaoa aupito maualuga o le routing.",
        "Fa'ata'ita'iga: o lau faleoloa o lo'o tamo'e i luga o www.acme.com nai lo le subdomain o le platform."
      ],
      "capi": [
        "Auina atu conversion events server-side mo se fua fa'atatau o le fanua o le kampeni.",
        "Fa'ata'ita'iga: o se purchase event e auina mai le server i le ad platform."
      ],
      "personal-mfs": [
        "Automate le verification o totogi Personal MFS ua lagolagoina.",
        "Fa'ata'ita'iga: o se Personal MFS payment e fua lelei ma le website order."
      ],
      "local-gateway": [
        "Feso'ota'i metotia totogi lotoifale mo tagata fa'atau i le itumalo.",
        "Fa'ata'ita'iga: o se tagata fa'atau lotoifale e fa'amae'a le checkout i le ala o se regional gateway."
      ],
      "international-gateway": [
        "Feso'ota'i metotia totogi fa'avaomalo mo tagata fa'atau i le lalolagi atoa.",
        "Fa'ata'ita'iga: o se tagata fa'atau i fafo e fa'amae'a le checkout ma se global method."
      ],
      "notifications": [
        "Auina atu suiga e uiga i totogi ma fa'atonuga i tagata fa'atau ma merchants.",
        "Fa'ata'ita'iga: o le manuia o le totogi e fa'ailoa atu i le merchant ma fa'afouga i le tagata fa'atau."
      ],
      "courier": [
        "Auina atu otometi fa'atonuga ua fa'amaonia i totonu o le workflow courier ua lagolagoina.",
        "Fa'ata'ita'iga: o se COD order ua fa'amaonia o loo sauni mo le auina atu i le courier."
      ],
      "business-email": [
        "Auina ma mauaina imeli fa'apisinisi i lau lava domain branded.",
        "Fa'ata'ita'iga: sales@acme.com maua talosaga ma support@acme.com tali atu."
      ]
    }
  },
  "toi": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Sakani no kusindikila masaiti ya e-commerce, chisambilo, blog, panandi saiti sha nsala, nangu takwaba kukoda.",
        "publish a landing page and product post kufuma ku seller dashboard."
      ],
      "custom-domain": [
        "Yanganishani domain yenu no kuumina professional digital identity ni njira ya kushaukila yachimbu.",
        "sitolo yenu ikashitabishe pa www.acme.com, pantu pali platform subdomain."
      ],
      "capi": [
        "Tumizhani conversion event pa server-side kuti campaign measurement ishindikile bwino.",
        "purchase event itumizwa kufuma ku server kuya ku ad platform."
      ],
      "personal-mfs": [
        "Sangulululani verification ya malipilo ya Personal MFS aishimikilwa mu automatic. MFS yikulumbulula ukushimikilila.",
        "personal MFS payment ilingananishwa no website order."
      ],
      "local-gateway": [
        "Yanganishani njira shalikupela malipilo yakuma kumushi pa bakasitomala bakumalilano.",
        "umwini wa kumushi apwishishe checkout na regional gateway."
      ],
      "international-gateway": [
        "Yanganishani njira shalikupela malipilo sha kunse kwensha pa bakasitomala bonse panshi.",
        "umwini wa kunse apwishishe checkout na global method."
      ],
      "notifications": [
        "Tumizhani vipola vya payment na order ku bakasitomala no ku ba merchant.",
        "payment ikashindikila, merchant alipokwa alert na customer apokwa update."
      ],
      "courier": [
        "Tumizhani ma order ayashimikilwa mu courier workflow ishiishimikilwa mwachisangululuko.",
        "confirmed COD order yakonkelwa pa courier handoff."
      ],
      "business-email": [
        "Tumeni no kupoka professional email pa branded domain yenu.",
        "sales@acme.com ipoka ma inquiry, support@acme.com isuminisha mivumbo."
      ]
    }
  },
  "ton": {
    "checkout": {
      "liveInstruction": "Choose the live method, enter and confirm the account number you'll send money from on the next page. A 10-minute live session will begin; sending money during that session will auto-verify the payment.",
      "trxInstruction": "Do a Cash In at a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and press the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper if they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Open the {provider} app or dial {dialCode} and choose 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Fai mo fakaha e ngaahi saiti e-commerce, ako, blog, pe ongoongo ‘ikai fie tohi koka.",
        "publish ha landing page mo ha product post mei he seller dashboard."
      ],
      "custom-domain": [
        "Fesili‘i ki ho‘o domain ‘o langa ha fakamatala‘o fakafaiako ‘oku poto mo e fe‘unga mo e ala vave ‘o e fehu‘i‘anga hala.",
        "‘e lele ho store ‘i he www.acme.com ‘o ‘ikai ha subdomain ‘a e platform."
      ],
      "capi": [
        "Fakafepaki e ngaahi konivesini ‘i he server-side ke fuoloa mo falala‘anga e fuofua ‘o e campaign.",
        "‘oku ‘ave ha purchase event mei he server ki he ad platform."
      ],
      "personal-mfs": [
        "Fakatekiteki ‘a e sivi‘ia ‘o e totongi ‘a e Personal MFS ‘oku ne tokoni ki ai.",
        "‘oku faka‘ataa ha Personal MFS payment ke fakatautaha mo e website order."
      ],
      "local-gateway": [
        "Fesili‘i e ngaahi founga totongi fakalokaloka ki he kau fakatau fakavahevahe.",
        "‘oku fakakakato ‘e ha fakatau faka‘api ha checkout ‘o ‘oatu ‘aki ha gateway fakavahevahe."
      ],
      "international-gateway": [
        "Fesili‘i e ngaahi founga totongi fakava‘olunga ki he kau kasitoma ‘o mamani kotoa.",
        "‘oku fakakakato ‘e ha fakatau mei tu‘apule‘anga ha checkout ‘aki ha founga fakalalahi."
      ],
      "notifications": [
        "‘Ave e ngaahi fakamatala fakalotofale ‘o e totongi mo e order ki he kau kasitoma mo e kau fa‘iteliha.",
        "kapau ‘e lava lelei e totongi, ‘e tukuhifo ha fanautaki ki he fa‘iteliha pea toe fakalelei‘i ‘a e kasitoma."
      ],
      "courier": [
        "‘Ave ‘a e ngaahi order kuo fakapapau‘i ki he courier workflow ‘oku tokoni ki ai ‘o aunoa mo ha ngaue fakaetangata.",
        "‘oku teuteu ha order COD kuo fakapapau‘i ki he courier handoff."
      ],
      "business-email": [
        "‘Ave mo tali e professional email ‘i ho‘o domain kuo fili ‘aki ho ho‘o hingoa fakapa‘anga.",
        "‘oku tali ‘e he sales@acme.com ‘a e ngaahi kole pea tali ki ai ‘e he support@acme.com."
      ]
    }
  },
  "tpi": {
    "checkout": {
      "liveInstruction": "Skelim bilong live method, putim na confirm namba bilong account we yu bai salim mani long nem bilong nekis pes. 10-minit live session bai stat; sapos yu salim mani long dispela taim, payment bai auto-verify.",
      "trxInstruction": "Cash In long shop o askim narapela man long Send Money. Em bihain, auto-verify wantaim Transaction ID (TrxID).",
      "enterNumberInstruction": "Putim namba bilong yu na klik '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification i no stap temporari.",
      "copyPersonal": "Kopi Personal Account namba we stap antap.",
      "sendMoneyOffline": "Send Money o mekim Cash In igo long namba antap, o askim narapela man long sendim mani.",
      "trxOffline": "Kolem Transaction ID (TrxID) na putim long daun. Taim merchant i kam online bai yu kisim email notis, o yu inap kontaktim merchant stret.",
      "cashinNagad": "Cash In i no allow long Nagad, olsem na plis Send Money long narapela Nagad account.",
      "cashinOther": "Bifo yu mekim Cash In, askim shopkeeper sapos bai em i givim TrxID; sapos em i no givim, no go het. Narapela rot, askim narapela man long Send Money.",
      "waitTrx": "Bihain long payment, wetim 10–15 seconds na putim TrxID long daun. Yu inap go aot long dispela page na kam bek long dispela payment page enitaim long 24 hours long auto-verify wantaim TrxID bilong yu.",
      "goApp": "Go long {provider} app o dial {dialCode} na selekt 'Send Money'.",
      "confirmAuto": "Putim namba we yu copim na amount, den confirm wantaim PIN bilong yu long auto-verify.",
      "dontClose": "Plis no klosim dispela page",
      "autoVerify": "Yupela payment i stap long auto verification",
      "successOffline": "Tenkyu, {name}. Transaction bilong yu i rikodim. Merchant i no online nau. Bai yu kisim email notis taim merchant i kam online na verify payment bilong yu.",
      "successOnline": "Tenkyu, {name}. Payment bilong yu bilong {amount} tru {provider} i bin kisim na i stap long process bilong verify."
    },
    "features": {
      "no-code-website": [
        "Yu inap mekim na pulisim e-commerce, education, blog o news sait nating long yusim coding.",
        "Example: pulisim wanpela landing page na product post long dashboard bilong course seller."
      ],
      "custom-domain": [
        "Konektim domain bilong yu yet na bildim professional digital identity wantaim fast routing.",
        "Example: stoa bilong yu i ran long www.acme.com insted long platform subdomain."
      ],
      "capi": [
        "Senim conversion events server-side long stretpela campaign measurement.",
        "Example: purchase event i sen long server i go long ad platform."
      ],
      "personal-mfs": [
        "Automate verification bilong supported personal MFS payments.",
        "Example: personal MFS payment i match wantaim website order."
      ],
      "local-gateway": [
        "Konektim local payment methods long regional customers.",
        "Example: local buyer i finis checkout tru regional gateway."
      ],
      "international-gateway": [
        "Konektim international payment methods long customers long wol.",
        "Example: overseas buyer i finis checkout wantaim global method."
      ],
      "notifications": [
        "Senim payment na order updates long customers na merchants.",
        "Example: payment success bai trigger merchant alert na customer update."
      ],
      "courier": [
        "Senim confirmed orders i go long supported courier workflow otomatiki.",
        "Example: confirmed COD order i redi long courier handoff."
      ],
      "business-email": [
        "Senim na kisim professional email long domain bilong yu yet.",
        "Example: sales@acme.com kisim inquiries na support@acme.com reply."
      ]
    }
  },
  "tsn": {
    "checkout": {
      "liveInstruction": "Kgetha tsela ya live, kenya o netefatse nomoro ya akhaonto e o tla romelang madi go tswa go yona mo letlhakoreng le le latelang. Sešene ya metsotso e 10 ya live e tla simolola; fa o romela madi mo nakong ya yona, tefo e tla netefadiwa ka boiketsetso.",
      "trxInstruction": "Dirang Cash In mo lebenkeleng kgotsa kopa mongwe go Send Money. Gomme netefatsa ka boiketsetso o dirisa Transaction ID (TrxID).",
      "enterNumberInstruction": "Kenya nomoro ya gago mme o tobetsa konopo ya '{action}'.",
      "offlineTitle": "Sesebediswa sa Morekisi se Sa Dirole (Merchant Device Offline)",
      "offlineDescription": "Go netefatsa ka boiketsetso ga go teng nako e potlako.",
      "copyPersonal": "Kopitsa nomoro ya Personal Account e e kwa tlase.",
      "sendMoneyOffline": "Send Money kgotsa dira Cash In go nomoro e e kwa godimo, kgotsa kopa mongwe go romela madi.",
      "trxOffline": "Kwa Transaction ID (TrxID) mme o e tsenye tlase. Fa morekisi a boa go nna online, o tla itsisiwa ka imeile, kgotsa o ka ikgolaganya le morekisi ka kotloloho.",
      "cashinNagad": "Cash In ga e letlelelwe mo Nagad, ka jalo tsweetswee Send Money go tswa ka akhaonto e nngwe ya Nagad.",
      "cashinOther": "Pele ga Cash In, botsa mosebeletsi wa lebenkele gore a tla fana ka TrxID; fa e se jalo, o se ka wa tswela pele. Gonne kgotsa kopa mongwe a Send Money.",
      "waitTrx": "Morago ga tefo, emela metsotsoana e 10–15 mme o tsenye TrxID e e kwa tlase. O ka tlogela letlhakore leno mme wa boela mo letlhakoreng la tefo nako nngwe le nngwe mo diura tse 24 go netefatsa ka boiketsetso o dirisa TrxID ya gago.",
      "goApp": "Tsamaya go app ya {provider} kgotsa diale {dialCode} mme o kgethe 'Send Money'.",
      "confirmAuto": "Kenya nomoro e o e kopitseng le palo, mme o netefatse ka PIN ya gago go netefatsa ka boiketsetso.",
      "dontClose": "Tsweetswee o seke wa koitsa letlhakore leno",
      "autoVerify": "Tefo ya gago e tsere kgato ya go netefadiwa ka boiketsetso",
      "successOffline": "Ke a leboga, {name}. Kgwebo ya gago e rekotilwe. Morekisi o a offline gone jaanong. O tla itsisiwa ka imeile morago ga gore morekisi a boe a netefatse tefo ya gago.",
      "successOnline": "Ke a leboga, {name}. Tefo ya gago ya {amount} ka {provider} e amogetswe mme e a netefadiwa."
    },
    "features": {
      "no-code-website": [
        "Tlhamela le go phatlalatsa diwebosaete tsa e-commerce, thuto, blog kgotsa ditaba ntle le go ngwala khoutu.",
        "Sampole: phatlalatsa letlhakore la go fofa (landing page) le poso ya sehlahisoa go tswa dashboard ya morekisi wa koerse."
      ],
      "custom-domain": [
        "Kopanya domain ya gago mme o bophe boitshepho jwa dijithale jo bo botse ka tsela ya go tsamaisa ka bonako.",
        "Sampole: lebenkele la gago le tswelela mo www.acme.com mo lefelong la subdomain ya sethala."
      ],
      "capi": [
        "Romela conversion events ka server-side bakeng sa tekanyo e e tswekaditsweng ya leano la papatso.",
        "Sampole: tiragalo ya thekiso e romelwa go tswa server go ad platform."
      ],
      "personal-mfs": [
        "Iketsetse netefatso ya ditefello tsa Personal MFS tse di tshegetsang.",
        "Sampole: tefo ya Personal MFS e tshwana le odara ya webosaete."
      ],
      "local-gateway": [
        "Kopanya ditsela tsa go duela tsa motseng bakeng sa bareki ba sebakeng.",
        "Sampole: moreki wa selegae o fetsa checkout ka gateway ya setšhaba."
      ],
      "international-gateway": [
        "Kopanya ditsela tsa go duela tsa machaba bakeng sa bareki ka bophara jwa lefats'e.",
        "Sampole: moreki wa ntle o fetsa checkout ka tsela ya lefats'e."
      ],
      "notifications": [
        "Romela dikitso tsa tefo le ditlhakiso tsa odara go bareki le barekisi.",
        "Sampole: katlego ya tefo e baka tsebiso ya morekisi le ntlafatso ya moreki."
      ],
      "courier": [
        "Romela ditaelo tse di netefaditsweng ka mokhoa wa courier o o tshegetsang ka boiketsetso.",
        "Sampole: odara ya COD e netefaditsweng e lokisitswe go romelwa ke courier."
      ],
      "business-email": [
        "Romela le go amogela imeile ya setsebi ka domain ya gago ya brand.",
        "Sampole: sales@acme.com e amogela dipotso mme support@acme.com e araba."
      ]
    }
  },
  "tso": {
    "checkout": {
      "liveInstruction": "Khetha ndlela ya live, nghenisa ni tlhela u tiyisisa nhlamulo ya akhawunti leyi u nga ta ri hlayisa eka peji ra le hansi. Nkarhi wa 10 mins wa live u ta sungula; ku rhumela ntirho wa nkarhi lowu swa ta enta ku leswi swi ta va swi verifayeriwa hi swa-otomateka.",
      "trxInstruction": "Cash In e shopi kumbe tiva munhu loyi a nga Send Money. Endzhaku, verifaya hi swi ololoxi hi Transaction ID (TrxID).",
      "enterNumberInstruction": "Nghenisa nambala ya wena u tshemba ka botton '{action}'.",
      "offlineTitle": "Moto-Device wa Merchant a Swi Online",
      "offlineDescription": "Ku verifaya hi swa-otomateka a ku ri kona nakambe.",
      "copyPersonal": "Kopi nambala ya Personal Account leyi nga henhla.",
      "sendMoneyOffline": "Send Money kumbe Cash In eka nambala leyi nga henhla, kumbe kopa munhu a ta Send Money.",
      "trxOffline": "Koka Transaction ID (TrxID) u yi nghenise henhla. Loko merchant a tlhela a tshama online, u ta tsundzuxiwa hi email, kumbe u nga tivisa merchant kahle.",
      "cashinNagad": "Cash In a yi pfuriwa eNagad, xikombiso, Send Money hi yinhwanyana ya Nagad.",
      "cashinOther": "Kambe u hlayisa Cash In, vutisa shopkeeper loko va ta nyika TrxID; loko va nga ri karhi, u nga teyi emahlweni. Ndzi nga tlhela u kopa munhu a ta Send Money.",
      "waitTrx": "Endzhaku ka mbuyelo, rindza 10–15 wa tikhomphiriyidi u nghenisa TrxID laha henhla. U nga siya peji leri u tlhela u vhukela eka peji ra mbuyelo hinkwayo hi nkarhi wun'wana exikarhi ka tiawara ta 24 ku verifaya hi swa-otomateka hi TrxID ya wena.",
      "goApp": "Endzela app ya {provider} kumbe dial {dialCode} u koxa 'Send Money'.",
      "confirmAuto": "Nghenisa nambala leyintshwa ni mali, endzhaku u tiyisisa hi PIN ya wena leswaku ku verifayeriwa hi swa-otomateka.",
      "dontClose": "Ndzi kombela u nga pfaleri peji leri",
      "autoVerify": "Mbuyelo wa wena wu endliwa hi swa-otomateka ku verifayeriwa",
      "successOffline": "Ndza khensa, {name}. Ntirho wa wena wu tsariwile. Merchant loyi a ha ri offline. U ta tsundzuxiwa hi email loko merchant a famba a tlhela a verifaya mbuyelo wa wena.",
      "successOnline": "Ndza khensa, {name}. Mbuyelo wa wena wa {amount} hi {provider} wu amukeriwile naswona wu njhani ku verifayeriwa."
    },
    "features": {
      "no-code-website": [
        "Aka ni pfuneta ma-site ya e-commerce, education, blog, kumbe news u nga ri karhi u tsala khodi.",
        "Xana hi xikombiso: pfuneta landing page ni product post ku suka eka dashboard ya course seller."
      ],
      "custom-domain": [
        "Hlanganisa domain ya wena ni aka brand ya digital yo profesional hi routing yo antswa.",
        "Xana hi xikombiso: store ya wena yi tirha eka www.acme.com eka ndzhawu ya subdomain ya platform."
      ],
      "capi": [
        "Rumela conversion events server-side leswaku ku vona kahle miehleketo ya kampeni.",
        "Xana hi xikombiso: purchase event yi ri nkarhi lowu yi rhumeriwa hi server yi ya eka ad platform."
      ],
      "personal-mfs": [
        "Automatiza ku verifaya kwihi ka payments za Personal MFS leswi yimeleketaka.",
        "Xana hi xikombiso: payment ya Personal MFS yi fanela na order ya website."
      ],
      "local-gateway": [
        "Hlanganisa ndlela za mbuyelo za le xifundzheni hi vatirhi va xifundzheni.",
        "Xana hi xikombiso: buyer wa le xifundzheni u hela checkout hi regional gateway."
      ],
      "international-gateway": [
        "Hlanganisa ndlela za mbuyelo za matiko hinkwawo hi vatirhi va misava hinkwayo.",
        "Xana hi xikombiso: buyer wa le nyele u hela checkout hi global method."
      ],
      "notifications": [
        "Rumela update za mbuyelo ni order eka vatirhi ni merchants.",
        "Xana hi xikombiso: success ya payment yi tumbuluxaแจ merchant alert ni customer update."
      ],
      "courier": [
        "Rumela ma-order lama nyikiwa kwalaho eka workflow ya courier leyi yimeleketaka hi swa-otomateka.",
        "Xana hi xikombiso: order ya COD leyi nyikiweke yi lulamisiwa ku hundzuluxiwa ku courier."
      ],
      "business-email": [
        "Rumela ni amukela email ya profesional eka domain ya wena ya brand.",
        "Xana hi xikombiso: sales@acme.com yi amukela swivutiso ni support@acme.com yi hlamula."
      ]
    }
  },
  "tuk": {
    "checkout": {
      "liveInstruction": "Live usulyny saýlañ, soňky sahypada tölemäge başlajak hasap belgisi giriziň we tassyklap goýuň. 10 minutlyk live sessiýasy başlar; şol sessiýa dowamynda pul ibermek tölegiň awtomatik tassyklanmagyna getirýär.",
      "trxInstruction": "Dükandan Cash In ediň ýa-da başga birinden Send Money etmegiňi haýyş ediň. Soňra Transaction ID (TrxID) ulanyp awtomatik tassyklama ediň.",
      "enterNumberInstruction": "Belgiňiz giriziň we '{action}' düwmesine basyň.",
      "offlineTitle": "Satyjynyň enjamy oflayn",
      "offlineDescription": "Awtomatik tassyklama wagtlaýyn ýagdaýda elýeterli däl.",
      "copyPersonal": "Ýokardaky Personal Account belgisini göçüriň.",
      "sendMoneyOffline": "Ýokardaky belgä Send Money ediň ýa-da Cash In ediň, ýa-da başga birinden pul ugradyp bermeklerini haýyş ediň.",
      "trxOffline": "Transaction ID (TrxID) alyň we aşakda giriziň. Satyjy onlaýna gaýdanda size e-poçta arkaly habar berler ýa-da satyjy bilen gönüden-göni habarlaşyp bilersiňiz.",
      "cashinNagad": "Nagad-de Cash In ýörite rugsat berilmeýär, şonuň üçin başga Nagad hasabyndan Send Money ediň.",
      "cashinOther": "Cash In etmezden ozal, dükançydan TrxID berjekdigini soraň; eger bermeýän bolsa işlemäň. Başgaça ýagdaýda birinden Send Money ediň.",
      "waitTrx": "Tölegden soň 10–15 sekunt garaşyň we aşakda TrxID giriziň. Bu sahypadan çykyp, 24 sagadyň dowamynda islendik wagt töleg sahypasyna gaýdyp gelip, TrxID bilen awtomatik tassyklama edip bilersiňiz.",
      "goApp": "{provider} programmaçmagyna geçiň ýa-da {dialCode} nomerine jaň edip 'Send Money' saýlaň.",
      "confirmAuto": "Köçürilen belgini we summany giriziň, soň PIN bilen tassyklap awtomatik tassyklama ediň.",
      "dontClose": "Bu sahypany ýapmaň, haýyş edýäris",
      "autoVerify": "Tölegiňiz awtomatik ýagdaýda barlananýar",
      "successOffline": "Sagboluň, {name}. Siziň amalyýatyňyz hasaba alnypdyr. Satyjy häzirki wagtda oflayndyr. Satyjy onlaýna gelip tölegiňizi tassyklansoň size e-poçta arkaly habar beriler.",
      "successOnline": "Sagboluň, {name}. {provider} arkaly {amount} möçberdäki tölegiňiz kabul edilip, barlanýar."
    },
    "features": {
      "no-code-website": [
        "Kod ýazmazdan e-commerce, bilim, blog ýa-da habar web ýerlerini dörediň we ýaýlaň.",
        "Mysal: kurs satuwçysy dashboardyndan bir landingi we önümiň habaryny ýaýratmak."
      ],
      "custom-domain": [
        "Öz domeniňizi birikdirip, has çalt dolanyşygy bolan professional sanly şahsyýeti gurup bilersiňiz.",
        "Mysal: dükanyňyz platformanyň subdomeniniň ýerine www.acme.com adresinde işleýär."
      ],
      "capi": [
        "Işiniň netijeliligini ölçemek üçin serwer tarapdan conversion wakalary iberiň.",
        "Mysal: satuw wakasy serwerden reklama platformasyna iberilýär."
      ],
      "personal-mfs": [
        "Goldawsyz personal MFS töleg tassyklamalaryny automatlaşdyryň.",
        "Mysal: personal MFS tölegi web sahypadaky sargyt bilen utgaşylýar."
      ],
      "local-gateway": [
        "Regionlaýyn müşderiler üçin ýerli töleg usullaryny birikdiriň.",
        "Mysal: ýerli alyjynyň regional geçelge arkaly satyn alşy tamamlaýar."
      ],
      "international-gateway": [
        "Dünýä boýunça müşderiler üçin halkara töleg usullaryny birikdiriň.",
        "Mysal: daşary ýurtly alyjy global usul bilen checkout tamamlaýar."
      ],
      "notifications": [
        "Töleg we sargyt täzelenmelerini müşderilere we satyjylar üçin ugradyň.",
        "Mysal: töleg üstünlikli bolan halatynda satyjy habary we müşderi täzelenmesi ýüze çykýar."
      ],
      "courier": [
        "Tassyklanan sargytlary goldanylýan kurýr iş akymyna awtomatik ugradyň.",
        "Mysal: tassyklanan COD sargydy kurýera bermek üçin taýýarlaýar."
      ],
      "business-email": [
        "Öz brend domeniňizde professional e-poçta ugradyň we alyň.",
        "Mysal: sales@acme.com haýyşlary kabul edýär we support@acme.com jogap berýär."
      ]
    }
  },
  "tvl": {
    "checkout": {
      "liveInstruction": "Select the live method, enter and confirm the account number you will send money from on the next page. A 10-minute live session will start; sending money during it will auto-verify the payment.",
      "trxInstruction": "Cash In from a shop or ask someone else to Send Money. Then auto-verify using the Transaction ID (TrxID).",
      "enterNumberInstruction": "Enter your number and click the '{action}' button.",
      "offlineTitle": "Merchant Device Offline",
      "offlineDescription": "Auto-verification is temporarily unavailable.",
      "copyPersonal": "Copy the Personal Account number above.",
      "sendMoneyOffline": "Send Money or Cash In to the number above, or ask someone else to send money.",
      "trxOffline": "Collect the Transaction ID (TrxID) and enter it below. When the merchant comes online, you will be notified by email, or you can contact the merchant directly.",
      "cashinNagad": "Cash In is not allowed in Nagad, so please Send Money from another Nagad account.",
      "cashinOther": "Before Cash In, ask the shopkeeper whether they will provide the TrxID; if not, do not proceed. Alternatively, ask someone else to Send Money.",
      "waitTrx": "After payment, wait 10–15 seconds and enter the TrxID below. You can leave this page and return to this payment page at any time within 24 hours to auto-verify using your TrxID.",
      "goApp": "Go to the {provider} app or dial {dialCode} and select 'Send Money'.",
      "confirmAuto": "Enter the copied number and amount, then confirm with your PIN to auto-verify.",
      "dontClose": "Please do not close this page",
      "autoVerify": "Your payment is being verified automatically",
      "successOffline": "Thank you, {name}. Your transaction has been recorded. The merchant is currently offline. You will be notified by email after the merchant comes online and verifies your payment.",
      "successOnline": "Thank you, {name}. Your payment of {amount} through {provider} has been received and is being verified."
    },
    "features": {
      "no-code-website": [
        "Fai kae publish ne ngaahi saiti e-commerce, ako, blog, mo niu e aunoa mo te kape kodesi.",
        "publish se landing page mo se product post mai te seller dashboard o te faiga ako."
      ],
      "custom-domain": [
        "Konekia kāu domain mō te fatuina o se professional digital identity mo te vave o te alagaala o fesokotaki.",
        "kā tau store e fakagaue i www.acme.com i luma i se platform subdomain."
      ],
      "capi": [
        "Lafo atu a conversion events i te server-side mō se kampane measurement fakatuatuagia.",
        "se purchase event e lafo mai te server ki te ad platform."
      ],
      "personal-mfs": [
        "Fakamalosi a te otometi o te verification o te totogi MFS a te Personal MFS e lagolagoina.",
        "se totogi Personal MFS e fetaui mo te website order."
      ],
      "local-gateway": [
        "Konekia auala totogi fakalotofenua mō kāiga faifaiga i te itū fenua.",
        "se tagata faipologa fakalotofenua e fakamāeʻa te checkout mā te gateway fakalotofenua."
      ],
      "international-gateway": [
        "Konekia auala totogi fakafetai ki tua-fenua mō kāiga faifaiga i te lalolagi kātoa.",
        "se tagata faipoloa mai tua-fenua e fakamāeʻa te checkout mā se auala global."
      ],
      "notifications": [
        "Lafo atu fakailoaga o totogi mo otā order ki tagata faipoloa mo tagata faipisinisi.",
        "ka manuia te totogi, e fakamalosi se fakailoaga ki te tagata faipisinisi mo se fakamaeʻa ki te tagata faipoloa."
      ],
      "courier": [
        "Lafo otometi atu a order kua fakamaoniga ki loto i se courier workflow e lagolagoina.",
        "se order COD kua fakamaoniga e sauni mō te courier handoff."
      ],
      "business-email": [
        "Lafo mo maua a professional email i tou lava branded domain.",
        "sales@acme.com e maua mai a fepulai fesili, kae support@acme.com e tali mai."
      ]
    }
  }
} as const;
